export const Country = [
    { id: 101, sortname: "IN", name: "India", phoneCode: 91 },
    ];
 
  export const State = [
    { id: "1", name: "Andaman and Nicobar Islands", country_id: "101" },
    { id: "2", name: "Andhra Pradesh", country_id: "101" },
    { id: "3", name: "Arunachal Pradesh", country_id: "101" },
    { id: "4", name: "Assam", country_id: "101" },
    { id: "5", name: "Bihar", country_id: "101" },
    { id: "6", name: "Chandigarh", country_id: "101" },
    { id: "7", name: "Chhattisgarh", country_id: "101" },
    { id: "8", name: "Dadra and Nagar Haveli", country_id: "101" },
    { id: "9", name: "Daman and Diu", country_id: "101" },
    { id: "10", name: "Delhi", country_id: "101" },
    { id: "11", name: "Goa", country_id: "101" },
    { id: "12", name: "Gujarat", country_id: "101" },
    { id: "13", name: "Haryana", country_id: "101" },
    { id: "14", name: "Himachal Pradesh", country_id: "101" },
    { id: "15", name: "Jammu and Kashmir", country_id: "101" },
    { id: "16", name: "Jharkhand", country_id: "101" },
    { id: "17", name: "Karnataka", country_id: "101" },
    { id: "19", name: "Kerala", country_id: "101" },
    { id: "20", name: "Lakshadweep", country_id: "101" },
    { id: "21", name: "Madhya Pradesh", country_id: "101" },
    { id: "22", name: "Maharashtra", country_id: "101" },
    { id: "23", name: "Manipur", country_id: "101" },
    { id: "24", name: "Meghalaya", country_id: "101" },
    { id: "25", name: "Mizoram", country_id: "101" },
    { id: "26", name: "Nagaland", country_id: "101" },
    { id: "29", name: "Odisha", country_id: "101" },
    { id: "31", name: "Pondicherry", country_id: "101" },
    { id: "32", name: "Punjab", country_id: "101" },
    { id: "33", name: "Rajasthan", country_id: "101" },
    { id: "34", name: "Sikkim", country_id: "101" },
    { id: "35", name: "Tamil Nadu", country_id: "101" },
    { id: "36", name: "Telangana", country_id: "101" },
    { id: "37", name: "Tripura", country_id: "101" },
    { id: "38", name: "Uttar Pradesh", country_id: "101" },
    { id: "39", name: "Uttarakhand", country_id: "101" },
    { id: "41", name: "West Bengal", country_id: "101" },
  ];
  

  export const City= [
  {
    "id": "1",
    "name": "Bombuflat",
    "state_id": "1"
  },
  {
    "id": "2",
    "name": "Garacharma",
    "state_id": "1"
  },
  {
    "id": "3",
    "name": "Port Blair",
    "state_id": "1"
  },
  {
    "id": "4",
    "name": "Rangat",
    "state_id": "1"
  },
  {
    "id": "5",
    "name": "Addanki",
    "state_id": "2"
  },
  {
    "id": "6",
    "name": "Adivivaram",
    "state_id": "2"
  },
  {
    "id": "7",
    "name": "Adoni",
    "state_id": "2"
  },
  {
    "id": "8",
    "name": "Aganampudi",
    "state_id": "2"
  },
  {
    "id": "9",
    "name": "Ajjaram",
    "state_id": "2"
  },
  {
    "id": "10",
    "name": "Akividu",
    "state_id": "2"
  },
  {
    "id": "11",
    "name": "Akkarampalle",
    "state_id": "2"
  },
  {
    "id": "12",
    "name": "Akkayapalle",
    "state_id": "2"
  },
  {
    "id": "13",
    "name": "Akkireddipalem",
    "state_id": "2"
  },
  {
    "id": "14",
    "name": "Alampur",
    "state_id": "2"
  },
  {
    "id": "15",
    "name": "Amalapuram",
    "state_id": "2"
  },
  {
    "id": "16",
    "name": "Amudalavalasa",
    "state_id": "2"
  },
  {
    "id": "17",
    "name": "Amur",
    "state_id": "2"
  },
  {
    "id": "18",
    "name": "Anakapalle",
    "state_id": "2"
  },
  {
    "id": "19",
    "name": "Anantapur",
    "state_id": "2"
  },
  {
    "id": "20",
    "name": "Andole",
    "state_id": "2"
  },
  {
    "id": "21",
    "name": "Atmakur",
    "state_id": "2"
  },
  {
    "id": "22",
    "name": "Attili",
    "state_id": "2"
  },
  {
    "id": "23",
    "name": "Avanigadda",
    "state_id": "2"
  },
  {
    "id": "24",
    "name": "Badepalli",
    "state_id": "2"
  },
  {
    "id": "25",
    "name": "Badvel",
    "state_id": "2"
  },
  {
    "id": "26",
    "name": "Balapur",
    "state_id": "2"
  },
  {
    "id": "27",
    "name": "Bandarulanka",
    "state_id": "2"
  },
  {
    "id": "28",
    "name": "Banganapalle",
    "state_id": "2"
  },
  {
    "id": "29",
    "name": "Bapatla",
    "state_id": "2"
  },
  {
    "id": "30",
    "name": "Bapulapadu",
    "state_id": "2"
  },
  {
    "id": "31",
    "name": "Belampalli",
    "state_id": "2"
  },
  {
    "id": "32",
    "name": "Bestavaripeta",
    "state_id": "2"
  },
  {
    "id": "33",
    "name": "Betamcherla",
    "state_id": "2"
  },
  {
    "id": "34",
    "name": "Bhattiprolu",
    "state_id": "2"
  },
  {
    "id": "35",
    "name": "Bhimavaram",
    "state_id": "2"
  },
  {
    "id": "36",
    "name": "Bhimunipatnam",
    "state_id": "2"
  },
  {
    "id": "37",
    "name": "Bobbili",
    "state_id": "2"
  },
  {
    "id": "38",
    "name": "Bombuflat",
    "state_id": "2"
  },
  {
    "id": "39",
    "name": "Bommuru",
    "state_id": "2"
  },
  {
    "id": "40",
    "name": "Bugganipalle",
    "state_id": "2"
  },
  {
    "id": "41",
    "name": "Challapalle",
    "state_id": "2"
  },
  {
    "id": "42",
    "name": "Chandur",
    "state_id": "2"
  },
  {
    "id": "43",
    "name": "Chatakonda",
    "state_id": "2"
  },
  {
    "id": "44",
    "name": "Chemmumiahpet",
    "state_id": "2"
  },
  {
    "id": "45",
    "name": "Chidiga",
    "state_id": "2"
  },
  {
    "id": "46",
    "name": "Chilakaluripet",
    "state_id": "2"
  },
  {
    "id": "47",
    "name": "Chimakurthy",
    "state_id": "2"
  },
  {
    "id": "48",
    "name": "Chinagadila",
    "state_id": "2"
  },
  {
    "id": "49",
    "name": "Chinagantyada",
    "state_id": "2"
  },
  {
    "id": "50",
    "name": "Chinnachawk",
    "state_id": "2"
  },
  {
    "id": "51",
    "name": "Chintalavalasa",
    "state_id": "2"
  },
  {
    "id": "52",
    "name": "Chipurupalle",
    "state_id": "2"
  },
  {
    "id": "53",
    "name": "Chirala",
    "state_id": "2"
  },
  {
    "id": "54",
    "name": "Chittoor",
    "state_id": "2"
  },
  {
    "id": "55",
    "name": "Chodavaram",
    "state_id": "2"
  },
  {
    "id": "56",
    "name": "Choutuppal",
    "state_id": "2"
  },
  {
    "id": "57",
    "name": "Chunchupalle",
    "state_id": "2"
  },
  {
    "id": "58",
    "name": "Cuddapah",
    "state_id": "2"
  },
  {
    "id": "59",
    "name": "Cumbum",
    "state_id": "2"
  },
  {
    "id": "60",
    "name": "Darnakal",
    "state_id": "2"
  },
  {
    "id": "61",
    "name": "Dasnapur",
    "state_id": "2"
  },
  {
    "id": "62",
    "name": "Dauleshwaram",
    "state_id": "2"
  },
  {
    "id": "63",
    "name": "Dharmavaram",
    "state_id": "2"
  },
  {
    "id": "64",
    "name": "Dhone",
    "state_id": "2"
  },
  {
    "id": "65",
    "name": "Dommara Nandyal",
    "state_id": "2"
  },
  {
    "id": "66",
    "name": "Dowlaiswaram",
    "state_id": "2"
  },
  {
    "id": "67",
    "name": "East Godavari Dist.",
    "state_id": "2"
  },
  {
    "id": "68",
    "name": "Eddumailaram",
    "state_id": "2"
  },
  {
    "id": "69",
    "name": "Edulapuram",
    "state_id": "2"
  },
  {
    "id": "70",
    "name": "Ekambara kuppam",
    "state_id": "2"
  },
  {
    "id": "71",
    "name": "Eluru",
    "state_id": "2"
  },
  {
    "id": "72",
    "name": "Enikapadu",
    "state_id": "2"
  },
  {
    "id": "73",
    "name": "Fakirtakya",
    "state_id": "2"
  },
  {
    "id": "74",
    "name": "Farrukhnagar",
    "state_id": "2"
  },
  {
    "id": "75",
    "name": "Gaddiannaram",
    "state_id": "2"
  },
  {
    "id": "76",
    "name": "Gajapathinagaram",
    "state_id": "2"
  },
  {
    "id": "77",
    "name": "Gajularega",
    "state_id": "2"
  },
  {
    "id": "78",
    "name": "Gajuvaka",
    "state_id": "2"
  },
  {
    "id": "79",
    "name": "Gannavaram",
    "state_id": "2"
  },
  {
    "id": "80",
    "name": "Garacharma",
    "state_id": "2"
  },
  {
    "id": "81",
    "name": "Garimellapadu",
    "state_id": "2"
  },
  {
    "id": "82",
    "name": "Giddalur",
    "state_id": "2"
  },
  {
    "id": "83",
    "name": "Godavarikhani",
    "state_id": "2"
  },
  {
    "id": "84",
    "name": "Gopalapatnam",
    "state_id": "2"
  },
  {
    "id": "85",
    "name": "Gopalur",
    "state_id": "2"
  },
  {
    "id": "86",
    "name": "Gorrekunta",
    "state_id": "2"
  },
  {
    "id": "87",
    "name": "Gudivada",
    "state_id": "2"
  },
  {
    "id": "88",
    "name": "Gudur",
    "state_id": "2"
  },
  {
    "id": "89",
    "name": "Guntakal",
    "state_id": "2"
  },
  {
    "id": "90",
    "name": "Guntur",
    "state_id": "2"
  },
  {
    "id": "91",
    "name": "Guti",
    "state_id": "2"
  },
  {
    "id": "92",
    "name": "Hindupur",
    "state_id": "2"
  },
  {
    "id": "93",
    "name": "Hukumpeta",
    "state_id": "2"
  },
  {
    "id": "94",
    "name": "Ichchapuram",
    "state_id": "2"
  },
  {
    "id": "95",
    "name": "Isnapur",
    "state_id": "2"
  },
  {
    "id": "96",
    "name": "Jaggayyapeta",
    "state_id": "2"
  },
  {
    "id": "97",
    "name": "Jallaram Kamanpur",
    "state_id": "2"
  },
  {
    "id": "98",
    "name": "Jammalamadugu",
    "state_id": "2"
  },
  {
    "id": "99",
    "name": "Jangampalli",
    "state_id": "2"
  },
  {
    "id": "100",
    "name": "Jarjapupeta",
    "state_id": "2"
  },
  {
    "id": "101",
    "name": "Kadiri",
    "state_id": "2"
  },
  {
    "id": "102",
    "name": "Kaikalur",
    "state_id": "2"
  },
  {
    "id": "103",
    "name": "Kakinada",
    "state_id": "2"
  },
  {
    "id": "104",
    "name": "Kallur",
    "state_id": "2"
  },
  {
    "id": "105",
    "name": "Kalyandurg",
    "state_id": "2"
  },
  {
    "id": "106",
    "name": "Kamalapuram",
    "state_id": "2"
  },
  {
    "id": "107",
    "name": "Kamareddi",
    "state_id": "2"
  },
  {
    "id": "108",
    "name": "Kanapaka",
    "state_id": "2"
  },
  {
    "id": "109",
    "name": "Kanigiri",
    "state_id": "2"
  },
  {
    "id": "110",
    "name": "Kanithi",
    "state_id": "2"
  },
  {
    "id": "111",
    "name": "Kankipadu",
    "state_id": "2"
  },
  {
    "id": "112",
    "name": "Kantabamsuguda",
    "state_id": "2"
  },
  {
    "id": "113",
    "name": "Kanuru",
    "state_id": "2"
  },
  {
    "id": "114",
    "name": "Karnul",
    "state_id": "2"
  },
  {
    "id": "115",
    "name": "Katheru",
    "state_id": "2"
  },
  {
    "id": "116",
    "name": "Kavali",
    "state_id": "2"
  },
  {
    "id": "117",
    "name": "Kazipet",
    "state_id": "2"
  },
  {
    "id": "118",
    "name": "Khanapuram Haveli",
    "state_id": "2"
  },
  {
    "id": "119",
    "name": "Kodar",
    "state_id": "2"
  },
  {
    "id": "120",
    "name": "Kollapur",
    "state_id": "2"
  },
  {
    "id": "121",
    "name": "Kondapalem",
    "state_id": "2"
  },
  {
    "id": "122",
    "name": "Kondapalle",
    "state_id": "2"
  },
  {
    "id": "123",
    "name": "Kondukur",
    "state_id": "2"
  },
  {
    "id": "124",
    "name": "Kosgi",
    "state_id": "2"
  },
  {
    "id": "125",
    "name": "Kothavalasa",
    "state_id": "2"
  },
  {
    "id": "126",
    "name": "Kottapalli",
    "state_id": "2"
  },
  {
    "id": "127",
    "name": "Kovur",
    "state_id": "2"
  },
  {
    "id": "128",
    "name": "Kovurpalle",
    "state_id": "2"
  },
  {
    "id": "129",
    "name": "Kovvur",
    "state_id": "2"
  },
  {
    "id": "130",
    "name": "Krishna",
    "state_id": "2"
  },
  {
    "id": "131",
    "name": "Kuppam",
    "state_id": "2"
  },
  {
    "id": "132",
    "name": "Kurmannapalem",
    "state_id": "2"
  },
  {
    "id": "133",
    "name": "Kurnool",
    "state_id": "2"
  },
  {
    "id": "134",
    "name": "Lakshettipet",
    "state_id": "2"
  },
  {
    "id": "135",
    "name": "Lalbahadur Nagar",
    "state_id": "2"
  },
  {
    "id": "136",
    "name": "Machavaram",
    "state_id": "2"
  },
  {
    "id": "137",
    "name": "Macherla",
    "state_id": "2"
  },
  {
    "id": "138",
    "name": "Machilipatnam",
    "state_id": "2"
  },
  {
    "id": "139",
    "name": "Madanapalle",
    "state_id": "2"
  },
  {
    "id": "140",
    "name": "Madaram",
    "state_id": "2"
  },
  {
    "id": "141",
    "name": "Madhuravada",
    "state_id": "2"
  },
  {
    "id": "142",
    "name": "Madikonda",
    "state_id": "2"
  },
  {
    "id": "143",
    "name": "Madugule",
    "state_id": "2"
  },
  {
    "id": "144",
    "name": "Mahabubnagar",
    "state_id": "2"
  },
  {
    "id": "145",
    "name": "Mahbubabad",
    "state_id": "2"
  },
  {
    "id": "146",
    "name": "Malkajgiri",
    "state_id": "2"
  },
  {
    "id": "147",
    "name": "Mamilapalle",
    "state_id": "2"
  },
  {
    "id": "148",
    "name": "Mancheral",
    "state_id": "2"
  },
  {
    "id": "149",
    "name": "Mandapeta",
    "state_id": "2"
  },
  {
    "id": "150",
    "name": "Mandasa",
    "state_id": "2"
  },
  {
    "id": "151",
    "name": "Mangalagiri",
    "state_id": "2"
  },
  {
    "id": "152",
    "name": "Manthani",
    "state_id": "2"
  },
  {
    "id": "153",
    "name": "Markapur",
    "state_id": "2"
  },
  {
    "id": "154",
    "name": "Marturu",
    "state_id": "2"
  },
  {
    "id": "155",
    "name": "Metpalli",
    "state_id": "2"
  },
  {
    "id": "156",
    "name": "Mindi",
    "state_id": "2"
  },
  {
    "id": "157",
    "name": "Mirpet",
    "state_id": "2"
  },
  {
    "id": "158",
    "name": "Moragudi",
    "state_id": "2"
  },
  {
    "id": "159",
    "name": "Mothugudam",
    "state_id": "2"
  },
  {
    "id": "160",
    "name": "Nagari",
    "state_id": "2"
  },
  {
    "id": "161",
    "name": "Nagireddipalle",
    "state_id": "2"
  },
  {
    "id": "162",
    "name": "Nandigama",
    "state_id": "2"
  },
  {
    "id": "163",
    "name": "Nandikotkur",
    "state_id": "2"
  },
  {
    "id": "164",
    "name": "Nandyal",
    "state_id": "2"
  },
  {
    "id": "165",
    "name": "Narasannapeta",
    "state_id": "2"
  },
  {
    "id": "166",
    "name": "Narasapur",
    "state_id": "2"
  },
  {
    "id": "167",
    "name": "Narasaraopet",
    "state_id": "2"
  },
  {
    "id": "168",
    "name": "Narayanavanam",
    "state_id": "2"
  },
  {
    "id": "169",
    "name": "Narsapur",
    "state_id": "2"
  },
  {
    "id": "170",
    "name": "Narsingi",
    "state_id": "2"
  },
  {
    "id": "171",
    "name": "Narsipatnam",
    "state_id": "2"
  },
  {
    "id": "172",
    "name": "Naspur",
    "state_id": "2"
  },
  {
    "id": "173",
    "name": "Nathayyapalem",
    "state_id": "2"
  },
  {
    "id": "174",
    "name": "Nayudupeta",
    "state_id": "2"
  },
  {
    "id": "175",
    "name": "Nelimaria",
    "state_id": "2"
  },
  {
    "id": "176",
    "name": "Nellore",
    "state_id": "2"
  },
  {
    "id": "177",
    "name": "Nidadavole",
    "state_id": "2"
  },
  {
    "id": "178",
    "name": "Nuzvid",
    "state_id": "2"
  },
  {
    "id": "179",
    "name": "Omerkhan daira",
    "state_id": "2"
  },
  {
    "id": "180",
    "name": "Ongole",
    "state_id": "2"
  },
  {
    "id": "181",
    "name": "Osmania University",
    "state_id": "2"
  },
  {
    "id": "182",
    "name": "Pakala",
    "state_id": "2"
  },
  {
    "id": "183",
    "name": "Palakole",
    "state_id": "2"
  },
  {
    "id": "184",
    "name": "Palakurthi",
    "state_id": "2"
  },
  {
    "id": "185",
    "name": "Palasa",
    "state_id": "2"
  },
  {
    "id": "186",
    "name": "Palempalle",
    "state_id": "2"
  },
  {
    "id": "187",
    "name": "Palkonda",
    "state_id": "2"
  },
  {
    "id": "188",
    "name": "Palmaner",
    "state_id": "2"
  },
  {
    "id": "189",
    "name": "Pamur",
    "state_id": "2"
  },
  {
    "id": "190",
    "name": "Panjim",
    "state_id": "2"
  },
  {
    "id": "191",
    "name": "Papampeta",
    "state_id": "2"
  },
  {
    "id": "192",
    "name": "Parasamba",
    "state_id": "2"
  },
  {
    "id": "193",
    "name": "Parvatipuram",
    "state_id": "2"
  },
  {
    "id": "194",
    "name": "Patancheru",
    "state_id": "2"
  },
  {
    "id": "195",
    "name": "Payakaraopet",
    "state_id": "2"
  },
  {
    "id": "196",
    "name": "Pedagantyada",
    "state_id": "2"
  },
  {
    "id": "197",
    "name": "Pedana",
    "state_id": "2"
  },
  {
    "id": "198",
    "name": "Peddapuram",
    "state_id": "2"
  },
  {
    "id": "199",
    "name": "Pendurthi",
    "state_id": "2"
  },
  {
    "id": "200",
    "name": "Penugonda",
    "state_id": "2"
  },
  {
    "id": "201",
    "name": "Penukonda",
    "state_id": "2"
  },
  {
    "id": "202",
    "name": "Phirangipuram",
    "state_id": "2"
  },
  {
    "id": "203",
    "name": "Pithapuram",
    "state_id": "2"
  },
  {
    "id": "204",
    "name": "Ponnur",
    "state_id": "2"
  },
  {
    "id": "205",
    "name": "Port Blair",
    "state_id": "2"
  },
  {
    "id": "206",
    "name": "Pothinamallayyapalem",
    "state_id": "2"
  },
  {
    "id": "207",
    "name": "Prakasam",
    "state_id": "2"
  },
  {
    "id": "208",
    "name": "Prasadampadu",
    "state_id": "2"
  },
  {
    "id": "209",
    "name": "Prasantinilayam",
    "state_id": "2"
  },
  {
    "id": "210",
    "name": "Proddatur",
    "state_id": "2"
  },
  {
    "id": "211",
    "name": "Pulivendla",
    "state_id": "2"
  },
  {
    "id": "212",
    "name": "Punganuru",
    "state_id": "2"
  },
  {
    "id": "213",
    "name": "Puttur",
    "state_id": "2"
  },
  {
    "id": "214",
    "name": "Qutubullapur",
    "state_id": "2"
  },
  {
    "id": "215",
    "name": "Rajahmundry",
    "state_id": "2"
  },
  {
    "id": "216",
    "name": "Rajamahendri",
    "state_id": "2"
  },
  {
    "id": "217",
    "name": "Rajampet",
    "state_id": "2"
  },
  {
    "id": "218",
    "name": "Rajendranagar",
    "state_id": "2"
  },
  {
    "id": "219",
    "name": "Rajoli",
    "state_id": "2"
  },
  {
    "id": "220",
    "name": "Ramachandrapuram",
    "state_id": "2"
  },
  {
    "id": "221",
    "name": "Ramanayyapeta",
    "state_id": "2"
  },
  {
    "id": "222",
    "name": "Ramapuram",
    "state_id": "2"
  },
  {
    "id": "223",
    "name": "Ramarajupalli",
    "state_id": "2"
  },
  {
    "id": "224",
    "name": "Ramavarappadu",
    "state_id": "2"
  },
  {
    "id": "225",
    "name": "Rameswaram",
    "state_id": "2"
  },
  {
    "id": "226",
    "name": "Rampachodavaram",
    "state_id": "2"
  },
  {
    "id": "227",
    "name": "Ravulapalam",
    "state_id": "2"
  },
  {
    "id": "228",
    "name": "Rayachoti",
    "state_id": "2"
  },
  {
    "id": "229",
    "name": "Rayadrug",
    "state_id": "2"
  },
  {
    "id": "230",
    "name": "Razam",
    "state_id": "2"
  },
  {
    "id": "231",
    "name": "Razole",
    "state_id": "2"
  },
  {
    "id": "232",
    "name": "Renigunta",
    "state_id": "2"
  },
  {
    "id": "233",
    "name": "Repalle",
    "state_id": "2"
  },
  {
    "id": "234",
    "name": "Rishikonda",
    "state_id": "2"
  },
  {
    "id": "235",
    "name": "Salur",
    "state_id": "2"
  },
  {
    "id": "236",
    "name": "Samalkot",
    "state_id": "2"
  },
  {
    "id": "237",
    "name": "Sattenapalle",
    "state_id": "2"
  },
  {
    "id": "238",
    "name": "Seetharampuram",
    "state_id": "2"
  },
  {
    "id": "239",
    "name": "Serilungampalle",
    "state_id": "2"
  },
  {
    "id": "240",
    "name": "Shankarampet",
    "state_id": "2"
  },
  {
    "id": "241",
    "name": "Shar",
    "state_id": "2"
  },
  {
    "id": "242",
    "name": "Singarayakonda",
    "state_id": "2"
  },
  {
    "id": "243",
    "name": "Sirpur",
    "state_id": "2"
  },
  {
    "id": "244",
    "name": "Sirsilla",
    "state_id": "2"
  },
  {
    "id": "245",
    "name": "Sompeta",
    "state_id": "2"
  },
  {
    "id": "246",
    "name": "Sriharikota",
    "state_id": "2"
  },
  {
    "id": "247",
    "name": "Srikakulam",
    "state_id": "2"
  },
  {
    "id": "248",
    "name": "Srikalahasti",
    "state_id": "2"
  },
  {
    "id": "249",
    "name": "Sriramnagar",
    "state_id": "2"
  },
  {
    "id": "250",
    "name": "Sriramsagar",
    "state_id": "2"
  },
  {
    "id": "251",
    "name": "Srisailam",
    "state_id": "2"
  },
  {
    "id": "252",
    "name": "Srisailamgudem Devasthanam",
    "state_id": "2"
  },
  {
    "id": "253",
    "name": "Sulurpeta",
    "state_id": "2"
  },
  {
    "id": "254",
    "name": "Suriapet",
    "state_id": "2"
  },
  {
    "id": "255",
    "name": "Suryaraopet",
    "state_id": "2"
  },
  {
    "id": "256",
    "name": "Tadepalle",
    "state_id": "2"
  },
  {
    "id": "257",
    "name": "Tadepalligudem",
    "state_id": "2"
  },
  {
    "id": "258",
    "name": "Tadpatri",
    "state_id": "2"
  },
  {
    "id": "259",
    "name": "Tallapalle",
    "state_id": "2"
  },
  {
    "id": "260",
    "name": "Tanuku",
    "state_id": "2"
  },
  {
    "id": "261",
    "name": "Tekkali",
    "state_id": "2"
  },
  {
    "id": "262",
    "name": "Tenali",
    "state_id": "2"
  },
  {
    "id": "263",
    "name": "Tigalapahad",
    "state_id": "2"
  },
  {
    "id": "264",
    "name": "Tiruchanur",
    "state_id": "2"
  },
  {
    "id": "265",
    "name": "Tirumala",
    "state_id": "2"
  },
  {
    "id": "266",
    "name": "Tirupati",
    "state_id": "2"
  },
  {
    "id": "267",
    "name": "Tirvuru",
    "state_id": "2"
  },
  {
    "id": "268",
    "name": "Trimulgherry",
    "state_id": "2"
  },
  {
    "id": "269",
    "name": "Tuni",
    "state_id": "2"
  },
  {
    "id": "270",
    "name": "Turangi",
    "state_id": "2"
  },
  {
    "id": "271",
    "name": "Ukkayapalli",
    "state_id": "2"
  },
  {
    "id": "272",
    "name": "Ukkunagaram",
    "state_id": "2"
  },
  {
    "id": "273",
    "name": "Uppal Kalan",
    "state_id": "2"
  },
  {
    "id": "274",
    "name": "Upper Sileru",
    "state_id": "2"
  },
  {
    "id": "275",
    "name": "Uravakonda",
    "state_id": "2"
  },
  {
    "id": "276",
    "name": "Vadlapudi",
    "state_id": "2"
  },
  {
    "id": "277",
    "name": "Vaparala",
    "state_id": "2"
  },
  {
    "id": "278",
    "name": "Vemalwada",
    "state_id": "2"
  },
  {
    "id": "279",
    "name": "Venkatagiri",
    "state_id": "2"
  },
  {
    "id": "280",
    "name": "Venkatapuram",
    "state_id": "2"
  },
  {
    "id": "281",
    "name": "Vepagunta",
    "state_id": "2"
  },
  {
    "id": "282",
    "name": "Vetapalem",
    "state_id": "2"
  },
  {
    "id": "283",
    "name": "Vijayapuri",
    "state_id": "2"
  },
  {
    "id": "284",
    "name": "Vijayapuri South",
    "state_id": "2"
  },
  {
    "id": "285",
    "name": "Vijayawada",
    "state_id": "2"
  },
  {
    "id": "286",
    "name": "Vinukonda",
    "state_id": "2"
  },
  {
    "id": "287",
    "name": "Visakhapatnam",
    "state_id": "2"
  },
  {
    "id": "288",
    "name": "Vizianagaram",
    "state_id": "2"
  },
  {
    "id": "289",
    "name": "Vuyyuru",
    "state_id": "2"
  },
  {
    "id": "290",
    "name": "Wanparti",
    "state_id": "2"
  },
  {
    "id": "291",
    "name": "West Godavari Dist.",
    "state_id": "2"
  },
  {
    "id": "292",
    "name": "Yadagirigutta",
    "state_id": "2"
  },
  {
    "id": "293",
    "name": "Yarada",
    "state_id": "2"
  },
  {
    "id": "294",
    "name": "Yellamanchili",
    "state_id": "2"
  },
  {
    "id": "295",
    "name": "Yemmiganur",
    "state_id": "2"
  },
  {
    "id": "296",
    "name": "Yenamalakudru",
    "state_id": "2"
  },
  {
    "id": "297",
    "name": "Yendada",
    "state_id": "2"
  },
  {
    "id": "298",
    "name": "Yerraguntla",
    "state_id": "2"
  },
  {
    "id": "299",
    "name": "Along",
    "state_id": "3"
  },
  {
    "id": "300",
    "name": "Basar",
    "state_id": "3"
  },
  {
    "id": "301",
    "name": "Bondila",
    "state_id": "3"
  },
  {
    "id": "302",
    "name": "Changlang",
    "state_id": "3"
  },
  {
    "id": "303",
    "name": "Daporijo",
    "state_id": "3"
  },
  {
    "id": "304",
    "name": "Deomali",
    "state_id": "3"
  },
  {
    "id": "305",
    "name": "Itanagar",
    "state_id": "3"
  },
  {
    "id": "306",
    "name": "Jairampur",
    "state_id": "3"
  },
  {
    "id": "307",
    "name": "Khonsa",
    "state_id": "3"
  },
  {
    "id": "308",
    "name": "Naharlagun",
    "state_id": "3"
  },
  {
    "id": "309",
    "name": "Namsai",
    "state_id": "3"
  },
  {
    "id": "310",
    "name": "Pasighat",
    "state_id": "3"
  },
  {
    "id": "311",
    "name": "Roing",
    "state_id": "3"
  },
  {
    "id": "312",
    "name": "Seppa",
    "state_id": "3"
  },
  {
    "id": "313",
    "name": "Tawang",
    "state_id": "3"
  },
  {
    "id": "314",
    "name": "Tezu",
    "state_id": "3"
  },
  {
    "id": "315",
    "name": "Ziro",
    "state_id": "3"
  },
  {
    "id": "316",
    "name": "Abhayapuri",
    "state_id": "4"
  },
  {
    "id": "317",
    "name": "Ambikapur",
    "state_id": "4"
  },
  {
    "id": "318",
    "name": "Amguri",
    "state_id": "4"
  },
  {
    "id": "319",
    "name": "Anand Nagar",
    "state_id": "4"
  },
  {
    "id": "320",
    "name": "Badarpur",
    "state_id": "4"
  },
  {
    "id": "321",
    "name": "Badarpur Railway Town",
    "state_id": "4"
  },
  {
    "id": "322",
    "name": "Bahbari Gaon",
    "state_id": "4"
  },
  {
    "id": "323",
    "name": "Bamun Sualkuchi",
    "state_id": "4"
  },
  {
    "id": "324",
    "name": "Barbari",
    "state_id": "4"
  },
  {
    "id": "325",
    "name": "Barpathar",
    "state_id": "4"
  },
  {
    "id": "326",
    "name": "Barpeta",
    "state_id": "4"
  },
  {
    "id": "327",
    "name": "Barpeta Road",
    "state_id": "4"
  },
  {
    "id": "328",
    "name": "Basugaon",
    "state_id": "4"
  },
  {
    "id": "329",
    "name": "Bihpuria",
    "state_id": "4"
  },
  {
    "id": "330",
    "name": "Bijni",
    "state_id": "4"
  },
  {
    "id": "331",
    "name": "Bilasipara",
    "state_id": "4"
  },
  {
    "id": "332",
    "name": "Biswanath Chariali",
    "state_id": "4"
  },
  {
    "id": "333",
    "name": "Bohori",
    "state_id": "4"
  },
  {
    "id": "334",
    "name": "Bokajan",
    "state_id": "4"
  },
  {
    "id": "335",
    "name": "Bokokhat",
    "state_id": "4"
  },
  {
    "id": "336",
    "name": "Bongaigaon",
    "state_id": "4"
  },
  {
    "id": "337",
    "name": "Bongaigaon Petro-chemical Town",
    "state_id": "4"
  },
  {
    "id": "338",
    "name": "Borgolai",
    "state_id": "4"
  },
  {
    "id": "339",
    "name": "Chabua",
    "state_id": "4"
  },
  {
    "id": "340",
    "name": "Chandrapur Bagicha",
    "state_id": "4"
  },
  {
    "id": "341",
    "name": "Chapar",
    "state_id": "4"
  },
  {
    "id": "342",
    "name": "Chekonidhara",
    "state_id": "4"
  },
  {
    "id": "343",
    "name": "Choto Haibor",
    "state_id": "4"
  },
  {
    "id": "344",
    "name": "Dergaon",
    "state_id": "4"
  },
  {
    "id": "345",
    "name": "Dharapur",
    "state_id": "4"
  },
  {
    "id": "346",
    "name": "Dhekiajuli",
    "state_id": "4"
  },
  {
    "id": "347",
    "name": "Dhemaji",
    "state_id": "4"
  },
  {
    "id": "348",
    "name": "Dhing",
    "state_id": "4"
  },
  {
    "id": "349",
    "name": "Dhubri",
    "state_id": "4"
  },
  {
    "id": "350",
    "name": "Dhuburi",
    "state_id": "4"
  },
  {
    "id": "351",
    "name": "Dibrugarh",
    "state_id": "4"
  },
  {
    "id": "352",
    "name": "Digboi",
    "state_id": "4"
  },
  {
    "id": "353",
    "name": "Digboi Oil Town",
    "state_id": "4"
  },
  {
    "id": "354",
    "name": "Dimaruguri",
    "state_id": "4"
  },
  {
    "id": "355",
    "name": "Diphu",
    "state_id": "4"
  },
  {
    "id": "356",
    "name": "Dispur",
    "state_id": "4"
  },
  {
    "id": "357",
    "name": "Doboka",
    "state_id": "4"
  },
  {
    "id": "358",
    "name": "Dokmoka",
    "state_id": "4"
  },
  {
    "id": "359",
    "name": "Donkamokan",
    "state_id": "4"
  },
  {
    "id": "360",
    "name": "Duliagaon",
    "state_id": "4"
  },
  {
    "id": "361",
    "name": "Duliajan",
    "state_id": "4"
  },
  {
    "id": "362",
    "name": "Duliajan No.1",
    "state_id": "4"
  },
  {
    "id": "363",
    "name": "Dum Duma",
    "state_id": "4"
  },
  {
    "id": "364",
    "name": "Durga Nagar",
    "state_id": "4"
  },
  {
    "id": "365",
    "name": "Gauripur",
    "state_id": "4"
  },
  {
    "id": "366",
    "name": "Goalpara",
    "state_id": "4"
  },
  {
    "id": "367",
    "name": "Gohpur",
    "state_id": "4"
  },
  {
    "id": "368",
    "name": "Golaghat",
    "state_id": "4"
  },
  {
    "id": "369",
    "name": "Golakganj",
    "state_id": "4"
  },
  {
    "id": "370",
    "name": "Gossaigaon",
    "state_id": "4"
  },
  {
    "id": "371",
    "name": "Guwahati",
    "state_id": "4"
  },
  {
    "id": "372",
    "name": "Haflong",
    "state_id": "4"
  },
  {
    "id": "373",
    "name": "Hailakandi",
    "state_id": "4"
  },
  {
    "id": "374",
    "name": "Hamren",
    "state_id": "4"
  },
  {
    "id": "375",
    "name": "Hauli",
    "state_id": "4"
  },
  {
    "id": "376",
    "name": "Hauraghat",
    "state_id": "4"
  },
  {
    "id": "377",
    "name": "Hojai",
    "state_id": "4"
  },
  {
    "id": "378",
    "name": "Jagiroad",
    "state_id": "4"
  },
  {
    "id": "379",
    "name": "Jagiroad Paper Mill",
    "state_id": "4"
  },
  {
    "id": "380",
    "name": "Jogighopa",
    "state_id": "4"
  },
  {
    "id": "381",
    "name": "Jonai Bazar",
    "state_id": "4"
  },
  {
    "id": "382",
    "name": "Jorhat",
    "state_id": "4"
  },
  {
    "id": "383",
    "name": "Kampur Town",
    "state_id": "4"
  },
  {
    "id": "384",
    "name": "Kamrup",
    "state_id": "4"
  },
  {
    "id": "385",
    "name": "Kanakpur",
    "state_id": "4"
  },
  {
    "id": "386",
    "name": "Karimganj",
    "state_id": "4"
  },
  {
    "id": "387",
    "name": "Kharijapikon",
    "state_id": "4"
  },
  {
    "id": "388",
    "name": "Kharupetia",
    "state_id": "4"
  },
  {
    "id": "389",
    "name": "Kochpara",
    "state_id": "4"
  },
  {
    "id": "390",
    "name": "Kokrajhar",
    "state_id": "4"
  },
  {
    "id": "391",
    "name": "Kumar Kaibarta Gaon",
    "state_id": "4"
  },
  {
    "id": "392",
    "name": "Lakhimpur",
    "state_id": "4"
  },
  {
    "id": "393",
    "name": "Lakhipur",
    "state_id": "4"
  },
  {
    "id": "394",
    "name": "Lala",
    "state_id": "4"
  },
  {
    "id": "395",
    "name": "Lanka",
    "state_id": "4"
  },
  {
    "id": "396",
    "name": "Lido Tikok",
    "state_id": "4"
  },
  {
    "id": "397",
    "name": "Lido Town",
    "state_id": "4"
  },
  {
    "id": "398",
    "name": "Lumding",
    "state_id": "4"
  },
  {
    "id": "399",
    "name": "Lumding Railway Colony",
    "state_id": "4"
  },
  {
    "id": "400",
    "name": "Mahur",
    "state_id": "4"
  },
  {
    "id": "401",
    "name": "Maibong",
    "state_id": "4"
  },
  {
    "id": "402",
    "name": "Majgaon",
    "state_id": "4"
  },
  {
    "id": "403",
    "name": "Makum",
    "state_id": "4"
  },
  {
    "id": "404",
    "name": "Mangaldai",
    "state_id": "4"
  },
  {
    "id": "405",
    "name": "Mankachar",
    "state_id": "4"
  },
  {
    "id": "406",
    "name": "Margherita",
    "state_id": "4"
  },
  {
    "id": "407",
    "name": "Mariani",
    "state_id": "4"
  },
  {
    "id": "408",
    "name": "Marigaon",
    "state_id": "4"
  },
  {
    "id": "409",
    "name": "Moran",
    "state_id": "4"
  },
  {
    "id": "410",
    "name": "Moranhat",
    "state_id": "4"
  },
  {
    "id": "411",
    "name": "Nagaon",
    "state_id": "4"
  },
  {
    "id": "412",
    "name": "Naharkatia",
    "state_id": "4"
  },
  {
    "id": "413",
    "name": "Nalbari",
    "state_id": "4"
  },
  {
    "id": "414",
    "name": "Namrup",
    "state_id": "4"
  },
  {
    "id": "415",
    "name": "Naubaisa Gaon",
    "state_id": "4"
  },
  {
    "id": "416",
    "name": "Nazira",
    "state_id": "4"
  },
  {
    "id": "417",
    "name": "New Bongaigaon Railway Colony",
    "state_id": "4"
  },
  {
    "id": "418",
    "name": "Niz-Hajo",
    "state_id": "4"
  },
  {
    "id": "419",
    "name": "North Guwahati",
    "state_id": "4"
  },
  {
    "id": "420",
    "name": "Numaligarh",
    "state_id": "4"
  },
  {
    "id": "421",
    "name": "Palasbari",
    "state_id": "4"
  },
  {
    "id": "422",
    "name": "Panchgram",
    "state_id": "4"
  },
  {
    "id": "423",
    "name": "Pathsala",
    "state_id": "4"
  },
  {
    "id": "424",
    "name": "Raha",
    "state_id": "4"
  },
  {
    "id": "425",
    "name": "Rangapara",
    "state_id": "4"
  },
  {
    "id": "426",
    "name": "Rangia",
    "state_id": "4"
  },
  {
    "id": "427",
    "name": "Salakati",
    "state_id": "4"
  },
  {
    "id": "428",
    "name": "Sapatgram",
    "state_id": "4"
  },
  {
    "id": "429",
    "name": "Sarthebari",
    "state_id": "4"
  },
  {
    "id": "430",
    "name": "Sarupathar",
    "state_id": "4"
  },
  {
    "id": "431",
    "name": "Sarupathar Bengali",
    "state_id": "4"
  },
  {
    "id": "432",
    "name": "Senchoagaon",
    "state_id": "4"
  },
  {
    "id": "433",
    "name": "Sibsagar",
    "state_id": "4"
  },
  {
    "id": "434",
    "name": "Silapathar",
    "state_id": "4"
  },
  {
    "id": "435",
    "name": "Silchar",
    "state_id": "4"
  },
  {
    "id": "436",
    "name": "Silchar Part-X",
    "state_id": "4"
  },
  {
    "id": "437",
    "name": "Sonari",
    "state_id": "4"
  },
  {
    "id": "438",
    "name": "Sorbhog",
    "state_id": "4"
  },
  {
    "id": "439",
    "name": "Sualkuchi",
    "state_id": "4"
  },
  {
    "id": "440",
    "name": "Tangla",
    "state_id": "4"
  },
  {
    "id": "441",
    "name": "Tezpur",
    "state_id": "4"
  },
  {
    "id": "442",
    "name": "Tihu",
    "state_id": "4"
  },
  {
    "id": "443",
    "name": "Tinsukia",
    "state_id": "4"
  },
  {
    "id": "444",
    "name": "Titabor",
    "state_id": "4"
  },
  {
    "id": "445",
    "name": "Udalguri",
    "state_id": "4"
  },
  {
    "id": "446",
    "name": "Umrangso",
    "state_id": "4"
  },
  {
    "id": "447",
    "name": "Uttar Krishnapur Part-I",
    "state_id": "4"
  },
  {
    "id": "448",
    "name": "Amarpur",
    "state_id": "5"
  },
  {
    "id": "449",
    "name": "Ara",
    "state_id": "5"
  },
  {
    "id": "450",
    "name": "Araria",
    "state_id": "5"
  },
  {
    "id": "451",
    "name": "Areraj",
    "state_id": "5"
  },
  {
    "id": "452",
    "name": "Asarganj",
    "state_id": "5"
  },
  {
    "id": "453",
    "name": "Aurangabad",
    "state_id": "5"
  },
  {
    "id": "454",
    "name": "Bagaha",
    "state_id": "5"
  },
  {
    "id": "455",
    "name": "Bahadurganj",
    "state_id": "5"
  },
  {
    "id": "456",
    "name": "Bairgania",
    "state_id": "5"
  },
  {
    "id": "457",
    "name": "Bakhtiyarpur",
    "state_id": "5"
  },
  {
    "id": "458",
    "name": "Banka",
    "state_id": "5"
  },
  {
    "id": "459",
    "name": "Banmankhi",
    "state_id": "5"
  },
  {
    "id": "460",
    "name": "Bar Bigha",
    "state_id": "5"
  },
  {
    "id": "461",
    "name": "Barauli",
    "state_id": "5"
  },
  {
    "id": "462",
    "name": "Barauni Oil Township",
    "state_id": "5"
  },
  {
    "id": "463",
    "name": "Barh",
    "state_id": "5"
  },
  {
    "id": "464",
    "name": "Barhiya",
    "state_id": "5"
  },
  {
    "id": "465",
    "name": "Bariapur",
    "state_id": "5"
  },
  {
    "id": "466",
    "name": "Baruni",
    "state_id": "5"
  },
  {
    "id": "467",
    "name": "Begusarai",
    "state_id": "5"
  },
  {
    "id": "468",
    "name": "Behea",
    "state_id": "5"
  },
  {
    "id": "469",
    "name": "Belsand",
    "state_id": "5"
  },
  {
    "id": "470",
    "name": "Bettiah",
    "state_id": "5"
  },
  {
    "id": "471",
    "name": "Bhabua",
    "state_id": "5"
  },
  {
    "id": "472",
    "name": "Bhagalpur",
    "state_id": "5"
  },
  {
    "id": "473",
    "name": "Bhimnagar",
    "state_id": "5"
  },
  {
    "id": "474",
    "name": "Bhojpur",
    "state_id": "5"
  },
  {
    "id": "475",
    "name": "Bihar",
    "state_id": "5"
  },
  {
    "id": "476",
    "name": "Bihar Sharif",
    "state_id": "5"
  },
  {
    "id": "477",
    "name": "Bihariganj",
    "state_id": "5"
  },
  {
    "id": "478",
    "name": "Bikramganj",
    "state_id": "5"
  },
  {
    "id": "479",
    "name": "Birpur",
    "state_id": "5"
  },
  {
    "id": "480",
    "name": "Bodh Gaya",
    "state_id": "5"
  },
  {
    "id": "481",
    "name": "Buxar",
    "state_id": "5"
  },
  {
    "id": "482",
    "name": "Chakia",
    "state_id": "5"
  },
  {
    "id": "483",
    "name": "Chanpatia",
    "state_id": "5"
  },
  {
    "id": "484",
    "name": "Chhapra",
    "state_id": "5"
  },
  {
    "id": "485",
    "name": "Chhatapur",
    "state_id": "5"
  },
  {
    "id": "486",
    "name": "Colgong",
    "state_id": "5"
  },
  {
    "id": "487",
    "name": "Dalsingh Sarai",
    "state_id": "5"
  },
  {
    "id": "488",
    "name": "Darbhanga",
    "state_id": "5"
  },
  {
    "id": "489",
    "name": "Daudnagar",
    "state_id": "5"
  },
  {
    "id": "490",
    "name": "Dehri",
    "state_id": "5"
  },
  {
    "id": "491",
    "name": "Dhaka",
    "state_id": "5"
  },
  {
    "id": "492",
    "name": "Dighwara",
    "state_id": "5"
  },
  {
    "id": "493",
    "name": "Dinapur",
    "state_id": "5"
  },
  {
    "id": "494",
    "name": "Dinapur Cantonment",
    "state_id": "5"
  },
  {
    "id": "495",
    "name": "Dumra",
    "state_id": "5"
  },
  {
    "id": "496",
    "name": "Dumraon",
    "state_id": "5"
  },
  {
    "id": "497",
    "name": "Fatwa",
    "state_id": "5"
  },
  {
    "id": "498",
    "name": "Forbesganj",
    "state_id": "5"
  },
  {
    "id": "499",
    "name": "Gaya",
    "state_id": "5"
  },
  {
    "id": "500",
    "name": "Gazipur",
    "state_id": "5"
  },
  {
    "id": "501",
    "name": "Ghoghardiha",
    "state_id": "5"
  },
  {
    "id": "502",
    "name": "Gogri Jamalpur",
    "state_id": "5"
  },
  {
    "id": "503",
    "name": "Gopalganj",
    "state_id": "5"
  },
  {
    "id": "504",
    "name": "Habibpur",
    "state_id": "5"
  },
  {
    "id": "505",
    "name": "Hajipur",
    "state_id": "5"
  },
  {
    "id": "506",
    "name": "Hasanpur",
    "state_id": "5"
  },
  {
    "id": "507",
    "name": "Hazaribagh",
    "state_id": "5"
  },
  {
    "id": "508",
    "name": "Hilsa",
    "state_id": "5"
  },
  {
    "id": "509",
    "name": "Hisua",
    "state_id": "5"
  },
  {
    "id": "510",
    "name": "Islampur",
    "state_id": "5"
  },
  {
    "id": "511",
    "name": "Jagdispur",
    "state_id": "5"
  },
  {
    "id": "512",
    "name": "Jahanabad",
    "state_id": "5"
  },
  {
    "id": "513",
    "name": "Jamalpur",
    "state_id": "5"
  },
  {
    "id": "514",
    "name": "Jamhaur",
    "state_id": "5"
  },
  {
    "id": "515",
    "name": "Jamui",
    "state_id": "5"
  },
  {
    "id": "516",
    "name": "Janakpur Road",
    "state_id": "5"
  },
  {
    "id": "517",
    "name": "Janpur",
    "state_id": "5"
  },
  {
    "id": "518",
    "name": "Jaynagar",
    "state_id": "5"
  },
  {
    "id": "519",
    "name": "Jha Jha",
    "state_id": "5"
  },
  {
    "id": "520",
    "name": "Jhanjharpur",
    "state_id": "5"
  },
  {
    "id": "521",
    "name": "Jogbani",
    "state_id": "5"
  },
  {
    "id": "522",
    "name": "Kanti",
    "state_id": "5"
  },
  {
    "id": "523",
    "name": "Kasba",
    "state_id": "5"
  },
  {
    "id": "524",
    "name": "Kataiya",
    "state_id": "5"
  },
  {
    "id": "525",
    "name": "Katihar",
    "state_id": "5"
  },
  {
    "id": "526",
    "name": "Khagaria",
    "state_id": "5"
  },
  {
    "id": "527",
    "name": "Khagaul",
    "state_id": "5"
  },
  {
    "id": "528",
    "name": "Kharagpur",
    "state_id": "5"
  },
  {
    "id": "529",
    "name": "Khusrupur",
    "state_id": "5"
  },
  {
    "id": "530",
    "name": "Kishanganj",
    "state_id": "5"
  },
  {
    "id": "531",
    "name": "Koath",
    "state_id": "5"
  },
  {
    "id": "532",
    "name": "Koilwar",
    "state_id": "5"
  },
  {
    "id": "533",
    "name": "Lakhisarai",
    "state_id": "5"
  },
  {
    "id": "534",
    "name": "Lalganj",
    "state_id": "5"
  },
  {
    "id": "535",
    "name": "Lauthaha",
    "state_id": "5"
  },
  {
    "id": "536",
    "name": "Madhepura",
    "state_id": "5"
  },
  {
    "id": "537",
    "name": "Madhubani",
    "state_id": "5"
  },
  {
    "id": "538",
    "name": "Maharajganj",
    "state_id": "5"
  },
  {
    "id": "539",
    "name": "Mahnar Bazar",
    "state_id": "5"
  },
  {
    "id": "540",
    "name": "Mairwa",
    "state_id": "5"
  },
  {
    "id": "541",
    "name": "Makhdumpur",
    "state_id": "5"
  },
  {
    "id": "542",
    "name": "Maner",
    "state_id": "5"
  },
  {
    "id": "543",
    "name": "Manihari",
    "state_id": "5"
  },
  {
    "id": "544",
    "name": "Marhaura",
    "state_id": "5"
  },
  {
    "id": "545",
    "name": "Masaurhi",
    "state_id": "5"
  },
  {
    "id": "546",
    "name": "Mirganj",
    "state_id": "5"
  },
  {
    "id": "547",
    "name": "Mohiuddinagar",
    "state_id": "5"
  },
  {
    "id": "548",
    "name": "Mokama",
    "state_id": "5"
  },
  {
    "id": "549",
    "name": "Motihari",
    "state_id": "5"
  },
  {
    "id": "550",
    "name": "Motipur",
    "state_id": "5"
  },
  {
    "id": "551",
    "name": "Munger",
    "state_id": "5"
  },
  {
    "id": "552",
    "name": "Murliganj",
    "state_id": "5"
  },
  {
    "id": "553",
    "name": "Muzaffarpur",
    "state_id": "5"
  },
  {
    "id": "554",
    "name": "Nabinagar",
    "state_id": "5"
  },
  {
    "id": "555",
    "name": "Narkatiaganj",
    "state_id": "5"
  },
  {
    "id": "556",
    "name": "Nasriganj",
    "state_id": "5"
  },
  {
    "id": "557",
    "name": "Natwar",
    "state_id": "5"
  },
  {
    "id": "558",
    "name": "Naugachhia",
    "state_id": "5"
  },
  {
    "id": "559",
    "name": "Nawada",
    "state_id": "5"
  },
  {
    "id": "560",
    "name": "Nirmali",
    "state_id": "5"
  },
  {
    "id": "561",
    "name": "Nokha",
    "state_id": "5"
  },
  {
    "id": "562",
    "name": "Paharpur",
    "state_id": "5"
  },
  {
    "id": "563",
    "name": "Patna",
    "state_id": "5"
  },
  {
    "id": "564",
    "name": "Phulwari",
    "state_id": "5"
  },
  {
    "id": "565",
    "name": "Piro",
    "state_id": "5"
  },
  {
    "id": "566",
    "name": "Purnia",
    "state_id": "5"
  },
  {
    "id": "567",
    "name": "Pusa",
    "state_id": "5"
  },
  {
    "id": "568",
    "name": "Rafiganj",
    "state_id": "5"
  },
  {
    "id": "569",
    "name": "Raghunathpur",
    "state_id": "5"
  },
  {
    "id": "570",
    "name": "Rajgir",
    "state_id": "5"
  },
  {
    "id": "571",
    "name": "Ramnagar",
    "state_id": "5"
  },
  {
    "id": "572",
    "name": "Raxaul",
    "state_id": "5"
  },
  {
    "id": "573",
    "name": "Revelganj",
    "state_id": "5"
  },
  {
    "id": "574",
    "name": "Rusera",
    "state_id": "5"
  },
  {
    "id": "575",
    "name": "Sagauli",
    "state_id": "5"
  },
  {
    "id": "576",
    "name": "Saharsa",
    "state_id": "5"
  },
  {
    "id": "577",
    "name": "Samastipur",
    "state_id": "5"
  },
  {
    "id": "578",
    "name": "Sasaram",
    "state_id": "5"
  },
  {
    "id": "579",
    "name": "Shahpur",
    "state_id": "5"
  },
  {
    "id": "580",
    "name": "Shaikhpura",
    "state_id": "5"
  },
  {
    "id": "581",
    "name": "Sherghati",
    "state_id": "5"
  },
  {
    "id": "582",
    "name": "Shivhar",
    "state_id": "5"
  },
  {
    "id": "583",
    "name": "Silao",
    "state_id": "5"
  },
  {
    "id": "584",
    "name": "Sitamarhi",
    "state_id": "5"
  },
  {
    "id": "585",
    "name": "Siwan",
    "state_id": "5"
  },
  {
    "id": "586",
    "name": "Sonepur",
    "state_id": "5"
  },
  {
    "id": "587",
    "name": "Sultanganj",
    "state_id": "5"
  },
  {
    "id": "588",
    "name": "Supaul",
    "state_id": "5"
  },
  {
    "id": "589",
    "name": "Teghra",
    "state_id": "5"
  },
  {
    "id": "590",
    "name": "Tekari",
    "state_id": "5"
  },
  {
    "id": "591",
    "name": "Thakurganj",
    "state_id": "5"
  },
  {
    "id": "592",
    "name": "Vaishali",
    "state_id": "5"
  },
  {
    "id": "593",
    "name": "Waris Aliganj",
    "state_id": "5"
  },
  {
    "id": "594",
    "name": "Chandigarh",
    "state_id": "6"
  },
  {
    "id": "595",
    "name": "Ahiwara",
    "state_id": "7"
  },
  {
    "id": "596",
    "name": "Akaltara",
    "state_id": "7"
  },
  {
    "id": "597",
    "name": "Ambagarh Chauki",
    "state_id": "7"
  },
  {
    "id": "598",
    "name": "Ambikapur",
    "state_id": "7"
  },
  {
    "id": "599",
    "name": "Arang",
    "state_id": "7"
  },
  {
    "id": "600",
    "name": "Bade Bacheli",
    "state_id": "7"
  },
  {
    "id": "601",
    "name": "Bagbahara",
    "state_id": "7"
  },
  {
    "id": "602",
    "name": "Baikunthpur",
    "state_id": "7"
  },
  {
    "id": "603",
    "name": "Balod",
    "state_id": "7"
  },
  {
    "id": "604",
    "name": "Baloda",
    "state_id": "7"
  },
  {
    "id": "605",
    "name": "Baloda Bazar",
    "state_id": "7"
  },
  {
    "id": "606",
    "name": "Banarsi",
    "state_id": "7"
  },
  {
    "id": "607",
    "name": "Basna",
    "state_id": "7"
  },
  {
    "id": "608",
    "name": "Bemetra",
    "state_id": "7"
  },
  {
    "id": "609",
    "name": "Bhanpuri",
    "state_id": "7"
  },
  {
    "id": "610",
    "name": "Bhatapara",
    "state_id": "7"
  },
  {
    "id": "611",
    "name": "Bhatgaon",
    "state_id": "7"
  },
  {
    "id": "612",
    "name": "Bhilai",
    "state_id": "7"
  },
  {
    "id": "613",
    "name": "Bilaspur",
    "state_id": "7"
  },
  {
    "id": "614",
    "name": "Bilha",
    "state_id": "7"
  },
  {
    "id": "615",
    "name": "Birgaon",
    "state_id": "7"
  },
  {
    "id": "616",
    "name": "Bodri",
    "state_id": "7"
  },
  {
    "id": "617",
    "name": "Champa",
    "state_id": "7"
  },
  {
    "id": "618",
    "name": "Charcha",
    "state_id": "7"
  },
  {
    "id": "619",
    "name": "Charoda",
    "state_id": "7"
  },
  {
    "id": "620",
    "name": "Chhuikhadan",
    "state_id": "7"
  },
  {
    "id": "621",
    "name": "Chirmiri",
    "state_id": "7"
  },
  {
    "id": "622",
    "name": "Dantewada",
    "state_id": "7"
  },
  {
    "id": "623",
    "name": "Deori",
    "state_id": "7"
  },
  {
    "id": "624",
    "name": "Dhamdha",
    "state_id": "7"
  },
  {
    "id": "625",
    "name": "Dhamtari",
    "state_id": "7"
  },
  {
    "id": "626",
    "name": "Dharamjaigarh",
    "state_id": "7"
  },
  {
    "id": "627",
    "name": "Dipka",
    "state_id": "7"
  },
  {
    "id": "628",
    "name": "Doman Hill Colliery",
    "state_id": "7"
  },
  {
    "id": "629",
    "name": "Dongargaon",
    "state_id": "7"
  },
  {
    "id": "630",
    "name": "Dongragarh",
    "state_id": "7"
  },
  {
    "id": "631",
    "name": "Durg",
    "state_id": "7"
  },
  {
    "id": "632",
    "name": "Frezarpur",
    "state_id": "7"
  },
  {
    "id": "633",
    "name": "Gandai",
    "state_id": "7"
  },
  {
    "id": "634",
    "name": "Gariaband",
    "state_id": "7"
  },
  {
    "id": "635",
    "name": "Gaurela",
    "state_id": "7"
  },
  {
    "id": "636",
    "name": "Gelhapani",
    "state_id": "7"
  },
  {
    "id": "637",
    "name": "Gharghoda",
    "state_id": "7"
  },
  {
    "id": "638",
    "name": "Gidam",
    "state_id": "7"
  },
  {
    "id": "639",
    "name": "Gobra Nawapara",
    "state_id": "7"
  },
  {
    "id": "640",
    "name": "Gogaon",
    "state_id": "7"
  },
  {
    "id": "641",
    "name": "Hatkachora",
    "state_id": "7"
  },
  {
    "id": "642",
    "name": "Jagdalpur",
    "state_id": "7"
  },
  {
    "id": "643",
    "name": "Jamui",
    "state_id": "7"
  },
  {
    "id": "644",
    "name": "Jashpurnagar",
    "state_id": "7"
  },
  {
    "id": "645",
    "name": "Jhagrakhand",
    "state_id": "7"
  },
  {
    "id": "646",
    "name": "Kanker",
    "state_id": "7"
  },
  {
    "id": "647",
    "name": "Katghora",
    "state_id": "7"
  },
  {
    "id": "648",
    "name": "Kawardha",
    "state_id": "7"
  },
  {
    "id": "649",
    "name": "Khairagarh",
    "state_id": "7"
  },
  {
    "id": "650",
    "name": "Khamhria",
    "state_id": "7"
  },
  {
    "id": "651",
    "name": "Kharod",
    "state_id": "7"
  },
  {
    "id": "652",
    "name": "Kharsia",
    "state_id": "7"
  },
  {
    "id": "653",
    "name": "Khonga Pani",
    "state_id": "7"
  },
  {
    "id": "654",
    "name": "Kirandu",
    "state_id": "7"
  },
  {
    "id": "655",
    "name": "Kirandul",
    "state_id": "7"
  },
  {
    "id": "656",
    "name": "Kohka",
    "state_id": "7"
  },
  {
    "id": "657",
    "name": "Kondagaon",
    "state_id": "7"
  },
  {
    "id": "658",
    "name": "Korba",
    "state_id": "7"
  },
  {
    "id": "659",
    "name": "Korea",
    "state_id": "7"
  },
  {
    "id": "660",
    "name": "Koria Block",
    "state_id": "7"
  },
  {
    "id": "661",
    "name": "Kota",
    "state_id": "7"
  },
  {
    "id": "662",
    "name": "Kumhari",
    "state_id": "7"
  },
  {
    "id": "663",
    "name": "Kumud Katta",
    "state_id": "7"
  },
  {
    "id": "664",
    "name": "Kurasia",
    "state_id": "7"
  },
  {
    "id": "665",
    "name": "Kurud",
    "state_id": "7"
  },
  {
    "id": "666",
    "name": "Lingiyadih",
    "state_id": "7"
  },
  {
    "id": "667",
    "name": "Lormi",
    "state_id": "7"
  },
  {
    "id": "668",
    "name": "Mahasamund",
    "state_id": "7"
  },
  {
    "id": "669",
    "name": "Mahendragarh",
    "state_id": "7"
  },
  {
    "id": "670",
    "name": "Mehmand",
    "state_id": "7"
  },
  {
    "id": "671",
    "name": "Mongra",
    "state_id": "7"
  },
  {
    "id": "672",
    "name": "Mowa",
    "state_id": "7"
  },
  {
    "id": "673",
    "name": "Mungeli",
    "state_id": "7"
  },
  {
    "id": "674",
    "name": "Nailajanjgir",
    "state_id": "7"
  },
  {
    "id": "675",
    "name": "Namna Kalan",
    "state_id": "7"
  },
  {
    "id": "676",
    "name": "Naya Baradwar",
    "state_id": "7"
  },
  {
    "id": "677",
    "name": "Pandariya",
    "state_id": "7"
  },
  {
    "id": "678",
    "name": "Patan",
    "state_id": "7"
  },
  {
    "id": "679",
    "name": "Pathalgaon",
    "state_id": "7"
  },
  {
    "id": "680",
    "name": "Pendra",
    "state_id": "7"
  },
  {
    "id": "681",
    "name": "Phunderdihari",
    "state_id": "7"
  },
  {
    "id": "682",
    "name": "Pithora",
    "state_id": "7"
  },
  {
    "id": "683",
    "name": "Raigarh",
    "state_id": "7"
  },
  {
    "id": "684",
    "name": "Raipur",
    "state_id": "7"
  },
  {
    "id": "685",
    "name": "Rajgamar",
    "state_id": "7"
  },
  {
    "id": "686",
    "name": "Rajhara",
    "state_id": "7"
  },
  {
    "id": "687",
    "name": "Rajnandgaon",
    "state_id": "7"
  },
  {
    "id": "688",
    "name": "Ramanuj Ganj",
    "state_id": "7"
  },
  {
    "id": "689",
    "name": "Ratanpur",
    "state_id": "7"
  },
  {
    "id": "690",
    "name": "Sakti",
    "state_id": "7"
  },
  {
    "id": "691",
    "name": "Saraipali",
    "state_id": "7"
  },
  {
    "id": "692",
    "name": "Sarajpur",
    "state_id": "7"
  },
  {
    "id": "693",
    "name": "Sarangarh",
    "state_id": "7"
  },
  {
    "id": "694",
    "name": "Shivrinarayan",
    "state_id": "7"
  },
  {
    "id": "695",
    "name": "Simga",
    "state_id": "7"
  },
  {
    "id": "696",
    "name": "Sirgiti",
    "state_id": "7"
  },
  {
    "id": "697",
    "name": "Takhatpur",
    "state_id": "7"
  },
  {
    "id": "698",
    "name": "Telgaon",
    "state_id": "7"
  },
  {
    "id": "699",
    "name": "Tildanewra",
    "state_id": "7"
  },
  {
    "id": "700",
    "name": "Urla",
    "state_id": "7"
  },
  {
    "id": "701",
    "name": "Vishrampur",
    "state_id": "7"
  },
  {
    "id": "702",
    "name": "Amli",
    "state_id": "8"
  },
  {
    "id": "703",
    "name": "Silvassa",
    "state_id": "8"
  },
  {
    "id": "704",
    "name": "Daman",
    "state_id": "9"
  },
  {
    "id": "705",
    "name": "Diu",
    "state_id": "9"
  },
  {
    "id": "706",
    "name": "Delhi",
    "state_id": "10"
  },
  {
    "id": "707",
    "name": "New Delhi",
    "state_id": "10"
  },
  {
    "id": "708",
    "name": "Aldona",
    "state_id": "11"
  },
  {
    "id": "709",
    "name": "Altinho",
    "state_id": "11"
  },
  {
    "id": "710",
    "name": "Aquem",
    "state_id": "11"
  },
  {
    "id": "711",
    "name": "Arpora",
    "state_id": "11"
  },
  {
    "id": "712",
    "name": "Bambolim",
    "state_id": "11"
  },
  {
    "id": "713",
    "name": "Bandora",
    "state_id": "11"
  },
  {
    "id": "714",
    "name": "Bardez",
    "state_id": "11"
  },
  {
    "id": "715",
    "name": "Benaulim",
    "state_id": "11"
  },
  {
    "id": "716",
    "name": "Betora",
    "state_id": "11"
  },
  {
    "id": "717",
    "name": "Bicholim",
    "state_id": "11"
  },
  {
    "id": "718",
    "name": "Calapor",
    "state_id": "11"
  },
  {
    "id": "719",
    "name": "Candolim",
    "state_id": "11"
  },
  {
    "id": "720",
    "name": "Caranzalem",
    "state_id": "11"
  },
  {
    "id": "721",
    "name": "Carapur",
    "state_id": "11"
  },
  {
    "id": "722",
    "name": "Chicalim",
    "state_id": "11"
  },
  {
    "id": "723",
    "name": "Chimbel",
    "state_id": "11"
  },
  {
    "id": "724",
    "name": "Chinchinim",
    "state_id": "11"
  },
  {
    "id": "725",
    "name": "Colvale",
    "state_id": "11"
  },
  {
    "id": "726",
    "name": "Corlim",
    "state_id": "11"
  },
  {
    "id": "727",
    "name": "Cortalim",
    "state_id": "11"
  },
  {
    "id": "728",
    "name": "Cuncolim",
    "state_id": "11"
  },
  {
    "id": "729",
    "name": "Curchorem",
    "state_id": "11"
  },
  {
    "id": "730",
    "name": "Curti",
    "state_id": "11"
  },
  {
    "id": "731",
    "name": "Davorlim",
    "state_id": "11"
  },
  {
    "id": "732",
    "name": "Dona Paula",
    "state_id": "11"
  },
  {
    "id": "733",
    "name": "Goa",
    "state_id": "11"
  },
  {
    "id": "734",
    "name": "Guirim",
    "state_id": "11"
  },
  {
    "id": "735",
    "name": "Jua",
    "state_id": "11"
  },
  {
    "id": "736",
    "name": "Kalangat",
    "state_id": "11"
  },
  {
    "id": "737",
    "name": "Kankon",
    "state_id": "11"
  },
  {
    "id": "738",
    "name": "Kundaim",
    "state_id": "11"
  },
  {
    "id": "739",
    "name": "Loutulim",
    "state_id": "11"
  },
  {
    "id": "740",
    "name": "Madgaon",
    "state_id": "11"
  },
  {
    "id": "741",
    "name": "Mapusa",
    "state_id": "11"
  },
  {
    "id": "742",
    "name": "Margao",
    "state_id": "11"
  },
  {
    "id": "743",
    "name": "Margaon",
    "state_id": "11"
  },
  {
    "id": "744",
    "name": "Miramar",
    "state_id": "11"
  },
  {
    "id": "745",
    "name": "Morjim",
    "state_id": "11"
  },
  {
    "id": "746",
    "name": "Mormugao",
    "state_id": "11"
  },
  {
    "id": "747",
    "name": "Navelim",
    "state_id": "11"
  },
  {
    "id": "748",
    "name": "Pale",
    "state_id": "11"
  },
  {
    "id": "749",
    "name": "Panaji",
    "state_id": "11"
  },
  {
    "id": "750",
    "name": "Parcem",
    "state_id": "11"
  },
  {
    "id": "751",
    "name": "Parra",
    "state_id": "11"
  },
  {
    "id": "752",
    "name": "Penha de Franca",
    "state_id": "11"
  },
  {
    "id": "753",
    "name": "Pernem",
    "state_id": "11"
  },
  {
    "id": "754",
    "name": "Pilerne",
    "state_id": "11"
  },
  {
    "id": "755",
    "name": "Pissurlem",
    "state_id": "11"
  },
  {
    "id": "756",
    "name": "Ponda",
    "state_id": "11"
  },
  {
    "id": "757",
    "name": "Porvorim",
    "state_id": "11"
  },
  {
    "id": "758",
    "name": "Quepem",
    "state_id": "11"
  },
  {
    "id": "759",
    "name": "Queula",
    "state_id": "11"
  },
  {
    "id": "760",
    "name": "Raia",
    "state_id": "11"
  },
  {
    "id": "761",
    "name": "Reis Magos",
    "state_id": "11"
  },
  {
    "id": "762",
    "name": "Salcette",
    "state_id": "11"
  },
  {
    "id": "763",
    "name": "Saligao",
    "state_id": "11"
  },
  {
    "id": "764",
    "name": "Sancoale",
    "state_id": "11"
  },
  {
    "id": "765",
    "name": "Sanguem",
    "state_id": "11"
  },
  {
    "id": "766",
    "name": "Sanquelim",
    "state_id": "11"
  },
  {
    "id": "767",
    "name": "Sanvordem",
    "state_id": "11"
  },
  {
    "id": "768",
    "name": "Sao Jose-de-Areal",
    "state_id": "11"
  },
  {
    "id": "769",
    "name": "Sattari",
    "state_id": "11"
  },
  {
    "id": "770",
    "name": "Serula",
    "state_id": "11"
  },
  {
    "id": "771",
    "name": "Sinquerim",
    "state_id": "11"
  },
  {
    "id": "772",
    "name": "Siolim",
    "state_id": "11"
  },
  {
    "id": "773",
    "name": "Taleigao",
    "state_id": "11"
  },
  {
    "id": "774",
    "name": "Tivim",
    "state_id": "11"
  },
  {
    "id": "775",
    "name": "Valpoi",
    "state_id": "11"
  },
  {
    "id": "776",
    "name": "Varca",
    "state_id": "11"
  },
  {
    "id": "777",
    "name": "Vasco",
    "state_id": "11"
  },
  {
    "id": "778",
    "name": "Verna",
    "state_id": "11"
  },
  {
    "id": "779",
    "name": "Abrama",
    "state_id": "12"
  },
  {
    "id": "780",
    "name": "Adalaj",
    "state_id": "12"
  },
  {
    "id": "781",
    "name": "Adityana",
    "state_id": "12"
  },
  {
    "id": "782",
    "name": "Advana",
    "state_id": "12"
  },
  {
    "id": "783",
    "name": "Ahmedabad",
    "state_id": "12"
  },
  {
    "id": "784",
    "name": "Ahwa",
    "state_id": "12"
  },
  {
    "id": "785",
    "name": "Alang",
    "state_id": "12"
  },
  {
    "id": "786",
    "name": "Ambaji",
    "state_id": "12"
  },
  {
    "id": "787",
    "name": "Ambaliyasan",
    "state_id": "12"
  },
  {
    "id": "788",
    "name": "Amod",
    "state_id": "12"
  },
  {
    "id": "789",
    "name": "Amreli",
    "state_id": "12"
  },
  {
    "id": "790",
    "name": "Amroli",
    "state_id": "12"
  },
  {
    "id": "791",
    "name": "Anand",
    "state_id": "12"
  },
  {
    "id": "792",
    "name": "Andada",
    "state_id": "12"
  },
  {
    "id": "793",
    "name": "Anjar",
    "state_id": "12"
  },
  {
    "id": "794",
    "name": "Anklav",
    "state_id": "12"
  },
  {
    "id": "795",
    "name": "Ankleshwar",
    "state_id": "12"
  },
  {
    "id": "796",
    "name": "Anklesvar INA",
    "state_id": "12"
  },
  {
    "id": "797",
    "name": "Antaliya",
    "state_id": "12"
  },
  {
    "id": "798",
    "name": "Arambhada",
    "state_id": "12"
  },
  {
    "id": "799",
    "name": "Asarma",
    "state_id": "12"
  },
  {
    "id": "800",
    "name": "Atul",
    "state_id": "12"
  },
  {
    "id": "801",
    "name": "Babra",
    "state_id": "12"
  },
  {
    "id": "802",
    "name": "Bag-e-Firdosh",
    "state_id": "12"
  },
  {
    "id": "803",
    "name": "Bagasara",
    "state_id": "12"
  },
  {
    "id": "804",
    "name": "Bahadarpar",
    "state_id": "12"
  },
  {
    "id": "805",
    "name": "Bajipura",
    "state_id": "12"
  },
  {
    "id": "806",
    "name": "Bajva",
    "state_id": "12"
  },
  {
    "id": "807",
    "name": "Balasinor",
    "state_id": "12"
  },
  {
    "id": "808",
    "name": "Banaskantha",
    "state_id": "12"
  },
  {
    "id": "809",
    "name": "Bansda",
    "state_id": "12"
  },
  {
    "id": "810",
    "name": "Bantva",
    "state_id": "12"
  },
  {
    "id": "811",
    "name": "Bardoli",
    "state_id": "12"
  },
  {
    "id": "812",
    "name": "Barwala",
    "state_id": "12"
  },
  {
    "id": "813",
    "name": "Bayad",
    "state_id": "12"
  },
  {
    "id": "814",
    "name": "Bechar",
    "state_id": "12"
  },
  {
    "id": "815",
    "name": "Bedi",
    "state_id": "12"
  },
  {
    "id": "816",
    "name": "Beyt",
    "state_id": "12"
  },
  {
    "id": "817",
    "name": "Bhachau",
    "state_id": "12"
  },
  {
    "id": "818",
    "name": "Bhanvad",
    "state_id": "12"
  },
  {
    "id": "819",
    "name": "Bharuch",
    "state_id": "12"
  },
  {
    "id": "820",
    "name": "Bharuch INA",
    "state_id": "12"
  },
  {
    "id": "821",
    "name": "Bhavnagar",
    "state_id": "12"
  },
  {
    "id": "822",
    "name": "Bhayavadar",
    "state_id": "12"
  },
  {
    "id": "823",
    "name": "Bhestan",
    "state_id": "12"
  },
  {
    "id": "824",
    "name": "Bhuj",
    "state_id": "12"
  },
  {
    "id": "825",
    "name": "Bilimora",
    "state_id": "12"
  },
  {
    "id": "826",
    "name": "Bilkha",
    "state_id": "12"
  },
  {
    "id": "827",
    "name": "Billimora",
    "state_id": "12"
  },
  {
    "id": "828",
    "name": "Bodakdev",
    "state_id": "12"
  },
  {
    "id": "829",
    "name": "Bodeli",
    "state_id": "12"
  },
  {
    "id": "830",
    "name": "Bopal",
    "state_id": "12"
  },
  {
    "id": "831",
    "name": "Boria",
    "state_id": "12"
  },
  {
    "id": "832",
    "name": "Boriavi",
    "state_id": "12"
  },
  {
    "id": "833",
    "name": "Borsad",
    "state_id": "12"
  },
  {
    "id": "834",
    "name": "Botad",
    "state_id": "12"
  },
  {
    "id": "835",
    "name": "Cambay",
    "state_id": "12"
  },
  {
    "id": "836",
    "name": "Chaklasi",
    "state_id": "12"
  },
  {
    "id": "837",
    "name": "Chala",
    "state_id": "12"
  },
  {
    "id": "838",
    "name": "Chalala",
    "state_id": "12"
  },
  {
    "id": "839",
    "name": "Chalthan",
    "state_id": "12"
  },
  {
    "id": "840",
    "name": "Chanasma",
    "state_id": "12"
  },
  {
    "id": "841",
    "name": "Chandisar",
    "state_id": "12"
  },
  {
    "id": "842",
    "name": "Chandkheda",
    "state_id": "12"
  },
  {
    "id": "843",
    "name": "Chanod",
    "state_id": "12"
  },
  {
    "id": "844",
    "name": "Chaya",
    "state_id": "12"
  },
  {
    "id": "845",
    "name": "Chenpur",
    "state_id": "12"
  },
  {
    "id": "846",
    "name": "Chhapi",
    "state_id": "12"
  },
  {
    "id": "847",
    "name": "Chhaprabhatha",
    "state_id": "12"
  },
  {
    "id": "848",
    "name": "Chhatral",
    "state_id": "12"
  },
  {
    "id": "849",
    "name": "Chhota Udepur",
    "state_id": "12"
  },
  {
    "id": "850",
    "name": "Chikhli",
    "state_id": "12"
  },
  {
    "id": "851",
    "name": "Chiloda",
    "state_id": "12"
  },
  {
    "id": "852",
    "name": "Chorvad",
    "state_id": "12"
  },
  {
    "id": "853",
    "name": "Chotila",
    "state_id": "12"
  },
  {
    "id": "854",
    "name": "Dabhoi",
    "state_id": "12"
  },
  {
    "id": "855",
    "name": "Dadara",
    "state_id": "12"
  },
  {
    "id": "856",
    "name": "Dahod",
    "state_id": "12"
  },
  {
    "id": "857",
    "name": "Dakor",
    "state_id": "12"
  },
  {
    "id": "858",
    "name": "Damnagar",
    "state_id": "12"
  },
  {
    "id": "859",
    "name": "Deesa",
    "state_id": "12"
  },
  {
    "id": "860",
    "name": "Delvada",
    "state_id": "12"
  },
  {
    "id": "861",
    "name": "Devgadh Baria",
    "state_id": "12"
  },
  {
    "id": "862",
    "name": "Devsar",
    "state_id": "12"
  },
  {
    "id": "863",
    "name": "Dhandhuka",
    "state_id": "12"
  },
  {
    "id": "864",
    "name": "Dhanera",
    "state_id": "12"
  },
  {
    "id": "865",
    "name": "Dhangdhra",
    "state_id": "12"
  },
  {
    "id": "866",
    "name": "Dhansura",
    "state_id": "12"
  },
  {
    "id": "867",
    "name": "Dharampur",
    "state_id": "12"
  },
  {
    "id": "868",
    "name": "Dhari",
    "state_id": "12"
  },
  {
    "id": "869",
    "name": "Dhola",
    "state_id": "12"
  },
  {
    "id": "870",
    "name": "Dholka",
    "state_id": "12"
  },
  {
    "id": "871",
    "name": "Dholka Rural",
    "state_id": "12"
  },
  {
    "id": "872",
    "name": "Dhoraji",
    "state_id": "12"
  },
  {
    "id": "873",
    "name": "Dhrangadhra",
    "state_id": "12"
  },
  {
    "id": "874",
    "name": "Dhrol",
    "state_id": "12"
  },
  {
    "id": "875",
    "name": "Dhuva",
    "state_id": "12"
  },
  {
    "id": "876",
    "name": "Dhuwaran",
    "state_id": "12"
  },
  {
    "id": "877",
    "name": "Digvijaygram",
    "state_id": "12"
  },
  {
    "id": "878",
    "name": "Disa",
    "state_id": "12"
  },
  {
    "id": "879",
    "name": "Dungar",
    "state_id": "12"
  },
  {
    "id": "880",
    "name": "Dungarpur",
    "state_id": "12"
  },
  {
    "id": "881",
    "name": "Dungra",
    "state_id": "12"
  },
  {
    "id": "882",
    "name": "Dwarka",
    "state_id": "12"
  },
  {
    "id": "883",
    "name": "Flelanganj",
    "state_id": "12"
  },
  {
    "id": "884",
    "name": "GSFC Complex",
    "state_id": "12"
  },
  {
    "id": "885",
    "name": "Gadhda",
    "state_id": "12"
  },
  {
    "id": "886",
    "name": "Gandevi",
    "state_id": "12"
  },
  {
    "id": "887",
    "name": "Gandhidham",
    "state_id": "12"
  },
  {
    "id": "888",
    "name": "Gandhinagar",
    "state_id": "12"
  },
  {
    "id": "889",
    "name": "Gariadhar",
    "state_id": "12"
  },
  {
    "id": "890",
    "name": "Ghogha",
    "state_id": "12"
  },
  {
    "id": "891",
    "name": "Godhra",
    "state_id": "12"
  },
  {
    "id": "892",
    "name": "Gondal",
    "state_id": "12"
  },
  {
    "id": "893",
    "name": "Hajira INA",
    "state_id": "12"
  },
  {
    "id": "894",
    "name": "Halol",
    "state_id": "12"
  },
  {
    "id": "895",
    "name": "Halvad",
    "state_id": "12"
  },
  {
    "id": "896",
    "name": "Hansot",
    "state_id": "12"
  },
  {
    "id": "897",
    "name": "Harij",
    "state_id": "12"
  },
  {
    "id": "898",
    "name": "Himatnagar",
    "state_id": "12"
  },
  {
    "id": "899",
    "name": "Ichchhapor",
    "state_id": "12"
  },
  {
    "id": "900",
    "name": "Idar",
    "state_id": "12"
  },
  {
    "id": "901",
    "name": "Jafrabad",
    "state_id": "12"
  },
  {
    "id": "902",
    "name": "Jalalpore",
    "state_id": "12"
  },
  {
    "id": "903",
    "name": "Jambusar",
    "state_id": "12"
  },
  {
    "id": "904",
    "name": "Jamjodhpur",
    "state_id": "12"
  },
  {
    "id": "905",
    "name": "Jamnagar",
    "state_id": "12"
  },
  {
    "id": "906",
    "name": "Jasdan",
    "state_id": "12"
  },
  {
    "id": "907",
    "name": "Jawaharnagar",
    "state_id": "12"
  },
  {
    "id": "908",
    "name": "Jetalsar",
    "state_id": "12"
  },
  {
    "id": "909",
    "name": "Jetpur",
    "state_id": "12"
  },
  {
    "id": "910",
    "name": "Jodiya",
    "state_id": "12"
  },
  {
    "id": "911",
    "name": "Joshipura",
    "state_id": "12"
  },
  {
    "id": "912",
    "name": "Junagadh",
    "state_id": "12"
  },
  {
    "id": "913",
    "name": "Kadi",
    "state_id": "12"
  },
  {
    "id": "914",
    "name": "Kadodara",
    "state_id": "12"
  },
  {
    "id": "915",
    "name": "Kalavad",
    "state_id": "12"
  },
  {
    "id": "916",
    "name": "Kali",
    "state_id": "12"
  },
  {
    "id": "917",
    "name": "Kaliawadi",
    "state_id": "12"
  },
  {
    "id": "918",
    "name": "Kalol",
    "state_id": "12"
  },
  {
    "id": "919",
    "name": "Kalol INA",
    "state_id": "12"
  },
  {
    "id": "920",
    "name": "Kandla",
    "state_id": "12"
  },
  {
    "id": "921",
    "name": "Kanjari",
    "state_id": "12"
  },
  {
    "id": "922",
    "name": "Kanodar",
    "state_id": "12"
  },
  {
    "id": "923",
    "name": "Kapadwanj",
    "state_id": "12"
  },
  {
    "id": "924",
    "name": "Karachiya",
    "state_id": "12"
  },
  {
    "id": "925",
    "name": "Karamsad",
    "state_id": "12"
  },
  {
    "id": "926",
    "name": "Karjan",
    "state_id": "12"
  },
  {
    "id": "927",
    "name": "Kathial",
    "state_id": "12"
  },
  {
    "id": "928",
    "name": "Kathor",
    "state_id": "12"
  },
  {
    "id": "929",
    "name": "Katpar",
    "state_id": "12"
  },
  {
    "id": "930",
    "name": "Kavant",
    "state_id": "12"
  },
  {
    "id": "931",
    "name": "Keshod",
    "state_id": "12"
  },
  {
    "id": "932",
    "name": "Kevadiya",
    "state_id": "12"
  },
  {
    "id": "933",
    "name": "Khambhaliya",
    "state_id": "12"
  },
  {
    "id": "934",
    "name": "Khambhat",
    "state_id": "12"
  },
  {
    "id": "935",
    "name": "Kharaghoda",
    "state_id": "12"
  },
  {
    "id": "936",
    "name": "Khed Brahma",
    "state_id": "12"
  },
  {
    "id": "937",
    "name": "Kheda",
    "state_id": "12"
  },
  {
    "id": "938",
    "name": "Kheralu",
    "state_id": "12"
  },
  {
    "id": "939",
    "name": "Kodinar",
    "state_id": "12"
  },
  {
    "id": "940",
    "name": "Kosamba",
    "state_id": "12"
  },
  {
    "id": "941",
    "name": "Kundla",
    "state_id": "12"
  },
  {
    "id": "942",
    "name": "Kutch",
    "state_id": "12"
  },
  {
    "id": "943",
    "name": "Kutiyana",
    "state_id": "12"
  },
  {
    "id": "944",
    "name": "Lakhtar",
    "state_id": "12"
  },
  {
    "id": "945",
    "name": "Lalpur",
    "state_id": "12"
  },
  {
    "id": "946",
    "name": "Lambha",
    "state_id": "12"
  },
  {
    "id": "947",
    "name": "Lathi",
    "state_id": "12"
  },
  {
    "id": "948",
    "name": "Limbdi",
    "state_id": "12"
  },
  {
    "id": "949",
    "name": "Limla",
    "state_id": "12"
  },
  {
    "id": "950",
    "name": "Lunavada",
    "state_id": "12"
  },
  {
    "id": "951",
    "name": "Madhapar",
    "state_id": "12"
  },
  {
    "id": "952",
    "name": "Maflipur",
    "state_id": "12"
  },
  {
    "id": "953",
    "name": "Mahemdavad",
    "state_id": "12"
  },
  {
    "id": "954",
    "name": "Mahudha",
    "state_id": "12"
  },
  {
    "id": "955",
    "name": "Mahuva",
    "state_id": "12"
  },
  {
    "id": "956",
    "name": "Mahuvar",
    "state_id": "12"
  },
  {
    "id": "957",
    "name": "Makarba",
    "state_id": "12"
  },
  {
    "id": "958",
    "name": "Makarpura",
    "state_id": "12"
  },
  {
    "id": "959",
    "name": "Makassar",
    "state_id": "12"
  },
  {
    "id": "960",
    "name": "Maktampur",
    "state_id": "12"
  },
  {
    "id": "961",
    "name": "Malia",
    "state_id": "12"
  },
  {
    "id": "962",
    "name": "Malpur",
    "state_id": "12"
  },
  {
    "id": "963",
    "name": "Manavadar",
    "state_id": "12"
  },
  {
    "id": "964",
    "name": "Mandal",
    "state_id": "12"
  },
  {
    "id": "965",
    "name": "Mandvi",
    "state_id": "12"
  },
  {
    "id": "966",
    "name": "Mangrol",
    "state_id": "12"
  },
  {
    "id": "967",
    "name": "Mansa",
    "state_id": "12"
  },
  {
    "id": "968",
    "name": "Meghraj",
    "state_id": "12"
  },
  {
    "id": "969",
    "name": "Mehsana",
    "state_id": "12"
  },
  {
    "id": "970",
    "name": "Mendarla",
    "state_id": "12"
  },
  {
    "id": "971",
    "name": "Mithapur",
    "state_id": "12"
  },
  {
    "id": "972",
    "name": "Modasa",
    "state_id": "12"
  },
  {
    "id": "973",
    "name": "Mogravadi",
    "state_id": "12"
  },
  {
    "id": "974",
    "name": "Morbi",
    "state_id": "12"
  },
  {
    "id": "975",
    "name": "Morvi",
    "state_id": "12"
  },
  {
    "id": "976",
    "name": "Mundra",
    "state_id": "12"
  },
  {
    "id": "977",
    "name": "Nadiad",
    "state_id": "12"
  },
  {
    "id": "978",
    "name": "Naliya",
    "state_id": "12"
  },
  {
    "id": "979",
    "name": "Nanakvada",
    "state_id": "12"
  },
  {
    "id": "980",
    "name": "Nandej",
    "state_id": "12"
  },
  {
    "id": "981",
    "name": "Nandesari",
    "state_id": "12"
  },
  {
    "id": "982",
    "name": "Nandesari INA",
    "state_id": "12"
  },
  {
    "id": "983",
    "name": "Naroda",
    "state_id": "12"
  },
  {
    "id": "984",
    "name": "Navagadh",
    "state_id": "12"
  },
  {
    "id": "985",
    "name": "Navagam Ghed",
    "state_id": "12"
  },
  {
    "id": "986",
    "name": "Navsari",
    "state_id": "12"
  },
  {
    "id": "987",
    "name": "Ode",
    "state_id": "12"
  },
  {
    "id": "988",
    "name": "Okaf",
    "state_id": "12"
  },
  {
    "id": "989",
    "name": "Okha",
    "state_id": "12"
  },
  {
    "id": "990",
    "name": "Olpad",
    "state_id": "12"
  },
  {
    "id": "991",
    "name": "Paddhari",
    "state_id": "12"
  },
  {
    "id": "992",
    "name": "Padra",
    "state_id": "12"
  },
  {
    "id": "993",
    "name": "Palanpur",
    "state_id": "12"
  },
  {
    "id": "994",
    "name": "Palej",
    "state_id": "12"
  },
  {
    "id": "995",
    "name": "Pali",
    "state_id": "12"
  },
  {
    "id": "996",
    "name": "Palitana",
    "state_id": "12"
  },
  {
    "id": "997",
    "name": "Paliyad",
    "state_id": "12"
  },
  {
    "id": "998",
    "name": "Pandesara",
    "state_id": "12"
  },
  {
    "id": "999",
    "name": "Panoli",
    "state_id": "12"
  },
  {
    "id": "1000",
    "name": "Pardi",
    "state_id": "12"
  },
  {
    "id": "1001",
    "name": "Parnera",
    "state_id": "12"
  },
  {
    "id": "1002",
    "name": "Parvat",
    "state_id": "12"
  },
  {
    "id": "1003",
    "name": "Patan",
    "state_id": "12"
  },
  {
    "id": "1004",
    "name": "Patdi",
    "state_id": "12"
  },
  {
    "id": "1005",
    "name": "Petlad",
    "state_id": "12"
  },
  {
    "id": "1006",
    "name": "Petrochemical Complex",
    "state_id": "12"
  },
  {
    "id": "1007",
    "name": "Porbandar",
    "state_id": "12"
  },
  {
    "id": "1008",
    "name": "Prantij",
    "state_id": "12"
  },
  {
    "id": "1009",
    "name": "Radhanpur",
    "state_id": "12"
  },
  {
    "id": "1010",
    "name": "Raiya",
    "state_id": "12"
  },
  {
    "id": "1011",
    "name": "Rajkot",
    "state_id": "12"
  },
  {
    "id": "1012",
    "name": "Rajpipla",
    "state_id": "12"
  },
  {
    "id": "1013",
    "name": "Rajula",
    "state_id": "12"
  },
  {
    "id": "1014",
    "name": "Ramod",
    "state_id": "12"
  },
  {
    "id": "1015",
    "name": "Ranavav",
    "state_id": "12"
  },
  {
    "id": "1016",
    "name": "Ranoli",
    "state_id": "12"
  },
  {
    "id": "1017",
    "name": "Rapar",
    "state_id": "12"
  },
  {
    "id": "1018",
    "name": "Sahij",
    "state_id": "12"
  },
  {
    "id": "1019",
    "name": "Salaya",
    "state_id": "12"
  },
  {
    "id": "1020",
    "name": "Sanand",
    "state_id": "12"
  },
  {
    "id": "1021",
    "name": "Sankheda",
    "state_id": "12"
  },
  {
    "id": "1022",
    "name": "Santrampur",
    "state_id": "12"
  },
  {
    "id": "1023",
    "name": "Saribujrang",
    "state_id": "12"
  },
  {
    "id": "1024",
    "name": "Sarigam INA",
    "state_id": "12"
  },
  {
    "id": "1025",
    "name": "Sayan",
    "state_id": "12"
  },
  {
    "id": "1026",
    "name": "Sayla",
    "state_id": "12"
  },
  {
    "id": "1027",
    "name": "Shahpur",
    "state_id": "12"
  },
  {
    "id": "1028",
    "name": "Shahwadi",
    "state_id": "12"
  },
  {
    "id": "1029",
    "name": "Shapar",
    "state_id": "12"
  },
  {
    "id": "1030",
    "name": "Shivrajpur",
    "state_id": "12"
  },
  {
    "id": "1031",
    "name": "Siddhapur",
    "state_id": "12"
  },
  {
    "id": "1032",
    "name": "Sidhpur",
    "state_id": "12"
  },
  {
    "id": "1033",
    "name": "Sihor",
    "state_id": "12"
  },
  {
    "id": "1034",
    "name": "Sika",
    "state_id": "12"
  },
  {
    "id": "1035",
    "name": "Singarva",
    "state_id": "12"
  },
  {
    "id": "1036",
    "name": "Sinor",
    "state_id": "12"
  },
  {
    "id": "1037",
    "name": "Sojitra",
    "state_id": "12"
  },
  {
    "id": "1038",
    "name": "Sola",
    "state_id": "12"
  },
  {
    "id": "1039",
    "name": "Songadh",
    "state_id": "12"
  },
  {
    "id": "1040",
    "name": "Suraj Karadi",
    "state_id": "12"
  },
  {
    "id": "1041",
    "name": "Surat",
    "state_id": "12"
  },
  {
    "id": "1042",
    "name": "Surendranagar",
    "state_id": "12"
  },
  {
    "id": "1043",
    "name": "Talaja",
    "state_id": "12"
  },
  {
    "id": "1044",
    "name": "Talala",
    "state_id": "12"
  },
  {
    "id": "1045",
    "name": "Talod",
    "state_id": "12"
  },
  {
    "id": "1046",
    "name": "Tankara",
    "state_id": "12"
  },
  {
    "id": "1047",
    "name": "Tarsali",
    "state_id": "12"
  },
  {
    "id": "1048",
    "name": "Thangadh",
    "state_id": "12"
  },
  {
    "id": "1049",
    "name": "Tharad",
    "state_id": "12"
  },
  {
    "id": "1050",
    "name": "Thasra",
    "state_id": "12"
  },
  {
    "id": "1051",
    "name": "Udyognagar",
    "state_id": "12"
  },
  {
    "id": "1052",
    "name": "Ukai",
    "state_id": "12"
  },
  {
    "id": "1053",
    "name": "Umbergaon",
    "state_id": "12"
  },
  {
    "id": "1054",
    "name": "Umbergaon INA",
    "state_id": "12"
  },
  {
    "id": "1055",
    "name": "Umrala",
    "state_id": "12"
  },
  {
    "id": "1056",
    "name": "Umreth",
    "state_id": "12"
  },
  {
    "id": "1057",
    "name": "Un",
    "state_id": "12"
  },
  {
    "id": "1058",
    "name": "Una",
    "state_id": "12"
  },
  {
    "id": "1059",
    "name": "Unjha",
    "state_id": "12"
  },
  {
    "id": "1060",
    "name": "Upleta",
    "state_id": "12"
  },
  {
    "id": "1061",
    "name": "Utran",
    "state_id": "12"
  },
  {
    "id": "1062",
    "name": "Uttarsanda",
    "state_id": "12"
  },
  {
    "id": "1063",
    "name": "V.U. Nagar",
    "state_id": "12"
  },
  {
    "id": "1064",
    "name": "V.V. Nagar",
    "state_id": "12"
  },
  {
    "id": "1065",
    "name": "Vadia",
    "state_id": "12"
  },
  {
    "id": "1066",
    "name": "Vadla",
    "state_id": "12"
  },
  {
    "id": "1067",
    "name": "Vadnagar",
    "state_id": "12"
  },
  {
    "id": "1068",
    "name": "Vadodara",
    "state_id": "12"
  },
  {
    "id": "1069",
    "name": "Vaghodia INA",
    "state_id": "12"
  },
  {
    "id": "1070",
    "name": "Valbhipur",
    "state_id": "12"
  },
  {
    "id": "1071",
    "name": "Vallabh Vidyanagar",
    "state_id": "12"
  },
  {
    "id": "1072",
    "name": "Valsad",
    "state_id": "12"
  },
  {
    "id": "1073",
    "name": "Valsad INA",
    "state_id": "12"
  },
  {
    "id": "1074",
    "name": "Vanthali",
    "state_id": "12"
  },
  {
    "id": "1075",
    "name": "Vapi",
    "state_id": "12"
  },
  {
    "id": "1076",
    "name": "Vapi INA",
    "state_id": "12"
  },
  {
    "id": "1077",
    "name": "Vartej",
    "state_id": "12"
  },
  {
    "id": "1078",
    "name": "Vasad",
    "state_id": "12"
  },
  {
    "id": "1079",
    "name": "Vasna Borsad INA",
    "state_id": "12"
  },
  {
    "id": "1080",
    "name": "Vaso",
    "state_id": "12"
  },
  {
    "id": "1081",
    "name": "Veraval",
    "state_id": "12"
  },
  {
    "id": "1082",
    "name": "Vidyanagar",
    "state_id": "12"
  },
  {
    "id": "1083",
    "name": "Vijalpor",
    "state_id": "12"
  },
  {
    "id": "1084",
    "name": "Vijapur",
    "state_id": "12"
  },
  {
    "id": "1085",
    "name": "Vinchhiya",
    "state_id": "12"
  },
  {
    "id": "1086",
    "name": "Vinzol",
    "state_id": "12"
  },
  {
    "id": "1087",
    "name": "Virpur",
    "state_id": "12"
  },
  {
    "id": "1088",
    "name": "Visavadar",
    "state_id": "12"
  },
  {
    "id": "1089",
    "name": "Visnagar",
    "state_id": "12"
  },
  {
    "id": "1090",
    "name": "Vyara",
    "state_id": "12"
  },
  {
    "id": "1091",
    "name": "Wadhwan",
    "state_id": "12"
  },
  {
    "id": "1092",
    "name": "Waghai",
    "state_id": "12"
  },
  {
    "id": "1093",
    "name": "Waghodia",
    "state_id": "12"
  },
  {
    "id": "1094",
    "name": "Wankaner",
    "state_id": "12"
  },
  {
    "id": "1095",
    "name": "Zalod",
    "state_id": "12"
  },
  {
    "id": "1096",
    "name": "Ambala",
    "state_id": "13"
  },
  {
    "id": "1097",
    "name": "Ambala Cantt",
    "state_id": "13"
  },
  {
    "id": "1098",
    "name": "Asan Khurd",
    "state_id": "13"
  },
  {
    "id": "1099",
    "name": "Asandh",
    "state_id": "13"
  },
  {
    "id": "1100",
    "name": "Ateli",
    "state_id": "13"
  },
  {
    "id": "1101",
    "name": "Babiyal",
    "state_id": "13"
  },
  {
    "id": "1102",
    "name": "Bahadurgarh",
    "state_id": "13"
  },
  {
    "id": "1103",
    "name": "Ballabgarh",
    "state_id": "13"
  },
  {
    "id": "1104",
    "name": "Barwala",
    "state_id": "13"
  },
  {
    "id": "1105",
    "name": "Bawal",
    "state_id": "13"
  },
  {
    "id": "1106",
    "name": "Bawani Khera",
    "state_id": "13"
  },
  {
    "id": "1107",
    "name": "Beri",
    "state_id": "13"
  },
  {
    "id": "1108",
    "name": "Bhiwani",
    "state_id": "13"
  },
  {
    "id": "1109",
    "name": "Bilaspur",
    "state_id": "13"
  },
  {
    "id": "1110",
    "name": "Buria",
    "state_id": "13"
  },
  {
    "id": "1111",
    "name": "Charkhi Dadri",
    "state_id": "13"
  },
  {
    "id": "1112",
    "name": "Chhachhrauli",
    "state_id": "13"
  },
  {
    "id": "1113",
    "name": "Chita",
    "state_id": "13"
  },
  {
    "id": "1114",
    "name": "Dabwali",
    "state_id": "13"
  },
  {
    "id": "1115",
    "name": "Dharuhera",
    "state_id": "13"
  },
  {
    "id": "1116",
    "name": "Dundahera",
    "state_id": "13"
  },
  {
    "id": "1117",
    "name": "Ellenabad",
    "state_id": "13"
  },
  {
    "id": "1118",
    "name": "Farakhpur",
    "state_id": "13"
  },
  {
    "id": "1119",
    "name": "Faridabad",
    "state_id": "13"
  },
  {
    "id": "1120",
    "name": "Farrukhnagar",
    "state_id": "13"
  },
  {
    "id": "1121",
    "name": "Fatehabad",
    "state_id": "13"
  },
  {
    "id": "1122",
    "name": "Firozpur Jhirka",
    "state_id": "13"
  },
  {
    "id": "1123",
    "name": "Gannaur",
    "state_id": "13"
  },
  {
    "id": "1124",
    "name": "Ghraunda",
    "state_id": "13"
  },
  {
    "id": "1125",
    "name": "Gohana",
    "state_id": "13"
  },
  {
    "id": "1126",
    "name": "Gurgaon",
    "state_id": "13"
  },
  {
    "id": "1127",
    "name": "Haileymandi",
    "state_id": "13"
  },
  {
    "id": "1128",
    "name": "Hansi",
    "state_id": "13"
  },
  {
    "id": "1129",
    "name": "Hasanpur",
    "state_id": "13"
  },
  {
    "id": "1130",
    "name": "Hathin",
    "state_id": "13"
  },
  {
    "id": "1131",
    "name": "Hisar",
    "state_id": "13"
  },
  {
    "id": "1132",
    "name": "Hissar",
    "state_id": "13"
  },
  {
    "id": "1133",
    "name": "Hodal",
    "state_id": "13"
  },
  {
    "id": "1134",
    "name": "Indri",
    "state_id": "13"
  },
  {
    "id": "1135",
    "name": "Jagadhri",
    "state_id": "13"
  },
  {
    "id": "1136",
    "name": "Jakhal Mandi",
    "state_id": "13"
  },
  {
    "id": "1137",
    "name": "Jhajjar",
    "state_id": "13"
  },
  {
    "id": "1138",
    "name": "Jind",
    "state_id": "13"
  },
  {
    "id": "1139",
    "name": "Julana",
    "state_id": "13"
  },
  {
    "id": "1140",
    "name": "Kaithal",
    "state_id": "13"
  },
  {
    "id": "1141",
    "name": "Kalanur",
    "state_id": "13"
  },
  {
    "id": "1142",
    "name": "Kalanwali",
    "state_id": "13"
  },
  {
    "id": "1143",
    "name": "Kalayat",
    "state_id": "13"
  },
  {
    "id": "1144",
    "name": "Kalka",
    "state_id": "13"
  },
  {
    "id": "1145",
    "name": "Kanina",
    "state_id": "13"
  },
  {
    "id": "1146",
    "name": "Kansepur",
    "state_id": "13"
  },
  {
    "id": "1147",
    "name": "Kardhan",
    "state_id": "13"
  },
  {
    "id": "1148",
    "name": "Karnal",
    "state_id": "13"
  },
  {
    "id": "1149",
    "name": "Kharkhoda",
    "state_id": "13"
  },
  {
    "id": "1150",
    "name": "Kheri Sampla",
    "state_id": "13"
  },
  {
    "id": "1151",
    "name": "Kundli",
    "state_id": "13"
  },
  {
    "id": "1152",
    "name": "Kurukshetra",
    "state_id": "13"
  },
  {
    "id": "1153",
    "name": "Ladrawan",
    "state_id": "13"
  },
  {
    "id": "1154",
    "name": "Ladwa",
    "state_id": "13"
  },
  {
    "id": "1155",
    "name": "Loharu",
    "state_id": "13"
  },
  {
    "id": "1156",
    "name": "Maham",
    "state_id": "13"
  },
  {
    "id": "1157",
    "name": "Mahendragarh",
    "state_id": "13"
  },
  {
    "id": "1158",
    "name": "Mustafabad",
    "state_id": "13"
  },
  {
    "id": "1159",
    "name": "Nagai Chaudhry",
    "state_id": "13"
  },
  {
    "id": "1160",
    "name": "Narayangarh",
    "state_id": "13"
  },
  {
    "id": "1161",
    "name": "Narnaul",
    "state_id": "13"
  },
  {
    "id": "1162",
    "name": "Narnaund",
    "state_id": "13"
  },
  {
    "id": "1163",
    "name": "Narwana",
    "state_id": "13"
  },
  {
    "id": "1164",
    "name": "Nilokheri",
    "state_id": "13"
  },
  {
    "id": "1165",
    "name": "Nuh",
    "state_id": "13"
  },
  {
    "id": "1166",
    "name": "Palwal",
    "state_id": "13"
  },
  {
    "id": "1167",
    "name": "Panchkula",
    "state_id": "13"
  },
  {
    "id": "1168",
    "name": "Panipat",
    "state_id": "13"
  },
  {
    "id": "1169",
    "name": "Panipat Taraf Ansar",
    "state_id": "13"
  },
  {
    "id": "1170",
    "name": "Panipat Taraf Makhdum Zadgan",
    "state_id": "13"
  },
  {
    "id": "1171",
    "name": "Panipat Taraf Rajputan",
    "state_id": "13"
  },
  {
    "id": "1172",
    "name": "Pehowa",
    "state_id": "13"
  },
  {
    "id": "1173",
    "name": "Pinjaur",
    "state_id": "13"
  },
  {
    "id": "1174",
    "name": "Punahana",
    "state_id": "13"
  },
  {
    "id": "1175",
    "name": "Pundri",
    "state_id": "13"
  },
  {
    "id": "1176",
    "name": "Radaur",
    "state_id": "13"
  },
  {
    "id": "1177",
    "name": "Raipur Rani",
    "state_id": "13"
  },
  {
    "id": "1178",
    "name": "Rania",
    "state_id": "13"
  },
  {
    "id": "1179",
    "name": "Ratiya",
    "state_id": "13"
  },
  {
    "id": "1180",
    "name": "Rewari",
    "state_id": "13"
  },
  {
    "id": "1181",
    "name": "Rohtak",
    "state_id": "13"
  },
  {
    "id": "1182",
    "name": "Ropar",
    "state_id": "13"
  },
  {
    "id": "1183",
    "name": "Sadauri",
    "state_id": "13"
  },
  {
    "id": "1184",
    "name": "Safidon",
    "state_id": "13"
  },
  {
    "id": "1185",
    "name": "Samalkha",
    "state_id": "13"
  },
  {
    "id": "1186",
    "name": "Sankhol",
    "state_id": "13"
  },
  {
    "id": "1187",
    "name": "Sasauli",
    "state_id": "13"
  },
  {
    "id": "1188",
    "name": "Shahabad",
    "state_id": "13"
  },
  {
    "id": "1189",
    "name": "Sirsa",
    "state_id": "13"
  },
  {
    "id": "1190",
    "name": "Siwani",
    "state_id": "13"
  },
  {
    "id": "1191",
    "name": "Sohna",
    "state_id": "13"
  },
  {
    "id": "1192",
    "name": "Sonipat",
    "state_id": "13"
  },
  {
    "id": "1193",
    "name": "Sukhrali",
    "state_id": "13"
  },
  {
    "id": "1194",
    "name": "Taoru",
    "state_id": "13"
  },
  {
    "id": "1195",
    "name": "Taraori",
    "state_id": "13"
  },
  {
    "id": "1196",
    "name": "Tauru",
    "state_id": "13"
  },
  {
    "id": "1197",
    "name": "Thanesar",
    "state_id": "13"
  },
  {
    "id": "1198",
    "name": "Tilpat",
    "state_id": "13"
  },
  {
    "id": "1199",
    "name": "Tohana",
    "state_id": "13"
  },
  {
    "id": "1200",
    "name": "Tosham",
    "state_id": "13"
  },
  {
    "id": "1201",
    "name": "Uchana",
    "state_id": "13"
  },
  {
    "id": "1202",
    "name": "Uklana Mandi",
    "state_id": "13"
  },
  {
    "id": "1203",
    "name": "Uncha Siwana",
    "state_id": "13"
  },
  {
    "id": "1204",
    "name": "Yamunanagar",
    "state_id": "13"
  },
  {
    "id": "1205",
    "name": "Arki",
    "state_id": "14"
  },
  {
    "id": "1206",
    "name": "Baddi",
    "state_id": "14"
  },
  {
    "id": "1207",
    "name": "Bakloh",
    "state_id": "14"
  },
  {
    "id": "1208",
    "name": "Banjar",
    "state_id": "14"
  },
  {
    "id": "1209",
    "name": "Bhota",
    "state_id": "14"
  },
  {
    "id": "1210",
    "name": "Bhuntar",
    "state_id": "14"
  },
  {
    "id": "1211",
    "name": "Bilaspur",
    "state_id": "14"
  },
  {
    "id": "1212",
    "name": "Chamba",
    "state_id": "14"
  },
  {
    "id": "1213",
    "name": "Chaupal",
    "state_id": "14"
  },
  {
    "id": "1214",
    "name": "Chuari Khas",
    "state_id": "14"
  },
  {
    "id": "1215",
    "name": "Dagshai",
    "state_id": "14"
  },
  {
    "id": "1216",
    "name": "Dalhousie",
    "state_id": "14"
  },
  {
    "id": "1217",
    "name": "Dalhousie Cantonment",
    "state_id": "14"
  },
  {
    "id": "1218",
    "name": "Damtal",
    "state_id": "14"
  },
  {
    "id": "1219",
    "name": "Daulatpur",
    "state_id": "14"
  },
  {
    "id": "1220",
    "name": "Dera Gopipur",
    "state_id": "14"
  },
  {
    "id": "1221",
    "name": "Dhalli",
    "state_id": "14"
  },
  {
    "id": "1222",
    "name": "Dharamshala",
    "state_id": "14"
  },
  {
    "id": "1223",
    "name": "Gagret",
    "state_id": "14"
  },
  {
    "id": "1224",
    "name": "Ghamarwin",
    "state_id": "14"
  },
  {
    "id": "1225",
    "name": "Hamirpur",
    "state_id": "14"
  },
  {
    "id": "1226",
    "name": "Jawala Mukhi",
    "state_id": "14"
  },
  {
    "id": "1227",
    "name": "Jogindarnagar",
    "state_id": "14"
  },
  {
    "id": "1228",
    "name": "Jubbal",
    "state_id": "14"
  },
  {
    "id": "1229",
    "name": "Jutogh",
    "state_id": "14"
  },
  {
    "id": "1230",
    "name": "Kala Amb",
    "state_id": "14"
  },
  {
    "id": "1231",
    "name": "Kalpa",
    "state_id": "14"
  },
  {
    "id": "1232",
    "name": "Kangra",
    "state_id": "14"
  },
  {
    "id": "1233",
    "name": "Kasauli",
    "state_id": "14"
  },
  {
    "id": "1234",
    "name": "Kot Khai",
    "state_id": "14"
  },
  {
    "id": "1235",
    "name": "Kullu",
    "state_id": "14"
  },
  {
    "id": "1236",
    "name": "Kulu",
    "state_id": "14"
  },
  {
    "id": "1237",
    "name": "Manali",
    "state_id": "14"
  },
  {
    "id": "1238",
    "name": "Mandi",
    "state_id": "14"
  },
  {
    "id": "1239",
    "name": "Mant Khas",
    "state_id": "14"
  },
  {
    "id": "1240",
    "name": "Mehatpur Basdehra",
    "state_id": "14"
  },
  {
    "id": "1241",
    "name": "Nadaun",
    "state_id": "14"
  },
  {
    "id": "1242",
    "name": "Nagrota",
    "state_id": "14"
  },
  {
    "id": "1243",
    "name": "Nahan",
    "state_id": "14"
  },
  {
    "id": "1244",
    "name": "Naina Devi",
    "state_id": "14"
  },
  {
    "id": "1245",
    "name": "Nalagarh",
    "state_id": "14"
  },
  {
    "id": "1246",
    "name": "Narkanda",
    "state_id": "14"
  },
  {
    "id": "1247",
    "name": "Nurpur",
    "state_id": "14"
  },
  {
    "id": "1248",
    "name": "Palampur",
    "state_id": "14"
  },
  {
    "id": "1249",
    "name": "Pandoh",
    "state_id": "14"
  },
  {
    "id": "1250",
    "name": "Paonta Sahib",
    "state_id": "14"
  },
  {
    "id": "1251",
    "name": "Parwanoo",
    "state_id": "14"
  },
  {
    "id": "1252",
    "name": "Parwanu",
    "state_id": "14"
  },
  {
    "id": "1253",
    "name": "Rajgarh",
    "state_id": "14"
  },
  {
    "id": "1254",
    "name": "Rampur",
    "state_id": "14"
  },
  {
    "id": "1255",
    "name": "Rawalsar",
    "state_id": "14"
  },
  {
    "id": "1256",
    "name": "Rohru",
    "state_id": "14"
  },
  {
    "id": "1257",
    "name": "Sabathu",
    "state_id": "14"
  },
  {
    "id": "1258",
    "name": "Santokhgarh",
    "state_id": "14"
  },
  {
    "id": "1259",
    "name": "Sarahan",
    "state_id": "14"
  },
  {
    "id": "1260",
    "name": "Sarka Ghat",
    "state_id": "14"
  },
  {
    "id": "1261",
    "name": "Seoni",
    "state_id": "14"
  },
  {
    "id": "1262",
    "name": "Shimla",
    "state_id": "14"
  },
  {
    "id": "1263",
    "name": "Sirmaur",
    "state_id": "14"
  },
  {
    "id": "1264",
    "name": "Solan",
    "state_id": "14"
  },
  {
    "id": "1265",
    "name": "Solon",
    "state_id": "14"
  },
  {
    "id": "1266",
    "name": "Sundarnagar",
    "state_id": "14"
  },
  {
    "id": "1267",
    "name": "Sundernagar",
    "state_id": "14"
  },
  {
    "id": "1268",
    "name": "Talai",
    "state_id": "14"
  },
  {
    "id": "1269",
    "name": "Theog",
    "state_id": "14"
  },
  {
    "id": "1270",
    "name": "Tira Sujanpur",
    "state_id": "14"
  },
  {
    "id": "1271",
    "name": "Una",
    "state_id": "14"
  },
  {
    "id": "1272",
    "name": "Yol",
    "state_id": "14"
  },
  {
    "id": "1273",
    "name": "Achabal",
    "state_id": "15"
  },
  {
    "id": "1274",
    "name": "Akhnur",
    "state_id": "15"
  },
  {
    "id": "1275",
    "name": "Anantnag",
    "state_id": "15"
  },
  {
    "id": "1276",
    "name": "Arnia",
    "state_id": "15"
  },
  {
    "id": "1277",
    "name": "Awantipora",
    "state_id": "15"
  },
  {
    "id": "1278",
    "name": "Badami Bagh",
    "state_id": "15"
  },
  {
    "id": "1279",
    "name": "Bandipur",
    "state_id": "15"
  },
  {
    "id": "1280",
    "name": "Banihal",
    "state_id": "15"
  },
  {
    "id": "1281",
    "name": "Baramula",
    "state_id": "15"
  },
  {
    "id": "1282",
    "name": "Baramulla",
    "state_id": "15"
  },
  {
    "id": "1283",
    "name": "Bari Brahmana",
    "state_id": "15"
  },
  {
    "id": "1284",
    "name": "Bashohli",
    "state_id": "15"
  },
  {
    "id": "1285",
    "name": "Batote",
    "state_id": "15"
  },
  {
    "id": "1286",
    "name": "Bhaderwah",
    "state_id": "15"
  },
  {
    "id": "1287",
    "name": "Bijbiara",
    "state_id": "15"
  },
  {
    "id": "1288",
    "name": "Billawar",
    "state_id": "15"
  },
  {
    "id": "1289",
    "name": "Birwah",
    "state_id": "15"
  },
  {
    "id": "1290",
    "name": "Bishna",
    "state_id": "15"
  },
  {
    "id": "1291",
    "name": "Budgam",
    "state_id": "15"
  },
  {
    "id": "1292",
    "name": "Charari Sharief",
    "state_id": "15"
  },
  {
    "id": "1293",
    "name": "Chenani",
    "state_id": "15"
  },
  {
    "id": "1294",
    "name": "Doda",
    "state_id": "15"
  },
  {
    "id": "1295",
    "name": "Duru-Verinag",
    "state_id": "15"
  },
  {
    "id": "1296",
    "name": "Gandarbat",
    "state_id": "15"
  },
  {
    "id": "1297",
    "name": "Gho Manhasan",
    "state_id": "15"
  },
  {
    "id": "1298",
    "name": "Gorah Salathian",
    "state_id": "15"
  },
  {
    "id": "1299",
    "name": "Gulmarg",
    "state_id": "15"
  },
  {
    "id": "1300",
    "name": "Hajan",
    "state_id": "15"
  },
  {
    "id": "1301",
    "name": "Handwara",
    "state_id": "15"
  },
  {
    "id": "1302",
    "name": "Hiranagar",
    "state_id": "15"
  },
  {
    "id": "1303",
    "name": "Jammu",
    "state_id": "15"
  },
  {
    "id": "1304",
    "name": "Jammu Cantonment",
    "state_id": "15"
  },
  {
    "id": "1305",
    "name": "Jammu Tawi",
    "state_id": "15"
  },
  {
    "id": "1306",
    "name": "Jourian",
    "state_id": "15"
  },
  {
    "id": "1307",
    "name": "Kargil",
    "state_id": "15"
  },
  {
    "id": "1308",
    "name": "Kathua",
    "state_id": "15"
  },
  {
    "id": "1309",
    "name": "Katra",
    "state_id": "15"
  },
  {
    "id": "1310",
    "name": "Khan Sahib",
    "state_id": "15"
  },
  {
    "id": "1311",
    "name": "Khour",
    "state_id": "15"
  },
  {
    "id": "1312",
    "name": "Khrew",
    "state_id": "15"
  },
  {
    "id": "1313",
    "name": "Kishtwar",
    "state_id": "15"
  },
  {
    "id": "1314",
    "name": "Kud",
    "state_id": "15"
  },
  {
    "id": "1315",
    "name": "Kukernag",
    "state_id": "15"
  },
  {
    "id": "1316",
    "name": "Kulgam",
    "state_id": "15"
  },
  {
    "id": "1317",
    "name": "Kunzer",
    "state_id": "15"
  },
  {
    "id": "1318",
    "name": "Kupwara",
    "state_id": "15"
  },
  {
    "id": "1319",
    "name": "Lakhenpur",
    "state_id": "15"
  },
  {
    "id": "1320",
    "name": "Leh",
    "state_id": "15"
  },
  {
    "id": "1321",
    "name": "Magam",
    "state_id": "15"
  },
  {
    "id": "1322",
    "name": "Mattan",
    "state_id": "15"
  },
  {
    "id": "1323",
    "name": "Naushehra",
    "state_id": "15"
  },
  {
    "id": "1324",
    "name": "Pahalgam",
    "state_id": "15"
  },
  {
    "id": "1325",
    "name": "Pampore",
    "state_id": "15"
  },
  {
    "id": "1326",
    "name": "Parole",
    "state_id": "15"
  },
  {
    "id": "1327",
    "name": "Pattan",
    "state_id": "15"
  },
  {
    "id": "1328",
    "name": "Pulwama",
    "state_id": "15"
  },
  {
    "id": "1329",
    "name": "Punch",
    "state_id": "15"
  },
  {
    "id": "1330",
    "name": "Qazigund",
    "state_id": "15"
  },
  {
    "id": "1331",
    "name": "Rajauri",
    "state_id": "15"
  },
  {
    "id": "1332",
    "name": "Ramban",
    "state_id": "15"
  },
  {
    "id": "1333",
    "name": "Ramgarh",
    "state_id": "15"
  },
  {
    "id": "1334",
    "name": "Ramnagar",
    "state_id": "15"
  },
  {
    "id": "1335",
    "name": "Ranbirsingh Pora",
    "state_id": "15"
  },
  {
    "id": "1336",
    "name": "Reasi",
    "state_id": "15"
  },
  {
    "id": "1337",
    "name": "Rehambal",
    "state_id": "15"
  },
  {
    "id": "1338",
    "name": "Samba",
    "state_id": "15"
  },
  {
    "id": "1339",
    "name": "Shupiyan",
    "state_id": "15"
  },
  {
    "id": "1340",
    "name": "Sopur",
    "state_id": "15"
  },
  {
    "id": "1341",
    "name": "Srinagar",
    "state_id": "15"
  },
  {
    "id": "1342",
    "name": "Sumbal",
    "state_id": "15"
  },
  {
    "id": "1343",
    "name": "Sunderbani",
    "state_id": "15"
  },
  {
    "id": "1344",
    "name": "Talwara",
    "state_id": "15"
  },
  {
    "id": "1345",
    "name": "Thanamandi",
    "state_id": "15"
  },
  {
    "id": "1346",
    "name": "Tral",
    "state_id": "15"
  },
  {
    "id": "1347",
    "name": "Udhampur",
    "state_id": "15"
  },
  {
    "id": "1348",
    "name": "Uri",
    "state_id": "15"
  },
  {
    "id": "1349",
    "name": "Vijaypur",
    "state_id": "15"
  },
  {
    "id": "1350",
    "name": "Adityapur",
    "state_id": "16"
  },
  {
    "id": "1351",
    "name": "Amlabad",
    "state_id": "16"
  },
  {
    "id": "1352",
    "name": "Angarpathar",
    "state_id": "16"
  },
  {
    "id": "1353",
    "name": "Ara",
    "state_id": "16"
  },
  {
    "id": "1354",
    "name": "Babua Kalan",
    "state_id": "16"
  },
  {
    "id": "1355",
    "name": "Bagbahra",
    "state_id": "16"
  },
  {
    "id": "1356",
    "name": "Baliapur",
    "state_id": "16"
  },
  {
    "id": "1357",
    "name": "Baliari",
    "state_id": "16"
  },
  {
    "id": "1358",
    "name": "Balkundra",
    "state_id": "16"
  },
  {
    "id": "1359",
    "name": "Bandhgora",
    "state_id": "16"
  },
  {
    "id": "1360",
    "name": "Barajamda",
    "state_id": "16"
  },
  {
    "id": "1361",
    "name": "Barhi",
    "state_id": "16"
  },
  {
    "id": "1362",
    "name": "Barka Kana",
    "state_id": "16"
  },
  {
    "id": "1363",
    "name": "Barki Saraiya",
    "state_id": "16"
  },
  {
    "id": "1364",
    "name": "Barughutu",
    "state_id": "16"
  },
  {
    "id": "1365",
    "name": "Barwadih",
    "state_id": "16"
  },
  {
    "id": "1366",
    "name": "Basaria",
    "state_id": "16"
  },
  {
    "id": "1367",
    "name": "Basukinath",
    "state_id": "16"
  },
  {
    "id": "1368",
    "name": "Bermo",
    "state_id": "16"
  },
  {
    "id": "1369",
    "name": "Bhagatdih",
    "state_id": "16"
  },
  {
    "id": "1370",
    "name": "Bhaurah",
    "state_id": "16"
  },
  {
    "id": "1371",
    "name": "Bhojudih",
    "state_id": "16"
  },
  {
    "id": "1372",
    "name": "Bhuli",
    "state_id": "16"
  },
  {
    "id": "1373",
    "name": "Bokaro",
    "state_id": "16"
  },
  {
    "id": "1374",
    "name": "Borio Bazar",
    "state_id": "16"
  },
  {
    "id": "1375",
    "name": "Bundu",
    "state_id": "16"
  },
  {
    "id": "1376",
    "name": "Chaibasa",
    "state_id": "16"
  },
  {
    "id": "1377",
    "name": "Chaitudih",
    "state_id": "16"
  },
  {
    "id": "1378",
    "name": "Chakradharpur",
    "state_id": "16"
  },
  {
    "id": "1379",
    "name": "Chakulia",
    "state_id": "16"
  },
  {
    "id": "1380",
    "name": "Chandaur",
    "state_id": "16"
  },
  {
    "id": "1381",
    "name": "Chandil",
    "state_id": "16"
  },
  {
    "id": "1382",
    "name": "Chandrapura",
    "state_id": "16"
  },
  {
    "id": "1383",
    "name": "Chas",
    "state_id": "16"
  },
  {
    "id": "1384",
    "name": "Chatra",
    "state_id": "16"
  },
  {
    "id": "1385",
    "name": "Chhatatanr",
    "state_id": "16"
  },
  {
    "id": "1386",
    "name": "Chhotaputki",
    "state_id": "16"
  },
  {
    "id": "1387",
    "name": "Chiria",
    "state_id": "16"
  },
  {
    "id": "1388",
    "name": "Chirkunda",
    "state_id": "16"
  },
  {
    "id": "1389",
    "name": "Churi",
    "state_id": "16"
  },
  {
    "id": "1390",
    "name": "Daltenganj",
    "state_id": "16"
  },
  {
    "id": "1391",
    "name": "Danguwapasi",
    "state_id": "16"
  },
  {
    "id": "1392",
    "name": "Dari",
    "state_id": "16"
  },
  {
    "id": "1393",
    "name": "Deoghar",
    "state_id": "16"
  },
  {
    "id": "1394",
    "name": "Deorikalan",
    "state_id": "16"
  },
  {
    "id": "1395",
    "name": "Devghar",
    "state_id": "16"
  },
  {
    "id": "1396",
    "name": "Dhanbad",
    "state_id": "16"
  },
  {
    "id": "1397",
    "name": "Dhanwar",
    "state_id": "16"
  },
  {
    "id": "1398",
    "name": "Dhaunsar",
    "state_id": "16"
  },
  {
    "id": "1399",
    "name": "Dugda",
    "state_id": "16"
  },
  {
    "id": "1400",
    "name": "Dumarkunda",
    "state_id": "16"
  },
  {
    "id": "1401",
    "name": "Dumka",
    "state_id": "16"
  },
  {
    "id": "1402",
    "name": "Egarkunr",
    "state_id": "16"
  },
  {
    "id": "1403",
    "name": "Gadhra",
    "state_id": "16"
  },
  {
    "id": "1404",
    "name": "Garwa",
    "state_id": "16"
  },
  {
    "id": "1405",
    "name": "Ghatsila",
    "state_id": "16"
  },
  {
    "id": "1406",
    "name": "Ghorabandha",
    "state_id": "16"
  },
  {
    "id": "1407",
    "name": "Gidi",
    "state_id": "16"
  },
  {
    "id": "1408",
    "name": "Giridih",
    "state_id": "16"
  },
  {
    "id": "1409",
    "name": "Gobindpur",
    "state_id": "16"
  },
  {
    "id": "1410",
    "name": "Godda",
    "state_id": "16"
  },
  {
    "id": "1411",
    "name": "Godhar",
    "state_id": "16"
  },
  {
    "id": "1412",
    "name": "Golphalbari",
    "state_id": "16"
  },
  {
    "id": "1413",
    "name": "Gomoh",
    "state_id": "16"
  },
  {
    "id": "1414",
    "name": "Gua",
    "state_id": "16"
  },
  {
    "id": "1415",
    "name": "Gumia",
    "state_id": "16"
  },
  {
    "id": "1416",
    "name": "Gumla",
    "state_id": "16"
  },
  {
    "id": "1417",
    "name": "Haludbani",
    "state_id": "16"
  },
  {
    "id": "1418",
    "name": "Hazaribag",
    "state_id": "16"
  },
  {
    "id": "1419",
    "name": "Hesla",
    "state_id": "16"
  },
  {
    "id": "1420",
    "name": "Husainabad",
    "state_id": "16"
  },
  {
    "id": "1421",
    "name": "Isri",
    "state_id": "16"
  },
  {
    "id": "1422",
    "name": "Jadugora",
    "state_id": "16"
  },
  {
    "id": "1423",
    "name": "Jagannathpur",
    "state_id": "16"
  },
  {
    "id": "1424",
    "name": "Jamadoba",
    "state_id": "16"
  },
  {
    "id": "1425",
    "name": "Jamshedpur",
    "state_id": "16"
  },
  {
    "id": "1426",
    "name": "Jamtara",
    "state_id": "16"
  },
  {
    "id": "1427",
    "name": "Jarangdih",
    "state_id": "16"
  },
  {
    "id": "1428",
    "name": "Jaridih",
    "state_id": "16"
  },
  {
    "id": "1429",
    "name": "Jasidih",
    "state_id": "16"
  },
  {
    "id": "1430",
    "name": "Jena",
    "state_id": "16"
  },
  {
    "id": "1431",
    "name": "Jharia",
    "state_id": "16"
  },
  {
    "id": "1432",
    "name": "Jharia Khas",
    "state_id": "16"
  },
  {
    "id": "1433",
    "name": "Jhinkpani",
    "state_id": "16"
  },
  {
    "id": "1434",
    "name": "Jhumri Tilaiya",
    "state_id": "16"
  },
  {
    "id": "1435",
    "name": "Jorapokhar",
    "state_id": "16"
  },
  {
    "id": "1436",
    "name": "Jugsalai",
    "state_id": "16"
  },
  {
    "id": "1437",
    "name": "Kailudih",
    "state_id": "16"
  },
  {
    "id": "1438",
    "name": "Kalikapur",
    "state_id": "16"
  },
  {
    "id": "1439",
    "name": "Kandra",
    "state_id": "16"
  },
  {
    "id": "1440",
    "name": "Kanke",
    "state_id": "16"
  },
  {
    "id": "1441",
    "name": "Katras",
    "state_id": "16"
  },
  {
    "id": "1442",
    "name": "Kedla",
    "state_id": "16"
  },
  {
    "id": "1443",
    "name": "Kenduadih",
    "state_id": "16"
  },
  {
    "id": "1444",
    "name": "Kharkhari",
    "state_id": "16"
  },
  {
    "id": "1445",
    "name": "Kharsawan",
    "state_id": "16"
  },
  {
    "id": "1446",
    "name": "Khelari",
    "state_id": "16"
  },
  {
    "id": "1447",
    "name": "Khunti",
    "state_id": "16"
  },
  {
    "id": "1448",
    "name": "Kiri Buru",
    "state_id": "16"
  },
  {
    "id": "1449",
    "name": "Kiriburu",
    "state_id": "16"
  },
  {
    "id": "1450",
    "name": "Kodarma",
    "state_id": "16"
  },
  {
    "id": "1451",
    "name": "Kuju",
    "state_id": "16"
  },
  {
    "id": "1452",
    "name": "Kurpania",
    "state_id": "16"
  },
  {
    "id": "1453",
    "name": "Kustai",
    "state_id": "16"
  },
  {
    "id": "1454",
    "name": "Lakarka",
    "state_id": "16"
  },
  {
    "id": "1455",
    "name": "Lapanga",
    "state_id": "16"
  },
  {
    "id": "1456",
    "name": "Latehar",
    "state_id": "16"
  },
  {
    "id": "1457",
    "name": "Lohardaga",
    "state_id": "16"
  },
  {
    "id": "1458",
    "name": "Loiya",
    "state_id": "16"
  },
  {
    "id": "1459",
    "name": "Loyabad",
    "state_id": "16"
  },
  {
    "id": "1460",
    "name": "Madhupur",
    "state_id": "16"
  },
  {
    "id": "1461",
    "name": "Mahesh Mundi",
    "state_id": "16"
  },
  {
    "id": "1462",
    "name": "Maithon",
    "state_id": "16"
  },
  {
    "id": "1463",
    "name": "Malkera",
    "state_id": "16"
  },
  {
    "id": "1464",
    "name": "Mango",
    "state_id": "16"
  },
  {
    "id": "1465",
    "name": "Manoharpur",
    "state_id": "16"
  },
  {
    "id": "1466",
    "name": "Marma",
    "state_id": "16"
  },
  {
    "id": "1467",
    "name": "Meghahatuburu Forest village",
    "state_id": "16"
  },
  {
    "id": "1468",
    "name": "Mera",
    "state_id": "16"
  },
  {
    "id": "1469",
    "name": "Meru",
    "state_id": "16"
  },
  {
    "id": "1470",
    "name": "Mihijam",
    "state_id": "16"
  },
  {
    "id": "1471",
    "name": "Mugma",
    "state_id": "16"
  },
  {
    "id": "1472",
    "name": "Muri",
    "state_id": "16"
  },
  {
    "id": "1473",
    "name": "Mushabani",
    "state_id": "16"
  },
  {
    "id": "1474",
    "name": "Nagri Kalan",
    "state_id": "16"
  },
  {
    "id": "1475",
    "name": "Netarhat",
    "state_id": "16"
  },
  {
    "id": "1476",
    "name": "Nirsa",
    "state_id": "16"
  },
  {
    "id": "1477",
    "name": "Noamundi",
    "state_id": "16"
  },
  {
    "id": "1478",
    "name": "Okni",
    "state_id": "16"
  },
  {
    "id": "1479",
    "name": "Orla",
    "state_id": "16"
  },
  {
    "id": "1480",
    "name": "Pakaur",
    "state_id": "16"
  },
  {
    "id": "1481",
    "name": "Palamau",
    "state_id": "16"
  },
  {
    "id": "1482",
    "name": "Palawa",
    "state_id": "16"
  },
  {
    "id": "1483",
    "name": "Panchet",
    "state_id": "16"
  },
  {
    "id": "1484",
    "name": "Panrra",
    "state_id": "16"
  },
  {
    "id": "1485",
    "name": "Paratdih",
    "state_id": "16"
  },
  {
    "id": "1486",
    "name": "Pathardih",
    "state_id": "16"
  },
  {
    "id": "1487",
    "name": "Patratu",
    "state_id": "16"
  },
  {
    "id": "1488",
    "name": "Phusro",
    "state_id": "16"
  },
  {
    "id": "1489",
    "name": "Pondar Kanali",
    "state_id": "16"
  },
  {
    "id": "1490",
    "name": "Rajmahal",
    "state_id": "16"
  },
  {
    "id": "1491",
    "name": "Ramgarh",
    "state_id": "16"
  },
  {
    "id": "1492",
    "name": "Ranchi",
    "state_id": "16"
  },
  {
    "id": "1493",
    "name": "Ray",
    "state_id": "16"
  },
  {
    "id": "1494",
    "name": "Rehla",
    "state_id": "16"
  },
  {
    "id": "1495",
    "name": "Religara",
    "state_id": "16"
  },
  {
    "id": "1496",
    "name": "Rohraband",
    "state_id": "16"
  },
  {
    "id": "1497",
    "name": "Sahibganj",
    "state_id": "16"
  },
  {
    "id": "1498",
    "name": "Sahnidih",
    "state_id": "16"
  },
  {
    "id": "1499",
    "name": "Saraidhela",
    "state_id": "16"
  },
  {
    "id": "1500",
    "name": "Saraikela",
    "state_id": "16"
  },
  {
    "id": "1501",
    "name": "Sarjamda",
    "state_id": "16"
  },
  {
    "id": "1502",
    "name": "Saunda",
    "state_id": "16"
  },
  {
    "id": "1503",
    "name": "Sewai",
    "state_id": "16"
  },
  {
    "id": "1504",
    "name": "Sijhua",
    "state_id": "16"
  },
  {
    "id": "1505",
    "name": "Sijua",
    "state_id": "16"
  },
  {
    "id": "1506",
    "name": "Simdega",
    "state_id": "16"
  },
  {
    "id": "1507",
    "name": "Sindari",
    "state_id": "16"
  },
  {
    "id": "1508",
    "name": "Sinduria",
    "state_id": "16"
  },
  {
    "id": "1509",
    "name": "Sini",
    "state_id": "16"
  },
  {
    "id": "1510",
    "name": "Sirka",
    "state_id": "16"
  },
  {
    "id": "1511",
    "name": "Siuliban",
    "state_id": "16"
  },
  {
    "id": "1512",
    "name": "Surubera",
    "state_id": "16"
  },
  {
    "id": "1513",
    "name": "Tati",
    "state_id": "16"
  },
  {
    "id": "1514",
    "name": "Tenudam",
    "state_id": "16"
  },
  {
    "id": "1515",
    "name": "Tisra",
    "state_id": "16"
  },
  {
    "id": "1516",
    "name": "Topa",
    "state_id": "16"
  },
  {
    "id": "1517",
    "name": "Topchanchi",
    "state_id": "16"
  },
  {
    "id": "1518",
    "name": "Adityanagar",
    "state_id": "17"
  },
  {
    "id": "1519",
    "name": "Adityapatna",
    "state_id": "17"
  },
  {
    "id": "1520",
    "name": "Afzalpur",
    "state_id": "17"
  },
  {
    "id": "1521",
    "name": "Ajjampur",
    "state_id": "17"
  },
  {
    "id": "1522",
    "name": "Aland",
    "state_id": "17"
  },
  {
    "id": "1523",
    "name": "Almatti Sitimani",
    "state_id": "17"
  },
  {
    "id": "1524",
    "name": "Alnavar",
    "state_id": "17"
  },
  {
    "id": "1525",
    "name": "Alur",
    "state_id": "17"
  },
  {
    "id": "1526",
    "name": "Ambikanagara",
    "state_id": "17"
  },
  {
    "id": "1527",
    "name": "Anekal",
    "state_id": "17"
  },
  {
    "id": "1528",
    "name": "Ankola",
    "state_id": "17"
  },
  {
    "id": "1529",
    "name": "Annigeri",
    "state_id": "17"
  },
  {
    "id": "1530",
    "name": "Arkalgud",
    "state_id": "17"
  },
  {
    "id": "1531",
    "name": "Arsikere",
    "state_id": "17"
  },
  {
    "id": "1532",
    "name": "Athni",
    "state_id": "17"
  },
  {
    "id": "1533",
    "name": "Aurad",
    "state_id": "17"
  },
  {
    "id": "1534",
    "name": "Badagavettu",
    "state_id": "17"
  },
  {
    "id": "1535",
    "name": "Badami",
    "state_id": "17"
  },
  {
    "id": "1536",
    "name": "Bagalkot",
    "state_id": "17"
  },
  {
    "id": "1537",
    "name": "Bagepalli",
    "state_id": "17"
  },
  {
    "id": "1538",
    "name": "Bailhongal",
    "state_id": "17"
  },
  {
    "id": "1539",
    "name": "Baindur",
    "state_id": "17"
  },
  {
    "id": "1540",
    "name": "Bajala",
    "state_id": "17"
  },
  {
    "id": "1541",
    "name": "Bajpe",
    "state_id": "17"
  },
  {
    "id": "1542",
    "name": "Banavar",
    "state_id": "17"
  },
  {
    "id": "1543",
    "name": "Bangarapet",
    "state_id": "17"
  },
  {
    "id": "1544",
    "name": "Bankapura",
    "state_id": "17"
  },
  {
    "id": "1545",
    "name": "Bannur",
    "state_id": "17"
  },
  {
    "id": "1546",
    "name": "Bantwal",
    "state_id": "17"
  },
  {
    "id": "1547",
    "name": "Basavakalyan",
    "state_id": "17"
  },
  {
    "id": "1548",
    "name": "Basavana Bagevadi",
    "state_id": "17"
  },
  {
    "id": "1549",
    "name": "Belagula",
    "state_id": "17"
  },
  {
    "id": "1550",
    "name": "Belakavadiq",
    "state_id": "17"
  },
  {
    "id": "1551",
    "name": "Belgaum",
    "state_id": "17"
  },
  {
    "id": "1552",
    "name": "Belgaum Cantonment",
    "state_id": "17"
  },
  {
    "id": "1553",
    "name": "Bellary",
    "state_id": "17"
  },
  {
    "id": "1554",
    "name": "Belluru",
    "state_id": "17"
  },
  {
    "id": "1555",
    "name": "Beltangadi",
    "state_id": "17"
  },
  {
    "id": "1556",
    "name": "Belur",
    "state_id": "17"
  },
  {
    "id": "1557",
    "name": "Belvata",
    "state_id": "17"
  },
  {
    "id": "1558",
    "name": "Bengaluru",
    "state_id": "17"
  },
  {
    "id": "1559",
    "name": "Bhadravati",
    "state_id": "17"
  },
  {
    "id": "1560",
    "name": "Bhalki",
    "state_id": "17"
  },
  {
    "id": "1561",
    "name": "Bhatkal",
    "state_id": "17"
  },
  {
    "id": "1562",
    "name": "Bhimarayanagudi",
    "state_id": "17"
  },
  {
    "id": "1563",
    "name": "Bhogadi",
    "state_id": "17"
  },
  {
    "id": "1564",
    "name": "Bidar",
    "state_id": "17"
  },
  {
    "id": "1565",
    "name": "Bijapur",
    "state_id": "17"
  },
  {
    "id": "1566",
    "name": "Bilgi",
    "state_id": "17"
  },
  {
    "id": "1567",
    "name": "Birur",
    "state_id": "17"
  },
  {
    "id": "1568",
    "name": "Bommanahalli",
    "state_id": "17"
  },
  {
    "id": "1569",
    "name": "Bommasandra",
    "state_id": "17"
  },
  {
    "id": "1570",
    "name": "Byadgi",
    "state_id": "17"
  },
  {
    "id": "1571",
    "name": "Byatarayanapura",
    "state_id": "17"
  },
  {
    "id": "1572",
    "name": "Chakranagar Colony",
    "state_id": "17"
  },
  {
    "id": "1573",
    "name": "Challakere",
    "state_id": "17"
  },
  {
    "id": "1574",
    "name": "Chamrajnagar",
    "state_id": "17"
  },
  {
    "id": "1575",
    "name": "Chamundi Betta",
    "state_id": "17"
  },
  {
    "id": "1576",
    "name": "Channagiri",
    "state_id": "17"
  },
  {
    "id": "1577",
    "name": "Channapatna",
    "state_id": "17"
  },
  {
    "id": "1578",
    "name": "Channarayapatna",
    "state_id": "17"
  },
  {
    "id": "1579",
    "name": "Chickballapur",
    "state_id": "17"
  },
  {
    "id": "1580",
    "name": "Chik Ballapur",
    "state_id": "17"
  },
  {
    "id": "1581",
    "name": "Chikkaballapur",
    "state_id": "17"
  },
  {
    "id": "1582",
    "name": "Chikmagalur",
    "state_id": "17"
  },
  {
    "id": "1583",
    "name": "Chiknayakanhalli",
    "state_id": "17"
  },
  {
    "id": "1584",
    "name": "Chikodi",
    "state_id": "17"
  },
  {
    "id": "1585",
    "name": "Chincholi",
    "state_id": "17"
  },
  {
    "id": "1586",
    "name": "Chintamani",
    "state_id": "17"
  },
  {
    "id": "1587",
    "name": "Chitaguppa",
    "state_id": "17"
  },
  {
    "id": "1588",
    "name": "Chitapur",
    "state_id": "17"
  },
  {
    "id": "1589",
    "name": "Chitradurga",
    "state_id": "17"
  },
  {
    "id": "1590",
    "name": "Coorg",
    "state_id": "17"
  },
  {
    "id": "1591",
    "name": "Dandeli",
    "state_id": "17"
  },
  {
    "id": "1592",
    "name": "Dargajogihalli",
    "state_id": "17"
  },
  {
    "id": "1593",
    "name": "Dasarahalli",
    "state_id": "17"
  },
  {
    "id": "1594",
    "name": "Davangere",
    "state_id": "17"
  },
  {
    "id": "1595",
    "name": "Devadurga",
    "state_id": "17"
  },
  {
    "id": "1596",
    "name": "Devagiri",
    "state_id": "17"
  },
  {
    "id": "1597",
    "name": "Devanhalli",
    "state_id": "17"
  },
  {
    "id": "1598",
    "name": "Dharwar",
    "state_id": "17"
  },
  {
    "id": "1599",
    "name": "Dhupdal",
    "state_id": "17"
  },
  {
    "id": "1600",
    "name": "Dod Ballapur",
    "state_id": "17"
  },
  {
    "id": "1601",
    "name": "Donimalai",
    "state_id": "17"
  },
  {
    "id": "1602",
    "name": "Gadag",
    "state_id": "17"
  },
  {
    "id": "1603",
    "name": "Gajendragarh",
    "state_id": "17"
  },
  {
    "id": "1604",
    "name": "Ganeshgudi",
    "state_id": "17"
  },
  {
    "id": "1605",
    "name": "Gangawati",
    "state_id": "17"
  },
  {
    "id": "1606",
    "name": "Gangoli",
    "state_id": "17"
  },
  {
    "id": "1607",
    "name": "Gauribidanur",
    "state_id": "17"
  },
  {
    "id": "1608",
    "name": "Gokak",
    "state_id": "17"
  },
  {
    "id": "1609",
    "name": "Gokak Falls",
    "state_id": "17"
  },
  {
    "id": "1610",
    "name": "Gonikoppal",
    "state_id": "17"
  },
  {
    "id": "1611",
    "name": "Gorur",
    "state_id": "17"
  },
  {
    "id": "1612",
    "name": "Gottikere",
    "state_id": "17"
  },
  {
    "id": "1613",
    "name": "Gubbi",
    "state_id": "17"
  },
  {
    "id": "1614",
    "name": "Gudibanda",
    "state_id": "17"
  },
  {
    "id": "1615",
    "name": "Gulbarga",
    "state_id": "17"
  },
  {
    "id": "1616",
    "name": "Guledgudda",
    "state_id": "17"
  },
  {
    "id": "1617",
    "name": "Gundlupet",
    "state_id": "17"
  },
  {
    "id": "1618",
    "name": "Gurmatkal",
    "state_id": "17"
  },
  {
    "id": "1619",
    "name": "Haliyal",
    "state_id": "17"
  },
  {
    "id": "1620",
    "name": "Hangal",
    "state_id": "17"
  },
  {
    "id": "1621",
    "name": "Harihar",
    "state_id": "17"
  },
  {
    "id": "1622",
    "name": "Harpanahalli",
    "state_id": "17"
  },
  {
    "id": "1623",
    "name": "Hassan",
    "state_id": "17"
  },
  {
    "id": "1624",
    "name": "Hatti",
    "state_id": "17"
  },
  {
    "id": "1625",
    "name": "Hatti Gold Mines",
    "state_id": "17"
  },
  {
    "id": "1626",
    "name": "Haveri",
    "state_id": "17"
  },
  {
    "id": "1627",
    "name": "Hebbagodi",
    "state_id": "17"
  },
  {
    "id": "1628",
    "name": "Hebbalu",
    "state_id": "17"
  },
  {
    "id": "1629",
    "name": "Hebri",
    "state_id": "17"
  },
  {
    "id": "1630",
    "name": "Heggadadevanakote",
    "state_id": "17"
  },
  {
    "id": "1631",
    "name": "Herohalli",
    "state_id": "17"
  },
  {
    "id": "1632",
    "name": "Hidkal",
    "state_id": "17"
  },
  {
    "id": "1633",
    "name": "Hindalgi",
    "state_id": "17"
  },
  {
    "id": "1634",
    "name": "Hirekerur",
    "state_id": "17"
  },
  {
    "id": "1635",
    "name": "Hiriyur",
    "state_id": "17"
  },
  {
    "id": "1636",
    "name": "Holalkere",
    "state_id": "17"
  },
  {
    "id": "1637",
    "name": "Hole Narsipur",
    "state_id": "17"
  },
  {
    "id": "1638",
    "name": "Homnabad",
    "state_id": "17"
  },
  {
    "id": "1639",
    "name": "Honavar",
    "state_id": "17"
  },
  {
    "id": "1640",
    "name": "Honnali",
    "state_id": "17"
  },
  {
    "id": "1641",
    "name": "Hosakote",
    "state_id": "17"
  },
  {
    "id": "1642",
    "name": "Hosanagara",
    "state_id": "17"
  },
  {
    "id": "1643",
    "name": "Hosangadi",
    "state_id": "17"
  },
  {
    "id": "1644",
    "name": "Hosdurga",
    "state_id": "17"
  },
  {
    "id": "1645",
    "name": "Hoskote",
    "state_id": "17"
  },
  {
    "id": "1646",
    "name": "Hospet",
    "state_id": "17"
  },
  {
    "id": "1647",
    "name": "Hubli",
    "state_id": "17"
  },
  {
    "id": "1648",
    "name": "Hukeri",
    "state_id": "17"
  },
  {
    "id": "1649",
    "name": "Hunasagi",
    "state_id": "17"
  },
  {
    "id": "1650",
    "name": "Hunasamaranahalli",
    "state_id": "17"
  },
  {
    "id": "1651",
    "name": "Hungund",
    "state_id": "17"
  },
  {
    "id": "1652",
    "name": "Hunsur",
    "state_id": "17"
  },
  {
    "id": "1653",
    "name": "Huvina Hadagalli",
    "state_id": "17"
  },
  {
    "id": "1654",
    "name": "Ilkal",
    "state_id": "17"
  },
  {
    "id": "1655",
    "name": "Indi",
    "state_id": "17"
  },
  {
    "id": "1656",
    "name": "Jagalur",
    "state_id": "17"
  },
  {
    "id": "1657",
    "name": "Jamkhandi",
    "state_id": "17"
  },
  {
    "id": "1658",
    "name": "Jevargi",
    "state_id": "17"
  },
  {
    "id": "1659",
    "name": "Jog Falls",
    "state_id": "17"
  },
  {
    "id": "1660",
    "name": "Kabini Colony",
    "state_id": "17"
  },
  {
    "id": "1661",
    "name": "Kadur",
    "state_id": "17"
  },
  {
    "id": "1662",
    "name": "Kalghatgi",
    "state_id": "17"
  },
  {
    "id": "1663",
    "name": "Kamalapuram",
    "state_id": "17"
  },
  {
    "id": "1664",
    "name": "Kampli",
    "state_id": "17"
  },
  {
    "id": "1665",
    "name": "Kanakapura",
    "state_id": "17"
  },
  {
    "id": "1666",
    "name": "Kangrali BK",
    "state_id": "17"
  },
  {
    "id": "1667",
    "name": "Kangrali KH",
    "state_id": "17"
  },
  {
    "id": "1668",
    "name": "Kannur",
    "state_id": "17"
  },
  {
    "id": "1669",
    "name": "Karkala",
    "state_id": "17"
  },
  {
    "id": "1670",
    "name": "Karwar",
    "state_id": "17"
  },
  {
    "id": "1671",
    "name": "Kemminja",
    "state_id": "17"
  },
  {
    "id": "1672",
    "name": "Kengeri",
    "state_id": "17"
  },
  {
    "id": "1673",
    "name": "Kerur",
    "state_id": "17"
  },
  {
    "id": "1674",
    "name": "Khanapur",
    "state_id": "17"
  },
  {
    "id": "1675",
    "name": "Kodigenahalli",
    "state_id": "17"
  },
  {
    "id": "1676",
    "name": "Kodiyal",
    "state_id": "17"
  },
  {
    "id": "1677",
    "name": "Kodlipet",
    "state_id": "17"
  },
  {
    "id": "1678",
    "name": "Kolar",
    "state_id": "17"
  },
  {
    "id": "1679",
    "name": "Kollegal",
    "state_id": "17"
  },
  {
    "id": "1680",
    "name": "Konanakunte",
    "state_id": "17"
  },
  {
    "id": "1681",
    "name": "Konanur",
    "state_id": "17"
  },
  {
    "id": "1682",
    "name": "Konnur",
    "state_id": "17"
  },
  {
    "id": "1683",
    "name": "Koppa",
    "state_id": "17"
  },
  {
    "id": "1684",
    "name": "Koppal",
    "state_id": "17"
  },
  {
    "id": "1685",
    "name": "Koratagere",
    "state_id": "17"
  },
  {
    "id": "1686",
    "name": "Kotekara",
    "state_id": "17"
  },
  {
    "id": "1687",
    "name": "Kothnur",
    "state_id": "17"
  },
  {
    "id": "1688",
    "name": "Kotturu",
    "state_id": "17"
  },
  {
    "id": "1689",
    "name": "Krishnapura",
    "state_id": "17"
  },
  {
    "id": "1690",
    "name": "Krishnarajanagar",
    "state_id": "17"
  },
  {
    "id": "1691",
    "name": "Krishnarajapura",
    "state_id": "17"
  },
  {
    "id": "1692",
    "name": "Krishnarajasagara",
    "state_id": "17"
  },
  {
    "id": "1693",
    "name": "Krishnarajpet",
    "state_id": "17"
  },
  {
    "id": "1694",
    "name": "Kudchi",
    "state_id": "17"
  },
  {
    "id": "1695",
    "name": "Kudligi",
    "state_id": "17"
  },
  {
    "id": "1696",
    "name": "Kudremukh",
    "state_id": "17"
  },
  {
    "id": "1697",
    "name": "Kumsi",
    "state_id": "17"
  },
  {
    "id": "1698",
    "name": "Kumta",
    "state_id": "17"
  },
  {
    "id": "1699",
    "name": "Kundapura",
    "state_id": "17"
  },
  {
    "id": "1700",
    "name": "Kundgol",
    "state_id": "17"
  },
  {
    "id": "1701",
    "name": "Kunigal",
    "state_id": "17"
  },
  {
    "id": "1702",
    "name": "Kurgunta",
    "state_id": "17"
  },
  {
    "id": "1703",
    "name": "Kushalnagar",
    "state_id": "17"
  },
  {
    "id": "1704",
    "name": "Kushtagi",
    "state_id": "17"
  },
  {
    "id": "1705",
    "name": "Kyathanahalli",
    "state_id": "17"
  },
  {
    "id": "1706",
    "name": "Lakshmeshwar",
    "state_id": "17"
  },
  {
    "id": "1707",
    "name": "Lingsugur",
    "state_id": "17"
  },
  {
    "id": "1708",
    "name": "Londa",
    "state_id": "17"
  },
  {
    "id": "1709",
    "name": "Maddur",
    "state_id": "17"
  },
  {
    "id": "1710",
    "name": "Madhugiri",
    "state_id": "17"
  },
  {
    "id": "1711",
    "name": "Madikeri",
    "state_id": "17"
  },
  {
    "id": "1712",
    "name": "Magadi",
    "state_id": "17"
  },
  {
    "id": "1713",
    "name": "Magod Falls",
    "state_id": "17"
  },
  {
    "id": "1714",
    "name": "Mahadeswara Hills",
    "state_id": "17"
  },
  {
    "id": "1715",
    "name": "Mahadevapura",
    "state_id": "17"
  },
  {
    "id": "1716",
    "name": "Mahalingpur",
    "state_id": "17"
  },
  {
    "id": "1717",
    "name": "Maisuru",
    "state_id": "17"
  },
  {
    "id": "1718",
    "name": "Maisuru Cantonment",
    "state_id": "17"
  },
  {
    "id": "1719",
    "name": "Malavalli",
    "state_id": "17"
  },
  {
    "id": "1720",
    "name": "Mallar",
    "state_id": "17"
  },
  {
    "id": "1721",
    "name": "Malpe",
    "state_id": "17"
  },
  {
    "id": "1722",
    "name": "Malur",
    "state_id": "17"
  },
  {
    "id": "1723",
    "name": "Manchenahalli",
    "state_id": "17"
  },
  {
    "id": "1724",
    "name": "Mandya",
    "state_id": "17"
  },
  {
    "id": "1725",
    "name": "Mangalore",
    "state_id": "17"
  },
  {
    "id": "1726",
    "name": "Mangaluru",
    "state_id": "17"
  },
  {
    "id": "1727",
    "name": "Manipal",
    "state_id": "17"
  },
  {
    "id": "1728",
    "name": "Manvi",
    "state_id": "17"
  },
  {
    "id": "1729",
    "name": "Maski",
    "state_id": "17"
  },
  {
    "id": "1730",
    "name": "Mastikatte Colony",
    "state_id": "17"
  },
  {
    "id": "1731",
    "name": "Mayakonda",
    "state_id": "17"
  },
  {
    "id": "1732",
    "name": "Melukote",
    "state_id": "17"
  },
  {
    "id": "1733",
    "name": "Molakalmuru",
    "state_id": "17"
  },
  {
    "id": "1734",
    "name": "Mudalgi",
    "state_id": "17"
  },
  {
    "id": "1735",
    "name": "Mudbidri",
    "state_id": "17"
  },
  {
    "id": "1736",
    "name": "Muddebihal",
    "state_id": "17"
  },
  {
    "id": "1737",
    "name": "Mudgal",
    "state_id": "17"
  },
  {
    "id": "1738",
    "name": "Mudhol",
    "state_id": "17"
  },
  {
    "id": "1739",
    "name": "Mudigere",
    "state_id": "17"
  },
  {
    "id": "1740",
    "name": "Mudushedde",
    "state_id": "17"
  },
  {
    "id": "1741",
    "name": "Mulbagal",
    "state_id": "17"
  },
  {
    "id": "1742",
    "name": "Mulgund",
    "state_id": "17"
  },
  {
    "id": "1743",
    "name": "Mulki",
    "state_id": "17"
  },
  {
    "id": "1744",
    "name": "Mulur",
    "state_id": "17"
  },
  {
    "id": "1745",
    "name": "Mundargi",
    "state_id": "17"
  },
  {
    "id": "1746",
    "name": "Mundgod",
    "state_id": "17"
  },
  {
    "id": "1747",
    "name": "Munirabad",
    "state_id": "17"
  },
  {
    "id": "1748",
    "name": "Munnur",
    "state_id": "17"
  },
  {
    "id": "1749",
    "name": "Murudeshwara",
    "state_id": "17"
  },
  {
    "id": "1750",
    "name": "Mysore",
    "state_id": "17"
  },
  {
    "id": "1751",
    "name": "Nagamangala",
    "state_id": "17"
  },
  {
    "id": "1752",
    "name": "Nanjangud",
    "state_id": "17"
  },
  {
    "id": "1753",
    "name": "Naragund",
    "state_id": "17"
  },
  {
    "id": "1754",
    "name": "Narasimharajapura",
    "state_id": "17"
  },
  {
    "id": "1755",
    "name": "Naravi",
    "state_id": "17"
  },
  {
    "id": "1756",
    "name": "Narayanpur",
    "state_id": "17"
  },
  {
    "id": "1757",
    "name": "Naregal",
    "state_id": "17"
  },
  {
    "id": "1758",
    "name": "Navalgund",
    "state_id": "17"
  },
  {
    "id": "1759",
    "name": "Nelmangala",
    "state_id": "17"
  },
  {
    "id": "1760",
    "name": "Nipani",
    "state_id": "17"
  },
  {
    "id": "1761",
    "name": "Nitte",
    "state_id": "17"
  },
  {
    "id": "1762",
    "name": "Nyamati",
    "state_id": "17"
  },
  {
    "id": "1763",
    "name": "Padu",
    "state_id": "17"
  },
  {
    "id": "1764",
    "name": "Pandavapura",
    "state_id": "17"
  },
  {
    "id": "1765",
    "name": "Pattanagere",
    "state_id": "17"
  },
  {
    "id": "1766",
    "name": "Pavagada",
    "state_id": "17"
  },
  {
    "id": "1767",
    "name": "Piriyapatna",
    "state_id": "17"
  },
  {
    "id": "1768",
    "name": "Ponnampet",
    "state_id": "17"
  },
  {
    "id": "1769",
    "name": "Puttur",
    "state_id": "17"
  },
  {
    "id": "1770",
    "name": "Rabkavi",
    "state_id": "17"
  },
  {
    "id": "1771",
    "name": "Raichur",
    "state_id": "17"
  },
  {
    "id": "1772",
    "name": "Ramanagaram",
    "state_id": "17"
  },
  {
    "id": "1773",
    "name": "Ramdurg",
    "state_id": "17"
  },
  {
    "id": "1774",
    "name": "Ranibennur",
    "state_id": "17"
  },
  {
    "id": "1775",
    "name": "Raybag",
    "state_id": "17"
  },
  {
    "id": "1776",
    "name": "Robertsonpet",
    "state_id": "17"
  },
  {
    "id": "1777",
    "name": "Ron",
    "state_id": "17"
  },
  {
    "id": "1778",
    "name": "Sadalgi",
    "state_id": "17"
  },
  {
    "id": "1779",
    "name": "Sagar",
    "state_id": "17"
  },
  {
    "id": "1780",
    "name": "Sakleshpur",
    "state_id": "17"
  },
  {
    "id": "1781",
    "name": "Saligram",
    "state_id": "17"
  },
  {
    "id": "1782",
    "name": "Sandur",
    "state_id": "17"
  },
  {
    "id": "1783",
    "name": "Sanivarsante",
    "state_id": "17"
  },
  {
    "id": "1784",
    "name": "Sankeshwar",
    "state_id": "17"
  },
  {
    "id": "1785",
    "name": "Sargur",
    "state_id": "17"
  },
  {
    "id": "1786",
    "name": "Sathyamangala",
    "state_id": "17"
  },
  {
    "id": "1787",
    "name": "Saundatti Yellamma",
    "state_id": "17"
  },
  {
    "id": "1788",
    "name": "Savanur",
    "state_id": "17"
  },
  {
    "id": "1789",
    "name": "Sedam",
    "state_id": "17"
  },
  {
    "id": "1790",
    "name": "Shahabad",
    "state_id": "17"
  },
  {
    "id": "1791",
    "name": "Shahabad A.C.C.",
    "state_id": "17"
  },
  {
    "id": "1792",
    "name": "Shahapur",
    "state_id": "17"
  },
  {
    "id": "1793",
    "name": "Shahpur",
    "state_id": "17"
  },
  {
    "id": "1794",
    "name": "Shaktinagar",
    "state_id": "17"
  },
  {
    "id": "1795",
    "name": "Shiggaon",
    "state_id": "17"
  },
  {
    "id": "1796",
    "name": "Shikarpur",
    "state_id": "17"
  },
  {
    "id": "1797",
    "name": "Shimoga",
    "state_id": "17"
  },
  {
    "id": "1798",
    "name": "Shirhatti",
    "state_id": "17"
  },
  {
    "id": "1799",
    "name": "Shorapur",
    "state_id": "17"
  },
  {
    "id": "1800",
    "name": "Shravanabelagola",
    "state_id": "17"
  },
  {
    "id": "1801",
    "name": "Shrirangapattana",
    "state_id": "17"
  },
  {
    "id": "1802",
    "name": "Siddapur",
    "state_id": "17"
  },
  {
    "id": "1803",
    "name": "Sidlaghatta",
    "state_id": "17"
  },
  {
    "id": "1804",
    "name": "Sindgi",
    "state_id": "17"
  },
  {
    "id": "1805",
    "name": "Sindhnur",
    "state_id": "17"
  },
  {
    "id": "1806",
    "name": "Sira",
    "state_id": "17"
  },
  {
    "id": "1807",
    "name": "Sirakoppa",
    "state_id": "17"
  },
  {
    "id": "1808",
    "name": "Sirsi",
    "state_id": "17"
  },
  {
    "id": "1809",
    "name": "Siruguppa",
    "state_id": "17"
  },
  {
    "id": "1810",
    "name": "Someshwar",
    "state_id": "17"
  },
  {
    "id": "1811",
    "name": "Somvarpet",
    "state_id": "17"
  },
  {
    "id": "1812",
    "name": "Sorab",
    "state_id": "17"
  },
  {
    "id": "1813",
    "name": "Sringeri",
    "state_id": "17"
  },
  {
    "id": "1814",
    "name": "Srinivaspur",
    "state_id": "17"
  },
  {
    "id": "1815",
    "name": "Sulya",
    "state_id": "17"
  },
  {
    "id": "1816",
    "name": "Suntikopa",
    "state_id": "17"
  },
  {
    "id": "1817",
    "name": "Talikota",
    "state_id": "17"
  },
  {
    "id": "1818",
    "name": "Tarikera",
    "state_id": "17"
  },
  {
    "id": "1819",
    "name": "Tekkalakota",
    "state_id": "17"
  },
  {
    "id": "1820",
    "name": "Terdal",
    "state_id": "17"
  },
  {
    "id": "1821",
    "name": "Thokur",
    "state_id": "17"
  },
  {
    "id": "1822",
    "name": "Thumbe",
    "state_id": "17"
  },
  {
    "id": "1823",
    "name": "Tiptur",
    "state_id": "17"
  },
  {
    "id": "1824",
    "name": "Tirthahalli",
    "state_id": "17"
  },
  {
    "id": "1825",
    "name": "Tirumakudal Narsipur",
    "state_id": "17"
  },
  {
    "id": "1826",
    "name": "Tonse",
    "state_id": "17"
  },
  {
    "id": "1827",
    "name": "Tumkur",
    "state_id": "17"
  },
  {
    "id": "1828",
    "name": "Turuvekere",
    "state_id": "17"
  },
  {
    "id": "1829",
    "name": "Udupi",
    "state_id": "17"
  },
  {
    "id": "1830",
    "name": "Ullal",
    "state_id": "17"
  },
  {
    "id": "1831",
    "name": "Uttarahalli",
    "state_id": "17"
  },
  {
    "id": "1832",
    "name": "Venkatapura",
    "state_id": "17"
  },
  {
    "id": "1833",
    "name": "Vijayapura",
    "state_id": "17"
  },
  {
    "id": "1834",
    "name": "Virarajendrapet",
    "state_id": "17"
  },
  {
    "id": "1835",
    "name": "Wadi",
    "state_id": "17"
  },
  {
    "id": "1836",
    "name": "Wadi A.C.C.",
    "state_id": "17"
  },
  {
    "id": "1837",
    "name": "Yadgir",
    "state_id": "17"
  },
  {
    "id": "1838",
    "name": "Yelahanka",
    "state_id": "17"
  },
  {
    "id": "1839",
    "name": "Yelandur",
    "state_id": "17"
  },
  {
    "id": "1840",
    "name": "Yelbarga",
    "state_id": "17"
  },
  {
    "id": "1841",
    "name": "Yellapur",
    "state_id": "17"
  },
  {
    "id": "1842",
    "name": "Yenagudde",
    "state_id": "17"
  },
  {
    "id": "1843",
    "name": "Adimaly",
    "state_id": "19"
  },
  {
    "id": "1844",
    "name": "Adoor",
    "state_id": "19"
  },
  {
    "id": "1845",
    "name": "Adur",
    "state_id": "19"
  },
  {
    "id": "1846",
    "name": "Akathiyur",
    "state_id": "19"
  },
  {
    "id": "1847",
    "name": "Alangad",
    "state_id": "19"
  },
  {
    "id": "1848",
    "name": "Alappuzha",
    "state_id": "19"
  },
  {
    "id": "1849",
    "name": "Aluva",
    "state_id": "19"
  },
  {
    "id": "1850",
    "name": "Ancharakandy",
    "state_id": "19"
  },
  {
    "id": "1851",
    "name": "Angamaly",
    "state_id": "19"
  },
  {
    "id": "1852",
    "name": "Aroor",
    "state_id": "19"
  },
  {
    "id": "1853",
    "name": "Arukutti",
    "state_id": "19"
  },
  {
    "id": "1854",
    "name": "Attingal",
    "state_id": "19"
  },
  {
    "id": "1855",
    "name": "Avinissery",
    "state_id": "19"
  },
  {
    "id": "1856",
    "name": "Azhikode North",
    "state_id": "19"
  },
  {
    "id": "1857",
    "name": "Azhikode South",
    "state_id": "19"
  },
  {
    "id": "1858",
    "name": "Azhiyur",
    "state_id": "19"
  },
  {
    "id": "1859",
    "name": "Balussery",
    "state_id": "19"
  },
  {
    "id": "1860",
    "name": "Bangramanjeshwar",
    "state_id": "19"
  },
  {
    "id": "1861",
    "name": "Beypur",
    "state_id": "19"
  },
  {
    "id": "1862",
    "name": "Brahmakulam",
    "state_id": "19"
  },
  {
    "id": "1863",
    "name": "Chala",
    "state_id": "19"
  },
  {
    "id": "1864",
    "name": "Chalakudi",
    "state_id": "19"
  },
  {
    "id": "1865",
    "name": "Changanacheri",
    "state_id": "19"
  },
  {
    "id": "1866",
    "name": "Chauwara",
    "state_id": "19"
  },
  {
    "id": "1867",
    "name": "Chavakkad",
    "state_id": "19"
  },
  {
    "id": "1868",
    "name": "Chelakkara",
    "state_id": "19"
  },
  {
    "id": "1869",
    "name": "Chelora",
    "state_id": "19"
  },
  {
    "id": "1870",
    "name": "Chendamangalam",
    "state_id": "19"
  },
  {
    "id": "1871",
    "name": "Chengamanad",
    "state_id": "19"
  },
  {
    "id": "1872",
    "name": "Chengannur",
    "state_id": "19"
  },
  {
    "id": "1873",
    "name": "Cheranallur",
    "state_id": "19"
  },
  {
    "id": "1874",
    "name": "Cheriyakadavu",
    "state_id": "19"
  },
  {
    "id": "1875",
    "name": "Cherthala",
    "state_id": "19"
  },
  {
    "id": "1876",
    "name": "Cherukunnu",
    "state_id": "19"
  },
  {
    "id": "1877",
    "name": "Cheruthazham",
    "state_id": "19"
  },
  {
    "id": "1878",
    "name": "Cheruvannur",
    "state_id": "19"
  },
  {
    "id": "1879",
    "name": "Cheruvattur",
    "state_id": "19"
  },
  {
    "id": "1880",
    "name": "Chevvur",
    "state_id": "19"
  },
  {
    "id": "1881",
    "name": "Chirakkal",
    "state_id": "19"
  },
  {
    "id": "1882",
    "name": "Chittur",
    "state_id": "19"
  },
  {
    "id": "1883",
    "name": "Chockli",
    "state_id": "19"
  },
  {
    "id": "1884",
    "name": "Churnikkara",
    "state_id": "19"
  },
  {
    "id": "1885",
    "name": "Dharmadam",
    "state_id": "19"
  },
  {
    "id": "1886",
    "name": "Edappal",
    "state_id": "19"
  },
  {
    "id": "1887",
    "name": "Edathala",
    "state_id": "19"
  },
  {
    "id": "1888",
    "name": "Elayavur",
    "state_id": "19"
  },
  {
    "id": "1889",
    "name": "Elur",
    "state_id": "19"
  },
  {
    "id": "1890",
    "name": "Eranholi",
    "state_id": "19"
  },
  {
    "id": "1891",
    "name": "Erattupetta",
    "state_id": "19"
  },
  {
    "id": "1892",
    "name": "Ernakulam",
    "state_id": "19"
  },
  {
    "id": "1893",
    "name": "Eruvatti",
    "state_id": "19"
  },
  {
    "id": "1894",
    "name": "Ettumanoor",
    "state_id": "19"
  },
  {
    "id": "1895",
    "name": "Feroke",
    "state_id": "19"
  },
  {
    "id": "1896",
    "name": "Guruvayur",
    "state_id": "19"
  },
  {
    "id": "1897",
    "name": "Haripad",
    "state_id": "19"
  },
  {
    "id": "1898",
    "name": "Hosabettu",
    "state_id": "19"
  },
  {
    "id": "1899",
    "name": "Idukki",
    "state_id": "19"
  },
  {
    "id": "1900",
    "name": "Iringaprom",
    "state_id": "19"
  },
  {
    "id": "1901",
    "name": "Irinjalakuda",
    "state_id": "19"
  },
  {
    "id": "1902",
    "name": "Iriveri",
    "state_id": "19"
  },
  {
    "id": "1903",
    "name": "Kadachira",
    "state_id": "19"
  },
  {
    "id": "1904",
    "name": "Kadalundi",
    "state_id": "19"
  },
  {
    "id": "1905",
    "name": "Kadamakkudy",
    "state_id": "19"
  },
  {
    "id": "1906",
    "name": "Kadirur",
    "state_id": "19"
  },
  {
    "id": "1907",
    "name": "Kadungallur",
    "state_id": "19"
  },
  {
    "id": "1908",
    "name": "Kakkodi",
    "state_id": "19"
  },
  {
    "id": "1909",
    "name": "Kalady",
    "state_id": "19"
  },
  {
    "id": "1910",
    "name": "Kalamassery",
    "state_id": "19"
  },
  {
    "id": "1911",
    "name": "Kalliasseri",
    "state_id": "19"
  },
  {
    "id": "1912",
    "name": "Kalpetta",
    "state_id": "19"
  },
  {
    "id": "1913",
    "name": "Kanhangad",
    "state_id": "19"
  },
  {
    "id": "1914",
    "name": "Kanhirode",
    "state_id": "19"
  },
  {
    "id": "1915",
    "name": "Kanjikkuzhi",
    "state_id": "19"
  },
  {
    "id": "1916",
    "name": "Kanjikode",
    "state_id": "19"
  },
  {
    "id": "1917",
    "name": "Kanjirappalli",
    "state_id": "19"
  },
  {
    "id": "1918",
    "name": "Kannadiparamba",
    "state_id": "19"
  },
  {
    "id": "1919",
    "name": "Kannangad",
    "state_id": "19"
  },
  {
    "id": "1920",
    "name": "Kannapuram",
    "state_id": "19"
  },
  {
    "id": "1921",
    "name": "Kannur",
    "state_id": "19"
  },
  {
    "id": "1922",
    "name": "Kannur Cantonment",
    "state_id": "19"
  },
  {
    "id": "1923",
    "name": "Karunagappally",
    "state_id": "19"
  },
  {
    "id": "1924",
    "name": "Karuvamyhuruthy",
    "state_id": "19"
  },
  {
    "id": "1925",
    "name": "Kasaragod",
    "state_id": "19"
  },
  {
    "id": "1926",
    "name": "Kasargod",
    "state_id": "19"
  },
  {
    "id": "1927",
    "name": "Kattappana",
    "state_id": "19"
  },
  {
    "id": "1928",
    "name": "Kayamkulam",
    "state_id": "19"
  },
  {
    "id": "1929",
    "name": "Kedamangalam",
    "state_id": "19"
  },
  {
    "id": "1930",
    "name": "Kochi",
    "state_id": "19"
  },
  {
    "id": "1931",
    "name": "Kodamthuruthu",
    "state_id": "19"
  },
  {
    "id": "1932",
    "name": "Kodungallur",
    "state_id": "19"
  },
  {
    "id": "1933",
    "name": "Koduvally",
    "state_id": "19"
  },
  {
    "id": "1934",
    "name": "Koduvayur",
    "state_id": "19"
  },
  {
    "id": "1935",
    "name": "Kokkothamangalam",
    "state_id": "19"
  },
  {
    "id": "1936",
    "name": "Kolazhy",
    "state_id": "19"
  },
  {
    "id": "1937",
    "name": "Kollam",
    "state_id": "19"
  },
  {
    "id": "1938",
    "name": "Komalapuram",
    "state_id": "19"
  },
  {
    "id": "1939",
    "name": "Koothattukulam",
    "state_id": "19"
  },
  {
    "id": "1940",
    "name": "Koratty",
    "state_id": "19"
  },
  {
    "id": "1941",
    "name": "Kothamangalam",
    "state_id": "19"
  },
  {
    "id": "1942",
    "name": "Kottarakkara",
    "state_id": "19"
  },
  {
    "id": "1943",
    "name": "Kottayam",
    "state_id": "19"
  },
  {
    "id": "1944",
    "name": "Kottayam Malabar",
    "state_id": "19"
  },
  {
    "id": "1945",
    "name": "Kottuvally",
    "state_id": "19"
  },
  {
    "id": "1946",
    "name": "Koyilandi",
    "state_id": "19"
  },
  {
    "id": "1947",
    "name": "Kozhikode",
    "state_id": "19"
  },
  {
    "id": "1948",
    "name": "Kudappanakunnu",
    "state_id": "19"
  },
  {
    "id": "1949",
    "name": "Kudlu",
    "state_id": "19"
  },
  {
    "id": "1950",
    "name": "Kumarakom",
    "state_id": "19"
  },
  {
    "id": "1951",
    "name": "Kumily",
    "state_id": "19"
  },
  {
    "id": "1952",
    "name": "Kunnamangalam",
    "state_id": "19"
  },
  {
    "id": "1953",
    "name": "Kunnamkulam",
    "state_id": "19"
  },
  {
    "id": "1954",
    "name": "Kurikkad",
    "state_id": "19"
  },
  {
    "id": "1955",
    "name": "Kurkkanchery",
    "state_id": "19"
  },
  {
    "id": "1956",
    "name": "Kuthuparamba",
    "state_id": "19"
  },
  {
    "id": "1957",
    "name": "Kuttakulam",
    "state_id": "19"
  },
  {
    "id": "1958",
    "name": "Kuttikkattur",
    "state_id": "19"
  },
  {
    "id": "1959",
    "name": "Kuttur",
    "state_id": "19"
  },
  {
    "id": "1960",
    "name": "Malappuram",
    "state_id": "19"
  },
  {
    "id": "1961",
    "name": "Mallappally",
    "state_id": "19"
  },
  {
    "id": "1962",
    "name": "Manjeri",
    "state_id": "19"
  },
  {
    "id": "1963",
    "name": "Manjeshwar",
    "state_id": "19"
  },
  {
    "id": "1964",
    "name": "Mannancherry",
    "state_id": "19"
  },
  {
    "id": "1965",
    "name": "Mannar",
    "state_id": "19"
  },
  {
    "id": "1966",
    "name": "Mannarakkat",
    "state_id": "19"
  },
  {
    "id": "1967",
    "name": "Maradu",
    "state_id": "19"
  },
  {
    "id": "1968",
    "name": "Marathakkara",
    "state_id": "19"
  },
  {
    "id": "1969",
    "name": "Marutharod",
    "state_id": "19"
  },
  {
    "id": "1970",
    "name": "Mattannur",
    "state_id": "19"
  },
  {
    "id": "1971",
    "name": "Mavelikara",
    "state_id": "19"
  },
  {
    "id": "1972",
    "name": "Mavilayi",
    "state_id": "19"
  },
  {
    "id": "1973",
    "name": "Mavur",
    "state_id": "19"
  },
  {
    "id": "1974",
    "name": "Methala",
    "state_id": "19"
  },
  {
    "id": "1975",
    "name": "Muhamma",
    "state_id": "19"
  },
  {
    "id": "1976",
    "name": "Mulavukad",
    "state_id": "19"
  },
  {
    "id": "1977",
    "name": "Mundakayam",
    "state_id": "19"
  },
  {
    "id": "1978",
    "name": "Munderi",
    "state_id": "19"
  },
  {
    "id": "1979",
    "name": "Munnar",
    "state_id": "19"
  },
  {
    "id": "1980",
    "name": "Muthakunnam",
    "state_id": "19"
  },
  {
    "id": "1981",
    "name": "Muvattupuzha",
    "state_id": "19"
  },
  {
    "id": "1982",
    "name": "Muzhappilangad",
    "state_id": "19"
  },
  {
    "id": "1983",
    "name": "Nadapuram",
    "state_id": "19"
  },
  {
    "id": "1984",
    "name": "Nadathara",
    "state_id": "19"
  },
  {
    "id": "1985",
    "name": "Narath",
    "state_id": "19"
  },
  {
    "id": "1986",
    "name": "Nattakam",
    "state_id": "19"
  },
  {
    "id": "1987",
    "name": "Nedumangad",
    "state_id": "19"
  },
  {
    "id": "1988",
    "name": "Nenmenikkara",
    "state_id": "19"
  },
  {
    "id": "1989",
    "name": "New Mahe",
    "state_id": "19"
  },
  {
    "id": "1990",
    "name": "Neyyattinkara",
    "state_id": "19"
  },
  {
    "id": "1991",
    "name": "Nileshwar",
    "state_id": "19"
  },
  {
    "id": "1992",
    "name": "Olavanna",
    "state_id": "19"
  },
  {
    "id": "1993",
    "name": "Ottapalam",
    "state_id": "19"
  },
  {
    "id": "1994",
    "name": "Ottappalam",
    "state_id": "19"
  },
  {
    "id": "1995",
    "name": "Paduvilayi",
    "state_id": "19"
  },
  {
    "id": "1996",
    "name": "Palai",
    "state_id": "19"
  },
  {
    "id": "1997",
    "name": "Palakkad",
    "state_id": "19"
  },
  {
    "id": "1998",
    "name": "Palayad",
    "state_id": "19"
  },
  {
    "id": "1999",
    "name": "Palissery",
    "state_id": "19"
  },
  {
    "id": "2000",
    "name": "Pallikkunnu",
    "state_id": "19"
  },
  {
    "id": "2001",
    "name": "Paluvai",
    "state_id": "19"
  },
  {
    "id": "2002",
    "name": "Panniyannur",
    "state_id": "19"
  },
  {
    "id": "2003",
    "name": "Pantalam",
    "state_id": "19"
  },
  {
    "id": "2004",
    "name": "Panthiramkavu",
    "state_id": "19"
  },
  {
    "id": "2005",
    "name": "Panur",
    "state_id": "19"
  },
  {
    "id": "2006",
    "name": "Pappinisseri",
    "state_id": "19"
  },
  {
    "id": "2007",
    "name": "Parassala",
    "state_id": "19"
  },
  {
    "id": "2008",
    "name": "Paravur",
    "state_id": "19"
  },
  {
    "id": "2009",
    "name": "Pathanamthitta",
    "state_id": "19"
  },
  {
    "id": "2010",
    "name": "Pathanapuram",
    "state_id": "19"
  },
  {
    "id": "2011",
    "name": "Pathiriyad",
    "state_id": "19"
  },
  {
    "id": "2012",
    "name": "Pattambi",
    "state_id": "19"
  },
  {
    "id": "2013",
    "name": "Pattiom",
    "state_id": "19"
  },
  {
    "id": "2014",
    "name": "Pavaratty",
    "state_id": "19"
  },
  {
    "id": "2015",
    "name": "Payyannur",
    "state_id": "19"
  },
  {
    "id": "2016",
    "name": "Peermade",
    "state_id": "19"
  },
  {
    "id": "2017",
    "name": "Perakam",
    "state_id": "19"
  },
  {
    "id": "2018",
    "name": "Peralasseri",
    "state_id": "19"
  },
  {
    "id": "2019",
    "name": "Peringathur",
    "state_id": "19"
  },
  {
    "id": "2020",
    "name": "Perinthalmanna",
    "state_id": "19"
  },
  {
    "id": "2021",
    "name": "Perole",
    "state_id": "19"
  },
  {
    "id": "2022",
    "name": "Perumanna",
    "state_id": "19"
  },
  {
    "id": "2023",
    "name": "Perumbaikadu",
    "state_id": "19"
  },
  {
    "id": "2024",
    "name": "Perumbavoor",
    "state_id": "19"
  },
  {
    "id": "2025",
    "name": "Pinarayi",
    "state_id": "19"
  },
  {
    "id": "2026",
    "name": "Piravam",
    "state_id": "19"
  },
  {
    "id": "2027",
    "name": "Ponnani",
    "state_id": "19"
  },
  {
    "id": "2028",
    "name": "Pottore",
    "state_id": "19"
  },
  {
    "id": "2029",
    "name": "Pudukad",
    "state_id": "19"
  },
  {
    "id": "2030",
    "name": "Punalur",
    "state_id": "19"
  },
  {
    "id": "2031",
    "name": "Puranattukara",
    "state_id": "19"
  },
  {
    "id": "2032",
    "name": "Puthunagaram",
    "state_id": "19"
  },
  {
    "id": "2033",
    "name": "Puthuppariyaram",
    "state_id": "19"
  },
  {
    "id": "2034",
    "name": "Puzhathi",
    "state_id": "19"
  },
  {
    "id": "2035",
    "name": "Ramanattukara",
    "state_id": "19"
  },
  {
    "id": "2036",
    "name": "Shoranur",
    "state_id": "19"
  },
  {
    "id": "2037",
    "name": "Sultans Battery",
    "state_id": "19"
  },
  {
    "id": "2038",
    "name": "Sulthan Bathery",
    "state_id": "19"
  },
  {
    "id": "2039",
    "name": "Talipparamba",
    "state_id": "19"
  },
  {
    "id": "2040",
    "name": "Thaikkad",
    "state_id": "19"
  },
  {
    "id": "2041",
    "name": "Thalassery",
    "state_id": "19"
  },
  {
    "id": "2042",
    "name": "Thannirmukkam",
    "state_id": "19"
  },
  {
    "id": "2043",
    "name": "Theyyalingal",
    "state_id": "19"
  },
  {
    "id": "2044",
    "name": "Thiruvalla",
    "state_id": "19"
  },
  {
    "id": "2045",
    "name": "Thiruvananthapuram",
    "state_id": "19"
  },
  {
    "id": "2046",
    "name": "Thiruvankulam",
    "state_id": "19"
  },
  {
    "id": "2047",
    "name": "Thodupuzha",
    "state_id": "19"
  },
  {
    "id": "2048",
    "name": "Thottada",
    "state_id": "19"
  },
  {
    "id": "2049",
    "name": "Thrippunithura",
    "state_id": "19"
  },
  {
    "id": "2050",
    "name": "Thrissur",
    "state_id": "19"
  },
  {
    "id": "2051",
    "name": "Tirur",
    "state_id": "19"
  },
  {
    "id": "2052",
    "name": "Udma",
    "state_id": "19"
  },
  {
    "id": "2053",
    "name": "Vadakara",
    "state_id": "19"
  },
  {
    "id": "2054",
    "name": "Vaikam",
    "state_id": "19"
  },
  {
    "id": "2055",
    "name": "Valapattam",
    "state_id": "19"
  },
  {
    "id": "2056",
    "name": "Vallachira",
    "state_id": "19"
  },
  {
    "id": "2057",
    "name": "Varam",
    "state_id": "19"
  },
  {
    "id": "2058",
    "name": "Varappuzha",
    "state_id": "19"
  },
  {
    "id": "2059",
    "name": "Varkala",
    "state_id": "19"
  },
  {
    "id": "2060",
    "name": "Vayalar",
    "state_id": "19"
  },
  {
    "id": "2061",
    "name": "Vazhakkala",
    "state_id": "19"
  },
  {
    "id": "2062",
    "name": "Venmanad",
    "state_id": "19"
  },
  {
    "id": "2063",
    "name": "Villiappally",
    "state_id": "19"
  },
  {
    "id": "2064",
    "name": "Wayanad",
    "state_id": "19"
  },
  {
    "id": "2065",
    "name": "Agethi",
    "state_id": "20"
  },
  {
    "id": "2066",
    "name": "Amini",
    "state_id": "20"
  },
  {
    "id": "2067",
    "name": "Androth Island",
    "state_id": "20"
  },
  {
    "id": "2068",
    "name": "Kavaratti",
    "state_id": "20"
  },
  {
    "id": "2069",
    "name": "Minicoy",
    "state_id": "20"
  },
  {
    "id": "2070",
    "name": "Agar",
    "state_id": "21"
  },
  {
    "id": "2071",
    "name": "Ajaigarh",
    "state_id": "21"
  },
  {
    "id": "2072",
    "name": "Akoda",
    "state_id": "21"
  },
  {
    "id": "2073",
    "name": "Akodia",
    "state_id": "21"
  },
  {
    "id": "2074",
    "name": "Alampur",
    "state_id": "21"
  },
  {
    "id": "2075",
    "name": "Alirajpur",
    "state_id": "21"
  },
  {
    "id": "2076",
    "name": "Alot",
    "state_id": "21"
  },
  {
    "id": "2077",
    "name": "Amanganj",
    "state_id": "21"
  },
  {
    "id": "2078",
    "name": "Amarkantak",
    "state_id": "21"
  },
  {
    "id": "2079",
    "name": "Amarpatan",
    "state_id": "21"
  },
  {
    "id": "2080",
    "name": "Amarwara",
    "state_id": "21"
  },
  {
    "id": "2081",
    "name": "Ambada",
    "state_id": "21"
  },
  {
    "id": "2082",
    "name": "Ambah",
    "state_id": "21"
  },
  {
    "id": "2083",
    "name": "Amla",
    "state_id": "21"
  },
  {
    "id": "2084",
    "name": "Amlai",
    "state_id": "21"
  },
  {
    "id": "2085",
    "name": "Anjad",
    "state_id": "21"
  },
  {
    "id": "2086",
    "name": "Antri",
    "state_id": "21"
  },
  {
    "id": "2087",
    "name": "Anuppur",
    "state_id": "21"
  },
  {
    "id": "2088",
    "name": "Aron",
    "state_id": "21"
  },
  {
    "id": "2089",
    "name": "Ashoknagar",
    "state_id": "21"
  },
  {
    "id": "2090",
    "name": "Ashta",
    "state_id": "21"
  },
  {
    "id": "2091",
    "name": "Babai",
    "state_id": "21"
  },
  {
    "id": "2092",
    "name": "Bada Malhera",
    "state_id": "21"
  },
  {
    "id": "2093",
    "name": "Badagaon",
    "state_id": "21"
  },
  {
    "id": "2094",
    "name": "Badagoan",
    "state_id": "21"
  },
  {
    "id": "2095",
    "name": "Badarwas",
    "state_id": "21"
  },
  {
    "id": "2096",
    "name": "Badawada",
    "state_id": "21"
  },
  {
    "id": "2097",
    "name": "Badi",
    "state_id": "21"
  },
  {
    "id": "2098",
    "name": "Badkuhi",
    "state_id": "21"
  },
  {
    "id": "2099",
    "name": "Badnagar",
    "state_id": "21"
  },
  {
    "id": "2100",
    "name": "Badnawar",
    "state_id": "21"
  },
  {
    "id": "2101",
    "name": "Badod",
    "state_id": "21"
  },
  {
    "id": "2102",
    "name": "Badoda",
    "state_id": "21"
  },
  {
    "id": "2103",
    "name": "Badra",
    "state_id": "21"
  },
  {
    "id": "2104",
    "name": "Bagh",
    "state_id": "21"
  },
  {
    "id": "2105",
    "name": "Bagli",
    "state_id": "21"
  },
  {
    "id": "2106",
    "name": "Baihar",
    "state_id": "21"
  },
  {
    "id": "2107",
    "name": "Baikunthpur",
    "state_id": "21"
  },
  {
    "id": "2108",
    "name": "Bakswaha",
    "state_id": "21"
  },
  {
    "id": "2109",
    "name": "Balaghat",
    "state_id": "21"
  },
  {
    "id": "2110",
    "name": "Baldeogarh",
    "state_id": "21"
  },
  {
    "id": "2111",
    "name": "Bamaniya",
    "state_id": "21"
  },
  {
    "id": "2112",
    "name": "Bamhani",
    "state_id": "21"
  },
  {
    "id": "2113",
    "name": "Bamor",
    "state_id": "21"
  },
  {
    "id": "2114",
    "name": "Bamora",
    "state_id": "21"
  },
  {
    "id": "2115",
    "name": "Banda",
    "state_id": "21"
  },
  {
    "id": "2116",
    "name": "Bangawan",
    "state_id": "21"
  },
  {
    "id": "2117",
    "name": "Bansatar Kheda",
    "state_id": "21"
  },
  {
    "id": "2118",
    "name": "Baraily",
    "state_id": "21"
  },
  {
    "id": "2119",
    "name": "Barela",
    "state_id": "21"
  },
  {
    "id": "2120",
    "name": "Barghat",
    "state_id": "21"
  },
  {
    "id": "2121",
    "name": "Bargi",
    "state_id": "21"
  },
  {
    "id": "2122",
    "name": "Barhi",
    "state_id": "21"
  },
  {
    "id": "2123",
    "name": "Barigarh",
    "state_id": "21"
  },
  {
    "id": "2124",
    "name": "Barwaha",
    "state_id": "21"
  },
  {
    "id": "2125",
    "name": "Barwani",
    "state_id": "21"
  },
  {
    "id": "2126",
    "name": "Basoda",
    "state_id": "21"
  },
  {
    "id": "2127",
    "name": "Begamganj",
    "state_id": "21"
  },
  {
    "id": "2128",
    "name": "Beohari",
    "state_id": "21"
  },
  {
    "id": "2129",
    "name": "Berasia",
    "state_id": "21"
  },
  {
    "id": "2130",
    "name": "Betma",
    "state_id": "21"
  },
  {
    "id": "2131",
    "name": "Betul",
    "state_id": "21"
  },
  {
    "id": "2132",
    "name": "Betul Bazar",
    "state_id": "21"
  },
  {
    "id": "2133",
    "name": "Bhainsdehi",
    "state_id": "21"
  },
  {
    "id": "2134",
    "name": "Bhamodi",
    "state_id": "21"
  },
  {
    "id": "2135",
    "name": "Bhander",
    "state_id": "21"
  },
  {
    "id": "2136",
    "name": "Bhanpura",
    "state_id": "21"
  },
  {
    "id": "2137",
    "name": "Bharveli",
    "state_id": "21"
  },
  {
    "id": "2138",
    "name": "Bhaurasa",
    "state_id": "21"
  },
  {
    "id": "2139",
    "name": "Bhavra",
    "state_id": "21"
  },
  {
    "id": "2140",
    "name": "Bhedaghat",
    "state_id": "21"
  },
  {
    "id": "2141",
    "name": "Bhikangaon",
    "state_id": "21"
  },
  {
    "id": "2142",
    "name": "Bhilakhedi",
    "state_id": "21"
  },
  {
    "id": "2143",
    "name": "Bhind",
    "state_id": "21"
  },
  {
    "id": "2144",
    "name": "Bhitarwar",
    "state_id": "21"
  },
  {
    "id": "2145",
    "name": "Bhopal",
    "state_id": "21"
  },
  {
    "id": "2146",
    "name": "Bhuibandh",
    "state_id": "21"
  },
  {
    "id": "2147",
    "name": "Biaora",
    "state_id": "21"
  },
  {
    "id": "2148",
    "name": "Bijawar",
    "state_id": "21"
  },
  {
    "id": "2149",
    "name": "Bijeypur",
    "state_id": "21"
  },
  {
    "id": "2150",
    "name": "Bijrauni",
    "state_id": "21"
  },
  {
    "id": "2151",
    "name": "Bijuri",
    "state_id": "21"
  },
  {
    "id": "2152",
    "name": "Bilaua",
    "state_id": "21"
  },
  {
    "id": "2153",
    "name": "Bilpura",
    "state_id": "21"
  },
  {
    "id": "2154",
    "name": "Bina Railway Colony",
    "state_id": "21"
  },
  {
    "id": "2155",
    "name": "Bina-Etawa",
    "state_id": "21"
  },
  {
    "id": "2156",
    "name": "Birsinghpur",
    "state_id": "21"
  },
  {
    "id": "2157",
    "name": "Boda",
    "state_id": "21"
  },
  {
    "id": "2158",
    "name": "Budhni",
    "state_id": "21"
  },
  {
    "id": "2159",
    "name": "Burhanpur",
    "state_id": "21"
  },
  {
    "id": "2160",
    "name": "Burhar",
    "state_id": "21"
  },
  {
    "id": "2161",
    "name": "Chachaura Binaganj",
    "state_id": "21"
  },
  {
    "id": "2162",
    "name": "Chakghat",
    "state_id": "21"
  },
  {
    "id": "2163",
    "name": "Chandameta Butar",
    "state_id": "21"
  },
  {
    "id": "2164",
    "name": "Chanderi",
    "state_id": "21"
  },
  {
    "id": "2165",
    "name": "Chandia",
    "state_id": "21"
  },
  {
    "id": "2166",
    "name": "Chandla",
    "state_id": "21"
  },
  {
    "id": "2167",
    "name": "Chaurai Khas",
    "state_id": "21"
  },
  {
    "id": "2168",
    "name": "Chhatarpur",
    "state_id": "21"
  },
  {
    "id": "2169",
    "name": "Chhindwara",
    "state_id": "21"
  },
  {
    "id": "2170",
    "name": "Chhota Chhindwara",
    "state_id": "21"
  },
  {
    "id": "2171",
    "name": "Chichli",
    "state_id": "21"
  },
  {
    "id": "2172",
    "name": "Chitrakut",
    "state_id": "21"
  },
  {
    "id": "2173",
    "name": "Churhat",
    "state_id": "21"
  },
  {
    "id": "2174",
    "name": "Daboh",
    "state_id": "21"
  },
  {
    "id": "2175",
    "name": "Dabra",
    "state_id": "21"
  },
  {
    "id": "2176",
    "name": "Damoh",
    "state_id": "21"
  },
  {
    "id": "2177",
    "name": "Damua",
    "state_id": "21"
  },
  {
    "id": "2178",
    "name": "Datia",
    "state_id": "21"
  },
  {
    "id": "2179",
    "name": "Deodara",
    "state_id": "21"
  },
  {
    "id": "2180",
    "name": "Deori",
    "state_id": "21"
  },
  {
    "id": "2181",
    "name": "Deori Khas",
    "state_id": "21"
  },
  {
    "id": "2182",
    "name": "Depalpur",
    "state_id": "21"
  },
  {
    "id": "2183",
    "name": "Devendranagar",
    "state_id": "21"
  },
  {
    "id": "2184",
    "name": "Devhara",
    "state_id": "21"
  },
  {
    "id": "2185",
    "name": "Dewas",
    "state_id": "21"
  },
  {
    "id": "2186",
    "name": "Dhamnod",
    "state_id": "21"
  },
  {
    "id": "2187",
    "name": "Dhana",
    "state_id": "21"
  },
  {
    "id": "2188",
    "name": "Dhanpuri",
    "state_id": "21"
  },
  {
    "id": "2189",
    "name": "Dhar",
    "state_id": "21"
  },
  {
    "id": "2190",
    "name": "Dharampuri",
    "state_id": "21"
  },
  {
    "id": "2191",
    "name": "Dighawani",
    "state_id": "21"
  },
  {
    "id": "2192",
    "name": "Diken",
    "state_id": "21"
  },
  {
    "id": "2193",
    "name": "Dindori",
    "state_id": "21"
  },
  {
    "id": "2194",
    "name": "Dola",
    "state_id": "21"
  },
  {
    "id": "2195",
    "name": "Dumar Kachhar",
    "state_id": "21"
  },
  {
    "id": "2196",
    "name": "Dungariya Chhapara",
    "state_id": "21"
  },
  {
    "id": "2197",
    "name": "Gadarwara",
    "state_id": "21"
  },
  {
    "id": "2198",
    "name": "Gairatganj",
    "state_id": "21"
  },
  {
    "id": "2199",
    "name": "Gandhi Sagar Hydel Colony",
    "state_id": "21"
  },
  {
    "id": "2200",
    "name": "Ganjbasoda",
    "state_id": "21"
  },
  {
    "id": "2201",
    "name": "Garhakota",
    "state_id": "21"
  },
  {
    "id": "2202",
    "name": "Garhi Malhara",
    "state_id": "21"
  },
  {
    "id": "2203",
    "name": "Garoth",
    "state_id": "21"
  },
  {
    "id": "2204",
    "name": "Gautapura",
    "state_id": "21"
  },
  {
    "id": "2205",
    "name": "Ghansor",
    "state_id": "21"
  },
  {
    "id": "2206",
    "name": "Ghuwara",
    "state_id": "21"
  },
  {
    "id": "2207",
    "name": "Gogaon",
    "state_id": "21"
  },
  {
    "id": "2208",
    "name": "Gogapur",
    "state_id": "21"
  },
  {
    "id": "2209",
    "name": "Gohad",
    "state_id": "21"
  },
  {
    "id": "2210",
    "name": "Gormi",
    "state_id": "21"
  },
  {
    "id": "2211",
    "name": "Govindgarh",
    "state_id": "21"
  },
  {
    "id": "2212",
    "name": "Guna",
    "state_id": "21"
  },
  {
    "id": "2213",
    "name": "Gurh",
    "state_id": "21"
  },
  {
    "id": "2214",
    "name": "Gwalior",
    "state_id": "21"
  },
  {
    "id": "2215",
    "name": "Hanumana",
    "state_id": "21"
  },
  {
    "id": "2216",
    "name": "Harda",
    "state_id": "21"
  },
  {
    "id": "2217",
    "name": "Harpalpur",
    "state_id": "21"
  },
  {
    "id": "2218",
    "name": "Harrai",
    "state_id": "21"
  },
  {
    "id": "2219",
    "name": "Harsud",
    "state_id": "21"
  },
  {
    "id": "2220",
    "name": "Hatod",
    "state_id": "21"
  },
  {
    "id": "2221",
    "name": "Hatpipalya",
    "state_id": "21"
  },
  {
    "id": "2222",
    "name": "Hatta",
    "state_id": "21"
  },
  {
    "id": "2223",
    "name": "Hindoria",
    "state_id": "21"
  },
  {
    "id": "2224",
    "name": "Hirapur",
    "state_id": "21"
  },
  {
    "id": "2225",
    "name": "Hoshangabad",
    "state_id": "21"
  },
  {
    "id": "2226",
    "name": "Ichhawar",
    "state_id": "21"
  },
  {
    "id": "2227",
    "name": "Iklehra",
    "state_id": "21"
  },
  {
    "id": "2228",
    "name": "Indergarh",
    "state_id": "21"
  },
  {
    "id": "2229",
    "name": "Indore",
    "state_id": "21"
  },
  {
    "id": "2230",
    "name": "Isagarh",
    "state_id": "21"
  },
  {
    "id": "2231",
    "name": "Itarsi",
    "state_id": "21"
  },
  {
    "id": "2232",
    "name": "Jabalpur",
    "state_id": "21"
  },
  {
    "id": "2233",
    "name": "Jabalpur Cantonment",
    "state_id": "21"
  },
  {
    "id": "2234",
    "name": "Jabalpur G.C.F",
    "state_id": "21"
  },
  {
    "id": "2235",
    "name": "Jaisinghnagar",
    "state_id": "21"
  },
  {
    "id": "2236",
    "name": "Jaithari",
    "state_id": "21"
  },
  {
    "id": "2237",
    "name": "Jaitwara",
    "state_id": "21"
  },
  {
    "id": "2238",
    "name": "Jamai",
    "state_id": "21"
  },
  {
    "id": "2239",
    "name": "Jaora",
    "state_id": "21"
  },
  {
    "id": "2240",
    "name": "Jatachhapar",
    "state_id": "21"
  },
  {
    "id": "2241",
    "name": "Jatara",
    "state_id": "21"
  },
  {
    "id": "2242",
    "name": "Jawad",
    "state_id": "21"
  },
  {
    "id": "2243",
    "name": "Jawar",
    "state_id": "21"
  },
  {
    "id": "2244",
    "name": "Jeronkhalsa",
    "state_id": "21"
  },
  {
    "id": "2245",
    "name": "Jhabua",
    "state_id": "21"
  },
  {
    "id": "2246",
    "name": "Jhundpura",
    "state_id": "21"
  },
  {
    "id": "2247",
    "name": "Jiran",
    "state_id": "21"
  },
  {
    "id": "2248",
    "name": "Jirapur",
    "state_id": "21"
  },
  {
    "id": "2249",
    "name": "Jobat",
    "state_id": "21"
  },
  {
    "id": "2250",
    "name": "Joura",
    "state_id": "21"
  },
  {
    "id": "2251",
    "name": "Kailaras",
    "state_id": "21"
  },
  {
    "id": "2252",
    "name": "Kaimur",
    "state_id": "21"
  },
  {
    "id": "2253",
    "name": "Kakarhati",
    "state_id": "21"
  },
  {
    "id": "2254",
    "name": "Kalichhapar",
    "state_id": "21"
  },
  {
    "id": "2255",
    "name": "Kanad",
    "state_id": "21"
  },
  {
    "id": "2256",
    "name": "Kannod",
    "state_id": "21"
  },
  {
    "id": "2257",
    "name": "Kantaphod",
    "state_id": "21"
  },
  {
    "id": "2258",
    "name": "Kareli",
    "state_id": "21"
  },
  {
    "id": "2259",
    "name": "Karera",
    "state_id": "21"
  },
  {
    "id": "2260",
    "name": "Kari",
    "state_id": "21"
  },
  {
    "id": "2261",
    "name": "Karnawad",
    "state_id": "21"
  },
  {
    "id": "2262",
    "name": "Karrapur",
    "state_id": "21"
  },
  {
    "id": "2263",
    "name": "Kasrawad",
    "state_id": "21"
  },
  {
    "id": "2264",
    "name": "Katangi",
    "state_id": "21"
  },
  {
    "id": "2265",
    "name": "Katni",
    "state_id": "21"
  },
  {
    "id": "2266",
    "name": "Kelhauri",
    "state_id": "21"
  },
  {
    "id": "2267",
    "name": "Khachrod",
    "state_id": "21"
  },
  {
    "id": "2268",
    "name": "Khajuraho",
    "state_id": "21"
  },
  {
    "id": "2269",
    "name": "Khamaria",
    "state_id": "21"
  },
  {
    "id": "2270",
    "name": "Khand",
    "state_id": "21"
  },
  {
    "id": "2271",
    "name": "Khandwa",
    "state_id": "21"
  },
  {
    "id": "2272",
    "name": "Khaniyadhana",
    "state_id": "21"
  },
  {
    "id": "2273",
    "name": "Khargapur",
    "state_id": "21"
  },
  {
    "id": "2274",
    "name": "Khargone",
    "state_id": "21"
  },
  {
    "id": "2275",
    "name": "Khategaon",
    "state_id": "21"
  },
  {
    "id": "2276",
    "name": "Khetia",
    "state_id": "21"
  },
  {
    "id": "2277",
    "name": "Khilchipur",
    "state_id": "21"
  },
  {
    "id": "2278",
    "name": "Khirkiya",
    "state_id": "21"
  },
  {
    "id": "2279",
    "name": "Khujner",
    "state_id": "21"
  },
  {
    "id": "2280",
    "name": "Khurai",
    "state_id": "21"
  },
  {
    "id": "2281",
    "name": "Kolaras",
    "state_id": "21"
  },
  {
    "id": "2282",
    "name": "Kotar",
    "state_id": "21"
  },
  {
    "id": "2283",
    "name": "Kothi",
    "state_id": "21"
  },
  {
    "id": "2284",
    "name": "Kotma",
    "state_id": "21"
  },
  {
    "id": "2285",
    "name": "Kukshi",
    "state_id": "21"
  },
  {
    "id": "2286",
    "name": "Kumbhraj",
    "state_id": "21"
  },
  {
    "id": "2287",
    "name": "Kurwai",
    "state_id": "21"
  },
  {
    "id": "2288",
    "name": "Lahar",
    "state_id": "21"
  },
  {
    "id": "2289",
    "name": "Lakhnadon",
    "state_id": "21"
  },
  {
    "id": "2290",
    "name": "Lateri",
    "state_id": "21"
  },
  {
    "id": "2291",
    "name": "Laundi",
    "state_id": "21"
  },
  {
    "id": "2292",
    "name": "Lidhora Khas",
    "state_id": "21"
  },
  {
    "id": "2293",
    "name": "Lodhikheda",
    "state_id": "21"
  },
  {
    "id": "2294",
    "name": "Loharda",
    "state_id": "21"
  },
  {
    "id": "2295",
    "name": "Machalpur",
    "state_id": "21"
  },
  {
    "id": "2296",
    "name": "Madhogarh",
    "state_id": "21"
  },
  {
    "id": "2297",
    "name": "Maharajpur",
    "state_id": "21"
  },
  {
    "id": "2298",
    "name": "Maheshwar",
    "state_id": "21"
  },
  {
    "id": "2299",
    "name": "Mahidpur",
    "state_id": "21"
  },
  {
    "id": "2300",
    "name": "Maihar",
    "state_id": "21"
  },
  {
    "id": "2301",
    "name": "Majholi",
    "state_id": "21"
  },
  {
    "id": "2302",
    "name": "Makronia",
    "state_id": "21"
  },
  {
    "id": "2303",
    "name": "Maksi",
    "state_id": "21"
  },
  {
    "id": "2304",
    "name": "Malaj Khand",
    "state_id": "21"
  },
  {
    "id": "2305",
    "name": "Malanpur",
    "state_id": "21"
  },
  {
    "id": "2306",
    "name": "Malhargarh",
    "state_id": "21"
  },
  {
    "id": "2307",
    "name": "Manasa",
    "state_id": "21"
  },
  {
    "id": "2308",
    "name": "Manawar",
    "state_id": "21"
  },
  {
    "id": "2309",
    "name": "Mandav",
    "state_id": "21"
  },
  {
    "id": "2310",
    "name": "Mandideep",
    "state_id": "21"
  },
  {
    "id": "2311",
    "name": "Mandla",
    "state_id": "21"
  },
  {
    "id": "2312",
    "name": "Mandleshwar",
    "state_id": "21"
  },
  {
    "id": "2313",
    "name": "Mandsaur",
    "state_id": "21"
  },
  {
    "id": "2314",
    "name": "Manegaon",
    "state_id": "21"
  },
  {
    "id": "2315",
    "name": "Mangawan",
    "state_id": "21"
  },
  {
    "id": "2316",
    "name": "Manglaya Sadak",
    "state_id": "21"
  },
  {
    "id": "2317",
    "name": "Manpur",
    "state_id": "21"
  },
  {
    "id": "2318",
    "name": "Mau",
    "state_id": "21"
  },
  {
    "id": "2319",
    "name": "Mauganj",
    "state_id": "21"
  },
  {
    "id": "2320",
    "name": "Meghnagar",
    "state_id": "21"
  },
  {
    "id": "2321",
    "name": "Mehara Gaon",
    "state_id": "21);"
  },
  {
    "id": "2322",
    "name": "Mehgaon",
    "state_id": "21"
  },
  {
    "id": "2323",
    "name": "Mhaugaon",
    "state_id": "21"
  },
  {
    "id": "2324",
    "name": "Mhow",
    "state_id": "21"
  },
  {
    "id": "2325",
    "name": "Mihona",
    "state_id": "21"
  },
  {
    "id": "2326",
    "name": "Mohgaon",
    "state_id": "21"
  },
  {
    "id": "2327",
    "name": "Morar",
    "state_id": "21"
  },
  {
    "id": "2328",
    "name": "Morena",
    "state_id": "21"
  },
  {
    "id": "2329",
    "name": "Morwa",
    "state_id": "21"
  },
  {
    "id": "2330",
    "name": "Multai",
    "state_id": "21"
  },
  {
    "id": "2331",
    "name": "Mundi",
    "state_id": "21"
  },
  {
    "id": "2332",
    "name": "Mungaoli",
    "state_id": "21"
  },
  {
    "id": "2333",
    "name": "Murwara",
    "state_id": "21"
  },
  {
    "id": "2334",
    "name": "Nagda",
    "state_id": "21"
  },
  {
    "id": "2335",
    "name": "Nagod",
    "state_id": "21"
  },
  {
    "id": "2336",
    "name": "Nagri",
    "state_id": "21"
  },
  {
    "id": "2337",
    "name": "Naigarhi",
    "state_id": "21"
  },
  {
    "id": "2338",
    "name": "Nainpur",
    "state_id": "21"
  },
  {
    "id": "2339",
    "name": "Nalkheda",
    "state_id": "21"
  },
  {
    "id": "2340",
    "name": "Namli",
    "state_id": "21"
  },
  {
    "id": "2341",
    "name": "Narayangarh",
    "state_id": "21"
  },
  {
    "id": "2342",
    "name": "Narsimhapur",
    "state_id": "21"
  },
  {
    "id": "2343",
    "name": "Narsingarh",
    "state_id": "21"
  },
  {
    "id": "2344",
    "name": "Narsinghpur",
    "state_id": "21"
  },
  {
    "id": "2345",
    "name": "Narwar",
    "state_id": "21"
  },
  {
    "id": "2346",
    "name": "Nasrullaganj",
    "state_id": "21"
  },
  {
    "id": "2347",
    "name": "Naudhia",
    "state_id": "21"
  },
  {
    "id": "2348",
    "name": "Naugaon",
    "state_id": "21"
  },
  {
    "id": "2349",
    "name": "Naurozabad",
    "state_id": "21"
  },
  {
    "id": "2350",
    "name": "Neemuch",
    "state_id": "21"
  },
  {
    "id": "2351",
    "name": "Nepa Nagar",
    "state_id": "21"
  },
  {
    "id": "2352",
    "name": "Neuton Chikhli Kalan",
    "state_id": "21"
  },
  {
    "id": "2353",
    "name": "Nimach",
    "state_id": "21"
  },
  {
    "id": "2354",
    "name": "Niwari",
    "state_id": "21"
  },
  {
    "id": "2355",
    "name": "Obedullaganj",
    "state_id": "21"
  },
  {
    "id": "2356",
    "name": "Omkareshwar",
    "state_id": "21"
  },
  {
    "id": "2357",
    "name": "Orachha",
    "state_id": "21"
  },
  {
    "id": "2358",
    "name": "Ordinance Factory Itarsi",
    "state_id": "21"
  },
  {
    "id": "2359",
    "name": "Pachmarhi",
    "state_id": "21"
  },
  {
    "id": "2360",
    "name": "Pachmarhi Cantonment",
    "state_id": "21"
  },
  {
    "id": "2361",
    "name": "Pachore",
    "state_id": "21"
  },
  {
    "id": "2362",
    "name": "Palchorai",
    "state_id": "21"
  },
  {
    "id": "2363",
    "name": "Palda",
    "state_id": "21"
  },
  {
    "id": "2364",
    "name": "Palera",
    "state_id": "21"
  },
  {
    "id": "2365",
    "name": "Pali",
    "state_id": "21"
  },
  {
    "id": "2366",
    "name": "Panagar",
    "state_id": "21"
  },
  {
    "id": "2367",
    "name": "Panara",
    "state_id": "21"
  },
  {
    "id": "2368",
    "name": "Pandaria",
    "state_id": "21"
  },
  {
    "id": "2369",
    "name": "Pandhana",
    "state_id": "21"
  },
  {
    "id": "2370",
    "name": "Pandhurna",
    "state_id": "21"
  },
  {
    "id": "2371",
    "name": "Panna",
    "state_id": "21"
  },
  {
    "id": "2372",
    "name": "Pansemal",
    "state_id": "21"
  },
  {
    "id": "2373",
    "name": "Parasia",
    "state_id": "21"
  },
  {
    "id": "2374",
    "name": "Pasan",
    "state_id": "21"
  },
  {
    "id": "2375",
    "name": "Patan",
    "state_id": "21"
  },
  {
    "id": "2376",
    "name": "Patharia",
    "state_id": "21"
  },
  {
    "id": "2377",
    "name": "Pawai",
    "state_id": "21"
  },
  {
    "id": "2378",
    "name": "Petlawad",
    "state_id": "21"
  },
  {
    "id": "2379",
    "name": "Phuph Kalan",
    "state_id": "21"
  },
  {
    "id": "2380",
    "name": "Pichhore",
    "state_id": "21"
  },
  {
    "id": "2381",
    "name": "Pipariya",
    "state_id": "21"
  },
  {
    "id": "2382",
    "name": "Pipliya Mandi",
    "state_id": "21"
  },
  {
    "id": "2383",
    "name": "Piploda",
    "state_id": "21"
  },
  {
    "id": "2384",
    "name": "Pithampur",
    "state_id": "21"
  },
  {
    "id": "2385",
    "name": "Polay Kalan",
    "state_id": "21"
  },
  {
    "id": "2386",
    "name": "Porsa",
    "state_id": "21"
  },
  {
    "id": "2387",
    "name": "Prithvipur",
    "state_id": "21"
  },
  {
    "id": "2388",
    "name": "Raghogarh",
    "state_id": "21"
  },
  {
    "id": "2389",
    "name": "Rahatgarh",
    "state_id": "21"
  },
  {
    "id": "2390",
    "name": "Raisen",
    "state_id": "21"
  },
  {
    "id": "2391",
    "name": "Rajakhedi",
    "state_id": "21"
  },
  {
    "id": "2392",
    "name": "Rajgarh",
    "state_id": "21"
  },
  {
    "id": "2393",
    "name": "Rajnagar",
    "state_id": "21"
  },
  {
    "id": "2394",
    "name": "Rajpur",
    "state_id": "21"
  },
  {
    "id": "2395",
    "name": "Rampur Baghelan",
    "state_id": "21"
  },
  {
    "id": "2396",
    "name": "Rampur Naikin",
    "state_id": "21"
  },
  {
    "id": "2397",
    "name": "Rampura",
    "state_id": "21"
  },
  {
    "id": "2398",
    "name": "Ranapur",
    "state_id": "21"
  },
  {
    "id": "2399",
    "name": "Ranipura",
    "state_id": "21"
  },
  {
    "id": "2400",
    "name": "Ratangarh",
    "state_id": "21"
  },
  {
    "id": "2401",
    "name": "Ratlam",
    "state_id": "21"
  },
  {
    "id": "2402",
    "name": "Ratlam Kasba",
    "state_id": "21"
  },
  {
    "id": "2403",
    "name": "Rau",
    "state_id": "21"
  },
  {
    "id": "2404",
    "name": "Rehli",
    "state_id": "21"
  },
  {
    "id": "2405",
    "name": "Rehti",
    "state_id": "21"
  },
  {
    "id": "2406",
    "name": "Rewa",
    "state_id": "21"
  },
  {
    "id": "2407",
    "name": "Sabalgarh",
    "state_id": "21"
  },
  {
    "id": "2408",
    "name": "Sagar",
    "state_id": "21"
  },
  {
    "id": "2409",
    "name": "Sagar Cantonment",
    "state_id": "21"
  },
  {
    "id": "2410",
    "name": "Sailana",
    "state_id": "21"
  },
  {
    "id": "2411",
    "name": "Sanawad",
    "state_id": "21"
  },
  {
    "id": "2412",
    "name": "Sanchi",
    "state_id": "21"
  },
  {
    "id": "2413",
    "name": "Sanwer",
    "state_id": "21"
  },
  {
    "id": "2414",
    "name": "Sarangpur",
    "state_id": "21"
  },
  {
    "id": "2415",
    "name": "Sardarpur",
    "state_id": "21"
  },
  {
    "id": "2416",
    "name": "Sarni",
    "state_id": "21"
  },
  {
    "id": "2417",
    "name": "Satai",
    "state_id": "21"
  },
  {
    "id": "2418",
    "name": "Satna",
    "state_id": "21"
  },
  {
    "id": "2419",
    "name": "Satwas",
    "state_id": "21"
  },
  {
    "id": "2420",
    "name": "Sausar",
    "state_id": "21"
  },
  {
    "id": "2421",
    "name": "Sehore",
    "state_id": "21"
  },
  {
    "id": "2422",
    "name": "Semaria",
    "state_id": "21"
  },
  {
    "id": "2423",
    "name": "Sendhwa",
    "state_id": "21"
  },
  {
    "id": "2424",
    "name": "Seondha",
    "state_id": "21"
  },
  {
    "id": "2425",
    "name": "Seoni",
    "state_id": "21"
  },
  {
    "id": "2426",
    "name": "Seoni Malwa",
    "state_id": "21"
  },
  {
    "id": "2427",
    "name": "Sethia",
    "state_id": "21"
  },
  {
    "id": "2428",
    "name": "Shahdol",
    "state_id": "21"
  },
  {
    "id": "2429",
    "name": "Shahgarh",
    "state_id": "21"
  },
  {
    "id": "2430",
    "name": "Shahpur",
    "state_id": "21"
  },
  {
    "id": "2431",
    "name": "Shahpura",
    "state_id": "21"
  },
  {
    "id": "2432",
    "name": "Shajapur",
    "state_id": "21"
  },
  {
    "id": "2433",
    "name": "Shamgarh",
    "state_id": "21"
  },
  {
    "id": "2434",
    "name": "Sheopur",
    "state_id": "21"
  },
  {
    "id": "2435",
    "name": "Shivpuri",
    "state_id": "21"
  },
  {
    "id": "2436",
    "name": "Shujalpur",
    "state_id": "21"
  },
  {
    "id": "2437",
    "name": "Sidhi",
    "state_id": "21"
  },
  {
    "id": "2438",
    "name": "Sihora",
    "state_id": "21"
  },
  {
    "id": "2439",
    "name": "Singolo",
    "state_id": "21"
  },
  {
    "id": "2440",
    "name": "Singrauli",
    "state_id": "21"
  },
  {
    "id": "2441",
    "name": "Sinhasa",
    "state_id": "21"
  },
  {
    "id": "2442",
    "name": "Sirgora",
    "state_id": "21"
  },
  {
    "id": "2443",
    "name": "Sirmaur",
    "state_id": "21"
  },
  {
    "id": "2444",
    "name": "Sironj",
    "state_id": "21"
  },
  {
    "id": "2445",
    "name": "Sitamau",
    "state_id": "21"
  },
  {
    "id": "2446",
    "name": "Sohagpur",
    "state_id": "21"
  },
  {
    "id": "2447",
    "name": "Sonkatch",
    "state_id": "21"
  },
  {
    "id": "2448",
    "name": "Soyatkalan",
    "state_id": "21"
  },
  {
    "id": "2449",
    "name": "Suhagi",
    "state_id": "21"
  },
  {
    "id": "2450",
    "name": "Sultanpur",
    "state_id": "21"
  },
  {
    "id": "2451",
    "name": "Susner",
    "state_id": "21"
  },
  {
    "id": "2452",
    "name": "Suthaliya",
    "state_id": "21"
  },
  {
    "id": "2453",
    "name": "Tal",
    "state_id": "21"
  },
  {
    "id": "2454",
    "name": "Talen",
    "state_id": "21"
  },
  {
    "id": "2455",
    "name": "Tarana",
    "state_id": "21"
  },
  {
    "id": "2456",
    "name": "Taricharkalan",
    "state_id": "21"
  },
  {
    "id": "2457",
    "name": "Tekanpur",
    "state_id": "21"
  },
  {
    "id": "2458",
    "name": "Tendukheda",
    "state_id": "21"
  },
  {
    "id": "2459",
    "name": "Teonthar",
    "state_id": "21"
  },
  {
    "id": "2460",
    "name": "Thandia",
    "state_id": "21"
  },
  {
    "id": "2461",
    "name": "Tikamgarh",
    "state_id": "21"
  },
  {
    "id": "2462",
    "name": "Timarni",
    "state_id": "21"
  },
  {
    "id": "2463",
    "name": "Tirodi",
    "state_id": "21"
  },
  {
    "id": "2464",
    "name": "Udaipura",
    "state_id": "21"
  },
  {
    "id": "2465",
    "name": "Ujjain",
    "state_id": "21"
  },
  {
    "id": "2466",
    "name": "Ukwa",
    "state_id": "21"
  },
  {
    "id": "2467",
    "name": "Umaria",
    "state_id": "21"
  },
  {
    "id": "2468",
    "name": "Unchahara",
    "state_id": "21"
  },
  {
    "id": "2469",
    "name": "Unhel",
    "state_id": "21"
  },
  {
    "id": "2470",
    "name": "Vehicle Factory Jabalpur",
    "state_id": "21"
  },
  {
    "id": "2471",
    "name": "Vidisha",
    "state_id": "21"
  },
  {
    "id": "2472",
    "name": "Vijayraghavgarh",
    "state_id": "21"
  },
  {
    "id": "2473",
    "name": "Waraseoni",
    "state_id": "21"
  },
  {
    "id": "2474",
    "name": "Achalpur",
    "state_id": "22"
  },
  {
    "id": "2475",
    "name": "Aheri",
    "state_id": "22"
  },
  {
    "id": "2476",
    "name": "Ahmadnagar Cantonment",
    "state_id": "22"
  },
  {
    "id": "2477",
    "name": "Ahmadpur",
    "state_id": "22"
  },
  {
    "id": "2478",
    "name": "Ahmednagar",
    "state_id": "22"
  },
  {
    "id": "2479",
    "name": "Ajra",
    "state_id": "22"
  },
  {
    "id": "2480",
    "name": "Akalkot",
    "state_id": "22"
  },
  {
    "id": "2481",
    "name": "Akkalkuwa",
    "state_id": "22"
  },
  {
    "id": "2482",
    "name": "Akola",
    "state_id": "22"
  },
  {
    "id": "2483",
    "name": "Akot",
    "state_id": "22"
  },
  {
    "id": "2484",
    "name": "Alandi",
    "state_id": "22"
  },
  {
    "id": "2485",
    "name": "Alibag",
    "state_id": "22"
  },
  {
    "id": "2486",
    "name": "Allapalli",
    "state_id": "22"
  },
  {
    "id": "2487",
    "name": "Alore",
    "state_id": "22"
  },
  {
    "id": "2488",
    "name": "Amalner",
    "state_id": "22"
  },
  {
    "id": "2489",
    "name": "Ambad",
    "state_id": "22"
  },
  {
    "id": "2490",
    "name": "Ambajogai",
    "state_id": "22"
  },
  {
    "id": "2491",
    "name": "Ambernath",
    "state_id": "22"
  },
  {
    "id": "2492",
    "name": "Ambivali Tarf Wankhal",
    "state_id": "22"
  },
  {
    "id": "2493",
    "name": "Amgaon",
    "state_id": "22"
  },
  {
    "id": "2494",
    "name": "Amravati",
    "state_id": "22"
  },
  {
    "id": "2495",
    "name": "Anjangaon",
    "state_id": "22"
  },
  {
    "id": "2496",
    "name": "Arvi",
    "state_id": "22"
  },
  {
    "id": "2497",
    "name": "Ashta",
    "state_id": "22"
  },
  {
    "id": "2498",
    "name": "Ashti",
    "state_id": "22"
  },
  {
    "id": "2499",
    "name": "Aurangabad",
    "state_id": "22"
  },
  {
    "id": "2500",
    "name": "Aurangabad Cantonment",
    "state_id": "22"
  },
  {
    "id": "2501",
    "name": "Ausa",
    "state_id": "22"
  },
  {
    "id": "2502",
    "name": "Babhulgaon",
    "state_id": "22"
  },
  {
    "id": "2503",
    "name": "Badlapur",
    "state_id": "22"
  },
  {
    "id": "2504",
    "name": "Balapur",
    "state_id": "22"
  },
  {
    "id": "2505",
    "name": "Ballarpur",
    "state_id": "22"
  },
  {
    "id": "2506",
    "name": "Baramati",
    "state_id": "22"
  },
  {
    "id": "2507",
    "name": "Barshi",
    "state_id": "22"
  },
  {
    "id": "2508",
    "name": "Basmat",
    "state_id": "22"
  },
  {
    "id": "2509",
    "name": "Beed",
    "state_id": "22"
  },
  {
    "id": "2510",
    "name": "Bhadravati",
    "state_id": "22"
  },
  {
    "id": "2511",
    "name": "Bhagur",
    "state_id": "22"
  },
  {
    "id": "2512",
    "name": "Bhandara",
    "state_id": "22"
  },
  {
    "id": "2513",
    "name": "Bhigvan",
    "state_id": "22"
  },
  {
    "id": "2514",
    "name": "Bhingar",
    "state_id": "22"
  },
  {
    "id": "2515",
    "name": "Bhiwandi",
    "state_id": "22"
  },
  {
    "id": "2516",
    "name": "Bhokhardan",
    "state_id": "22"
  },
  {
    "id": "2517",
    "name": "Bhor",
    "state_id": "22"
  },
  {
    "id": "2518",
    "name": "Bhosari",
    "state_id": "22"
  },
  {
    "id": "2519",
    "name": "Bhum",
    "state_id": "22"
  },
  {
    "id": "2520",
    "name": "Bhusawal",
    "state_id": "22"
  },
  {
    "id": "2521",
    "name": "Bid",
    "state_id": "22"
  },
  {
    "id": "2522",
    "name": "Biloli",
    "state_id": "22"
  },
  {
    "id": "2523",
    "name": "Birwadi",
    "state_id": "22"
  },
  {
    "id": "2524",
    "name": "Boisar",
    "state_id": "22"
  },
  {
    "id": "2525",
    "name": "Bop Khel",
    "state_id": "22"
  },
  {
    "id": "2526",
    "name": "Brahmapuri",
    "state_id": "22"
  },
  {
    "id": "2527",
    "name": "Budhgaon",
    "state_id": "22"
  },
  {
    "id": "2528",
    "name": "Buldana",
    "state_id": "22"
  },
  {
    "id": "2529",
    "name": "Buldhana",
    "state_id": "22"
  },
  {
    "id": "2530",
    "name": "Butibori",
    "state_id": "22"
  },
  {
    "id": "2531",
    "name": "Chakan",
    "state_id": "22"
  },
  {
    "id": "2532",
    "name": "Chalisgaon",
    "state_id": "22"
  },
  {
    "id": "2533",
    "name": "Chandrapur",
    "state_id": "22"
  },
  {
    "id": "2534",
    "name": "Chandur",
    "state_id": "22"
  },
  {
    "id": "2535",
    "name": "Chandur Bazar",
    "state_id": "22"
  },
  {
    "id": "2536",
    "name": "Chandvad",
    "state_id": "22"
  },
  {
    "id": "2537",
    "name": "Chicholi",
    "state_id": "22"
  },
  {
    "id": "2538",
    "name": "Chikhala",
    "state_id": "22"
  },
  {
    "id": "2539",
    "name": "Chikhaldara",
    "state_id": "22"
  },
  {
    "id": "2540",
    "name": "Chikhli",
    "state_id": "22"
  },
  {
    "id": "2541",
    "name": "Chinchani",
    "state_id": "22"
  },
  {
    "id": "2542",
    "name": "Chinchwad",
    "state_id": "22"
  },
  {
    "id": "2543",
    "name": "Chiplun",
    "state_id": "22"
  },
  {
    "id": "2544",
    "name": "Chopda",
    "state_id": "22"
  },
  {
    "id": "2545",
    "name": "Dabhol",
    "state_id": "22"
  },
  {
    "id": "2546",
    "name": "Dahance",
    "state_id": "22"
  },
  {
    "id": "2547",
    "name": "Dahanu",
    "state_id": "22"
  },
  {
    "id": "2548",
    "name": "Daharu",
    "state_id": "22"
  },
  {
    "id": "2549",
    "name": "Dapoli Camp",
    "state_id": "22"
  },
  {
    "id": "2550",
    "name": "Darwa",
    "state_id": "22"
  },
  {
    "id": "2551",
    "name": "Daryapur",
    "state_id": "22"
  },
  {
    "id": "2552",
    "name": "Dattapur",
    "state_id": "22"
  },
  {
    "id": "2553",
    "name": "Daund",
    "state_id": "22"
  },
  {
    "id": "2554",
    "name": "Davlameti",
    "state_id": "22"
  },
  {
    "id": "2555",
    "name": "Deglur",
    "state_id": "22"
  },
  {
    "id": "2556",
    "name": "Dehu Road",
    "state_id": "22"
  },
  {
    "id": "2557",
    "name": "Deolali",
    "state_id": "22"
  },
  {
    "id": "2558",
    "name": "Deolali Pravara",
    "state_id": "22"
  },
  {
    "id": "2559",
    "name": "Deoli",
    "state_id": "22"
  },
  {
    "id": "2560",
    "name": "Desaiganj",
    "state_id": "22"
  },
  {
    "id": "2561",
    "name": "Deulgaon Raja",
    "state_id": "22"
  },
  {
    "id": "2562",
    "name": "Dewhadi",
    "state_id": "22"
  },
  {
    "id": "2563",
    "name": "Dharangaon",
    "state_id": "22"
  },
  {
    "id": "2564",
    "name": "Dharmabad",
    "state_id": "22"
  },
  {
    "id": "2565",
    "name": "Dharur",
    "state_id": "22"
  },
  {
    "id": "2566",
    "name": "Dhatau",
    "state_id": "22"
  },
  {
    "id": "2567",
    "name": "Dhule",
    "state_id": "22"
  },
  {
    "id": "2568",
    "name": "Digdoh",
    "state_id": "22"
  },
  {
    "id": "2569",
    "name": "Diglur",
    "state_id": "22"
  },
  {
    "id": "2570",
    "name": "Digras",
    "state_id": "22"
  },
  {
    "id": "2571",
    "name": "Dombivli",
    "state_id": "22"
  },
  {
    "id": "2572",
    "name": "Dondaicha",
    "state_id": "22"
  },
  {
    "id": "2573",
    "name": "Dudhani",
    "state_id": "22"
  },
  {
    "id": "2574",
    "name": "Durgapur",
    "state_id": "22"
  },
  {
    "id": "2575",
    "name": "Dyane",
    "state_id": "22"
  },
  {
    "id": "2576",
    "name": "Edandol",
    "state_id": "22"
  },
  {
    "id": "2577",
    "name": "Eklahare",
    "state_id": "22"
  },
  {
    "id": "2578",
    "name": "Faizpur",
    "state_id": "22"
  },
  {
    "id": "2579",
    "name": "Fekari",
    "state_id": "22"
  },
  {
    "id": "2580",
    "name": "Gadchiroli",
    "state_id": "22"
  },
  {
    "id": "2581",
    "name": "Gadhinghaj",
    "state_id": "22"
  },
  {
    "id": "2582",
    "name": "Gandhi Nagar",
    "state_id": "22"
  },
  {
    "id": "2583",
    "name": "Ganeshpur",
    "state_id": "22"
  },
  {
    "id": "2584",
    "name": "Gangakher",
    "state_id": "22"
  },
  {
    "id": "2585",
    "name": "Gangapur",
    "state_id": "22"
  },
  {
    "id": "2586",
    "name": "Gevrai",
    "state_id": "22"
  },
  {
    "id": "2587",
    "name": "Ghatanji",
    "state_id": "22"
  },
  {
    "id": "2588",
    "name": "Ghoti",
    "state_id": "22"
  },
  {
    "id": "2589",
    "name": "Ghugus",
    "state_id": "22"
  },
  {
    "id": "2590",
    "name": "Ghulewadi",
    "state_id": "22"
  },
  {
    "id": "2591",
    "name": "Godoli",
    "state_id": "22"
  },
  {
    "id": "2592",
    "name": "Gondia",
    "state_id": "22"
  },
  {
    "id": "2593",
    "name": "Guhagar",
    "state_id": "22"
  },
  {
    "id": "2594",
    "name": "Hadgaon",
    "state_id": "22"
  },
  {
    "id": "2595",
    "name": "Harnai Beach",
    "state_id": "22"
  },
  {
    "id": "2596",
    "name": "Hinganghat",
    "state_id": "22"
  },
  {
    "id": "2597",
    "name": "Hingoli",
    "state_id": "22"
  },
  {
    "id": "2598",
    "name": "Hupari",
    "state_id": "22"
  },
  {
    "id": "2599",
    "name": "Ichalkaranji",
    "state_id": "22"
  },
  {
    "id": "2600",
    "name": "Igatpuri",
    "state_id": "22"
  },
  {
    "id": "2601",
    "name": "Indapur",
    "state_id": "22"
  },
  {
    "id": "2602",
    "name": "Jaisinghpur",
    "state_id": "22"
  },
  {
    "id": "2603",
    "name": "Jalgaon",
    "state_id": "22"
  },
  {
    "id": "2604",
    "name": "Jalna",
    "state_id": "22"
  },
  {
    "id": "2605",
    "name": "Jamkhed",
    "state_id": "22"
  },
  {
    "id": "2606",
    "name": "Jawhar",
    "state_id": "22"
  },
  {
    "id": "2607",
    "name": "Jaysingpur",
    "state_id": "22"
  },
  {
    "id": "2608",
    "name": "Jejuri",
    "state_id": "22"
  },
  {
    "id": "2609",
    "name": "Jintur",
    "state_id": "22"
  },
  {
    "id": "2610",
    "name": "Junnar",
    "state_id": "22"
  },
  {
    "id": "2611",
    "name": "Kabnur",
    "state_id": "22"
  },
  {
    "id": "2612",
    "name": "Kagal",
    "state_id": "22"
  },
  {
    "id": "2613",
    "name": "Kalamb",
    "state_id": "22"
  },
  {
    "id": "2614",
    "name": "Kalamnuri",
    "state_id": "22"
  },
  {
    "id": "2615",
    "name": "Kalas",
    "state_id": "22"
  },
  {
    "id": "2616",
    "name": "Kalmeshwar",
    "state_id": "22"
  },
  {
    "id": "2617",
    "name": "Kalundre",
    "state_id": "22"
  },
  {
    "id": "2618",
    "name": "Kalyan",
    "state_id": "22"
  },
  {
    "id": "2619",
    "name": "Kamthi",
    "state_id": "22"
  },
  {
    "id": "2620",
    "name": "Kamthi Cantonment",
    "state_id": "22"
  },
  {
    "id": "2621",
    "name": "Kandari",
    "state_id": "22"
  },
  {
    "id": "2622",
    "name": "Kandhar",
    "state_id": "22"
  },
  {
    "id": "2623",
    "name": "Kandri",
    "state_id": "22"
  },
  {
    "id": "2624",
    "name": "Kandri II",
    "state_id": "22"
  },
  {
    "id": "2625",
    "name": "Kanhan",
    "state_id": "22"
  },
  {
    "id": "2626",
    "name": "Kankavli",
    "state_id": "22"
  },
  {
    "id": "2627",
    "name": "Kannad",
    "state_id": "22"
  },
  {
    "id": "2628",
    "name": "Karad",
    "state_id": "22"
  },
  {
    "id": "2629",
    "name": "Karanja",
    "state_id": "22"
  },
  {
    "id": "2630",
    "name": "Karanje Tarf",
    "state_id": "22"
  },
  {
    "id": "2631",
    "name": "Karivali",
    "state_id": "22"
  },
  {
    "id": "2632",
    "name": "Karjat",
    "state_id": "22"
  },
  {
    "id": "2633",
    "name": "Karmala",
    "state_id": "22"
  },
  {
    "id": "2634",
    "name": "Kasara Budruk",
    "state_id": "22"
  },
  {
    "id": "2635",
    "name": "Katai",
    "state_id": "22"
  },
  {
    "id": "2636",
    "name": "Katkar",
    "state_id": "22"
  },
  {
    "id": "2637",
    "name": "Katol",
    "state_id": "22"
  },
  {
    "id": "2638",
    "name": "Kegaon",
    "state_id": "22"
  },
  {
    "id": "2639",
    "name": "Khadkale",
    "state_id": "22"
  },
  {
    "id": "2640",
    "name": "Khadki",
    "state_id": "22"
  },
  {
    "id": "2641",
    "name": "Khamgaon",
    "state_id": "22"
  },
  {
    "id": "2642",
    "name": "Khapa",
    "state_id": "22"
  },
  {
    "id": "2643",
    "name": "Kharadi",
    "state_id": "22"
  },
  {
    "id": "2644",
    "name": "Kharakvasla",
    "state_id": "22"
  },
  {
    "id": "2645",
    "name": "Khed",
    "state_id": "22"
  },
  {
    "id": "2646",
    "name": "Kherdi",
    "state_id": "22"
  },
  {
    "id": "2647",
    "name": "Khoni",
    "state_id": "22"
  },
  {
    "id": "2648",
    "name": "Khopoli",
    "state_id": "22"
  },
  {
    "id": "2649",
    "name": "Khuldabad",
    "state_id": "22"
  },
  {
    "id": "2650",
    "name": "Kinwat",
    "state_id": "22"
  },
  {
    "id": "2651",
    "name": "Kodoli",
    "state_id": "22"
  },
  {
    "id": "2652",
    "name": "Kolhapur",
    "state_id": "22"
  },
  {
    "id": "2653",
    "name": "Kon",
    "state_id": "22"
  },
  {
    "id": "2654",
    "name": "Kondumal",
    "state_id": "22"
  },
  {
    "id": "2655",
    "name": "Kopargaon",
    "state_id": "22"
  },
  {
    "id": "2656",
    "name": "Kopharad",
    "state_id": "22"
  },
  {
    "id": "2657",
    "name": "Koradi",
    "state_id": "22"
  },
  {
    "id": "2658",
    "name": "Koregaon",
    "state_id": "22"
  },
  {
    "id": "2659",
    "name": "Korochi",
    "state_id": "22"
  },
  {
    "id": "2660",
    "name": "Kudal",
    "state_id": "22"
  },
  {
    "id": "2661",
    "name": "Kundaim",
    "state_id": "22"
  },
  {
    "id": "2662",
    "name": "Kundalwadi",
    "state_id": "22"
  },
  {
    "id": "2663",
    "name": "Kurandvad",
    "state_id": "22"
  },
  {
    "id": "2664",
    "name": "Kurduvadi",
    "state_id": "22"
  },
  {
    "id": "2665",
    "name": "Kusgaon Budruk",
    "state_id": "22"
  },
  {
    "id": "2666",
    "name": "Lanja",
    "state_id": "22"
  },
  {
    "id": "2667",
    "name": "Lasalgaon",
    "state_id": "22"
  },
  {
    "id": "2668",
    "name": "Latur",
    "state_id": "22"
  },
  {
    "id": "2669",
    "name": "Loha",
    "state_id": "22"
  },
  {
    "id": "2670",
    "name": "Lohegaon",
    "state_id": "22"
  },
  {
    "id": "2671",
    "name": "Lonar",
    "state_id": "22"
  },
  {
    "id": "2672",
    "name": "Lonavala",
    "state_id": "22"
  },
  {
    "id": "2673",
    "name": "Madhavnagar",
    "state_id": "22"
  },
  {
    "id": "2674",
    "name": "Mahabaleshwar",
    "state_id": "22"
  },
  {
    "id": "2675",
    "name": "Mahad",
    "state_id": "22"
  },
  {
    "id": "2676",
    "name": "Mahadula",
    "state_id": "22"
  },
  {
    "id": "2677",
    "name": "Maindargi",
    "state_id": "22"
  },
  {
    "id": "2678",
    "name": "Majalgaon",
    "state_id": "22"
  },
  {
    "id": "2679",
    "name": "Malegaon",
    "state_id": "22"
  },
  {
    "id": "2680",
    "name": "Malgaon",
    "state_id": "22"
  },
  {
    "id": "2681",
    "name": "Malkapur",
    "state_id": "22"
  },
  {
    "id": "2682",
    "name": "Malwan",
    "state_id": "22"
  },
  {
    "id": "2683",
    "name": "Manadur",
    "state_id": "22"
  },
  {
    "id": "2684",
    "name": "Manchar",
    "state_id": "22"
  },
  {
    "id": "2685",
    "name": "Mangalvedhe",
    "state_id": "22"
  },
  {
    "id": "2686",
    "name": "Mangrul Pir",
    "state_id": "22"
  },
  {
    "id": "2687",
    "name": "Manmad",
    "state_id": "22"
  },
  {
    "id": "2688",
    "name": "Manor",
    "state_id": "22"
  },
  {
    "id": "2689",
    "name": "Mansar",
    "state_id": "22"
  },
  {
    "id": "2690",
    "name": "Manwath",
    "state_id": "22"
  },
  {
    "id": "2691",
    "name": "Mapuca",
    "state_id": "22"
  },
  {
    "id": "2692",
    "name": "Matheran",
    "state_id": "22"
  },
  {
    "id": "2693",
    "name": "Mehkar",
    "state_id": "22"
  },
  {
    "id": "2694",
    "name": "Mhasla",
    "state_id": "22"
  },
  {
    "id": "2695",
    "name": "Mhaswad",
    "state_id": "22"
  },
  {
    "id": "2696",
    "name": "Mira Bhayandar",
    "state_id": "22"
  },
  {
    "id": "2697",
    "name": "Miraj",
    "state_id": "22"
  },
  {
    "id": "2698",
    "name": "Mohpa",
    "state_id": "22"
  },
  {
    "id": "2699",
    "name": "Mohpada",
    "state_id": "22"
  },
  {
    "id": "2700",
    "name": "Moram",
    "state_id": "22"
  },
  {
    "id": "2701",
    "name": "Morshi",
    "state_id": "22"
  },
  {
    "id": "2702",
    "name": "Mowad",
    "state_id": "22"
  },
  {
    "id": "2703",
    "name": "Mudkhed",
    "state_id": "22"
  },
  {
    "id": "2704",
    "name": "Mukhed",
    "state_id": "22"
  },
  {
    "id": "2705",
    "name": "Mul",
    "state_id": "22"
  },
  {
    "id": "2706",
    "name": "Mulshi",
    "state_id": "22"
  },
  {
    "id": "2707",
    "name": "Mumbai",
    "state_id": "22"
  },
  {
    "id": "2708",
    "name": "Murbad",
    "state_id": "22"
  },
  {
    "id": "2709",
    "name": "Murgud",
    "state_id": "22"
  },
  {
    "id": "2710",
    "name": "Murtijapur",
    "state_id": "22"
  },
  {
    "id": "2711",
    "name": "Murud",
    "state_id": "22"
  },
  {
    "id": "2712",
    "name": "Nachane",
    "state_id": "22"
  },
  {
    "id": "2713",
    "name": "Nagardeole",
    "state_id": "22"
  },
  {
    "id": "2714",
    "name": "Nagothane",
    "state_id": "22"
  },
  {
    "id": "2715",
    "name": "Nagpur",
    "state_id": "22"
  },
  {
    "id": "2716",
    "name": "Nakoda",
    "state_id": "22"
  },
  {
    "id": "2717",
    "name": "Nalasopara",
    "state_id": "22"
  },
  {
    "id": "2718",
    "name": "Naldurg",
    "state_id": "22"
  },
  {
    "id": "2719",
    "name": "Nanded",
    "state_id": "22"
  },
  {
    "id": "2720",
    "name": "Nandgaon",
    "state_id": "22"
  },
  {
    "id": "2721",
    "name": "Nandura",
    "state_id": "22"
  },
  {
    "id": "2722",
    "name": "Nandurbar",
    "state_id": "22"
  },
  {
    "id": "2723",
    "name": "Narkhed",
    "state_id": "22"
  },
  {
    "id": "2724",
    "name": "Nashik",
    "state_id": "22"
  },
  {
    "id": "2725",
    "name": "Navapur",
    "state_id": "22"
  },
  {
    "id": "2726",
    "name": "Navi Mumbai",
    "state_id": "22"
  },
  {
    "id": "2727",
    "name": "Navi Mumbai Panvel",
    "state_id": "22"
  },
  {
    "id": "2728",
    "name": "Neral",
    "state_id": "22"
  },
  {
    "id": "2729",
    "name": "Nigdi",
    "state_id": "22"
  },
  {
    "id": "2730",
    "name": "Nilanga",
    "state_id": "22"
  },
  {
    "id": "2731",
    "name": "Nildoh",
    "state_id": "22"
  },
  {
    "id": "2732",
    "name": "Nimbhore",
    "state_id": "22"
  },
  {
    "id": "2733",
    "name": "Ojhar",
    "state_id": "22"
  },
  {
    "id": "2734",
    "name": "Osmanabad",
    "state_id": "22"
  },
  {
    "id": "2735",
    "name": "Pachgaon",
    "state_id": "22"
  },
  {
    "id": "2736",
    "name": "Pachora",
    "state_id": "22"
  },
  {
    "id": "2737",
    "name": "Padagha",
    "state_id": "22"
  },
  {
    "id": "2738",
    "name": "Paithan",
    "state_id": "22"
  },
  {
    "id": "2739",
    "name": "Palghar",
    "state_id": "22"
  },
  {
    "id": "2740",
    "name": "Pali",
    "state_id": "22"
  },
  {
    "id": "2741",
    "name": "Panchgani",
    "state_id": "22"
  },
  {
    "id": "2742",
    "name": "Pandhakarwada",
    "state_id": "22"
  },
  {
    "id": "2743",
    "name": "Pandharpur",
    "state_id": "22"
  },
  {
    "id": "2744",
    "name": "Panhala",
    "state_id": "22"
  },
  {
    "id": "2745",
    "name": "Panvel",
    "state_id": "22"
  },
  {
    "id": "2746",
    "name": "Paranda",
    "state_id": "22"
  },
  {
    "id": "2747",
    "name": "Parbhani",
    "state_id": "22"
  },
  {
    "id": "2748",
    "name": "Parli",
    "state_id": "22"
  },
  {
    "id": "2749",
    "name": "Parola",
    "state_id": "22"
  },
  {
    "id": "2750",
    "name": "Partur",
    "state_id": "22"
  },
  {
    "id": "2751",
    "name": "Pasthal",
    "state_id": "22"
  },
  {
    "id": "2752",
    "name": "Patan",
    "state_id": "22"
  },
  {
    "id": "2753",
    "name": "Pathardi",
    "state_id": "22"
  },
  {
    "id": "2754",
    "name": "Pathri",
    "state_id": "22"
  },
  {
    "id": "2755",
    "name": "Patur",
    "state_id": "22"
  },
  {
    "id": "2756",
    "name": "Pawni",
    "state_id": "22"
  },
  {
    "id": "2757",
    "name": "Pen",
    "state_id": "22"
  },
  {
    "id": "2758",
    "name": "Pethumri",
    "state_id": "22"
  },
  {
    "id": "2759",
    "name": "Phaltan",
    "state_id": "22"
  },
  {
    "id": "2760",
    "name": "Pimpri",
    "state_id": "22"
  },
  {
    "id": "2761",
    "name": "Poladpur",
    "state_id": "22"
  },
  {
    "id": "2762",
    "name": "Pulgaon",
    "state_id": "22"
  },
  {
    "id": "2763",
    "name": "Pune",
    "state_id": "22"
  },
  {
    "id": "2764",
    "name": "Pune Cantonment",
    "state_id": "22"
  },
  {
    "id": "2765",
    "name": "Purna",
    "state_id": "22"
  },
  {
    "id": "2766",
    "name": "Purushottamnagar",
    "state_id": "22"
  },
  {
    "id": "2767",
    "name": "Pusad",
    "state_id": "22"
  },
  {
    "id": "2768",
    "name": "Rahimatpur",
    "state_id": "22"
  },
  {
    "id": "2769",
    "name": "Rahta Pimplas",
    "state_id": "22"
  },
  {
    "id": "2770",
    "name": "Rahuri",
    "state_id": "22"
  },
  {
    "id": "2771",
    "name": "Raigad",
    "state_id": "22"
  },
  {
    "id": "2772",
    "name": "Rajapur",
    "state_id": "22"
  },
  {
    "id": "2773",
    "name": "Rajgurunagar",
    "state_id": "22"
  },
  {
    "id": "2774",
    "name": "Rajur",
    "state_id": "22"
  },
  {
    "id": "2775",
    "name": "Rajura",
    "state_id": "22"
  },
  {
    "id": "2776",
    "name": "Ramtek",
    "state_id": "22"
  },
  {
    "id": "2777",
    "name": "Ratnagiri",
    "state_id": "22"
  },
  {
    "id": "2778",
    "name": "Ravalgaon",
    "state_id": "22"
  },
  {
    "id": "2779",
    "name": "Raver",
    "state_id": "22"
  },
  {
    "id": "2780",
    "name": "Revadanda",
    "state_id": "22"
  },
  {
    "id": "2781",
    "name": "Risod",
    "state_id": "22"
  },
  {
    "id": "2782",
    "name": "Roha Ashtami",
    "state_id": "22"
  },
  {
    "id": "2783",
    "name": "Sakri",
    "state_id": "22"
  },
  {
    "id": "2784",
    "name": "Sandor",
    "state_id": "22"
  },
  {
    "id": "2785",
    "name": "Sangamner",
    "state_id": "22"
  },
  {
    "id": "2786",
    "name": "Sangli",
    "state_id": "22"
  },
  {
    "id": "2787",
    "name": "Sangole",
    "state_id": "22"
  },
  {
    "id": "2788",
    "name": "Sasti",
    "state_id": "22"
  },
  {
    "id": "2789",
    "name": "Sasvad",
    "state_id": "22"
  },
  {
    "id": "2790",
    "name": "Satana",
    "state_id": "22"
  },
  {
    "id": "2791",
    "name": "Satara",
    "state_id": "22"
  },
  {
    "id": "2792",
    "name": "Savantvadi",
    "state_id": "22"
  },
  {
    "id": "2793",
    "name": "Savda",
    "state_id": "22"
  },
  {
    "id": "2794",
    "name": "Savner",
    "state_id": "22"
  },
  {
    "id": "2795",
    "name": "Sawari Jawharnagar",
    "state_id": "22"
  },
  {
    "id": "2796",
    "name": "Selu",
    "state_id": "22"
  },
  {
    "id": "2797",
    "name": "Shahada",
    "state_id": "22"
  },
  {
    "id": "2798",
    "name": "Shahapur",
    "state_id": "22"
  },
  {
    "id": "2799",
    "name": "Shegaon",
    "state_id": "22"
  },
  {
    "id": "2800",
    "name": "Shelar",
    "state_id": "22"
  },
  {
    "id": "2801",
    "name": "Shendurjana",
    "state_id": "22"
  },
  {
    "id": "2802",
    "name": "Shirdi",
    "state_id": "22"
  },
  {
    "id": "2803",
    "name": "Shirgaon",
    "state_id": "22"
  },
  {
    "id": "2804",
    "name": "Shirpur",
    "state_id": "22"
  },
  {
    "id": "2805",
    "name": "Shirur",
    "state_id": "22"
  },
  {
    "id": "2806",
    "name": "Shirwal",
    "state_id": "22"
  },
  {
    "id": "2807",
    "name": "Shivatkar",
    "state_id": "22"
  },
  {
    "id": "2808",
    "name": "Shrigonda",
    "state_id": "22"
  },
  {
    "id": "2809",
    "name": "Shrirampur",
    "state_id": "22"
  },
  {
    "id": "2810",
    "name": "Shrirampur Rural",
    "state_id": "22"
  },
  {
    "id": "2811",
    "name": "Sillewada",
    "state_id": "22"
  },
  {
    "id": "2812",
    "name": "Sillod",
    "state_id": "22"
  },
  {
    "id": "2813",
    "name": "Sindhudurg",
    "state_id": "22"
  },
  {
    "id": "2814",
    "name": "Sindi",
    "state_id": "22"
  },
  {
    "id": "2815",
    "name": "Sindi Turf Hindnagar",
    "state_id": "22"
  },
  {
    "id": "2816",
    "name": "Sindkhed Raja",
    "state_id": "22"
  },
  {
    "id": "2817",
    "name": "Singnapur",
    "state_id": "22"
  },
  {
    "id": "2818",
    "name": "Sinnar",
    "state_id": "22"
  },
  {
    "id": "2819",
    "name": "Sirur",
    "state_id": "22"
  },
  {
    "id": "2820",
    "name": "Sitasawangi",
    "state_id": "22"
  },
  {
    "id": "2821",
    "name": "Solapur",
    "state_id": "22"
  },
  {
    "id": "2822",
    "name": "Sonai",
    "state_id": "22"
  },
  {
    "id": "2823",
    "name": "Sonegaon",
    "state_id": "22"
  },
  {
    "id": "2824",
    "name": "Soyagaon",
    "state_id": "22"
  },
  {
    "id": "2825",
    "name": "Srivardhan",
    "state_id": "22"
  },
  {
    "id": "2826",
    "name": "Surgana",
    "state_id": "22"
  },
  {
    "id": "2827",
    "name": "Talegaon Dabhade",
    "state_id": "22"
  },
  {
    "id": "2828",
    "name": "Taloda",
    "state_id": "22"
  },
  {
    "id": "2829",
    "name": "Taloja",
    "state_id": "22"
  },
  {
    "id": "2830",
    "name": "Talwade",
    "state_id": "22"
  },
  {
    "id": "2831",
    "name": "Tarapur",
    "state_id": "22"
  },
  {
    "id": "2832",
    "name": "Tasgaon",
    "state_id": "22"
  },
  {
    "id": "2833",
    "name": "Tathavade",
    "state_id": "22"
  },
  {
    "id": "2834",
    "name": "Tekadi",
    "state_id": "22"
  },
  {
    "id": "2835",
    "name": "Telhara",
    "state_id": "22"
  },
  {
    "id": "2836",
    "name": "Thane",
    "state_id": "22"
  },
  {
    "id": "2837",
    "name": "Tirira",
    "state_id": "22"
  },
  {
    "id": "2838",
    "name": "Totaladoh",
    "state_id": "22"
  },
  {
    "id": "2839",
    "name": "Trimbak",
    "state_id": "22"
  },
  {
    "id": "2840",
    "name": "Tuljapur",
    "state_id": "22"
  },
  {
    "id": "2841",
    "name": "Tumsar",
    "state_id": "22"
  },
  {
    "id": "2842",
    "name": "Uchgaon",
    "state_id": "22"
  },
  {
    "id": "2843",
    "name": "Udgir",
    "state_id": "22"
  },
  {
    "id": "2844",
    "name": "Ulhasnagar",
    "state_id": "22"
  },
  {
    "id": "2845",
    "name": "Umarga",
    "state_id": "22"
  },
  {
    "id": "2846",
    "name": "Umarkhed",
    "state_id": "22"
  },
  {
    "id": "2847",
    "name": "Umarsara",
    "state_id": "22"
  },
  {
    "id": "2848",
    "name": "Umbar Pada Nandade",
    "state_id": "22"
  },
  {
    "id": "2849",
    "name": "Umred",
    "state_id": "22"
  },
  {
    "id": "2850",
    "name": "Umri Pragane Balapur",
    "state_id": "22"
  },
  {
    "id": "2851",
    "name": "Uran",
    "state_id": "22"
  },
  {
    "id": "2852",
    "name": "Uran Islampur",
    "state_id": "22"
  },
  {
    "id": "2853",
    "name": "Utekhol",
    "state_id": "22"
  },
  {
    "id": "2854",
    "name": "Vada",
    "state_id": "22"
  },
  {
    "id": "2855",
    "name": "Vadgaon",
    "state_id": "22"
  },
  {
    "id": "2856",
    "name": "Vadgaon Kasba",
    "state_id": "22"
  },
  {
    "id": "2857",
    "name": "Vaijapur",
    "state_id": "22"
  },
  {
    "id": "2858",
    "name": "Vanvadi",
    "state_id": "22"
  },
  {
    "id": "2859",
    "name": "Varangaon",
    "state_id": "22"
  },
  {
    "id": "2860",
    "name": "Vasai",
    "state_id": "22"
  },
  {
    "id": "2861",
    "name": "Vasantnagar",
    "state_id": "22"
  },
  {
    "id": "2862",
    "name": "Vashind",
    "state_id": "22"
  },
  {
    "id": "2863",
    "name": "Vengurla",
    "state_id": "22"
  },
  {
    "id": "2864",
    "name": "Virar",
    "state_id": "22"
  },
  {
    "id": "2865",
    "name": "Visapur",
    "state_id": "22"
  },
  {
    "id": "2866",
    "name": "Vite",
    "state_id": "22"
  },
  {
    "id": "2867",
    "name": "Vithalwadi",
    "state_id": "22"
  },
  {
    "id": "2868",
    "name": "Wadi",
    "state_id": "22"
  },
  {
    "id": "2869",
    "name": "Waghapur",
    "state_id": "22"
  },
  {
    "id": "2870",
    "name": "Wai",
    "state_id": "22"
  },
  {
    "id": "2871",
    "name": "Wajegaon",
    "state_id": "22"
  },
  {
    "id": "2872",
    "name": "Walani",
    "state_id": "22"
  },
  {
    "id": "2873",
    "name": "Wanadongri",
    "state_id": "22"
  },
  {
    "id": "2874",
    "name": "Wani",
    "state_id": "22"
  },
  {
    "id": "2875",
    "name": "Wardha",
    "state_id": "22"
  },
  {
    "id": "2876",
    "name": "Warora",
    "state_id": "22"
  },
  {
    "id": "2877",
    "name": "Warthi",
    "state_id": "22"
  },
  {
    "id": "2878",
    "name": "Warud",
    "state_id": "22"
  },
  {
    "id": "2879",
    "name": "Washim",
    "state_id": "22"
  },
  {
    "id": "2880",
    "name": "Yaval",
    "state_id": "22"
  },
  {
    "id": "2881",
    "name": "Yavatmal",
    "state_id": "22"
  },
  {
    "id": "2882",
    "name": "Yeola",
    "state_id": "22"
  },
  {
    "id": "2883",
    "name": "Yerkheda",
    "state_id": "22"
  },
  {
    "id": "2884",
    "name": "Andro",
    "state_id": "23"
  },
  {
    "id": "2885",
    "name": "Bijoy Govinda",
    "state_id": "23"
  },
  {
    "id": "2886",
    "name": "Bishnupur",
    "state_id": "23"
  },
  {
    "id": "2887",
    "name": "Churachandpur",
    "state_id": "23"
  },
  {
    "id": "2888",
    "name": "Heriok",
    "state_id": "23"
  },
  {
    "id": "2889",
    "name": "Imphal",
    "state_id": "23"
  },
  {
    "id": "2890",
    "name": "Jiribam",
    "state_id": "23"
  },
  {
    "id": "2891",
    "name": "Kakching",
    "state_id": "23"
  },
  {
    "id": "2892",
    "name": "Kakching Khunou",
    "state_id": "23"
  },
  {
    "id": "2893",
    "name": "Khongman",
    "state_id": "23"
  },
  {
    "id": "2894",
    "name": "Kumbi",
    "state_id": "23"
  },
  {
    "id": "2895",
    "name": "Kwakta",
    "state_id": "23"
  },
  {
    "id": "2896",
    "name": "Lamai",
    "state_id": "23"
  },
  {
    "id": "2897",
    "name": "Lamjaotongba",
    "state_id": "23"
  },
  {
    "id": "2898",
    "name": "Lamshang",
    "state_id": "23"
  },
  {
    "id": "2899",
    "name": "Lilong",
    "state_id": "23"
  },
  {
    "id": "2900",
    "name": "Mayang Imphal",
    "state_id": "23"
  },
  {
    "id": "2901",
    "name": "Moirang",
    "state_id": "23"
  },
  {
    "id": "2902",
    "name": "Moreh",
    "state_id": "23"
  },
  {
    "id": "2903",
    "name": "Nambol",
    "state_id": "23"
  },
  {
    "id": "2904",
    "name": "Naoriya Pakhanglakpa",
    "state_id": "23"
  },
  {
    "id": "2905",
    "name": "Ningthoukhong",
    "state_id": "23"
  },
  {
    "id": "2906",
    "name": "Oinam",
    "state_id": "23"
  },
  {
    "id": "2907",
    "name": "Porompat",
    "state_id": "23"
  },
  {
    "id": "2908",
    "name": "Samurou",
    "state_id": "23"
  },
  {
    "id": "2909",
    "name": "Sekmai Bazar",
    "state_id": "23"
  },
  {
    "id": "2910",
    "name": "Senapati",
    "state_id": "23"
  },
  {
    "id": "2911",
    "name": "Sikhong Sekmai",
    "state_id": "23"
  },
  {
    "id": "2912",
    "name": "Sugnu",
    "state_id": "23"
  },
  {
    "id": "2913",
    "name": "Thongkhong Laxmi Bazar",
    "state_id": "23"
  },
  {
    "id": "2914",
    "name": "Thoubal",
    "state_id": "23"
  },
  {
    "id": "2915",
    "name": "Torban",
    "state_id": "23"
  },
  {
    "id": "2916",
    "name": "Wangjing",
    "state_id": "23"
  },
  {
    "id": "2917",
    "name": "Wangoi",
    "state_id": "23"
  },
  {
    "id": "2918",
    "name": "Yairipok",
    "state_id": "23"
  },
  {
    "id": "2919",
    "name": "Baghmara",
    "state_id": "24"
  },
  {
    "id": "2920",
    "name": "Cherrapunji",
    "state_id": "24"
  },
  {
    "id": "2921",
    "name": "Jawai",
    "state_id": "24"
  },
  {
    "id": "2922",
    "name": "Madanrting",
    "state_id": "24"
  },
  {
    "id": "2923",
    "name": "Mairang",
    "state_id": "24"
  },
  {
    "id": "2924",
    "name": "Mawlai",
    "state_id": "24"
  },
  {
    "id": "2925",
    "name": "Nongmynsong",
    "state_id": "24"
  },
  {
    "id": "2926",
    "name": "Nongpoh",
    "state_id": "24"
  },
  {
    "id": "2927",
    "name": "Nongstoin",
    "state_id": "24"
  },
  {
    "id": "2928",
    "name": "Nongthymmai",
    "state_id": "24"
  },
  {
    "id": "2929",
    "name": "Pynthorumkhrah",
    "state_id": "24"
  },
  {
    "id": "2930",
    "name": "Resubelpara",
    "state_id": "24"
  },
  {
    "id": "2931",
    "name": "Shillong",
    "state_id": "24"
  },
  {
    "id": "2932",
    "name": "Shillong Cantonment",
    "state_id": "24"
  },
  {
    "id": "2933",
    "name": "Tura",
    "state_id": "24"
  },
  {
    "id": "2934",
    "name": "Williamnagar",
    "state_id": "24"
  },
  {
    "id": "2935",
    "name": "Aizawl",
    "state_id": "25"
  },
  {
    "id": "2936",
    "name": "Bairabi",
    "state_id": "25"
  },
  {
    "id": "2937",
    "name": "Biate",
    "state_id": "25"
  },
  {
    "id": "2938",
    "name": "Champhai",
    "state_id": "25"
  },
  {
    "id": "2939",
    "name": "Darlawn",
    "state_id": "25"
  },
  {
    "id": "2940",
    "name": "Hnahthial",
    "state_id": "25"
  },
  {
    "id": "2941",
    "name": "Kawnpui",
    "state_id": "25"
  },
  {
    "id": "2942",
    "name": "Khawhai",
    "state_id": "25"
  },
  {
    "id": "2943",
    "name": "Khawzawl",
    "state_id": "25"
  },
  {
    "id": "2944",
    "name": "Kolasib",
    "state_id": "25"
  },
  {
    "id": "2945",
    "name": "Lengpui",
    "state_id": "25"
  },
  {
    "id": "2946",
    "name": "Lunglei",
    "state_id": "25"
  },
  {
    "id": "2947",
    "name": "Mamit",
    "state_id": "25"
  },
  {
    "id": "2948",
    "name": "North Vanlaiphai",
    "state_id": "25"
  },
  {
    "id": "2949",
    "name": "Saiha",
    "state_id": "25"
  },
  {
    "id": "2950",
    "name": "Sairang",
    "state_id": "25"
  },
  {
    "id": "2951",
    "name": "Saitul",
    "state_id": "25"
  },
  {
    "id": "2952",
    "name": "Serchhip",
    "state_id": "25"
  },
  {
    "id": "2953",
    "name": "Thenzawl",
    "state_id": "25"
  },
  {
    "id": "2954",
    "name": "Tlabung",
    "state_id": "25"
  },
  {
    "id": "2955",
    "name": "Vairengte",
    "state_id": "25"
  },
  {
    "id": "2956",
    "name": "Zawlnuam",
    "state_id": "25"
  },
  {
    "id": "2957",
    "name": "Chumukedima",
    "state_id": "26"
  },
  {
    "id": "2958",
    "name": "Dimapur",
    "state_id": "26"
  },
  {
    "id": "2959",
    "name": "Kohima",
    "state_id": "26"
  },
  {
    "id": "2960",
    "name": "Mokokchung",
    "state_id": "26"
  },
  {
    "id": "2961",
    "name": "Mon",
    "state_id": "26"
  },
  {
    "id": "2962",
    "name": "Phek",
    "state_id": "26"
  },
  {
    "id": "2963",
    "name": "Tuensang",
    "state_id": "26"
  },
  {
    "id": "2964",
    "name": "Wokha",
    "state_id": "26"
  },
  {
    "id": "2965",
    "name": "Zunheboto",
    "state_id": "26"
  },
  {
    "id": "2966",
    "name": "Anandapur",
    "state_id": "29"
  },
  {
    "id": "2967",
    "name": "Angul",
    "state_id": "29"
  },
  {
    "id": "2968",
    "name": "Aska",
    "state_id": "29"
  },
  {
    "id": "2969",
    "name": "Athgarh",
    "state_id": "29"
  },
  {
    "id": "2970",
    "name": "Athmallik",
    "state_id": "29"
  },
  {
    "id": "2971",
    "name": "Balagoda",
    "state_id": "29"
  },
  {
    "id": "2972",
    "name": "Balangir",
    "state_id": "29"
  },
  {
    "id": "2973",
    "name": "Balasore",
    "state_id": "29"
  },
  {
    "id": "2974",
    "name": "Baleshwar",
    "state_id": "29"
  },
  {
    "id": "2975",
    "name": "Balimeta",
    "state_id": "29"
  },
  {
    "id": "2976",
    "name": "Balugaon",
    "state_id": "29"
  },
  {
    "id": "2977",
    "name": "Banapur",
    "state_id": "29"
  },
  {
    "id": "2978",
    "name": "Bangura",
    "state_id": "29"
  },
  {
    "id": "2979",
    "name": "Banki",
    "state_id": "29"
  },
  {
    "id": "2980",
    "name": "Banposh",
    "state_id": "29"
  },
  {
    "id": "2981",
    "name": "Barbil",
    "state_id": "29"
  },
  {
    "id": "2982",
    "name": "Bargarh",
    "state_id": "29"
  },
  {
    "id": "2983",
    "name": "Baripada",
    "state_id": "29"
  },
  {
    "id": "2984",
    "name": "Barpali",
    "state_id": "29"
  },
  {
    "id": "2985",
    "name": "Basudebpur",
    "state_id": "29"
  },
  {
    "id": "2986",
    "name": "Baudh",
    "state_id": "29"
  },
  {
    "id": "2987",
    "name": "Belagachhia",
    "state_id": "29"
  },
  {
    "id": "2988",
    "name": "Belaguntha",
    "state_id": "29"
  },
  {
    "id": "2989",
    "name": "Belpahar",
    "state_id": "29"
  },
  {
    "id": "2990",
    "name": "Berhampur",
    "state_id": "29"
  },
  {
    "id": "2991",
    "name": "Bhadrak",
    "state_id": "29"
  },
  {
    "id": "2992",
    "name": "Bhanjanagar",
    "state_id": "29"
  },
  {
    "id": "2993",
    "name": "Bhawanipatna",
    "state_id": "29"
  },
  {
    "id": "2994",
    "name": "Bhuban",
    "state_id": "29"
  },
  {
    "id": "2995",
    "name": "Bhubaneswar",
    "state_id": "29"
  },
  {
    "id": "2996",
    "name": "Binika",
    "state_id": "29"
  },
  {
    "id": "2997",
    "name": "Birmitrapur",
    "state_id": "29"
  },
  {
    "id": "2998",
    "name": "Bishama Katek",
    "state_id": "29"
  },
  {
    "id": "2999",
    "name": "Bolangir",
    "state_id": "29"
  },
  {
    "id": "3000",
    "name": "Brahmapur",
    "state_id": "29"
  },
  {
    "id": "3001",
    "name": "Brajrajnagar",
    "state_id": "29"
  },
  {
    "id": "3002",
    "name": "Buguda",
    "state_id": "29"
  },
  {
    "id": "3003",
    "name": "Burla",
    "state_id": "29"
  },
  {
    "id": "3004",
    "name": "Byasanagar",
    "state_id": "29"
  },
  {
    "id": "3005",
    "name": "Champua",
    "state_id": "29"
  },
  {
    "id": "3006",
    "name": "Chandapur",
    "state_id": "29"
  },
  {
    "id": "3007",
    "name": "Chandbali",
    "state_id": "29"
  },
  {
    "id": "3008",
    "name": "Chandili",
    "state_id": "29"
  },
  {
    "id": "3009",
    "name": "Charibatia",
    "state_id": "29"
  },
  {
    "id": "3010",
    "name": "Chatrapur",
    "state_id": "29"
  },
  {
    "id": "3011",
    "name": "Chikitigarh",
    "state_id": "29"
  },
  {
    "id": "3012",
    "name": "Chitrakonda",
    "state_id": "29"
  },
  {
    "id": "3013",
    "name": "Choudwar",
    "state_id": "29"
  },
  {
    "id": "3014",
    "name": "Cuttack",
    "state_id": "29"
  },
  {
    "id": "3015",
    "name": "Dadhapatna",
    "state_id": "29"
  },
  {
    "id": "3016",
    "name": "Daitari",
    "state_id": "29"
  },
  {
    "id": "3017",
    "name": "Damanjodi",
    "state_id": "29"
  },
  {
    "id": "3018",
    "name": "Deogarh",
    "state_id": "29"
  },
  {
    "id": "3019",
    "name": "Deracolliery",
    "state_id": "29"
  },
  {
    "id": "3020",
    "name": "Dhamanagar",
    "state_id": "29"
  },
  {
    "id": "3021",
    "name": "Dhenkanal",
    "state_id": "29"
  },
  {
    "id": "3022",
    "name": "Digapahandi",
    "state_id": "29"
  },
  {
    "id": "3023",
    "name": "Dungamal",
    "state_id": "29"
  },
  {
    "id": "3024",
    "name": "Fertilizer Corporation of Indi",
    "state_id": "29"
  },
  {
    "id": "3025",
    "name": "Ganjam",
    "state_id": "29"
  },
  {
    "id": "3026",
    "name": "Ghantapada",
    "state_id": "29"
  },
  {
    "id": "3027",
    "name": "Gopalpur",
    "state_id": "29"
  },
  {
    "id": "3028",
    "name": "Gudari",
    "state_id": "29"
  },
  {
    "id": "3029",
    "name": "Gunupur",
    "state_id": "29"
  },
  {
    "id": "3030",
    "name": "Hatibandha",
    "state_id": "29"
  },
  {
    "id": "3031",
    "name": "Hinjilikatu",
    "state_id": "29"
  },
  {
    "id": "3032",
    "name": "Hirakud",
    "state_id": "29"
  },
  {
    "id": "3033",
    "name": "Jagatsinghapur",
    "state_id": "29"
  },
  {
    "id": "3034",
    "name": "Jajpur",
    "state_id": "29"
  },
  {
    "id": "3035",
    "name": "Jalda",
    "state_id": "29"
  },
  {
    "id": "3036",
    "name": "Jaleswar",
    "state_id": "29"
  },
  {
    "id": "3037",
    "name": "Jatni",
    "state_id": "29"
  },
  {
    "id": "3038",
    "name": "Jaypur",
    "state_id": "29"
  },
  {
    "id": "3039",
    "name": "Jeypore",
    "state_id": "29"
  },
  {
    "id": "3040",
    "name": "Jharsuguda",
    "state_id": "29"
  },
  {
    "id": "3041",
    "name": "Jhumpura",
    "state_id": "29"
  },
  {
    "id": "3042",
    "name": "Joda",
    "state_id": "29"
  },
  {
    "id": "3043",
    "name": "Junagarh",
    "state_id": "29"
  },
  {
    "id": "3044",
    "name": "Kamakhyanagar",
    "state_id": "29"
  },
  {
    "id": "3045",
    "name": "Kantabanji",
    "state_id": "29"
  },
  {
    "id": "3046",
    "name": "Kantilo",
    "state_id": "29"
  },
  {
    "id": "3047",
    "name": "Karanja",
    "state_id": "29"
  },
  {
    "id": "3048",
    "name": "Kashinagara",
    "state_id": "29"
  },
  {
    "id": "3049",
    "name": "Kataka",
    "state_id": "29"
  },
  {
    "id": "3050",
    "name": "Kavisuryanagar",
    "state_id": "29"
  },
  {
    "id": "3051",
    "name": "Kendrapara",
    "state_id": "29"
  },
  {
    "id": "3052",
    "name": "Kendujhar",
    "state_id": "29"
  },
  {
    "id": "3053",
    "name": "Keonjhar",
    "state_id": "29"
  },
  {
    "id": "3054",
    "name": "Kesinga",
    "state_id": "29"
  },
  {
    "id": "3055",
    "name": "Khaliapali",
    "state_id": "29"
  },
  {
    "id": "3056",
    "name": "Khalikote",
    "state_id": "29"
  },
  {
    "id": "3057",
    "name": "Khandaparha",
    "state_id": "29"
  },
  {
    "id": "3058",
    "name": "Kharhial",
    "state_id": "29"
  },
  {
    "id": "3059",
    "name": "Kharhial Road",
    "state_id": "29"
  },
  {
    "id": "3060",
    "name": "Khatiguda",
    "state_id": "29"
  },
  {
    "id": "3061",
    "name": "Khurda",
    "state_id": "29"
  },
  {
    "id": "3062",
    "name": "Kochinda",
    "state_id": "29"
  },
  {
    "id": "3063",
    "name": "Kodala",
    "state_id": "29"
  },
  {
    "id": "3064",
    "name": "Konark",
    "state_id": "29"
  },
  {
    "id": "3065",
    "name": "Koraput",
    "state_id": "29"
  },
  {
    "id": "3066",
    "name": "Kotaparh",
    "state_id": "29"
  },
  {
    "id": "3067",
    "name": "Lanjigarh",
    "state_id": "29"
  },
  {
    "id": "3068",
    "name": "Lattikata",
    "state_id": "29"
  },
  {
    "id": "3069",
    "name": "Makundapur",
    "state_id": "29"
  },
  {
    "id": "3070",
    "name": "Malkangiri",
    "state_id": "29"
  },
  {
    "id": "3071",
    "name": "Mukhiguda",
    "state_id": "29"
  },
  {
    "id": "3072",
    "name": "Nabarangpur",
    "state_id": "29"
  },
  {
    "id": "3073",
    "name": "Nalco",
    "state_id": "29"
  },
  {
    "id": "3074",
    "name": "Naurangapur",
    "state_id": "29"
  },
  {
    "id": "3075",
    "name": "Nayagarh",
    "state_id": "29"
  },
  {
    "id": "3076",
    "name": "Nilagiri",
    "state_id": "29"
  },
  {
    "id": "3077",
    "name": "Nimaparha",
    "state_id": "29"
  },
  {
    "id": "3078",
    "name": "Nuapada",
    "state_id": "29"
  },
  {
    "id": "3079",
    "name": "Nuapatna",
    "state_id": "29"
  },
  {
    "id": "3080",
    "name": "OCL Industrialship",
    "state_id": "29"
  },
  {
    "id": "3081",
    "name": "Padampur",
    "state_id": "29"
  },
  {
    "id": "3082",
    "name": "Paradip",
    "state_id": "29"
  },
  {
    "id": "3083",
    "name": "Paradwip",
    "state_id": "29"
  },
  {
    "id": "3084",
    "name": "Parlakimidi",
    "state_id": "29"
  },
  {
    "id": "3085",
    "name": "Patamundai",
    "state_id": "29"
  },
  {
    "id": "3086",
    "name": "Patnagarh",
    "state_id": "29"
  },
  {
    "id": "3087",
    "name": "Phulabani",
    "state_id": "29"
  },
  {
    "id": "3088",
    "name": "Pipili",
    "state_id": "29"
  },
  {
    "id": "3089",
    "name": "Polasara",
    "state_id": "29"
  },
  {
    "id": "3090",
    "name": "Pratapsasan",
    "state_id": "29"
  },
  {
    "id": "3091",
    "name": "Puri",
    "state_id": "29"
  },
  {
    "id": "3092",
    "name": "Purushottampur",
    "state_id": "29"
  },
  {
    "id": "3093",
    "name": "Rairangpur",
    "state_id": "29"
  },
  {
    "id": "3094",
    "name": "Raj Gangpur",
    "state_id": "29"
  },
  {
    "id": "3095",
    "name": "Rambha",
    "state_id": "29"
  },
  {
    "id": "3096",
    "name": "Raurkela",
    "state_id": "29"
  },
  {
    "id": "3097",
    "name": "Raurkela Civil Township",
    "state_id": "29"
  },
  {
    "id": "3098",
    "name": "Rayagada",
    "state_id": "29"
  },
  {
    "id": "3099",
    "name": "Redhakhol",
    "state_id": "29"
  },
  {
    "id": "3100",
    "name": "Remuna",
    "state_id": "29"
  },
  {
    "id": "3101",
    "name": "Rengali",
    "state_id": "29"
  },
  {
    "id": "3102",
    "name": "Rourkela",
    "state_id": "29"
  },
  {
    "id": "3103",
    "name": "Sambalpur",
    "state_id": "29"
  },
  {
    "id": "3104",
    "name": "Sinapali",
    "state_id": "29"
  },
  {
    "id": "3105",
    "name": "Sonepur",
    "state_id": "29"
  },
  {
    "id": "3106",
    "name": "Sorada",
    "state_id": "29"
  },
  {
    "id": "3107",
    "name": "Soro",
    "state_id": "29"
  },
  {
    "id": "3108",
    "name": "Sunabeda",
    "state_id": "29"
  },
  {
    "id": "3109",
    "name": "Sundargarh",
    "state_id": "29"
  },
  {
    "id": "3110",
    "name": "Talcher",
    "state_id": "29"
  },
  {
    "id": "3111",
    "name": "Talcher Thermal Power Station",
    "state_id": "29"
  },
  {
    "id": "3112",
    "name": "Tarabha",
    "state_id": "29"
  },
  {
    "id": "3113",
    "name": "Tensa",
    "state_id": "29"
  },
  {
    "id": "3114",
    "name": "Titlagarh",
    "state_id": "29"
  },
  {
    "id": "3115",
    "name": "Udala",
    "state_id": "29"
  },
  {
    "id": "3116",
    "name": "Udayagiri",
    "state_id": "29"
  },
  {
    "id": "3117",
    "name": "Umarkot",
    "state_id": "29"
  },
  {
    "id": "3118",
    "name": "Vikrampur",
    "state_id": "29"
  },
  {
    "id": "3119",
    "name": "Ariankuppam",
    "state_id": "31"
  },
  {
    "id": "3120",
    "name": "Karaikal",
    "state_id": "31"
  },
  {
    "id": "3121",
    "name": "Kurumbapet",
    "state_id": "31"
  },
  {
    "id": "3122",
    "name": "Mahe",
    "state_id": "31"
  },
  {
    "id": "3123",
    "name": "Ozhukarai",
    "state_id": "31"
  },
  {
    "id": "3124",
    "name": "Pondicherry",
    "state_id": "31"
  },
  {
    "id": "3125",
    "name": "Villianur",
    "state_id": "31"
  },
  {
    "id": "3126",
    "name": "Yanam",
    "state_id": "31"
  },
  {
    "id": "3127",
    "name": "Abohar",
    "state_id": "32"
  },
  {
    "id": "3128",
    "name": "Adampur",
    "state_id": "32"
  },
  {
    "id": "3129",
    "name": "Ahmedgarh",
    "state_id": "32"
  },
  {
    "id": "3130",
    "name": "Ajnala",
    "state_id": "32"
  },
  {
    "id": "3131",
    "name": "Akalgarh",
    "state_id": "32"
  },
  {
    "id": "3132",
    "name": "Alawalpur",
    "state_id": "32"
  },
  {
    "id": "3133",
    "name": "Amloh",
    "state_id": "32"
  },
  {
    "id": "3134",
    "name": "Amritsar",
    "state_id": "32"
  },
  {
    "id": "3135",
    "name": "Amritsar Cantonment",
    "state_id": "32"
  },
  {
    "id": "3136",
    "name": "Anandpur Sahib",
    "state_id": "32"
  },
  {
    "id": "3137",
    "name": "Badhni Kalan",
    "state_id": "32"
  },
  {
    "id": "3138",
    "name": "Bagh Purana",
    "state_id": "32"
  },
  {
    "id": "3139",
    "name": "Balachaur",
    "state_id": "32"
  },
  {
    "id": "3140",
    "name": "Banaur",
    "state_id": "32"
  },
  {
    "id": "3141",
    "name": "Banga",
    "state_id": "32"
  },
  {
    "id": "3142",
    "name": "Banur",
    "state_id": "32"
  },
  {
    "id": "3143",
    "name": "Baretta",
    "state_id": "32"
  },
  {
    "id": "3144",
    "name": "Bariwala",
    "state_id": "32"
  },
  {
    "id": "3145",
    "name": "Barnala",
    "state_id": "32"
  },
  {
    "id": "3146",
    "name": "Bassi Pathana",
    "state_id": "32"
  },
  {
    "id": "3147",
    "name": "Batala",
    "state_id": "32"
  },
  {
    "id": "3148",
    "name": "Bathinda",
    "state_id": "32"
  },
  {
    "id": "3149",
    "name": "Begowal",
    "state_id": "32"
  },
  {
    "id": "3150",
    "name": "Behrampur",
    "state_id": "32"
  },
  {
    "id": "3151",
    "name": "Bhabat",
    "state_id": "32"
  },
  {
    "id": "3152",
    "name": "Bhadur",
    "state_id": "32"
  },
  {
    "id": "3153",
    "name": "Bhankharpur",
    "state_id": "32"
  },
  {
    "id": "3154",
    "name": "Bharoli Kalan",
    "state_id": "32"
  },
  {
    "id": "3155",
    "name": "Bhawanigarh",
    "state_id": "32"
  },
  {
    "id": "3156",
    "name": "Bhikhi",
    "state_id": "32"
  },
  {
    "id": "3157",
    "name": "Bhikhiwind",
    "state_id": "32"
  },
  {
    "id": "3158",
    "name": "Bhisiana",
    "state_id": "32"
  },
  {
    "id": "3159",
    "name": "Bhogpur",
    "state_id": "32"
  },
  {
    "id": "3160",
    "name": "Bhuch",
    "state_id": "32"
  },
  {
    "id": "3161",
    "name": "Bhulath",
    "state_id": "32"
  },
  {
    "id": "3162",
    "name": "Budha Theh",
    "state_id": "32"
  },
  {
    "id": "3163",
    "name": "Budhlada",
    "state_id": "32"
  },
  {
    "id": "3164",
    "name": "Chima",
    "state_id": "32"
  },
  {
    "id": "3165",
    "name": "Chohal",
    "state_id": "32"
  },
  {
    "id": "3166",
    "name": "Dasuya",
    "state_id": "32"
  },
  {
    "id": "3167",
    "name": "Daulatpur",
    "state_id": "32"
  },
  {
    "id": "3168",
    "name": "Dera Baba Nanak",
    "state_id": "32"
  },
  {
    "id": "3169",
    "name": "Dera Bassi",
    "state_id": "32"
  },
  {
    "id": "3170",
    "name": "Dhanaula",
    "state_id": "32"
  },
  {
    "id": "3171",
    "name": "Dharam Kot",
    "state_id": "32"
  },
  {
    "id": "3172",
    "name": "Dhariwal",
    "state_id": "32"
  },
  {
    "id": "3173",
    "name": "Dhilwan",
    "state_id": "32"
  },
  {
    "id": "3174",
    "name": "Dhuri",
    "state_id": "32"
  },
  {
    "id": "3175",
    "name": "Dinanagar",
    "state_id": "32"
  },
  {
    "id": "3176",
    "name": "Dirba",
    "state_id": "32"
  },
  {
    "id": "3177",
    "name": "Doraha",
    "state_id": "32"
  },
  {
    "id": "3178",
    "name": "Faridkot",
    "state_id": "32"
  },
  {
    "id": "3179",
    "name": "Fateh Nangal",
    "state_id": "32"
  },
  {
    "id": "3180",
    "name": "Fatehgarh Churian",
    "state_id": "32"
  },
  {
    "id": "3181",
    "name": "Fatehgarh Sahib",
    "state_id": "32"
  },
  {
    "id": "3182",
    "name": "Fazilka",
    "state_id": "32"
  },
  {
    "id": "3183",
    "name": "Firozpur",
    "state_id": "32"
  },
  {
    "id": "3184",
    "name": "Firozpur Cantonment",
    "state_id": "32"
  },
  {
    "id": "3185",
    "name": "Gardhiwala",
    "state_id": "32"
  },
  {
    "id": "3186",
    "name": "Garhshankar",
    "state_id": "32"
  },
  {
    "id": "3187",
    "name": "Ghagga",
    "state_id": "32"
  },
  {
    "id": "3188",
    "name": "Ghanaur",
    "state_id": "32"
  },
  {
    "id": "3189",
    "name": "Giddarbaha",
    "state_id": "32"
  },
  {
    "id": "3190",
    "name": "Gobindgarh",
    "state_id": "32"
  },
  {
    "id": "3191",
    "name": "Goniana",
    "state_id": "32"
  },
  {
    "id": "3192",
    "name": "Goraya",
    "state_id": "32"
  },
  {
    "id": "3193",
    "name": "Gurdaspur",
    "state_id": "32"
  },
  {
    "id": "3194",
    "name": "Guru Har Sahai",
    "state_id": "32"
  },
  {
    "id": "3195",
    "name": "Hajipur",
    "state_id": "32"
  },
  {
    "id": "3196",
    "name": "Handiaya",
    "state_id": "32"
  },
  {
    "id": "3197",
    "name": "Hariana",
    "state_id": "32"
  },
  {
    "id": "3198",
    "name": "Hoshiarpur",
    "state_id": "32"
  },
  {
    "id": "3199",
    "name": "Hussainpur",
    "state_id": "32"
  },
  {
    "id": "3200",
    "name": "Jagraon",
    "state_id": "32"
  },
  {
    "id": "3201",
    "name": "Jaitu",
    "state_id": "32"
  },
  {
    "id": "3202",
    "name": "Jalalabad",
    "state_id": "32"
  },
  {
    "id": "3203",
    "name": "Jalandhar",
    "state_id": "32"
  },
  {
    "id": "3204",
    "name": "Jalandhar Cantonment",
    "state_id": "32"
  },
  {
    "id": "3205",
    "name": "Jandiala",
    "state_id": "32"
  },
  {
    "id": "3206",
    "name": "Jugial",
    "state_id": "32"
  },
  {
    "id": "3207",
    "name": "Kalanaur",
    "state_id": "32"
  },
  {
    "id": "3208",
    "name": "Kapurthala",
    "state_id": "32"
  },
  {
    "id": "3209",
    "name": "Karoran",
    "state_id": "32"
  },
  {
    "id": "3210",
    "name": "Kartarpur",
    "state_id": "32"
  },
  {
    "id": "3211",
    "name": "Khamanon",
    "state_id": "32"
  },
  {
    "id": "3212",
    "name": "Khanauri",
    "state_id": "32"
  },
  {
    "id": "3213",
    "name": "Khanna",
    "state_id": "32"
  },
  {
    "id": "3214",
    "name": "Kharar",
    "state_id": "32"
  },
  {
    "id": "3215",
    "name": "Khem Karan",
    "state_id": "32"
  },
  {
    "id": "3216",
    "name": "Kot Fatta",
    "state_id": "32"
  },
  {
    "id": "3217",
    "name": "Kot Isa Khan",
    "state_id": "32"
  },
  {
    "id": "3218",
    "name": "Kot Kapura",
    "state_id": "32"
  },
  {
    "id": "3219",
    "name": "Kotkapura",
    "state_id": "32"
  },
  {
    "id": "3220",
    "name": "Kurali",
    "state_id": "32"
  },
  {
    "id": "3221",
    "name": "Lalru",
    "state_id": "32"
  },
  {
    "id": "3222",
    "name": "Lehra Gaga",
    "state_id": "32"
  },
  {
    "id": "3223",
    "name": "Lodhian Khas",
    "state_id": "32"
  },
  {
    "id": "3224",
    "name": "Longowal",
    "state_id": "32"
  },
  {
    "id": "3225",
    "name": "Ludhiana",
    "state_id": "32"
  },
  {
    "id": "3226",
    "name": "Machhiwara",
    "state_id": "32"
  },
  {
    "id": "3227",
    "name": "Mahilpur",
    "state_id": "32"
  },
  {
    "id": "3228",
    "name": "Majitha",
    "state_id": "32"
  },
  {
    "id": "3229",
    "name": "Makhu",
    "state_id": "32"
  },
  {
    "id": "3230",
    "name": "Malaut",
    "state_id": "32"
  },
  {
    "id": "3231",
    "name": "Malerkotla",
    "state_id": "32"
  },
  {
    "id": "3232",
    "name": "Maloud",
    "state_id": "32"
  },
  {
    "id": "3233",
    "name": "Mandi Gobindgarh",
    "state_id": "32"
  },
  {
    "id": "3234",
    "name": "Mansa",
    "state_id": "32"
  },
  {
    "id": "3235",
    "name": "Maur",
    "state_id": "32"
  },
  {
    "id": "3236",
    "name": "Moga",
    "state_id": "32"
  },
  {
    "id": "3237",
    "name": "Mohali",
    "state_id": "32"
  },
  {
    "id": "3238",
    "name": "Moonak",
    "state_id": "32"
  },
  {
    "id": "3239",
    "name": "Morinda",
    "state_id": "32"
  },
  {
    "id": "3240",
    "name": "Mukerian",
    "state_id": "32"
  },
  {
    "id": "3241",
    "name": "Muktsar",
    "state_id": "32"
  },
  {
    "id": "3242",
    "name": "Mullanpur Dakha",
    "state_id": "32"
  },
  {
    "id": "3243",
    "name": "Mullanpur Garibdas",
    "state_id": "32"
  },
  {
    "id": "3244",
    "name": "Munak",
    "state_id": "32"
  },
  {
    "id": "3245",
    "name": "Muradpura",
    "state_id": "32"
  },
  {
    "id": "3246",
    "name": "Nabha",
    "state_id": "32"
  },
  {
    "id": "3247",
    "name": "Nakodar",
    "state_id": "32"
  },
  {
    "id": "3248",
    "name": "Nangal",
    "state_id": "32"
  },
  {
    "id": "3249",
    "name": "Nawashahr",
    "state_id": "32"
  },
  {
    "id": "3250",
    "name": "Naya Nangal",
    "state_id": "32"
  },
  {
    "id": "3251",
    "name": "Nehon",
    "state_id": "32"
  },
  {
    "id": "3252",
    "name": "Nurmahal",
    "state_id": "32"
  },
  {
    "id": "3253",
    "name": "Pathankot",
    "state_id": "32"
  },
  {
    "id": "3254",
    "name": "Patiala",
    "state_id": "32"
  },
  {
    "id": "3255",
    "name": "Patti",
    "state_id": "32"
  },
  {
    "id": "3256",
    "name": "Pattran",
    "state_id": "32"
  },
  {
    "id": "3257",
    "name": "Payal",
    "state_id": "32"
  },
  {
    "id": "3258",
    "name": "Phagwara",
    "state_id": "32"
  },
  {
    "id": "3259",
    "name": "Phillaur",
    "state_id": "32"
  },
  {
    "id": "3260",
    "name": "Qadian",
    "state_id": "32"
  },
  {
    "id": "3261",
    "name": "Rahon",
    "state_id": "32"
  },
  {
    "id": "3262",
    "name": "Raikot",
    "state_id": "32"
  },
  {
    "id": "3263",
    "name": "Raja Sansi",
    "state_id": "32"
  },
  {
    "id": "3264",
    "name": "Rajpura",
    "state_id": "32"
  },
  {
    "id": "3265",
    "name": "Ram Das",
    "state_id": "32"
  },
  {
    "id": "3266",
    "name": "Raman",
    "state_id": "32"
  },
  {
    "id": "3267",
    "name": "Rampura",
    "state_id": "32"
  },
  {
    "id": "3268",
    "name": "Rayya",
    "state_id": "32"
  },
  {
    "id": "3269",
    "name": "Rupnagar",
    "state_id": "32"
  },
  {
    "id": "3270",
    "name": "Rurki Kasba",
    "state_id": "32"
  },
  {
    "id": "3271",
    "name": "Sahnewal",
    "state_id": "32"
  },
  {
    "id": "3272",
    "name": "Samana",
    "state_id": "32"
  },
  {
    "id": "3273",
    "name": "Samrala",
    "state_id": "32"
  },
  {
    "id": "3274",
    "name": "Sanaur",
    "state_id": "32"
  },
  {
    "id": "3275",
    "name": "Sangat",
    "state_id": "32"
  },
  {
    "id": "3276",
    "name": "Sangrur",
    "state_id": "32"
  },
  {
    "id": "3277",
    "name": "Sansarpur",
    "state_id": "32"
  },
  {
    "id": "3278",
    "name": "Sardulgarh",
    "state_id": "32"
  },
  {
    "id": "3279",
    "name": "Shahkot",
    "state_id": "32"
  },
  {
    "id": "3280",
    "name": "Sham Churasi",
    "state_id": "32"
  },
  {
    "id": "3281",
    "name": "Shekhpura",
    "state_id": "32"
  },
  {
    "id": "3282",
    "name": "Sirhind",
    "state_id": "32"
  },
  {
    "id": "3283",
    "name": "Sri Hargobindpur",
    "state_id": "32"
  },
  {
    "id": "3284",
    "name": "Sujanpur",
    "state_id": "32"
  },
  {
    "id": "3285",
    "name": "Sultanpur Lodhi",
    "state_id": "32"
  },
  {
    "id": "3286",
    "name": "Sunam",
    "state_id": "32"
  },
  {
    "id": "3287",
    "name": "Talwandi Bhai",
    "state_id": "32"
  },
  {
    "id": "3288",
    "name": "Talwara",
    "state_id": "32"
  },
  {
    "id": "3289",
    "name": "Tappa",
    "state_id": "32"
  },
  {
    "id": "3290",
    "name": "Tarn Taran",
    "state_id": "32"
  },
  {
    "id": "3291",
    "name": "Urmar Tanda",
    "state_id": "32"
  },
  {
    "id": "3292",
    "name": "Zira",
    "state_id": "32"
  },
  {
    "id": "3293",
    "name": "Zirakpur",
    "state_id": "32"
  },
  {
    "id": "3294",
    "name": "Abu Road",
    "state_id": "33"
  },
  {
    "id": "3295",
    "name": "Ajmer",
    "state_id": "33"
  },
  {
    "id": "3296",
    "name": "Aklera",
    "state_id": "33"
  },
  {
    "id": "3297",
    "name": "Alwar",
    "state_id": "33"
  },
  {
    "id": "3298",
    "name": "Amet",
    "state_id": "33"
  },
  {
    "id": "3299",
    "name": "Antah",
    "state_id": "33"
  },
  {
    "id": "3300",
    "name": "Anupgarh",
    "state_id": "33"
  },
  {
    "id": "3301",
    "name": "Asind",
    "state_id": "33"
  },
  {
    "id": "3302",
    "name": "Bagar",
    "state_id": "33"
  },
  {
    "id": "3303",
    "name": "Bagru",
    "state_id": "33"
  },
  {
    "id": "3304",
    "name": "Bahror",
    "state_id": "33"
  },
  {
    "id": "3305",
    "name": "Bakani",
    "state_id": "33"
  },
  {
    "id": "3306",
    "name": "Bali",
    "state_id": "33"
  },
  {
    "id": "3307",
    "name": "Balotra",
    "state_id": "33"
  },
  {
    "id": "3308",
    "name": "Bandikui",
    "state_id": "33"
  },
  {
    "id": "3309",
    "name": "Banswara",
    "state_id": "33"
  },
  {
    "id": "3310",
    "name": "Baran",
    "state_id": "33"
  },
  {
    "id": "3311",
    "name": "Bari",
    "state_id": "33"
  },
  {
    "id": "3312",
    "name": "Bari Sadri",
    "state_id": "33"
  },
  {
    "id": "3313",
    "name": "Barmer",
    "state_id": "33"
  },
  {
    "id": "3314",
    "name": "Basi",
    "state_id": "33"
  },
  {
    "id": "3315",
    "name": "Basni Belima",
    "state_id": "33"
  },
  {
    "id": "3316",
    "name": "Baswa",
    "state_id": "33"
  },
  {
    "id": "3317",
    "name": "Bayana",
    "state_id": "33"
  },
  {
    "id": "3318",
    "name": "Beawar",
    "state_id": "33"
  },
  {
    "id": "3319",
    "name": "Begun",
    "state_id": "33"
  },
  {
    "id": "3320",
    "name": "Bhadasar",
    "state_id": "33"
  },
  {
    "id": "3321",
    "name": "Bhadra",
    "state_id": "33"
  },
  {
    "id": "3322",
    "name": "Bhalariya",
    "state_id": "33"
  },
  {
    "id": "3323",
    "name": "Bharatpur",
    "state_id": "33"
  },
  {
    "id": "3324",
    "name": "Bhasawar",
    "state_id": "33"
  },
  {
    "id": "3325",
    "name": "Bhawani Mandi",
    "state_id": "33"
  },
  {
    "id": "3326",
    "name": "Bhawri",
    "state_id": "33"
  },
  {
    "id": "3327",
    "name": "Bhilwara",
    "state_id": "33"
  },
  {
    "id": "3328",
    "name": "Bhindar",
    "state_id": "33"
  },
  {
    "id": "3329",
    "name": "Bhinmal",
    "state_id": "33"
  },
  {
    "id": "3330",
    "name": "Bhiwadi",
    "state_id": "33"
  },
  {
    "id": "3331",
    "name": "Bijoliya Kalan",
    "state_id": "33"
  },
  {
    "id": "3332",
    "name": "Bikaner",
    "state_id": "33"
  },
  {
    "id": "3333",
    "name": "Bilara",
    "state_id": "33"
  },
  {
    "id": "3334",
    "name": "Bissau",
    "state_id": "33"
  },
  {
    "id": "3335",
    "name": "Borkhera",
    "state_id": "33"
  },
  {
    "id": "3336",
    "name": "Budhpura",
    "state_id": "33"
  },
  {
    "id": "3337",
    "name": "Bundi",
    "state_id": "33"
  },
  {
    "id": "3338",
    "name": "Chatsu",
    "state_id": "33"
  },
  {
    "id": "3339",
    "name": "Chechat",
    "state_id": "33"
  },
  {
    "id": "3340",
    "name": "Chhabra",
    "state_id": "33"
  },
  {
    "id": "3341",
    "name": "Chhapar",
    "state_id": "33"
  },
  {
    "id": "3342",
    "name": "Chhipa Barod",
    "state_id": "33"
  },
  {
    "id": "3343",
    "name": "Chhoti Sadri",
    "state_id": "33"
  },
  {
    "id": "3344",
    "name": "Chirawa",
    "state_id": "33"
  },
  {
    "id": "3345",
    "name": "Chittaurgarh",
    "state_id": "33"
  },
  {
    "id": "3346",
    "name": "Chittorgarh",
    "state_id": "33"
  },
  {
    "id": "3347",
    "name": "Chomun",
    "state_id": "33"
  },
  {
    "id": "3348",
    "name": "Churu",
    "state_id": "33"
  },
  {
    "id": "3349",
    "name": "Daosa",
    "state_id": "33"
  },
  {
    "id": "3350",
    "name": "Dariba",
    "state_id": "33"
  },
  {
    "id": "3351",
    "name": "Dausa",
    "state_id": "33"
  },
  {
    "id": "3352",
    "name": "Deoli",
    "state_id": "33"
  },
  {
    "id": "3353",
    "name": "Deshnok",
    "state_id": "33"
  },
  {
    "id": "3354",
    "name": "Devgarh",
    "state_id": "33"
  },
  {
    "id": "3355",
    "name": "Devli",
    "state_id": "33"
  },
  {
    "id": "3356",
    "name": "Dhariawad",
    "state_id": "33"
  },
  {
    "id": "3357",
    "name": "Dhaulpur",
    "state_id": "33"
  },
  {
    "id": "3358",
    "name": "Dholpur",
    "state_id": "33"
  },
  {
    "id": "3359",
    "name": "Didwana",
    "state_id": "33"
  },
  {
    "id": "3360",
    "name": "Dig",
    "state_id": "33"
  },
  {
    "id": "3361",
    "name": "Dungargarh",
    "state_id": "33"
  },
  {
    "id": "3362",
    "name": "Dungarpur",
    "state_id": "33"
  },
  {
    "id": "3363",
    "name": "Falna",
    "state_id": "33"
  },
  {
    "id": "3364",
    "name": "Fatehnagar",
    "state_id": "33"
  },
  {
    "id": "3365",
    "name": "Fatehpur",
    "state_id": "33"
  },
  {
    "id": "3366",
    "name": "Gajsinghpur",
    "state_id": "33"
  },
  {
    "id": "3367",
    "name": "Galiakot",
    "state_id": "33"
  },
  {
    "id": "3368",
    "name": "Ganganagar",
    "state_id": "33"
  },
  {
    "id": "3369",
    "name": "Gangapur",
    "state_id": "33"
  },
  {
    "id": "3370",
    "name": "Goredi Chancha",
    "state_id": "33"
  },
  {
    "id": "3371",
    "name": "Gothra",
    "state_id": "33"
  },
  {
    "id": "3372",
    "name": "Govindgarh",
    "state_id": "33"
  },
  {
    "id": "3373",
    "name": "Gulabpura",
    "state_id": "33"
  },
  {
    "id": "3374",
    "name": "Hanumangarh",
    "state_id": "33"
  },
  {
    "id": "3375",
    "name": "Hindaun",
    "state_id": "33"
  },
  {
    "id": "3376",
    "name": "Indragarh",
    "state_id": "33"
  },
  {
    "id": "3377",
    "name": "Jahazpur",
    "state_id": "33"
  },
  {
    "id": "3378",
    "name": "Jaipur",
    "state_id": "33"
  },
  {
    "id": "3379",
    "name": "Jaisalmer",
    "state_id": "33"
  },
  {
    "id": "3380",
    "name": "Jaiselmer",
    "state_id": "33"
  },
  {
    "id": "3381",
    "name": "Jaitaran",
    "state_id": "33"
  },
  {
    "id": "3382",
    "name": "Jalore",
    "state_id": "33"
  },
  {
    "id": "3383",
    "name": "Jhalawar",
    "state_id": "33"
  },
  {
    "id": "3384",
    "name": "Jhalrapatan",
    "state_id": "33"
  },
  {
    "id": "3385",
    "name": "Jhunjhunun",
    "state_id": "33"
  },
  {
    "id": "3386",
    "name": "Jobner",
    "state_id": "33"
  },
  {
    "id": "3387",
    "name": "Jodhpur",
    "state_id": "33"
  },
  {
    "id": "3388",
    "name": "Kaithun",
    "state_id": "33"
  },
  {
    "id": "3389",
    "name": "Kaman",
    "state_id": "33"
  },
  {
    "id": "3390",
    "name": "Kankroli",
    "state_id": "33"
  },
  {
    "id": "3391",
    "name": "Kanor",
    "state_id": "33"
  },
  {
    "id": "3392",
    "name": "Kapasan",
    "state_id": "33"
  },
  {
    "id": "3393",
    "name": "Kaprain",
    "state_id": "33"
  },
  {
    "id": "3394",
    "name": "Karanpura",
    "state_id": "33"
  },
  {
    "id": "3395",
    "name": "Karauli",
    "state_id": "33"
  },
  {
    "id": "3396",
    "name": "Kekri",
    "state_id": "33"
  },
  {
    "id": "3397",
    "name": "Keshorai Patan",
    "state_id": "33"
  },
  {
    "id": "3398",
    "name": "Kesrisinghpur",
    "state_id": "33"
  },
  {
    "id": "3399",
    "name": "Khairthal",
    "state_id": "33"
  },
  {
    "id": "3400",
    "name": "Khandela",
    "state_id": "33"
  },
  {
    "id": "3401",
    "name": "Khanpur",
    "state_id": "33"
  },
  {
    "id": "3402",
    "name": "Kherli",
    "state_id": "33"
  },
  {
    "id": "3403",
    "name": "Kherliganj",
    "state_id": "33"
  },
  {
    "id": "3404",
    "name": "Kherwara Chhaoni",
    "state_id": "33"
  },
  {
    "id": "3405",
    "name": "Khetri",
    "state_id": "33"
  },
  {
    "id": "3406",
    "name": "Kiranipura",
    "state_id": "33"
  },
  {
    "id": "3407",
    "name": "Kishangarh",
    "state_id": "33"
  },
  {
    "id": "3408",
    "name": "Kishangarh Ranwal",
    "state_id": "33"
  },
  {
    "id": "3409",
    "name": "Kolvi Rajendrapura",
    "state_id": "33"
  },
  {
    "id": "3410",
    "name": "Kot Putli",
    "state_id": "33"
  },
  {
    "id": "3411",
    "name": "Kota",
    "state_id": "33"
  },
  {
    "id": "3412",
    "name": "Kuchaman",
    "state_id": "33"
  },
  {
    "id": "3413",
    "name": "Kuchera",
    "state_id": "33"
  },
  {
    "id": "3414",
    "name": "Kumbhalgarh",
    "state_id": "33"
  },
  {
    "id": "3415",
    "name": "Kumbhkot",
    "state_id": "33"
  },
  {
    "id": "3416",
    "name": "Kumher",
    "state_id": "33"
  },
  {
    "id": "3417",
    "name": "Kushalgarh",
    "state_id": "33"
  },
  {
    "id": "3418",
    "name": "Lachhmangarh",
    "state_id": "33"
  },
  {
    "id": "3419",
    "name": "Ladnun",
    "state_id": "33"
  },
  {
    "id": "3420",
    "name": "Lakheri",
    "state_id": "33"
  },
  {
    "id": "3421",
    "name": "Lalsot",
    "state_id": "33"
  },
  {
    "id": "3422",
    "name": "Losal",
    "state_id": "33"
  },
  {
    "id": "3423",
    "name": "Madanganj",
    "state_id": "33"
  },
  {
    "id": "3424",
    "name": "Mahu Kalan",
    "state_id": "33"
  },
  {
    "id": "3425",
    "name": "Mahwa",
    "state_id": "33"
  },
  {
    "id": "3426",
    "name": "Makrana",
    "state_id": "33"
  },
  {
    "id": "3427",
    "name": "Malpura",
    "state_id": "33"
  },
  {
    "id": "3428",
    "name": "Mandal",
    "state_id": "33"
  },
  {
    "id": "3429",
    "name": "Mandalgarh",
    "state_id": "33"
  },
  {
    "id": "3430",
    "name": "Mandawar",
    "state_id": "33"
  },
  {
    "id": "3431",
    "name": "Mandwa",
    "state_id": "33"
  },
  {
    "id": "3432",
    "name": "Mangrol",
    "state_id": "33"
  },
  {
    "id": "3433",
    "name": "Manohar Thana",
    "state_id": "33"
  },
  {
    "id": "3434",
    "name": "Manoharpur",
    "state_id": "33"
  },
  {
    "id": "3435",
    "name": "Marwar",
    "state_id": "33"
  },
  {
    "id": "3436",
    "name": "Merta",
    "state_id": "33"
  },
  {
    "id": "3437",
    "name": "Modak",
    "state_id": "33"
  },
  {
    "id": "3438",
    "name": "Mount Abu",
    "state_id": "33"
  },
  {
    "id": "3439",
    "name": "Mukandgarh",
    "state_id": "33"
  },
  {
    "id": "3440",
    "name": "Mundwa",
    "state_id": "33"
  },
  {
    "id": "3441",
    "name": "Nadbai",
    "state_id": "33"
  },
  {
    "id": "3442",
    "name": "Naenwa",
    "state_id": "33"
  },
  {
    "id": "3443",
    "name": "Nagar",
    "state_id": "33"
  },
  {
    "id": "3444",
    "name": "Nagaur",
    "state_id": "33"
  },
  {
    "id": "3445",
    "name": "Napasar",
    "state_id": "33"
  },
  {
    "id": "3446",
    "name": "Naraina",
    "state_id": "33"
  },
  {
    "id": "3447",
    "name": "Nasirabad",
    "state_id": "33"
  },
  {
    "id": "3448",
    "name": "Nathdwara",
    "state_id": "33"
  },
  {
    "id": "3449",
    "name": "Nawa",
    "state_id": "33"
  },
  {
    "id": "3450",
    "name": "Nawalgarh",
    "state_id": "33"
  },
  {
    "id": "3451",
    "name": "Neem Ka Thana",
    "state_id": "33"
  },
  {
    "id": "3452",
    "name": "Neemrana",
    "state_id": "33"
  },
  {
    "id": "3453",
    "name": "Newa Talai",
    "state_id": "33"
  },
  {
    "id": "3454",
    "name": "Nimaj",
    "state_id": "33"
  },
  {
    "id": "3455",
    "name": "Nimbahera",
    "state_id": "33"
  },
  {
    "id": "3456",
    "name": "Niwai",
    "state_id": "33"
  },
  {
    "id": "3457",
    "name": "Nohar",
    "state_id": "33"
  },
  {
    "id": "3458",
    "name": "Nokha",
    "state_id": "33"
  },
  {
    "id": "3459",
    "name": "One SGM",
    "state_id": "33"
  },
  {
    "id": "3460",
    "name": "Padampur",
    "state_id": "33"
  },
  {
    "id": "3461",
    "name": "Pali",
    "state_id": "33"
  },
  {
    "id": "3462",
    "name": "Partapur",
    "state_id": "33"
  },
  {
    "id": "3463",
    "name": "Parvatsar",
    "state_id": "33"
  },
  {
    "id": "3464",
    "name": "Pasoond",
    "state_id": "33"
  },
  {
    "id": "3465",
    "name": "Phalna",
    "state_id": "33"
  },
  {
    "id": "3466",
    "name": "Phalodi",
    "state_id": "33"
  },
  {
    "id": "3467",
    "name": "Phulera",
    "state_id": "33"
  },
  {
    "id": "3468",
    "name": "Pilani",
    "state_id": "33"
  },
  {
    "id": "3469",
    "name": "Pilibanga",
    "state_id": "33"
  },
  {
    "id": "3470",
    "name": "Pindwara",
    "state_id": "33"
  },
  {
    "id": "3471",
    "name": "Pipalia Kalan",
    "state_id": "33"
  },
  {
    "id": "3472",
    "name": "Pipar",
    "state_id": "33"
  },
  {
    "id": "3473",
    "name": "Pirawa",
    "state_id": "33"
  },
  {
    "id": "3474",
    "name": "Pokaran",
    "state_id": "33"
  },
  {
    "id": "3475",
    "name": "Pratapgarh",
    "state_id": "33"
  },
  {
    "id": "3476",
    "name": "Pushkar",
    "state_id": "33"
  },
  {
    "id": "3477",
    "name": "Raipur",
    "state_id": "33"
  },
  {
    "id": "3478",
    "name": "Raisinghnagar",
    "state_id": "33"
  },
  {
    "id": "3479",
    "name": "Rajakhera",
    "state_id": "33"
  },
  {
    "id": "3480",
    "name": "Rajaldesar",
    "state_id": "33"
  },
  {
    "id": "3481",
    "name": "Rajgarh",
    "state_id": "33"
  },
  {
    "id": "3482",
    "name": "Rajsamand",
    "state_id": "33"
  },
  {
    "id": "3483",
    "name": "Ramganj Mandi",
    "state_id": "33"
  },
  {
    "id": "3484",
    "name": "Ramgarh",
    "state_id": "33"
  },
  {
    "id": "3485",
    "name": "Rani",
    "state_id": "33"
  },
  {
    "id": "3486",
    "name": "Raniwara",
    "state_id": "33"
  },
  {
    "id": "3487",
    "name": "Ratan Nagar",
    "state_id": "33"
  },
  {
    "id": "3488",
    "name": "Ratangarh",
    "state_id": "33"
  },
  {
    "id": "3489",
    "name": "Rawatbhata",
    "state_id": "33"
  },
  {
    "id": "3490",
    "name": "Rawatsar",
    "state_id": "33"
  },
  {
    "id": "3491",
    "name": "Rikhabdev",
    "state_id": "33"
  },
  {
    "id": "3492",
    "name": "Ringas",
    "state_id": "33"
  },
  {
    "id": "3493",
    "name": "Sadri",
    "state_id": "33"
  },
  {
    "id": "3494",
    "name": "Sadulshahar",
    "state_id": "33"
  },
  {
    "id": "3495",
    "name": "Sagwara",
    "state_id": "33"
  },
  {
    "id": "3496",
    "name": "Salumbar",
    "state_id": "33"
  },
  {
    "id": "3497",
    "name": "Sambhar",
    "state_id": "33"
  },
  {
    "id": "3498",
    "name": "Samdari",
    "state_id": "33"
  },
  {
    "id": "3499",
    "name": "Sanchor",
    "state_id": "33"
  },
  {
    "id": "3500",
    "name": "Sangariya",
    "state_id": "33"
  },
  {
    "id": "3501",
    "name": "Sangod",
    "state_id": "33"
  },
  {
    "id": "3502",
    "name": "Sardarshahr",
    "state_id": "33"
  },
  {
    "id": "3503",
    "name": "Sarwar",
    "state_id": "33"
  },
  {
    "id": "3504",
    "name": "Satal Kheri",
    "state_id": "33"
  },
  {
    "id": "3505",
    "name": "Sawai Madhopur",
    "state_id": "33"
  },
  {
    "id": "3506",
    "name": "Sewan Kalan",
    "state_id": "33"
  },
  {
    "id": "3507",
    "name": "Shahpura",
    "state_id": "33"
  },
  {
    "id": "3508",
    "name": "Sheoganj",
    "state_id": "33"
  },
  {
    "id": "3509",
    "name": "Sikar",
    "state_id": "33"
  },
  {
    "id": "3510",
    "name": "Sirohi",
    "state_id": "33"
  },
  {
    "id": "3511",
    "name": "Siwana",
    "state_id": "33"
  },
  {
    "id": "3512",
    "name": "Sogariya",
    "state_id": "33"
  },
  {
    "id": "3513",
    "name": "Sojat",
    "state_id": "33"
  },
  {
    "id": "3514",
    "name": "Sojat Road",
    "state_id": "33"
  },
  {
    "id": "3515",
    "name": "Sri Madhopur",
    "state_id": "33"
  },
  {
    "id": "3516",
    "name": "Sriganganagar",
    "state_id": "33"
  },
  {
    "id": "3517",
    "name": "Sujangarh",
    "state_id": "33"
  },
  {
    "id": "3518",
    "name": "Suket",
    "state_id": "33"
  },
  {
    "id": "3519",
    "name": "Sumerpur",
    "state_id": "33"
  },
  {
    "id": "3520",
    "name": "Sunel",
    "state_id": "33"
  },
  {
    "id": "3521",
    "name": "Surajgarh",
    "state_id": "33"
  },
  {
    "id": "3522",
    "name": "Suratgarh",
    "state_id": "33"
  },
  {
    "id": "3523",
    "name": "Swaroopganj",
    "state_id": "33"
  },
  {
    "id": "3524",
    "name": "Takhatgarh",
    "state_id": "33"
  },
  {
    "id": "3525",
    "name": "Taranagar",
    "state_id": "33"
  },
  {
    "id": "3526",
    "name": "Three STR",
    "state_id": "33"
  },
  {
    "id": "3527",
    "name": "Tijara",
    "state_id": "33"
  },
  {
    "id": "3528",
    "name": "Toda Bhim",
    "state_id": "33"
  },
  {
    "id": "3529",
    "name": "Toda Raisingh",
    "state_id": "33"
  },
  {
    "id": "3530",
    "name": "Todra",
    "state_id": "33"
  },
  {
    "id": "3531",
    "name": "Tonk",
    "state_id": "33"
  },
  {
    "id": "3532",
    "name": "Udaipur",
    "state_id": "33"
  },
  {
    "id": "3533",
    "name": "Udpura",
    "state_id": "33"
  },
  {
    "id": "3534",
    "name": "Uniara",
    "state_id": "33"
  },
  {
    "id": "3535",
    "name": "Vanasthali",
    "state_id": "33"
  },
  {
    "id": "3536",
    "name": "Vidyavihar",
    "state_id": "33"
  },
  {
    "id": "3537",
    "name": "Vijainagar",
    "state_id": "33"
  },
  {
    "id": "3538",
    "name": "Viratnagar",
    "state_id": "33"
  },
  {
    "id": "3539",
    "name": "Wer",
    "state_id": "33"
  },
  {
    "id": "3540",
    "name": "Gangtok",
    "state_id": "34"
  },
  {
    "id": "3541",
    "name": "Gezing",
    "state_id": "34"
  },
  {
    "id": "3542",
    "name": "Jorethang",
    "state_id": "34"
  },
  {
    "id": "3543",
    "name": "Mangan",
    "state_id": "34"
  },
  {
    "id": "3544",
    "name": "Namchi",
    "state_id": "34"
  },
  {
    "id": "3545",
    "name": "Naya Bazar",
    "state_id": "34"
  },
  {
    "id": "3546",
    "name": "No City",
    "state_id": "34"
  },
  {
    "id": "3547",
    "name": "Rangpo",
    "state_id": "34"
  },
  {
    "id": "3548",
    "name": "Sikkim",
    "state_id": "34"
  },
  {
    "id": "3549",
    "name": "Singtam",
    "state_id": "34"
  },
  {
    "id": "3550",
    "name": "Upper Tadong",
    "state_id": "34"
  },
  {
    "id": "3551",
    "name": "Abiramam",
    "state_id": "35"
  },
  {
    "id": "3552",
    "name": "Achampudur",
    "state_id": "35"
  },
  {
    "id": "3553",
    "name": "Acharapakkam",
    "state_id": "35"
  },
  {
    "id": "3554",
    "name": "Acharipallam",
    "state_id": "35"
  },
  {
    "id": "3555",
    "name": "Achipatti",
    "state_id": "35"
  },
  {
    "id": "3556",
    "name": "Adikaratti",
    "state_id": "35"
  },
  {
    "id": "3557",
    "name": "Adiramapattinam",
    "state_id": "35"
  },
  {
    "id": "3558",
    "name": "Aduturai",
    "state_id": "35"
  },
  {
    "id": "3559",
    "name": "Adyar",
    "state_id": "35"
  },
  {
    "id": "3560",
    "name": "Agaram",
    "state_id": "35"
  },
  {
    "id": "3561",
    "name": "Agasthiswaram",
    "state_id": "35"
  },
  {
    "id": "3562",
    "name": "Akkaraipettai",
    "state_id": "35"
  },
  {
    "id": "3563",
    "name": "Alagappapuram",
    "state_id": "35"
  },
  {
    "id": "3564",
    "name": "Alagapuri",
    "state_id": "35"
  },
  {
    "id": "3565",
    "name": "Alampalayam",
    "state_id": "35"
  },
  {
    "id": "3566",
    "name": "Alandur",
    "state_id": "35"
  },
  {
    "id": "3567",
    "name": "Alanganallur",
    "state_id": "35"
  },
  {
    "id": "3568",
    "name": "Alangayam",
    "state_id": "35"
  },
  {
    "id": "3569",
    "name": "Alangudi",
    "state_id": "35"
  },
  {
    "id": "3570",
    "name": "Alangulam",
    "state_id": "35"
  },
  {
    "id": "3571",
    "name": "Alanthurai",
    "state_id": "35"
  },
  {
    "id": "3572",
    "name": "Alapakkam",
    "state_id": "35"
  },
  {
    "id": "3573",
    "name": "Allapuram",
    "state_id": "35"
  },
  {
    "id": "3574",
    "name": "Alur",
    "state_id": "35"
  },
  {
    "id": "3575",
    "name": "Alwar Tirunagari",
    "state_id": "35"
  },
  {
    "id": "3576",
    "name": "Alwarkurichi",
    "state_id": "35"
  },
  {
    "id": "3577",
    "name": "Ambasamudram",
    "state_id": "35"
  },
  {
    "id": "3578",
    "name": "Ambur",
    "state_id": "35"
  },
  {
    "id": "3579",
    "name": "Ammainaickanur",
    "state_id": "35"
  },
  {
    "id": "3580",
    "name": "Ammaparikuppam",
    "state_id": "35"
  },
  {
    "id": "3581",
    "name": "Ammapettai",
    "state_id": "35"
  },
  {
    "id": "3582",
    "name": "Ammavarikuppam",
    "state_id": "35"
  },
  {
    "id": "3583",
    "name": "Ammur",
    "state_id": "35"
  },
  {
    "id": "3584",
    "name": "Anaimalai",
    "state_id": "35"
  },
  {
    "id": "3585",
    "name": "Anaiyur",
    "state_id": "35"
  },
  {
    "id": "3586",
    "name": "Anakaputhur",
    "state_id": "35"
  },
  {
    "id": "3587",
    "name": "Ananthapuram",
    "state_id": "35"
  },
  {
    "id": "3588",
    "name": "Andanappettai",
    "state_id": "35"
  },
  {
    "id": "3589",
    "name": "Andipalayam",
    "state_id": "35"
  },
  {
    "id": "3590",
    "name": "Andippatti",
    "state_id": "35"
  },
  {
    "id": "3591",
    "name": "Anjugramam",
    "state_id": "35"
  },
  {
    "id": "3592",
    "name": "Annamalainagar",
    "state_id": "35"
  },
  {
    "id": "3593",
    "name": "Annavasal",
    "state_id": "35"
  },
  {
    "id": "3594",
    "name": "Annur",
    "state_id": "35"
  },
  {
    "id": "3595",
    "name": "Anthiyur",
    "state_id": "35"
  },
  {
    "id": "3596",
    "name": "Appakudal",
    "state_id": "35"
  },
  {
    "id": "3597",
    "name": "Arachalur",
    "state_id": "35"
  },
  {
    "id": "3598",
    "name": "Arakandanallur",
    "state_id": "35"
  },
  {
    "id": "3599",
    "name": "Arakonam",
    "state_id": "35"
  },
  {
    "id": "3600",
    "name": "Aralvaimozhi",
    "state_id": "35"
  },
  {
    "id": "3601",
    "name": "Arani",
    "state_id": "35"
  },
  {
    "id": "3602",
    "name": "Arani Road",
    "state_id": "35"
  },
  {
    "id": "3603",
    "name": "Arantangi",
    "state_id": "35"
  },
  {
    "id": "3604",
    "name": "Arasiramani",
    "state_id": "35"
  },
  {
    "id": "3605",
    "name": "Aravakurichi",
    "state_id": "35"
  },
  {
    "id": "3606",
    "name": "Aravankadu",
    "state_id": "35"
  },
  {
    "id": "3607",
    "name": "Arcot",
    "state_id": "35"
  },
  {
    "id": "3608",
    "name": "Arimalam",
    "state_id": "35"
  },
  {
    "id": "3609",
    "name": "Ariyalur",
    "state_id": "35"
  },
  {
    "id": "3610",
    "name": "Ariyappampalayam",
    "state_id": "35"
  },
  {
    "id": "3611",
    "name": "Ariyur",
    "state_id": "35"
  },
  {
    "id": "3612",
    "name": "Arni",
    "state_id": "35"
  },
  {
    "id": "3613",
    "name": "Arulmigu Thirumuruganpundi",
    "state_id": "35"
  },
  {
    "id": "3614",
    "name": "Arumanai",
    "state_id": "35"
  },
  {
    "id": "3615",
    "name": "Arumbavur",
    "state_id": "35"
  },
  {
    "id": "3616",
    "name": "Arumuganeri",
    "state_id": "35"
  },
  {
    "id": "3617",
    "name": "Aruppukkottai",
    "state_id": "35"
  },
  {
    "id": "3618",
    "name": "Ashokapuram",
    "state_id": "35"
  },
  {
    "id": "3619",
    "name": "Athani",
    "state_id": "35"
  },
  {
    "id": "3620",
    "name": "Athanur",
    "state_id": "35"
  },
  {
    "id": "3621",
    "name": "Athimarapatti",
    "state_id": "35"
  },
  {
    "id": "3622",
    "name": "Athipattu",
    "state_id": "35"
  },
  {
    "id": "3623",
    "name": "Athur",
    "state_id": "35"
  },
  {
    "id": "3624",
    "name": "Attayyampatti",
    "state_id": "35"
  },
  {
    "id": "3625",
    "name": "Attur",
    "state_id": "35"
  },
  {
    "id": "3626",
    "name": "Auroville",
    "state_id": "35"
  },
  {
    "id": "3627",
    "name": "Avadattur",
    "state_id": "35"
  },
  {
    "id": "3628",
    "name": "Avadi",
    "state_id": "35"
  },
  {
    "id": "3629",
    "name": "Avalpundurai",
    "state_id": "35"
  },
  {
    "id": "3630",
    "name": "Avaniapuram",
    "state_id": "35"
  },
  {
    "id": "3631",
    "name": "Avinashi",
    "state_id": "35"
  },
  {
    "id": "3632",
    "name": "Ayakudi",
    "state_id": "35"
  },
  {
    "id": "3633",
    "name": "Ayanadaippu",
    "state_id": "35"
  },
  {
    "id": "3634",
    "name": "Aygudi",
    "state_id": "35"
  },
  {
    "id": "3635",
    "name": "Ayothiapattinam",
    "state_id": "35"
  },
  {
    "id": "3636",
    "name": "Ayyalur",
    "state_id": "35"
  },
  {
    "id": "3637",
    "name": "Ayyampalayam",
    "state_id": "35"
  },
  {
    "id": "3638",
    "name": "Ayyampettai",
    "state_id": "35"
  },
  {
    "id": "3639",
    "name": "Azhagiapandiapuram",
    "state_id": "35"
  },
  {
    "id": "3640",
    "name": "Balakrishnampatti",
    "state_id": "35"
  },
  {
    "id": "3641",
    "name": "Balakrishnapuram",
    "state_id": "35"
  },
  {
    "id": "3642",
    "name": "Balapallam",
    "state_id": "35"
  },
  {
    "id": "3643",
    "name": "Balasamudram",
    "state_id": "35"
  },
  {
    "id": "3644",
    "name": "Bargur",
    "state_id": "35"
  },
  {
    "id": "3645",
    "name": "Belur",
    "state_id": "35"
  },
  {
    "id": "3646",
    "name": "Berhatty",
    "state_id": "35"
  },
  {
    "id": "3647",
    "name": "Bhavani",
    "state_id": "35"
  },
  {
    "id": "3648",
    "name": "Bhawanisagar",
    "state_id": "35"
  },
  {
    "id": "3649",
    "name": "Bhuvanagiri",
    "state_id": "35"
  },
  {
    "id": "3650",
    "name": "Bikketti",
    "state_id": "35"
  },
  {
    "id": "3651",
    "name": "Bodinayakkanur",
    "state_id": "35"
  },
  {
    "id": "3652",
    "name": "Brahmana Periya Agraharam",
    "state_id": "35"
  },
  {
    "id": "3653",
    "name": "Buthapandi",
    "state_id": "35"
  },
  {
    "id": "3654",
    "name": "Buthipuram",
    "state_id": "35"
  },
  {
    "id": "3655",
    "name": "Chatrapatti",
    "state_id": "35"
  },
  {
    "id": "3656",
    "name": "Chembarambakkam",
    "state_id": "35"
  },
  {
    "id": "3657",
    "name": "Chengalpattu",
    "state_id": "35"
  },
  {
    "id": "3658",
    "name": "Chengam",
    "state_id": "35"
  },
  {
    "id": "3659",
    "name": "Chennai",
    "state_id": "35"
  },
  {
    "id": "3660",
    "name": "Chennasamudram",
    "state_id": "35"
  },
  {
    "id": "3661",
    "name": "Chennimalai",
    "state_id": "35"
  },
  {
    "id": "3662",
    "name": "Cheranmadevi",
    "state_id": "35"
  },
  {
    "id": "3663",
    "name": "Cheruvanki",
    "state_id": "35"
  },
  {
    "id": "3664",
    "name": "Chetpet",
    "state_id": "35"
  },
  {
    "id": "3665",
    "name": "Chettiarpatti",
    "state_id": "35"
  },
  {
    "id": "3666",
    "name": "Chettipalaiyam",
    "state_id": "35"
  },
  {
    "id": "3667",
    "name": "Chettipalayam Cantonment",
    "state_id": "35"
  },
  {
    "id": "3668",
    "name": "Chettithangal",
    "state_id": "35"
  },
  {
    "id": "3669",
    "name": "Cheyur",
    "state_id": "35"
  },
  {
    "id": "3670",
    "name": "Cheyyar",
    "state_id": "35"
  },
  {
    "id": "3671",
    "name": "Chidambaram",
    "state_id": "35"
  },
  {
    "id": "3672",
    "name": "Chinalapatti",
    "state_id": "35"
  },
  {
    "id": "3673",
    "name": "Chinna Anuppanadi",
    "state_id": "35"
  },
  {
    "id": "3674",
    "name": "Chinna Salem",
    "state_id": "35"
  },
  {
    "id": "3675",
    "name": "Chinnakkampalayam",
    "state_id": "35"
  },
  {
    "id": "3676",
    "name": "Chinnammanur",
    "state_id": "35"
  },
  {
    "id": "3677",
    "name": "Chinnampalaiyam",
    "state_id": "35"
  },
  {
    "id": "3678",
    "name": "Chinnasekkadu",
    "state_id": "35"
  },
  {
    "id": "3679",
    "name": "Chinnavedampatti",
    "state_id": "35"
  },
  {
    "id": "3680",
    "name": "Chitlapakkam",
    "state_id": "35"
  },
  {
    "id": "3681",
    "name": "Chittodu",
    "state_id": "35"
  },
  {
    "id": "3682",
    "name": "Cholapuram",
    "state_id": "35"
  },
  {
    "id": "3683",
    "name": "Coimbatore",
    "state_id": "35"
  },
  {
    "id": "3684",
    "name": "Coonoor",
    "state_id": "35"
  },
  {
    "id": "3685",
    "name": "Courtalam",
    "state_id": "35"
  },
  {
    "id": "3686",
    "name": "Cuddalore",
    "state_id": "35"
  },
  {
    "id": "3687",
    "name": "Dalavaipatti",
    "state_id": "35"
  },
  {
    "id": "3688",
    "name": "Darasuram",
    "state_id": "35"
  },
  {
    "id": "3689",
    "name": "Denkanikottai",
    "state_id": "35"
  },
  {
    "id": "3690",
    "name": "Desur",
    "state_id": "35"
  },
  {
    "id": "3691",
    "name": "Devadanapatti",
    "state_id": "35"
  },
  {
    "id": "3692",
    "name": "Devakkottai",
    "state_id": "35"
  },
  {
    "id": "3693",
    "name": "Devakottai",
    "state_id": "35"
  },
  {
    "id": "3694",
    "name": "Devanangurichi",
    "state_id": "35"
  },
  {
    "id": "3695",
    "name": "Devarshola",
    "state_id": "35"
  },
  {
    "id": "3696",
    "name": "Devasthanam",
    "state_id": "35"
  },
  {
    "id": "3697",
    "name": "Dhalavoipuram",
    "state_id": "35"
  },
  {
    "id": "3698",
    "name": "Dhali",
    "state_id": "35"
  },
  {
    "id": "3699",
    "name": "Dhaliyur",
    "state_id": "35"
  },
  {
    "id": "3700",
    "name": "Dharapadavedu",
    "state_id": "35"
  },
  {
    "id": "3701",
    "name": "Dharapuram",
    "state_id": "35"
  },
  {
    "id": "3702",
    "name": "Dharmapuri",
    "state_id": "35"
  },
  {
    "id": "3703",
    "name": "Dindigul",
    "state_id": "35"
  },
  {
    "id": "3704",
    "name": "Dusi",
    "state_id": "35"
  },
  {
    "id": "3705",
    "name": "Edaganasalai",
    "state_id": "35"
  },
  {
    "id": "3706",
    "name": "Edaikodu",
    "state_id": "35"
  },
  {
    "id": "3707",
    "name": "Edakalinadu",
    "state_id": "35"
  },
  {
    "id": "3708",
    "name": "Elathur",
    "state_id": "35"
  },
  {
    "id": "3709",
    "name": "Elayirampannai",
    "state_id": "35"
  },
  {
    "id": "3710",
    "name": "Elumalai",
    "state_id": "35"
  },
  {
    "id": "3711",
    "name": "Eral",
    "state_id": "35"
  },
  {
    "id": "3712",
    "name": "Eraniel",
    "state_id": "35"
  },
  {
    "id": "3713",
    "name": "Eriodu",
    "state_id": "35"
  },
  {
    "id": "3714",
    "name": "Erode",
    "state_id": "35"
  },
  {
    "id": "3715",
    "name": "Erumaipatti",
    "state_id": "35"
  },
  {
    "id": "3716",
    "name": "Eruvadi",
    "state_id": "35"
  },
  {
    "id": "3717",
    "name": "Ethapur",
    "state_id": "35"
  },
  {
    "id": "3718",
    "name": "Ettaiyapuram",
    "state_id": "35"
  },
  {
    "id": "3719",
    "name": "Ettimadai",
    "state_id": "35"
  },
  {
    "id": "3720",
    "name": "Ezhudesam",
    "state_id": "35"
  },
  {
    "id": "3721",
    "name": "Ganapathipuram",
    "state_id": "35"
  },
  {
    "id": "3722",
    "name": "Gandhi Nagar",
    "state_id": "35"
  },
  {
    "id": "3723",
    "name": "Gangaikondan",
    "state_id": "35"
  },
  {
    "id": "3724",
    "name": "Gangavalli",
    "state_id": "35"
  },
  {
    "id": "3725",
    "name": "Ganguvarpatti",
    "state_id": "35"
  },
  {
    "id": "3726",
    "name": "Gingi",
    "state_id": "35"
  },
  {
    "id": "3727",
    "name": "Gopalasamudram",
    "state_id": "35"
  },
  {
    "id": "3728",
    "name": "Gopichettipalaiyam",
    "state_id": "35"
  },
  {
    "id": "3729",
    "name": "Gudalur",
    "state_id": "35"
  },
  {
    "id": "3730",
    "name": "Gudiyattam",
    "state_id": "35"
  },
  {
    "id": "3731",
    "name": "Guduvanchery",
    "state_id": "35"
  },
  {
    "id": "3732",
    "name": "Gummidipoondi",
    "state_id": "35"
  },
  {
    "id": "3733",
    "name": "Hanumanthampatti",
    "state_id": "35"
  },
  {
    "id": "3734",
    "name": "Harur",
    "state_id": "35"
  },
  {
    "id": "3735",
    "name": "Harveypatti",
    "state_id": "35"
  },
  {
    "id": "3736",
    "name": "Highways",
    "state_id": "35"
  },
  {
    "id": "3737",
    "name": "Hosur",
    "state_id": "35"
  },
  {
    "id": "3738",
    "name": "Hubbathala",
    "state_id": "35"
  },
  {
    "id": "3739",
    "name": "Huligal",
    "state_id": "35"
  },
  {
    "id": "3740",
    "name": "Idappadi",
    "state_id": "35"
  },
  {
    "id": "3741",
    "name": "Idikarai",
    "state_id": "35"
  },
  {
    "id": "3742",
    "name": "Ilampillai",
    "state_id": "35"
  },
  {
    "id": "3743",
    "name": "Ilanji",
    "state_id": "35"
  },
  {
    "id": "3744",
    "name": "Iluppaiyurani",
    "state_id": "35"
  },
  {
    "id": "3745",
    "name": "Iluppur",
    "state_id": "35"
  },
  {
    "id": "3746",
    "name": "Inam Karur",
    "state_id": "35"
  },
  {
    "id": "3747",
    "name": "Injambakkam",
    "state_id": "35"
  },
  {
    "id": "3748",
    "name": "Irugur",
    "state_id": "35"
  },
  {
    "id": "3749",
    "name": "Jaffrabad",
    "state_id": "35"
  },
  {
    "id": "3750",
    "name": "Jagathala",
    "state_id": "35"
  },
  {
    "id": "3751",
    "name": "Jalakandapuram",
    "state_id": "35"
  },
  {
    "id": "3752",
    "name": "Jalladiampet",
    "state_id": "35"
  },
  {
    "id": "3753",
    "name": "Jambai",
    "state_id": "35"
  },
  {
    "id": "3754",
    "name": "Jayankondam",
    "state_id": "35"
  },
  {
    "id": "3755",
    "name": "Jolarpet",
    "state_id": "35"
  },
  {
    "id": "3756",
    "name": "Kadambur",
    "state_id": "35"
  },
  {
    "id": "3757",
    "name": "Kadathur",
    "state_id": "35"
  },
  {
    "id": "3758",
    "name": "Kadayal",
    "state_id": "35"
  },
  {
    "id": "3759",
    "name": "Kadayampatti",
    "state_id": "35"
  },
  {
    "id": "3760",
    "name": "Kadayanallur",
    "state_id": "35"
  },
  {
    "id": "3761",
    "name": "Kadiapatti",
    "state_id": "35"
  },
  {
    "id": "3762",
    "name": "Kalakkad",
    "state_id": "35"
  },
  {
    "id": "3763",
    "name": "Kalambur",
    "state_id": "35"
  },
  {
    "id": "3764",
    "name": "Kalapatti",
    "state_id": "35"
  },
  {
    "id": "3765",
    "name": "Kalappanaickenpatti",
    "state_id": "35"
  },
  {
    "id": "3766",
    "name": "Kalavai",
    "state_id": "35"
  },
  {
    "id": "3767",
    "name": "Kalinjur",
    "state_id": "35"
  },
  {
    "id": "3768",
    "name": "Kaliyakkavilai",
    "state_id": "35"
  },
  {
    "id": "3769",
    "name": "Kallakkurichi",
    "state_id": "35"
  },
  {
    "id": "3770",
    "name": "Kallakudi",
    "state_id": "35"
  },
  {
    "id": "3771",
    "name": "Kallidaikurichchi",
    "state_id": "35"
  },
  {
    "id": "3772",
    "name": "Kallukuttam",
    "state_id": "35"
  },
  {
    "id": "3773",
    "name": "Kallupatti",
    "state_id": "35"
  },
  {
    "id": "3774",
    "name": "Kalpakkam",
    "state_id": "35"
  },
  {
    "id": "3775",
    "name": "Kalugumalai",
    "state_id": "35"
  },
  {
    "id": "3776",
    "name": "Kamayagoundanpatti",
    "state_id": "35"
  },
  {
    "id": "3777",
    "name": "Kambainallur",
    "state_id": "35"
  },
  {
    "id": "3778",
    "name": "Kambam",
    "state_id": "35"
  },
  {
    "id": "3779",
    "name": "Kamuthi",
    "state_id": "35"
  },
  {
    "id": "3780",
    "name": "Kanadukathan",
    "state_id": "35"
  },
  {
    "id": "3781",
    "name": "Kanakkampalayam",
    "state_id": "35"
  },
  {
    "id": "3782",
    "name": "Kanam",
    "state_id": "35"
  },
  {
    "id": "3783",
    "name": "Kanchipuram",
    "state_id": "35"
  },
  {
    "id": "3784",
    "name": "Kandanur",
    "state_id": "35"
  },
  {
    "id": "3785",
    "name": "Kangayam",
    "state_id": "35"
  },
  {
    "id": "3786",
    "name": "Kangayampalayam",
    "state_id": "35"
  },
  {
    "id": "3787",
    "name": "Kangeyanallur",
    "state_id": "35"
  },
  {
    "id": "3788",
    "name": "Kaniyur",
    "state_id": "35"
  },
  {
    "id": "3789",
    "name": "Kanjikoil",
    "state_id": "35"
  },
  {
    "id": "3790",
    "name": "Kannadendal",
    "state_id": "35"
  },
  {
    "id": "3791",
    "name": "Kannamangalam",
    "state_id": "35"
  },
  {
    "id": "3792",
    "name": "Kannampalayam",
    "state_id": "35"
  },
  {
    "id": "3793",
    "name": "Kannankurichi",
    "state_id": "35"
  },
  {
    "id": "3794",
    "name": "Kannapalaiyam",
    "state_id": "35"
  },
  {
    "id": "3795",
    "name": "Kannivadi",
    "state_id": "35"
  },
  {
    "id": "3796",
    "name": "Kanyakumari",
    "state_id": "35"
  },
  {
    "id": "3797",
    "name": "Kappiyarai",
    "state_id": "35"
  },
  {
    "id": "3798",
    "name": "Karaikkudi",
    "state_id": "35"
  },
  {
    "id": "3799",
    "name": "Karamadai",
    "state_id": "35"
  },
  {
    "id": "3800",
    "name": "Karambakkam",
    "state_id": "35"
  },
  {
    "id": "3801",
    "name": "Karambakkudi",
    "state_id": "35"
  },
  {
    "id": "3802",
    "name": "Kariamangalam",
    "state_id": "35"
  },
  {
    "id": "3803",
    "name": "Kariapatti",
    "state_id": "35"
  },
  {
    "id": "3804",
    "name": "Karugampattur",
    "state_id": "35"
  },
  {
    "id": "3805",
    "name": "Karumandi Chellipalayam",
    "state_id": "35"
  },
  {
    "id": "3806",
    "name": "Karumathampatti",
    "state_id": "35"
  },
  {
    "id": "3807",
    "name": "Karumbakkam",
    "state_id": "35"
  },
  {
    "id": "3808",
    "name": "Karungal",
    "state_id": "35"
  },
  {
    "id": "3809",
    "name": "Karunguzhi",
    "state_id": "35"
  },
  {
    "id": "3810",
    "name": "Karuppur",
    "state_id": "35"
  },
  {
    "id": "3811",
    "name": "Karur",
    "state_id": "35"
  },
  {
    "id": "3812",
    "name": "Kasipalaiyam",
    "state_id": "35"
  },
  {
    "id": "3813",
    "name": "Kasipalayam G",
    "state_id": "35"
  },
  {
    "id": "3814",
    "name": "Kathirvedu",
    "state_id": "35"
  },
  {
    "id": "3815",
    "name": "Kathujuganapalli",
    "state_id": "35"
  },
  {
    "id": "3816",
    "name": "Katpadi",
    "state_id": "35"
  },
  {
    "id": "3817",
    "name": "Kattivakkam",
    "state_id": "35"
  },
  {
    "id": "3818",
    "name": "Kattumannarkoil",
    "state_id": "35"
  },
  {
    "id": "3819",
    "name": "Kattupakkam",
    "state_id": "35"
  },
  {
    "id": "3820",
    "name": "Kattuputhur",
    "state_id": "35"
  },
  {
    "id": "3821",
    "name": "Kaveripakkam",
    "state_id": "35"
  },
  {
    "id": "3822",
    "name": "Kaveripattinam",
    "state_id": "35"
  },
  {
    "id": "3823",
    "name": "Kavundampalaiyam",
    "state_id": "35"
  },
  {
    "id": "3824",
    "name": "Kavundampalayam",
    "state_id": "35"
  },
  {
    "id": "3825",
    "name": "Kayalpattinam",
    "state_id": "35"
  },
  {
    "id": "3826",
    "name": "Kayattar",
    "state_id": "35"
  },
  {
    "id": "3827",
    "name": "Kelamangalam",
    "state_id": "35"
  },
  {
    "id": "3828",
    "name": "Kelambakkam",
    "state_id": "35"
  },
  {
    "id": "3829",
    "name": "Kembainaickenpalayam",
    "state_id": "35"
  },
  {
    "id": "3830",
    "name": "Kethi",
    "state_id": "35"
  },
  {
    "id": "3831",
    "name": "Kilakarai",
    "state_id": "35"
  },
  {
    "id": "3832",
    "name": "Kilampadi",
    "state_id": "35"
  },
  {
    "id": "3833",
    "name": "Kilkulam",
    "state_id": "35"
  },
  {
    "id": "3834",
    "name": "Kilkunda",
    "state_id": "35"
  },
  {
    "id": "3835",
    "name": "Killiyur",
    "state_id": "35"
  },
  {
    "id": "3836",
    "name": "Killlai",
    "state_id": "35"
  },
  {
    "id": "3837",
    "name": "Kilpennathur",
    "state_id": "35"
  },
  {
    "id": "3838",
    "name": "Kilvelur",
    "state_id": "35"
  },
  {
    "id": "3839",
    "name": "Kinathukadavu",
    "state_id": "35"
  },
  {
    "id": "3840",
    "name": "Kiramangalam",
    "state_id": "35"
  },
  {
    "id": "3841",
    "name": "Kiranur",
    "state_id": "35"
  },
  {
    "id": "3842",
    "name": "Kiripatti",
    "state_id": "35"
  },
  {
    "id": "3843",
    "name": "Kizhapavur",
    "state_id": "35"
  },
  {
    "id": "3844",
    "name": "Kmarasamipatti",
    "state_id": "35"
  },
  {
    "id": "3845",
    "name": "Kochadai",
    "state_id": "35"
  },
  {
    "id": "3846",
    "name": "Kodaikanal",
    "state_id": "35"
  },
  {
    "id": "3847",
    "name": "Kodambakkam",
    "state_id": "35"
  },
  {
    "id": "3848",
    "name": "Kodavasal",
    "state_id": "35"
  },
  {
    "id": "3849",
    "name": "Kodumudi",
    "state_id": "35"
  },
  {
    "id": "3850",
    "name": "Kolachal",
    "state_id": "35"
  },
  {
    "id": "3851",
    "name": "Kolappalur",
    "state_id": "35"
  },
  {
    "id": "3852",
    "name": "Kolathupalayam",
    "state_id": "35"
  },
  {
    "id": "3853",
    "name": "Kolathur",
    "state_id": "35"
  },
  {
    "id": "3854",
    "name": "Kollankodu",
    "state_id": "35"
  },
  {
    "id": "3855",
    "name": "Kollankoil",
    "state_id": "35"
  },
  {
    "id": "3856",
    "name": "Komaralingam",
    "state_id": "35"
  },
  {
    "id": "3857",
    "name": "Komarapalayam",
    "state_id": "35"
  },
  {
    "id": "3858",
    "name": "Kombai",
    "state_id": "35"
  },
  {
    "id": "3859",
    "name": "Konakkarai",
    "state_id": "35"
  },
  {
    "id": "3860",
    "name": "Konavattam",
    "state_id": "35"
  },
  {
    "id": "3861",
    "name": "Kondalampatti",
    "state_id": "35"
  },
  {
    "id": "3862",
    "name": "Konganapuram",
    "state_id": "35"
  },
  {
    "id": "3863",
    "name": "Koradacheri",
    "state_id": "35"
  },
  {
    "id": "3864",
    "name": "Korampallam",
    "state_id": "35"
  },
  {
    "id": "3865",
    "name": "Kotagiri",
    "state_id": "35"
  },
  {
    "id": "3866",
    "name": "Kothinallur",
    "state_id": "35"
  },
  {
    "id": "3867",
    "name": "Kottaiyur",
    "state_id": "35"
  },
  {
    "id": "3868",
    "name": "Kottakuppam",
    "state_id": "35"
  },
  {
    "id": "3869",
    "name": "Kottaram",
    "state_id": "35"
  },
  {
    "id": "3870",
    "name": "Kottivakkam",
    "state_id": "35"
  },
  {
    "id": "3871",
    "name": "Kottur",
    "state_id": "35"
  },
  {
    "id": "3872",
    "name": "Kovilpatti",
    "state_id": "35"
  },
  {
    "id": "3873",
    "name": "Koyampattur",
    "state_id": "35"
  },
  {
    "id": "3874",
    "name": "Krishnagiri",
    "state_id": "35"
  },
  {
    "id": "3875",
    "name": "Krishnarayapuram",
    "state_id": "35"
  },
  {
    "id": "3876",
    "name": "Krishnasamudram",
    "state_id": "35"
  },
  {
    "id": "3877",
    "name": "Kuchanur",
    "state_id": "35"
  },
  {
    "id": "3878",
    "name": "Kuhalur",
    "state_id": "35"
  },
  {
    "id": "3879",
    "name": "Kulasekarappattinam",
    "state_id": "35"
  },
  {
    "id": "3880",
    "name": "Kulasekarapuram",
    "state_id": "35"
  },
  {
    "id": "3881",
    "name": "Kulithalai",
    "state_id": "35"
  },
  {
    "id": "3882",
    "name": "Kumarapalaiyam",
    "state_id": "35"
  },
  {
    "id": "3883",
    "name": "Kumarapalayam",
    "state_id": "35"
  },
  {
    "id": "3884",
    "name": "Kumarapuram",
    "state_id": "35"
  },
  {
    "id": "3885",
    "name": "Kumbakonam",
    "state_id": "35"
  },
  {
    "id": "3886",
    "name": "Kundrathur",
    "state_id": "35"
  },
  {
    "id": "3887",
    "name": "Kuniyamuthur",
    "state_id": "35"
  },
  {
    "id": "3888",
    "name": "Kunnathur",
    "state_id": "35"
  },
  {
    "id": "3889",
    "name": "Kunur",
    "state_id": "35"
  },
  {
    "id": "3890",
    "name": "Kuraikundu",
    "state_id": "35"
  },
  {
    "id": "3891",
    "name": "Kurichi",
    "state_id": "35"
  },
  {
    "id": "3892",
    "name": "Kurinjippadi",
    "state_id": "35"
  },
  {
    "id": "3893",
    "name": "Kurudampalaiyam",
    "state_id": "35"
  },
  {
    "id": "3894",
    "name": "Kurumbalur",
    "state_id": "35"
  },
  {
    "id": "3895",
    "name": "Kuthalam",
    "state_id": "35"
  },
  {
    "id": "3896",
    "name": "Kuthappar",
    "state_id": "35"
  },
  {
    "id": "3897",
    "name": "Kuttalam",
    "state_id": "35"
  },
  {
    "id": "3898",
    "name": "Kuttanallur",
    "state_id": "35"
  },
  {
    "id": "3899",
    "name": "Kuzhithurai",
    "state_id": "35"
  },
  {
    "id": "3900",
    "name": "Labbaikudikadu",
    "state_id": "35"
  },
  {
    "id": "3901",
    "name": "Lakkampatti",
    "state_id": "35"
  },
  {
    "id": "3902",
    "name": "Lalgudi",
    "state_id": "35"
  },
  {
    "id": "3903",
    "name": "Lalpet",
    "state_id": "35"
  },
  {
    "id": "3904",
    "name": "Llayangudi",
    "state_id": "35"
  },
  {
    "id": "3905",
    "name": "Madambakkam",
    "state_id": "35"
  },
  {
    "id": "3906",
    "name": "Madanur",
    "state_id": "35"
  },
  {
    "id": "3907",
    "name": "Madathukulam",
    "state_id": "35"
  },
  {
    "id": "3908",
    "name": "Madhavaram",
    "state_id": "35"
  },
  {
    "id": "3909",
    "name": "Madippakkam",
    "state_id": "35"
  },
  {
    "id": "3910",
    "name": "Madukkarai",
    "state_id": "35"
  },
  {
    "id": "3911",
    "name": "Madukkur",
    "state_id": "35"
  },
  {
    "id": "3912",
    "name": "Madurai",
    "state_id": "35"
  },
  {
    "id": "3913",
    "name": "Maduranthakam",
    "state_id": "35"
  },
  {
    "id": "3914",
    "name": "Maduravoyal",
    "state_id": "35"
  },
  {
    "id": "3915",
    "name": "Mahabalipuram",
    "state_id": "35"
  },
  {
    "id": "3916",
    "name": "Makkinanpatti",
    "state_id": "35"
  },
  {
    "id": "3917",
    "name": "Mallamuppampatti",
    "state_id": "35"
  },
  {
    "id": "3918",
    "name": "Mallankinaru",
    "state_id": "35"
  },
  {
    "id": "3919",
    "name": "Mallapuram",
    "state_id": "35"
  },
  {
    "id": "3920",
    "name": "Mallasamudram",
    "state_id": "35"
  },
  {
    "id": "3921",
    "name": "Mallur",
    "state_id": "35"
  },
  {
    "id": "3922",
    "name": "Mamallapuram",
    "state_id": "35"
  },
  {
    "id": "3923",
    "name": "Mamsapuram",
    "state_id": "35"
  },
  {
    "id": "3924",
    "name": "Manachanallur",
    "state_id": "35"
  },
  {
    "id": "3925",
    "name": "Manali",
    "state_id": "35"
  },
  {
    "id": "3926",
    "name": "Manalmedu",
    "state_id": "35"
  },
  {
    "id": "3927",
    "name": "Manalurpet",
    "state_id": "35"
  },
  {
    "id": "3928",
    "name": "Manamadurai",
    "state_id": "35"
  },
  {
    "id": "3929",
    "name": "Manapakkam",
    "state_id": "35"
  },
  {
    "id": "3930",
    "name": "Manapparai",
    "state_id": "35"
  },
  {
    "id": "3931",
    "name": "Manavalakurichi",
    "state_id": "35"
  },
  {
    "id": "3932",
    "name": "Mandaikadu",
    "state_id": "35"
  },
  {
    "id": "3933",
    "name": "Mandapam",
    "state_id": "35"
  },
  {
    "id": "3934",
    "name": "Mangadu",
    "state_id": "35"
  },
  {
    "id": "3935",
    "name": "Mangalam",
    "state_id": "35"
  },
  {
    "id": "3936",
    "name": "Mangalampet",
    "state_id": "35"
  },
  {
    "id": "3937",
    "name": "Manimutharu",
    "state_id": "35"
  },
  {
    "id": "3938",
    "name": "Mannargudi",
    "state_id": "35"
  },
  {
    "id": "3939",
    "name": "Mappilaiurani",
    "state_id": "35"
  },
  {
    "id": "3940",
    "name": "Maraimalai Nagar",
    "state_id": "35"
  },
  {
    "id": "3941",
    "name": "Marakkanam",
    "state_id": "35"
  },
  {
    "id": "3942",
    "name": "Maramangalathupatti",
    "state_id": "35"
  },
  {
    "id": "3943",
    "name": "Marandahalli",
    "state_id": "35"
  },
  {
    "id": "3944",
    "name": "Markayankottai",
    "state_id": "35"
  },
  {
    "id": "3945",
    "name": "Marudur",
    "state_id": "35"
  },
  {
    "id": "3946",
    "name": "Marungur",
    "state_id": "35"
  },
  {
    "id": "3947",
    "name": "Masinigudi",
    "state_id": "35"
  },
  {
    "id": "3948",
    "name": "Mathigiri",
    "state_id": "35"
  },
  {
    "id": "3949",
    "name": "Mattur",
    "state_id": "35"
  },
  {
    "id": "3950",
    "name": "Mayiladuthurai",
    "state_id": "35"
  },
  {
    "id": "3951",
    "name": "Mecheri",
    "state_id": "35"
  },
  {
    "id": "3952",
    "name": "Melacheval",
    "state_id": "35"
  },
  {
    "id": "3953",
    "name": "Melachokkanathapuram",
    "state_id": "35"
  },
  {
    "id": "3954",
    "name": "Melagaram",
    "state_id": "35"
  },
  {
    "id": "3955",
    "name": "Melamadai",
    "state_id": "35"
  },
  {
    "id": "3956",
    "name": "Melamaiyur",
    "state_id": "35"
  },
  {
    "id": "3957",
    "name": "Melanattam",
    "state_id": "35"
  },
  {
    "id": "3958",
    "name": "Melathiruppanthuruthi",
    "state_id": "35"
  },
  {
    "id": "3959",
    "name": "Melattur",
    "state_id": "35"
  },
  {
    "id": "3960",
    "name": "Melmananbedu",
    "state_id": "35"
  },
  {
    "id": "3961",
    "name": "Melpattampakkam",
    "state_id": "35"
  },
  {
    "id": "3962",
    "name": "Melur",
    "state_id": "35"
  },
  {
    "id": "3963",
    "name": "Melvisharam",
    "state_id": "35"
  },
  {
    "id": "3964",
    "name": "Mettupalayam",
    "state_id": "35"
  },
  {
    "id": "3965",
    "name": "Mettur",
    "state_id": "35"
  },
  {
    "id": "3966",
    "name": "Meyyanur",
    "state_id": "35"
  },
  {
    "id": "3967",
    "name": "Milavittan",
    "state_id": "35"
  },
  {
    "id": "3968",
    "name": "Minakshipuram",
    "state_id": "35"
  },
  {
    "id": "3969",
    "name": "Minambakkam",
    "state_id": "35"
  },
  {
    "id": "3970",
    "name": "Minjur",
    "state_id": "35"
  },
  {
    "id": "3971",
    "name": "Modakurichi",
    "state_id": "35"
  },
  {
    "id": "3972",
    "name": "Mohanur",
    "state_id": "35"
  },
  {
    "id": "3973",
    "name": "Mopperipalayam",
    "state_id": "35"
  },
  {
    "id": "3974",
    "name": "Mudalur",
    "state_id": "35"
  },
  {
    "id": "3975",
    "name": "Mudichur",
    "state_id": "35"
  },
  {
    "id": "3976",
    "name": "Mudukulathur",
    "state_id": "35"
  },
  {
    "id": "3977",
    "name": "Mukasipidariyur",
    "state_id": "35"
  },
  {
    "id": "3978",
    "name": "Mukkudal",
    "state_id": "35"
  },
  {
    "id": "3979",
    "name": "Mulagumudu",
    "state_id": "35"
  },
  {
    "id": "3980",
    "name": "Mulakaraipatti",
    "state_id": "35"
  },
  {
    "id": "3981",
    "name": "Mulanur",
    "state_id": "35"
  },
  {
    "id": "3982",
    "name": "Mullakkadu",
    "state_id": "35"
  },
  {
    "id": "3983",
    "name": "Muruganpalayam",
    "state_id": "35"
  },
  {
    "id": "3984",
    "name": "Musiri",
    "state_id": "35"
  },
  {
    "id": "3985",
    "name": "Muthupet",
    "state_id": "35"
  },
  {
    "id": "3986",
    "name": "Muthur",
    "state_id": "35"
  },
  {
    "id": "3987",
    "name": "Muttayyapuram",
    "state_id": "35"
  },
  {
    "id": "3988",
    "name": "Muttupet",
    "state_id": "35"
  },
  {
    "id": "3989",
    "name": "Muvarasampettai",
    "state_id": "35"
  },
  {
    "id": "3990",
    "name": "Myladi",
    "state_id": "35"
  },
  {
    "id": "3991",
    "name": "Mylapore",
    "state_id": "35"
  },
  {
    "id": "3992",
    "name": "Nadukkuthagai",
    "state_id": "35"
  },
  {
    "id": "3993",
    "name": "Naduvattam",
    "state_id": "35"
  },
  {
    "id": "3994",
    "name": "Nagapattinam",
    "state_id": "35"
  },
  {
    "id": "3995",
    "name": "Nagavakulam",
    "state_id": "35"
  },
  {
    "id": "3996",
    "name": "Nagercoil",
    "state_id": "35"
  },
  {
    "id": "3997",
    "name": "Nagojanahalli",
    "state_id": "35"
  },
  {
    "id": "3998",
    "name": "Nallampatti",
    "state_id": "35"
  },
  {
    "id": "3999",
    "name": "Nallur",
    "state_id": "35"
  },
  {
    "id": "4000",
    "name": "Namagiripettai",
    "state_id": "35"
  },
  {
    "id": "4001",
    "name": "Namakkal",
    "state_id": "35"
  },
  {
    "id": "4002",
    "name": "Nambiyur",
    "state_id": "35"
  },
  {
    "id": "4003",
    "name": "Nambutalai",
    "state_id": "35"
  },
  {
    "id": "4004",
    "name": "Nandambakkam",
    "state_id": "35"
  },
  {
    "id": "4005",
    "name": "Nandivaram",
    "state_id": "35"
  },
  {
    "id": "4006",
    "name": "Nangavalli",
    "state_id": "35"
  },
  {
    "id": "4007",
    "name": "Nangavaram",
    "state_id": "35"
  },
  {
    "id": "4008",
    "name": "Nanguneri",
    "state_id": "35"
  },
  {
    "id": "4009",
    "name": "Nanjikottai",
    "state_id": "35"
  },
  {
    "id": "4010",
    "name": "Nannilam",
    "state_id": "35"
  },
  {
    "id": "4011",
    "name": "Naranammalpuram",
    "state_id": "35"
  },
  {
    "id": "4012",
    "name": "Naranapuram",
    "state_id": "35"
  },
  {
    "id": "4013",
    "name": "Narasimhanaickenpalayam",
    "state_id": "35"
  },
  {
    "id": "4014",
    "name": "Narasingapuram",
    "state_id": "35"
  },
  {
    "id": "4015",
    "name": "Narasojipatti",
    "state_id": "35"
  },
  {
    "id": "4016",
    "name": "Naravarikuppam",
    "state_id": "35"
  },
  {
    "id": "4017",
    "name": "Nasiyanur",
    "state_id": "35"
  },
  {
    "id": "4018",
    "name": "Natham",
    "state_id": "35"
  },
  {
    "id": "4019",
    "name": "Nathampannai",
    "state_id": "35"
  },
  {
    "id": "4020",
    "name": "Natrampalli",
    "state_id": "35"
  },
  {
    "id": "4021",
    "name": "Nattam",
    "state_id": "35"
  },
  {
    "id": "4022",
    "name": "Nattapettai",
    "state_id": "35"
  },
  {
    "id": "4023",
    "name": "Nattarasankottai",
    "state_id": "35"
  },
  {
    "id": "4024",
    "name": "Navalpattu",
    "state_id": "35"
  },
  {
    "id": "4025",
    "name": "Nazarethpettai",
    "state_id": "35"
  },
  {
    "id": "4026",
    "name": "Nazerath",
    "state_id": "35"
  },
  {
    "id": "4027",
    "name": "Neikkarapatti",
    "state_id": "35"
  },
  {
    "id": "4028",
    "name": "Neiyyur",
    "state_id": "35"
  },
  {
    "id": "4029",
    "name": "Nellikkuppam",
    "state_id": "35"
  },
  {
    "id": "4030",
    "name": "Nelliyalam",
    "state_id": "35"
  },
  {
    "id": "4031",
    "name": "Nemili",
    "state_id": "35"
  },
  {
    "id": "4032",
    "name": "Nemilicheri",
    "state_id": "35"
  },
  {
    "id": "4033",
    "name": "Neripperichal",
    "state_id": "35"
  },
  {
    "id": "4034",
    "name": "Nerkunram",
    "state_id": "35"
  },
  {
    "id": "4035",
    "name": "Nerkuppai",
    "state_id": "35"
  },
  {
    "id": "4036",
    "name": "Nerunjipettai",
    "state_id": "35"
  },
  {
    "id": "4037",
    "name": "Neykkarappatti",
    "state_id": "35"
  },
  {
    "id": "4038",
    "name": "Neyveli",
    "state_id": "35"
  },
  {
    "id": "4039",
    "name": "Nidamangalam",
    "state_id": "35"
  },
  {
    "id": "4040",
    "name": "Nilagiri",
    "state_id": "35"
  },
  {
    "id": "4041",
    "name": "Nilakkottai",
    "state_id": "35"
  },
  {
    "id": "4042",
    "name": "Nilankarai",
    "state_id": "35"
  },
  {
    "id": "4043",
    "name": "Odaipatti",
    "state_id": "35"
  },
  {
    "id": "4044",
    "name": "Odaiyakulam",
    "state_id": "35"
  },
  {
    "id": "4045",
    "name": "Oddanchatram",
    "state_id": "35"
  },
  {
    "id": "4046",
    "name": "Odugathur",
    "state_id": "35"
  },
  {
    "id": "4047",
    "name": "Oggiyamduraipakkam",
    "state_id": "35"
  },
  {
    "id": "4048",
    "name": "Olagadam",
    "state_id": "35"
  },
  {
    "id": "4049",
    "name": "Omalur",
    "state_id": "35"
  },
  {
    "id": "4050",
    "name": "Ooty",
    "state_id": "35"
  },
  {
    "id": "4051",
    "name": "Orathanadu",
    "state_id": "35"
  },
  {
    "id": "4052",
    "name": "Othakadai",
    "state_id": "35"
  },
  {
    "id": "4053",
    "name": "Othakalmandapam",
    "state_id": "35"
  },
  {
    "id": "4054",
    "name": "Ottapparai",
    "state_id": "35"
  },
  {
    "id": "4055",
    "name": "Pacode",
    "state_id": "35"
  },
  {
    "id": "4056",
    "name": "Padaividu",
    "state_id": "35"
  },
  {
    "id": "4057",
    "name": "Padianallur",
    "state_id": "35"
  },
  {
    "id": "4058",
    "name": "Padirikuppam",
    "state_id": "35"
  },
  {
    "id": "4059",
    "name": "Padmanabhapuram",
    "state_id": "35"
  },
  {
    "id": "4060",
    "name": "Padririvedu",
    "state_id": "35"
  },
  {
    "id": "4061",
    "name": "Palaganangudy",
    "state_id": "35"
  },
  {
    "id": "4062",
    "name": "Palaimpatti",
    "state_id": "35"
  },
  {
    "id": "4063",
    "name": "Palakkodu",
    "state_id": "35"
  },
  {
    "id": "4064",
    "name": "Palamedu",
    "state_id": "35"
  },
  {
    "id": "4065",
    "name": "Palani",
    "state_id": "35"
  },
  {
    "id": "4066",
    "name": "Palani Chettipatti",
    "state_id": "35"
  },
  {
    "id": "4067",
    "name": "Palavakkam",
    "state_id": "35"
  },
  {
    "id": "4068",
    "name": "Palavansathu",
    "state_id": "35"
  },
  {
    "id": "4069",
    "name": "Palayakayal",
    "state_id": "35"
  },
  {
    "id": "4070",
    "name": "Palayam",
    "state_id": "35"
  },
  {
    "id": "4071",
    "name": "Palayamkottai",
    "state_id": "35"
  },
  {
    "id": "4072",
    "name": "Palladam",
    "state_id": "35"
  },
  {
    "id": "4073",
    "name": "Pallapalayam",
    "state_id": "35"
  },
  {
    "id": "4074",
    "name": "Pallapatti",
    "state_id": "35"
  },
  {
    "id": "4075",
    "name": "Pallattur",
    "state_id": "35"
  },
  {
    "id": "4076",
    "name": "Pallavaram",
    "state_id": "35"
  },
  {
    "id": "4077",
    "name": "Pallikaranai",
    "state_id": "35"
  },
  {
    "id": "4078",
    "name": "Pallikonda",
    "state_id": "35"
  },
  {
    "id": "4079",
    "name": "Pallipalaiyam",
    "state_id": "35"
  },
  {
    "id": "4080",
    "name": "Pallipalaiyam Agraharam",
    "state_id": "35"
  },
  {
    "id": "4081",
    "name": "Pallipattu",
    "state_id": "35"
  },
  {
    "id": "4082",
    "name": "Pammal",
    "state_id": "35"
  },
  {
    "id": "4083",
    "name": "Panagudi",
    "state_id": "35"
  },
  {
    "id": "4084",
    "name": "Panaimarathupatti",
    "state_id": "35"
  },
  {
    "id": "4085",
    "name": "Panapakkam",
    "state_id": "35"
  },
  {
    "id": "4086",
    "name": "Panboli",
    "state_id": "35"
  },
  {
    "id": "4087",
    "name": "Pandamangalam",
    "state_id": "35"
  },
  {
    "id": "4088",
    "name": "Pannaikadu",
    "state_id": "35"
  },
  {
    "id": "4089",
    "name": "Pannaipuram",
    "state_id": "35"
  },
  {
    "id": "4090",
    "name": "Pannuratti",
    "state_id": "35"
  },
  {
    "id": "4091",
    "name": "Panruti",
    "state_id": "35"
  },
  {
    "id": "4092",
    "name": "Papanasam",
    "state_id": "35"
  },
  {
    "id": "4093",
    "name": "Pappankurichi",
    "state_id": "35"
  },
  {
    "id": "4094",
    "name": "Papparapatti",
    "state_id": "35"
  },
  {
    "id": "4095",
    "name": "Pappireddipatti",
    "state_id": "35"
  },
  {
    "id": "4096",
    "name": "Paramakkudi",
    "state_id": "35"
  },
  {
    "id": "4097",
    "name": "Paramankurichi",
    "state_id": "35"
  },
  {
    "id": "4098",
    "name": "Paramathi",
    "state_id": "35"
  },
  {
    "id": "4099",
    "name": "Parangippettai",
    "state_id": "35"
  },
  {
    "id": "4100",
    "name": "Paravai",
    "state_id": "35"
  },
  {
    "id": "4101",
    "name": "Pasur",
    "state_id": "35"
  },
  {
    "id": "4102",
    "name": "Pathamadai",
    "state_id": "35"
  },
  {
    "id": "4103",
    "name": "Pattinam",
    "state_id": "35"
  },
  {
    "id": "4104",
    "name": "Pattiviranpatti",
    "state_id": "35"
  },
  {
    "id": "4105",
    "name": "Pattukkottai",
    "state_id": "35"
  },
  {
    "id": "4106",
    "name": "Pazhugal",
    "state_id": "35"
  },
  {
    "id": "4107",
    "name": "Pennadam",
    "state_id": "35"
  },
  {
    "id": "4108",
    "name": "Pennagaram",
    "state_id": "35"
  },
  {
    "id": "4109",
    "name": "Pennathur",
    "state_id": "35"
  },
  {
    "id": "4110",
    "name": "Peraiyur",
    "state_id": "35"
  },
  {
    "id": "4111",
    "name": "Peralam",
    "state_id": "35"
  },
  {
    "id": "4112",
    "name": "Perambalur",
    "state_id": "35"
  },
  {
    "id": "4113",
    "name": "Peranamallur",
    "state_id": "35"
  },
  {
    "id": "4114",
    "name": "Peravurani",
    "state_id": "35"
  },
  {
    "id": "4115",
    "name": "Periyakodiveri",
    "state_id": "35"
  },
  {
    "id": "4116",
    "name": "Periyakulam",
    "state_id": "35"
  },
  {
    "id": "4117",
    "name": "Periyanayakkanpalaiyam",
    "state_id": "35"
  },
  {
    "id": "4118",
    "name": "Periyanegamam",
    "state_id": "35"
  },
  {
    "id": "4119",
    "name": "Periyapatti",
    "state_id": "35"
  },
  {
    "id": "4120",
    "name": "Periyasemur",
    "state_id": "35"
  },
  {
    "id": "4121",
    "name": "Pernambut",
    "state_id": "35"
  },
  {
    "id": "4122",
    "name": "Perumagalur",
    "state_id": "35"
  },
  {
    "id": "4123",
    "name": "Perumandi",
    "state_id": "35"
  },
  {
    "id": "4124",
    "name": "Perumuchi",
    "state_id": "35"
  },
  {
    "id": "4125",
    "name": "Perundurai",
    "state_id": "35"
  },
  {
    "id": "4126",
    "name": "Perungalathur",
    "state_id": "35"
  },
  {
    "id": "4127",
    "name": "Perungudi",
    "state_id": "35"
  },
  {
    "id": "4128",
    "name": "Perungulam",
    "state_id": "35"
  },
  {
    "id": "4129",
    "name": "Perur",
    "state_id": "35"
  },
  {
    "id": "4130",
    "name": "Perur Chettipalaiyam",
    "state_id": "35"
  },
  {
    "id": "4131",
    "name": "Pethampalayam",
    "state_id": "35"
  },
  {
    "id": "4132",
    "name": "Pethanaickenpalayam",
    "state_id": "35"
  },
  {
    "id": "4133",
    "name": "Pillanallur",
    "state_id": "35"
  },
  {
    "id": "4134",
    "name": "Pirkankaranai",
    "state_id": "35"
  },
  {
    "id": "4135",
    "name": "Polichalur",
    "state_id": "35"
  },
  {
    "id": "4136",
    "name": "Pollachi",
    "state_id": "35"
  },
  {
    "id": "4137",
    "name": "Polur",
    "state_id": "35"
  },
  {
    "id": "4138",
    "name": "Ponmani",
    "state_id": "35"
  },
  {
    "id": "4139",
    "name": "Ponnamaravathi",
    "state_id": "35"
  },
  {
    "id": "4140",
    "name": "Ponnampatti",
    "state_id": "35"
  },
  {
    "id": "4141",
    "name": "Ponneri",
    "state_id": "35"
  },
  {
    "id": "4142",
    "name": "Porur",
    "state_id": "35"
  },
  {
    "id": "4143",
    "name": "Pothanur",
    "state_id": "35"
  },
  {
    "id": "4144",
    "name": "Pothatturpettai",
    "state_id": "35"
  },
  {
    "id": "4145",
    "name": "Pudukadai",
    "state_id": "35"
  },
  {
    "id": "4146",
    "name": "Pudukkottai Cantonment",
    "state_id": "35"
  },
  {
    "id": "4147",
    "name": "Pudukottai",
    "state_id": "35"
  },
  {
    "id": "4148",
    "name": "Pudupalaiyam Aghraharam",
    "state_id": "35"
  },
  {
    "id": "4149",
    "name": "Pudupalayam",
    "state_id": "35"
  },
  {
    "id": "4150",
    "name": "Pudupatti",
    "state_id": "35"
  },
  {
    "id": "4151",
    "name": "Pudupattinam",
    "state_id": "35"
  },
  {
    "id": "4152",
    "name": "Pudur",
    "state_id": "35"
  },
  {
    "id": "4153",
    "name": "Puduvayal",
    "state_id": "35"
  },
  {
    "id": "4154",
    "name": "Pulambadi",
    "state_id": "35"
  },
  {
    "id": "4155",
    "name": "Pulampatti",
    "state_id": "35"
  },
  {
    "id": "4156",
    "name": "Puliyampatti",
    "state_id": "35"
  },
  {
    "id": "4157",
    "name": "Puliyankudi",
    "state_id": "35"
  },
  {
    "id": "4158",
    "name": "Puliyur",
    "state_id": "35"
  },
  {
    "id": "4159",
    "name": "Pullampadi",
    "state_id": "35"
  },
  {
    "id": "4160",
    "name": "Puluvapatti",
    "state_id": "35"
  },
  {
    "id": "4161",
    "name": "Punamalli",
    "state_id": "35"
  },
  {
    "id": "4162",
    "name": "Punjai Puliyampatti",
    "state_id": "35"
  },
  {
    "id": "4163",
    "name": "Punjai Thottakurichi",
    "state_id": "35"
  },
  {
    "id": "4164",
    "name": "Punjaipugalur",
    "state_id": "35"
  },
  {
    "id": "4165",
    "name": "Puthalam",
    "state_id": "35"
  },
  {
    "id": "4166",
    "name": "Putteri",
    "state_id": "35"
  },
  {
    "id": "4167",
    "name": "Puvalur",
    "state_id": "35"
  },
  {
    "id": "4168",
    "name": "Puzhal",
    "state_id": "35"
  },
  {
    "id": "4169",
    "name": "Puzhithivakkam",
    "state_id": "35"
  },
  {
    "id": "4170",
    "name": "Rajapalayam",
    "state_id": "35"
  },
  {
    "id": "4171",
    "name": "Ramanathapuram",
    "state_id": "35"
  },
  {
    "id": "4172",
    "name": "Ramapuram",
    "state_id": "35"
  },
  {
    "id": "4173",
    "name": "Rameswaram",
    "state_id": "35"
  },
  {
    "id": "4174",
    "name": "Ranipet",
    "state_id": "35"
  },
  {
    "id": "4175",
    "name": "Rasipuram",
    "state_id": "35"
  },
  {
    "id": "4176",
    "name": "Rayagiri",
    "state_id": "35"
  },
  {
    "id": "4177",
    "name": "Rithapuram",
    "state_id": "35"
  },
  {
    "id": "4178",
    "name": "Rosalpatti",
    "state_id": "35"
  },
  {
    "id": "4179",
    "name": "Rudravathi",
    "state_id": "35"
  },
  {
    "id": "4180",
    "name": "Sadayankuppam",
    "state_id": "35"
  },
  {
    "id": "4181",
    "name": "Saint Thomas Mount",
    "state_id": "35"
  },
  {
    "id": "4182",
    "name": "Salangapalayam",
    "state_id": "35"
  },
  {
    "id": "4183",
    "name": "Salem",
    "state_id": "35"
  },
  {
    "id": "4184",
    "name": "Samalapuram",
    "state_id": "35"
  },
  {
    "id": "4185",
    "name": "Samathur",
    "state_id": "35"
  },
  {
    "id": "4186",
    "name": "Sambavar Vadagarai",
    "state_id": "35"
  },
  {
    "id": "4187",
    "name": "Sankaramanallur",
    "state_id": "35"
  },
  {
    "id": "4188",
    "name": "Sankarankoil",
    "state_id": "35"
  },
  {
    "id": "4189",
    "name": "Sankarapuram",
    "state_id": "35"
  },
  {
    "id": "4190",
    "name": "Sankari",
    "state_id": "35"
  },
  {
    "id": "4191",
    "name": "Sankarnagar",
    "state_id": "35"
  },
  {
    "id": "4192",
    "name": "Saravanampatti",
    "state_id": "35"
  },
  {
    "id": "4193",
    "name": "Sarcarsamakulam",
    "state_id": "35"
  },
  {
    "id": "4194",
    "name": "Sathiyavijayanagaram",
    "state_id": "35"
  },
  {
    "id": "4195",
    "name": "Sathuvachari",
    "state_id": "35"
  },
  {
    "id": "4196",
    "name": "Sathyamangalam",
    "state_id": "35"
  },
  {
    "id": "4197",
    "name": "Sattankulam",
    "state_id": "35"
  },
  {
    "id": "4198",
    "name": "Sattur",
    "state_id": "35"
  },
  {
    "id": "4199",
    "name": "Sayalgudi",
    "state_id": "35"
  },
  {
    "id": "4200",
    "name": "Sayapuram",
    "state_id": "35"
  },
  {
    "id": "4201",
    "name": "Seithur",
    "state_id": "35"
  },
  {
    "id": "4202",
    "name": "Sembakkam",
    "state_id": "35"
  },
  {
    "id": "4203",
    "name": "Semmipalayam",
    "state_id": "35"
  },
  {
    "id": "4204",
    "name": "Sennirkuppam",
    "state_id": "35"
  },
  {
    "id": "4205",
    "name": "Senthamangalam",
    "state_id": "35"
  },
  {
    "id": "4206",
    "name": "Sentharapatti",
    "state_id": "35"
  },
  {
    "id": "4207",
    "name": "Senur",
    "state_id": "35"
  },
  {
    "id": "4208",
    "name": "Sethiathoppu",
    "state_id": "35"
  },
  {
    "id": "4209",
    "name": "Sevilimedu",
    "state_id": "35"
  },
  {
    "id": "4210",
    "name": "Sevugampatti",
    "state_id": "35"
  },
  {
    "id": "4211",
    "name": "Shenbakkam",
    "state_id": "35"
  },
  {
    "id": "4212",
    "name": "Shencottai",
    "state_id": "35"
  },
  {
    "id": "4213",
    "name": "Shenkottai",
    "state_id": "35"
  },
  {
    "id": "4214",
    "name": "Sholavandan",
    "state_id": "35"
  },
  {
    "id": "4215",
    "name": "Sholinganallur",
    "state_id": "35"
  },
  {
    "id": "4216",
    "name": "Sholingur",
    "state_id": "35"
  },
  {
    "id": "4217",
    "name": "Sholur",
    "state_id": "35"
  },
  {
    "id": "4218",
    "name": "Sikkarayapuram",
    "state_id": "35"
  },
  {
    "id": "4219",
    "name": "Singampuneri",
    "state_id": "35"
  },
  {
    "id": "4220",
    "name": "Singanallur",
    "state_id": "35"
  },
  {
    "id": "4221",
    "name": "Singaperumalkoil",
    "state_id": "35"
  },
  {
    "id": "4222",
    "name": "Sirapalli",
    "state_id": "35"
  },
  {
    "id": "4223",
    "name": "Sirkali",
    "state_id": "35"
  },
  {
    "id": "4224",
    "name": "Sirugamani",
    "state_id": "35"
  },
  {
    "id": "4225",
    "name": "Sirumugai",
    "state_id": "35"
  },
  {
    "id": "4226",
    "name": "Sithayankottai",
    "state_id": "35"
  },
  {
    "id": "4227",
    "name": "Sithurajapuram",
    "state_id": "35"
  },
  {
    "id": "4228",
    "name": "Sivaganga",
    "state_id": "35"
  },
  {
    "id": "4229",
    "name": "Sivagiri",
    "state_id": "35"
  },
  {
    "id": "4230",
    "name": "Sivakasi",
    "state_id": "35"
  },
  {
    "id": "4231",
    "name": "Sivanthipuram",
    "state_id": "35"
  },
  {
    "id": "4232",
    "name": "Sivur",
    "state_id": "35"
  },
  {
    "id": "4233",
    "name": "Soranjeri",
    "state_id": "35"
  },
  {
    "id": "4234",
    "name": "South Kannanur",
    "state_id": "35"
  },
  {
    "id": "4235",
    "name": "South Kodikulam",
    "state_id": "35"
  },
  {
    "id": "4236",
    "name": "Srimushnam",
    "state_id": "35"
  },
  {
    "id": "4237",
    "name": "Sriperumpudur",
    "state_id": "35"
  },
  {
    "id": "4238",
    "name": "Sriramapuram",
    "state_id": "35"
  },
  {
    "id": "4239",
    "name": "Srirangam",
    "state_id": "35"
  },
  {
    "id": "4240",
    "name": "Srivaikuntam",
    "state_id": "35"
  },
  {
    "id": "4241",
    "name": "Srivilliputtur",
    "state_id": "35"
  },
  {
    "id": "4242",
    "name": "Suchindram",
    "state_id": "35"
  },
  {
    "id": "4243",
    "name": "Suliswaranpatti",
    "state_id": "35"
  },
  {
    "id": "4244",
    "name": "Sulur",
    "state_id": "35"
  },
  {
    "id": "4245",
    "name": "Sundarapandiam",
    "state_id": "35"
  },
  {
    "id": "4246",
    "name": "Sundarapandiapuram",
    "state_id": "35"
  },
  {
    "id": "4247",
    "name": "Surampatti",
    "state_id": "35"
  },
  {
    "id": "4248",
    "name": "Surandai",
    "state_id": "35"
  },
  {
    "id": "4249",
    "name": "Suriyampalayam",
    "state_id": "35"
  },
  {
    "id": "4250",
    "name": "Swamimalai",
    "state_id": "35"
  },
  {
    "id": "4251",
    "name": "TNPL Pugalur",
    "state_id": "35"
  },
  {
    "id": "4252",
    "name": "Tambaram",
    "state_id": "35"
  },
  {
    "id": "4253",
    "name": "Taramangalam",
    "state_id": "35"
  },
  {
    "id": "4254",
    "name": "Tattayyangarpettai",
    "state_id": "35"
  },
  {
    "id": "4255",
    "name": "Tayilupatti",
    "state_id": "35"
  },
  {
    "id": "4256",
    "name": "Tenkasi",
    "state_id": "35"
  },
  {
    "id": "4257",
    "name": "Thadikombu",
    "state_id": "35"
  },
  {
    "id": "4258",
    "name": "Thakkolam",
    "state_id": "35"
  },
  {
    "id": "4259",
    "name": "Thalainayar",
    "state_id": "35"
  },
  {
    "id": "4260",
    "name": "Thalakudi",
    "state_id": "35"
  },
  {
    "id": "4261",
    "name": "Thamaraikulam",
    "state_id": "35"
  },
  {
    "id": "4262",
    "name": "Thammampatti",
    "state_id": "35"
  },
  {
    "id": "4263",
    "name": "Thanjavur",
    "state_id": "35"
  },
  {
    "id": "4264",
    "name": "Thanthoni",
    "state_id": "35"
  },
  {
    "id": "4265",
    "name": "Tharangambadi",
    "state_id": "35"
  },
  {
    "id": "4266",
    "name": "Thedavur",
    "state_id": "35"
  },
  {
    "id": "4267",
    "name": "Thenambakkam",
    "state_id": "35"
  },
  {
    "id": "4268",
    "name": "Thengampudur",
    "state_id": "35"
  },
  {
    "id": "4269",
    "name": "Theni",
    "state_id": "35"
  },
  {
    "id": "4270",
    "name": "Theni Allinagaram",
    "state_id": "35"
  },
  {
    "id": "4271",
    "name": "Thenkarai",
    "state_id": "35"
  },
  {
    "id": "4272",
    "name": "Thenthamaraikulam",
    "state_id": "35"
  },
  {
    "id": "4273",
    "name": "Thenthiruperai",
    "state_id": "35"
  },
  {
    "id": "4274",
    "name": "Thesur",
    "state_id": "35"
  },
  {
    "id": "4275",
    "name": "Thevaram",
    "state_id": "35"
  },
  {
    "id": "4276",
    "name": "Thevur",
    "state_id": "35"
  },
  {
    "id": "4277",
    "name": "Thiagadurgam",
    "state_id": "35"
  },
  {
    "id": "4278",
    "name": "Thiagarajar Colony",
    "state_id": "35"
  },
  {
    "id": "4279",
    "name": "Thingalnagar",
    "state_id": "35"
  },
  {
    "id": "4280",
    "name": "Thiruchirapalli",
    "state_id": "35"
  },
  {
    "id": "4281",
    "name": "Thirukarungudi",
    "state_id": "35"
  },
  {
    "id": "4282",
    "name": "Thirukazhukundram",
    "state_id": "35"
  },
  {
    "id": "4283",
    "name": "Thirumalayampalayam",
    "state_id": "35"
  },
  {
    "id": "4284",
    "name": "Thirumazhisai",
    "state_id": "35"
  },
  {
    "id": "4285",
    "name": "Thirunagar",
    "state_id": "35"
  },
  {
    "id": "4286",
    "name": "Thirunageswaram",
    "state_id": "35"
  },
  {
    "id": "4287",
    "name": "Thirunindravur",
    "state_id": "35"
  },
  {
    "id": "4288",
    "name": "Thirunirmalai",
    "state_id": "35"
  },
  {
    "id": "4289",
    "name": "Thiruparankundram",
    "state_id": "35"
  },
  {
    "id": "4290",
    "name": "Thiruparappu",
    "state_id": "35"
  },
  {
    "id": "4291",
    "name": "Thiruporur",
    "state_id": "35"
  },
  {
    "id": "4292",
    "name": "Thiruppanandal",
    "state_id": "35"
  },
  {
    "id": "4293",
    "name": "Thirupuvanam",
    "state_id": "35"
  },
  {
    "id": "4294",
    "name": "Thiruthangal",
    "state_id": "35"
  },
  {
    "id": "4295",
    "name": "Thiruthuraipundi",
    "state_id": "35"
  },
  {
    "id": "4296",
    "name": "Thiruvaivaru",
    "state_id": "35"
  },
  {
    "id": "4297",
    "name": "Thiruvalam",
    "state_id": "35"
  },
  {
    "id": "4298",
    "name": "Thiruvarur",
    "state_id": "35"
  },
  {
    "id": "4299",
    "name": "Thiruvattaru",
    "state_id": "35"
  },
  {
    "id": "4300",
    "name": "Thiruvenkatam",
    "state_id": "35"
  },
  {
    "id": "4301",
    "name": "Thiruvennainallur",
    "state_id": "35"
  },
  {
    "id": "4302",
    "name": "Thiruvithankodu",
    "state_id": "35"
  },
  {
    "id": "4303",
    "name": "Thisayanvilai",
    "state_id": "35"
  },
  {
    "id": "4304",
    "name": "Thittacheri",
    "state_id": "35"
  },
  {
    "id": "4305",
    "name": "Thondamuthur",
    "state_id": "35"
  },
  {
    "id": "4306",
    "name": "Thorapadi",
    "state_id": "35"
  },
  {
    "id": "4307",
    "name": "Thottipalayam",
    "state_id": "35"
  },
  {
    "id": "4308",
    "name": "Thottiyam",
    "state_id": "35"
  },
  {
    "id": "4309",
    "name": "Thudiyalur",
    "state_id": "35"
  },
  {
    "id": "4310",
    "name": "Thuthipattu",
    "state_id": "35"
  },
  {
    "id": "4311",
    "name": "Thuvakudi",
    "state_id": "35"
  },
  {
    "id": "4312",
    "name": "Timiri",
    "state_id": "35"
  },
  {
    "id": "4313",
    "name": "Tindivanam",
    "state_id": "35"
  },
  {
    "id": "4314",
    "name": "Tinnanur",
    "state_id": "35"
  },
  {
    "id": "4315",
    "name": "Tiruchchendur",
    "state_id": "35"
  },
  {
    "id": "4316",
    "name": "Tiruchengode",
    "state_id": "35"
  },
  {
    "id": "4317",
    "name": "Tirukkalukkundram",
    "state_id": "35"
  },
  {
    "id": "4318",
    "name": "Tirukkattuppalli",
    "state_id": "35"
  },
  {
    "id": "4319",
    "name": "Tirukkoyilur",
    "state_id": "35"
  },
  {
    "id": "4320",
    "name": "Tirumangalam",
    "state_id": "35"
  },
  {
    "id": "4321",
    "name": "Tirumullaivasal",
    "state_id": "35"
  },
  {
    "id": "4322",
    "name": "Tirumuruganpundi",
    "state_id": "35"
  },
  {
    "id": "4323",
    "name": "Tirunageswaram",
    "state_id": "35"
  },
  {
    "id": "4324",
    "name": "Tirunelveli",
    "state_id": "35"
  },
  {
    "id": "4325",
    "name": "Tirupathur",
    "state_id": "35"
  },
  {
    "id": "4326",
    "name": "Tirupattur",
    "state_id": "35"
  },
  {
    "id": "4327",
    "name": "Tiruppuvanam",
    "state_id": "35"
  },
  {
    "id": "4328",
    "name": "Tirupur",
    "state_id": "35"
  },
  {
    "id": "4329",
    "name": "Tirusulam",
    "state_id": "35"
  },
  {
    "id": "4330",
    "name": "Tiruttani",
    "state_id": "35"
  },
  {
    "id": "4331",
    "name": "Tiruvallur",
    "state_id": "35"
  },
  {
    "id": "4332",
    "name": "Tiruvannamalai",
    "state_id": "35"
  },
  {
    "id": "4333",
    "name": "Tiruverambur",
    "state_id": "35"
  },
  {
    "id": "4334",
    "name": "Tiruverkadu",
    "state_id": "35"
  },
  {
    "id": "4335",
    "name": "Tiruvethipuram",
    "state_id": "35"
  },
  {
    "id": "4336",
    "name": "Tiruvidaimarudur",
    "state_id": "35"
  },
  {
    "id": "4337",
    "name": "Tiruvottiyur",
    "state_id": "35"
  },
  {
    "id": "4338",
    "name": "Tittakudi",
    "state_id": "35"
  },
  {
    "id": "4339",
    "name": "Tondi",
    "state_id": "35"
  },
  {
    "id": "4340",
    "name": "Turaiyur",
    "state_id": "35"
  },
  {
    "id": "4341",
    "name": "Tuticorin",
    "state_id": "35"
  },
  {
    "id": "4342",
    "name": "Udagamandalam",
    "state_id": "35"
  },
  {
    "id": "4343",
    "name": "Udagamandalam Valley",
    "state_id": "35"
  },
  {
    "id": "4344",
    "name": "Udankudi",
    "state_id": "35"
  },
  {
    "id": "4345",
    "name": "Udayarpalayam",
    "state_id": "35"
  },
  {
    "id": "4346",
    "name": "Udumalaipettai",
    "state_id": "35"
  },
  {
    "id": "4347",
    "name": "Udumalpet",
    "state_id": "35"
  },
  {
    "id": "4348",
    "name": "Ullur",
    "state_id": "35"
  },
  {
    "id": "4349",
    "name": "Ulundurpettai",
    "state_id": "35"
  },
  {
    "id": "4350",
    "name": "Unjalaur",
    "state_id": "35"
  },
  {
    "id": "4351",
    "name": "Unnamalaikadai",
    "state_id": "35"
  },
  {
    "id": "4352",
    "name": "Uppidamangalam",
    "state_id": "35"
  },
  {
    "id": "4353",
    "name": "Uppiliapuram",
    "state_id": "35"
  },
  {
    "id": "4354",
    "name": "Urachikkottai",
    "state_id": "35"
  },
  {
    "id": "4355",
    "name": "Urapakkam",
    "state_id": "35"
  },
  {
    "id": "4356",
    "name": "Usilampatti",
    "state_id": "35"
  },
  {
    "id": "4357",
    "name": "Uthangarai",
    "state_id": "35"
  },
  {
    "id": "4358",
    "name": "Uthayendram",
    "state_id": "35"
  },
  {
    "id": "4359",
    "name": "Uthiramerur",
    "state_id": "35"
  },
  {
    "id": "4360",
    "name": "Uthukkottai",
    "state_id": "35"
  },
  {
    "id": "4361",
    "name": "Uttamapalaiyam",
    "state_id": "35"
  },
  {
    "id": "4362",
    "name": "Uttukkuli",
    "state_id": "35"
  },
  {
    "id": "4363",
    "name": "Vadakarai Kizhpadugai",
    "state_id": "35"
  },
  {
    "id": "4364",
    "name": "Vadakkanandal",
    "state_id": "35"
  },
  {
    "id": "4365",
    "name": "Vadakku Valliyur",
    "state_id": "35"
  },
  {
    "id": "4366",
    "name": "Vadalur",
    "state_id": "35"
  },
  {
    "id": "4367",
    "name": "Vadamadurai",
    "state_id": "35"
  },
  {
    "id": "4368",
    "name": "Vadavalli",
    "state_id": "35"
  },
  {
    "id": "4369",
    "name": "Vadipatti",
    "state_id": "35"
  },
  {
    "id": "4370",
    "name": "Vadugapatti",
    "state_id": "35"
  },
  {
    "id": "4371",
    "name": "Vaithiswarankoil",
    "state_id": "35"
  },
  {
    "id": "4372",
    "name": "Valangaiman",
    "state_id": "35"
  },
  {
    "id": "4373",
    "name": "Valasaravakkam",
    "state_id": "35"
  },
  {
    "id": "4374",
    "name": "Valavanur",
    "state_id": "35"
  },
  {
    "id": "4375",
    "name": "Vallam",
    "state_id": "35"
  },
  {
    "id": "4376",
    "name": "Valparai",
    "state_id": "35"
  },
  {
    "id": "4377",
    "name": "Valvaithankoshtam",
    "state_id": "35"
  },
  {
    "id": "4378",
    "name": "Vanavasi",
    "state_id": "35"
  },
  {
    "id": "4379",
    "name": "Vandalur",
    "state_id": "35"
  },
  {
    "id": "4380",
    "name": "Vandavasi",
    "state_id": "35"
  },
  {
    "id": "4381",
    "name": "Vandiyur",
    "state_id": "35"
  },
  {
    "id": "4382",
    "name": "Vaniputhur",
    "state_id": "35"
  },
  {
    "id": "4383",
    "name": "Vaniyambadi",
    "state_id": "35"
  },
  {
    "id": "4384",
    "name": "Varadarajanpettai",
    "state_id": "35"
  },
  {
    "id": "4385",
    "name": "Varadharajapuram",
    "state_id": "35"
  },
  {
    "id": "4386",
    "name": "Vasudevanallur",
    "state_id": "35"
  },
  {
    "id": "4387",
    "name": "Vathirairuppu",
    "state_id": "35"
  },
  {
    "id": "4388",
    "name": "Vattalkundu",
    "state_id": "35"
  },
  {
    "id": "4389",
    "name": "Vazhapadi",
    "state_id": "35"
  },
  {
    "id": "4390",
    "name": "Vedapatti",
    "state_id": "35"
  },
  {
    "id": "4391",
    "name": "Vedaranniyam",
    "state_id": "35"
  },
  {
    "id": "4392",
    "name": "Vedasandur",
    "state_id": "35"
  },
  {
    "id": "4393",
    "name": "Velampalaiyam",
    "state_id": "35"
  },
  {
    "id": "4394",
    "name": "Velankanni",
    "state_id": "35"
  },
  {
    "id": "4395",
    "name": "Vellakinar",
    "state_id": "35"
  },
  {
    "id": "4396",
    "name": "Vellakoil",
    "state_id": "35"
  },
  {
    "id": "4397",
    "name": "Vellalapatti",
    "state_id": "35"
  },
  {
    "id": "4398",
    "name": "Vellalur",
    "state_id": "35"
  },
  {
    "id": "4399",
    "name": "Vellanur",
    "state_id": "35"
  },
  {
    "id": "4400",
    "name": "Vellimalai",
    "state_id": "35"
  },
  {
    "id": "4401",
    "name": "Vellore",
    "state_id": "35"
  },
  {
    "id": "4402",
    "name": "Vellottamparappu",
    "state_id": "35"
  },
  {
    "id": "4403",
    "name": "Velluru",
    "state_id": "35"
  },
  {
    "id": "4404",
    "name": "Vengampudur",
    "state_id": "35"
  },
  {
    "id": "4405",
    "name": "Vengathur",
    "state_id": "35"
  },
  {
    "id": "4406",
    "name": "Vengavasal",
    "state_id": "35"
  },
  {
    "id": "4407",
    "name": "Venghatur",
    "state_id": "35"
  },
  {
    "id": "4408",
    "name": "Venkarai",
    "state_id": "35"
  },
  {
    "id": "4409",
    "name": "Vennanthur",
    "state_id": "35"
  },
  {
    "id": "4410",
    "name": "Veppathur",
    "state_id": "35"
  },
  {
    "id": "4411",
    "name": "Verkilambi",
    "state_id": "35"
  },
  {
    "id": "4412",
    "name": "Vettaikaranpudur",
    "state_id": "35"
  },
  {
    "id": "4413",
    "name": "Vettavalam",
    "state_id": "35"
  },
  {
    "id": "4414",
    "name": "Vijayapuri",
    "state_id": "35"
  },
  {
    "id": "4415",
    "name": "Vikramasingapuram",
    "state_id": "35"
  },
  {
    "id": "4416",
    "name": "Vikravandi",
    "state_id": "35"
  },
  {
    "id": "4417",
    "name": "Vilangudi",
    "state_id": "35"
  },
  {
    "id": "4418",
    "name": "Vilankurichi",
    "state_id": "35"
  },
  {
    "id": "4419",
    "name": "Vilapakkam",
    "state_id": "35"
  },
  {
    "id": "4420",
    "name": "Vilathikulam",
    "state_id": "35"
  },
  {
    "id": "4421",
    "name": "Vilavur",
    "state_id": "35"
  },
  {
    "id": "4422",
    "name": "Villukuri",
    "state_id": "35"
  },
  {
    "id": "4423",
    "name": "Villupuram",
    "state_id": "35"
  },
  {
    "id": "4424",
    "name": "Viraganur",
    "state_id": "35"
  },
  {
    "id": "4425",
    "name": "Virakeralam",
    "state_id": "35"
  },
  {
    "id": "4426",
    "name": "Virakkalpudur",
    "state_id": "35"
  },
  {
    "id": "4427",
    "name": "Virapandi",
    "state_id": "35"
  },
  {
    "id": "4428",
    "name": "Virapandi Cantonment",
    "state_id": "35"
  },
  {
    "id": "4429",
    "name": "Virappanchatram",
    "state_id": "35"
  },
  {
    "id": "4430",
    "name": "Viravanallur",
    "state_id": "35"
  },
  {
    "id": "4431",
    "name": "Virudambattu",
    "state_id": "35"
  },
  {
    "id": "4432",
    "name": "Virudhachalam",
    "state_id": "35"
  },
  {
    "id": "4433",
    "name": "Virudhunagar",
    "state_id": "35"
  },
  {
    "id": "4434",
    "name": "Virupakshipuram",
    "state_id": "35"
  },
  {
    "id": "4435",
    "name": "Viswanatham",
    "state_id": "35"
  },
  {
    "id": "4436",
    "name": "Vriddhachalam",
    "state_id": "35"
  },
  {
    "id": "4437",
    "name": "Walajabad",
    "state_id": "35"
  },
  {
    "id": "4438",
    "name": "Walajapet",
    "state_id": "35"
  },
  {
    "id": "4439",
    "name": "Wellington",
    "state_id": "35"
  },
  {
    "id": "4440",
    "name": "Yercaud",
    "state_id": "35"
  },
  {
    "id": "4441",
    "name": "Zamin Uthukuli",
    "state_id": "35"
  },
  {
    "id": "4442",
    "name": "Achampet",
    "state_id": "36"
  },
  {
    "id": "4443",
    "name": "Adilabad",
    "state_id": "36"
  },
  {
    "id": "4444",
    "name": "Armoor",
    "state_id": "36"
  },
  {
    "id": "4445",
    "name": "Asifabad",
    "state_id": "36"
  },
  {
    "id": "4446",
    "name": "Badepally",
    "state_id": "36"
  },
  {
    "id": "4447",
    "name": "Banswada",
    "state_id": "36"
  },
  {
    "id": "4448",
    "name": "Bellampalli",
    "state_id": "36"
  },
  {
    "id": "4449",
    "name": "Bhadrachalam",
    "state_id": "36"
  },
  {
    "id": "4450",
    "name": "Bhainsa",
    "state_id": "36"
  },
  {
    "id": "4451",
    "name": "Bhongir",
    "state_id": "36"
  },
  {
    "id": "4452",
    "name": "Bhupalpally",
    "state_id": "36"
  },
  {
    "id": "4453",
    "name": "Bodhan",
    "state_id": "36"
  },
  {
    "id": "4454",
    "name": "Bollaram",
    "state_id": "36"
  },
  {
    "id": "4455",
    "name": "Devarkonda",
    "state_id": "36"
  },
  {
    "id": "4456",
    "name": "Farooqnagar",
    "state_id": "36"
  },
  {
    "id": "4457",
    "name": "Gadwal",
    "state_id": "36"
  },
  {
    "id": "4458",
    "name": "Gajwel",
    "state_id": "36"
  },
  {
    "id": "4459",
    "name": "Ghatkesar",
    "state_id": "36"
  },
  {
    "id": "4460",
    "name": "Hyderabad",
    "state_id": "36"
  },
  {
    "id": "4461",
    "name": "Jagtial",
    "state_id": "36"
  },
  {
    "id": "4462",
    "name": "Jangaon",
    "state_id": "36"
  },
  {
    "id": "4463",
    "name": "Kagaznagar",
    "state_id": "36"
  },
  {
    "id": "4464",
    "name": "Kalwakurthy",
    "state_id": "36"
  },
  {
    "id": "4465",
    "name": "Kamareddy",
    "state_id": "36"
  },
  {
    "id": "4466",
    "name": "Karimnagar",
    "state_id": "36"
  },
  {
    "id": "4467",
    "name": "Khammam",
    "state_id": "36"
  },
  {
    "id": "4468",
    "name": "Kodada",
    "state_id": "36"
  },
  {
    "id": "4469",
    "name": "Koratla",
    "state_id": "36"
  },
  {
    "id": "4470",
    "name": "Kottagudem",
    "state_id": "36"
  },
  {
    "id": "4471",
    "name": "Kyathampalle",
    "state_id": "36"
  },
  {
    "id": "4472",
    "name": "Madhira",
    "state_id": "36"
  },
  {
    "id": "4473",
    "name": "Mahabubabad",
    "state_id": "36"
  },
  {
    "id": "4474",
    "name": "Mahbubnagar",
    "state_id": "36"
  },
  {
    "id": "4475",
    "name": "Mancherial",
    "state_id": "36"
  },
  {
    "id": "4476",
    "name": "Mandamarri",
    "state_id": "36"
  },
  {
    "id": "4477",
    "name": "Manuguru",
    "state_id": "36"
  },
  {
    "id": "4478",
    "name": "Medak",
    "state_id": "36);"
  },
  {
    "id": "4479",
    "name": "Medchal",
    "state_id": "36"
  },
  {
    "id": "4480",
    "name": "Miryalaguda",
    "state_id": "36"
  },
  {
    "id": "4481",
    "name": "Nagar Karnul",
    "state_id": "36"
  },
  {
    "id": "4482",
    "name": "Nakrekal",
    "state_id": "36"
  },
  {
    "id": "4483",
    "name": "Nalgonda",
    "state_id": "36"
  },
  {
    "id": "4484",
    "name": "Narayanpet",
    "state_id": "36"
  },
  {
    "id": "4485",
    "name": "Narsampet",
    "state_id": "36"
  },
  {
    "id": "4486",
    "name": "Nirmal",
    "state_id": "36"
  },
  {
    "id": "4487",
    "name": "Nizamabad",
    "state_id": "36"
  },
  {
    "id": "4488",
    "name": "Palwancha",
    "state_id": "36"
  },
  {
    "id": "4489",
    "name": "Peddapalli",
    "state_id": "36"
  },
  {
    "id": "4490",
    "name": "Ramagundam",
    "state_id": "36"
  },
  {
    "id": "4491",
    "name": "Ranga Reddy district",
    "state_id": "36"
  },
  {
    "id": "4492",
    "name": "Sadasivpet",
    "state_id": "36"
  },
  {
    "id": "4493",
    "name": "Sangareddy",
    "state_id": "36"
  },
  {
    "id": "4494",
    "name": "Sarapaka",
    "state_id": "36"
  },
  {
    "id": "4495",
    "name": "Sathupalle",
    "state_id": "36"
  },
  {
    "id": "4496",
    "name": "Secunderabad",
    "state_id": "36"
  },
  {
    "id": "4497",
    "name": "Siddipet",
    "state_id": "36"
  },
  {
    "id": "4498",
    "name": "Singapur",
    "state_id": "36"
  },
  {
    "id": "4499",
    "name": "Sircilla",
    "state_id": "36"
  },
  {
    "id": "4500",
    "name": "Suryapet",
    "state_id": "36"
  },
  {
    "id": "4501",
    "name": "Tandur",
    "state_id": "36"
  },
  {
    "id": "4502",
    "name": "Vemulawada",
    "state_id": "36"
  },
  {
    "id": "4503",
    "name": "Vikarabad",
    "state_id": "36"
  },
  {
    "id": "4504",
    "name": "Wanaparthy",
    "state_id": "36"
  },
  {
    "id": "4505",
    "name": "Warangal",
    "state_id": "36"
  },
  {
    "id": "4506",
    "name": "Yellandu",
    "state_id": "36"
  },
  {
    "id": "4507",
    "name": "Zahirabad",
    "state_id": "36"
  },
  {
    "id": "4508",
    "name": "Agartala",
    "state_id": "37"
  },
  {
    "id": "4509",
    "name": "Amarpur",
    "state_id": "37"
  },
  {
    "id": "4510",
    "name": "Ambassa",
    "state_id": "37"
  },
  {
    "id": "4511",
    "name": "Badharghat",
    "state_id": "37"
  },
  {
    "id": "4512",
    "name": "Belonia",
    "state_id": "37"
  },
  {
    "id": "4513",
    "name": "Dharmanagar",
    "state_id": "37"
  },
  {
    "id": "4514",
    "name": "Gakulnagar",
    "state_id": "37"
  },
  {
    "id": "4515",
    "name": "Gandhigram",
    "state_id": "37"
  },
  {
    "id": "4516",
    "name": "Indranagar",
    "state_id": "37"
  },
  {
    "id": "4517",
    "name": "Jogendranagar",
    "state_id": "37"
  },
  {
    "id": "4518",
    "name": "Kailasahar",
    "state_id": "37"
  },
  {
    "id": "4519",
    "name": "Kamalpur",
    "state_id": "37"
  },
  {
    "id": "4520",
    "name": "Kanchanpur",
    "state_id": "37"
  },
  {
    "id": "4521",
    "name": "Khowai",
    "state_id": "37"
  },
  {
    "id": "4522",
    "name": "Kumarghat",
    "state_id": "37"
  },
  {
    "id": "4523",
    "name": "Kunjaban",
    "state_id": "37"
  },
  {
    "id": "4524",
    "name": "Narsingarh",
    "state_id": "37"
  },
  {
    "id": "4525",
    "name": "Pratapgarh",
    "state_id": "37"
  },
  {
    "id": "4526",
    "name": "Ranir Bazar",
    "state_id": "37"
  },
  {
    "id": "4527",
    "name": "Sabrum",
    "state_id": "37"
  },
  {
    "id": "4528",
    "name": "Sonamura",
    "state_id": "37"
  },
  {
    "id": "4529",
    "name": "Teliamura",
    "state_id": "37"
  },
  {
    "id": "4530",
    "name": "Udaipur",
    "state_id": "37"
  },
  {
    "id": "4531",
    "name": "Achhalda",
    "state_id": "38"
  },
  {
    "id": "4532",
    "name": "Achhnera",
    "state_id": "38"
  },
  {
    "id": "4533",
    "name": "Adari",
    "state_id": "38"
  },
  {
    "id": "4534",
    "name": "Afzalgarh",
    "state_id": "38"
  },
  {
    "id": "4535",
    "name": "Agarwal Mandi",
    "state_id": "38"
  },
  {
    "id": "4536",
    "name": "Agra",
    "state_id": "38"
  },
  {
    "id": "4537",
    "name": "Agra Cantonment",
    "state_id": "38"
  },
  {
    "id": "4538",
    "name": "Ahraura",
    "state_id": "38"
  },
  {
    "id": "4539",
    "name": "Ailum",
    "state_id": "38"
  },
  {
    "id": "4540",
    "name": "Air Force Area",
    "state_id": "38"
  },
  {
    "id": "4541",
    "name": "Ajhuwa",
    "state_id": "38"
  },
  {
    "id": "4542",
    "name": "Akbarpur",
    "state_id": "38"
  },
  {
    "id": "4543",
    "name": "Alapur",
    "state_id": "38"
  },
  {
    "id": "4544",
    "name": "Aliganj",
    "state_id": "38"
  },
  {
    "id": "4545",
    "name": "Aligarh",
    "state_id": "38"
  },
  {
    "id": "4546",
    "name": "Allahabad",
    "state_id": "38"
  },
  {
    "id": "4547",
    "name": "Allahabad Cantonment",
    "state_id": "38"
  },
  {
    "id": "4548",
    "name": "Allahganj",
    "state_id": "38"
  },
  {
    "id": "4549",
    "name": "Amanpur",
    "state_id": "38"
  },
  {
    "id": "4550",
    "name": "Ambahta",
    "state_id": "38"
  },
  {
    "id": "4551",
    "name": "Amethi",
    "state_id": "38"
  },
  {
    "id": "4552",
    "name": "Amila",
    "state_id": "38"
  },
  {
    "id": "4553",
    "name": "Amilo",
    "state_id": "38"
  },
  {
    "id": "4554",
    "name": "Aminagar Sarai",
    "state_id": "38"
  },
  {
    "id": "4555",
    "name": "Aminagar Urf Bhurbaral",
    "state_id": "38"
  },
  {
    "id": "4556",
    "name": "Amraudha",
    "state_id": "38"
  },
  {
    "id": "4557",
    "name": "Amroha",
    "state_id": "38"
  },
  {
    "id": "4558",
    "name": "Anandnagar",
    "state_id": "38"
  },
  {
    "id": "4559",
    "name": "Anpara",
    "state_id": "38"
  },
  {
    "id": "4560",
    "name": "Antu",
    "state_id": "38"
  },
  {
    "id": "4561",
    "name": "Anupshahr",
    "state_id": "38"
  },
  {
    "id": "4562",
    "name": "Aonla",
    "state_id": "38"
  },
  {
    "id": "4563",
    "name": "Armapur Estate",
    "state_id": "38"
  },
  {
    "id": "4564",
    "name": "Ashokpuram",
    "state_id": "38"
  },
  {
    "id": "4565",
    "name": "Ashrafpur Kichhauchha",
    "state_id": "38"
  },
  {
    "id": "4566",
    "name": "Atarra",
    "state_id": "38"
  },
  {
    "id": "4567",
    "name": "Atasu",
    "state_id": "38"
  },
  {
    "id": "4568",
    "name": "Atrauli",
    "state_id": "38"
  },
  {
    "id": "4569",
    "name": "Atraulia",
    "state_id": "38"
  },
  {
    "id": "4570",
    "name": "Auraiya",
    "state_id": "38"
  },
  {
    "id": "4571",
    "name": "Aurangabad",
    "state_id": "38"
  },
  {
    "id": "4572",
    "name": "Aurangabad Bangar",
    "state_id": "38"
  },
  {
    "id": "4573",
    "name": "Auras",
    "state_id": "38"
  },
  {
    "id": "4574",
    "name": "Awagarh",
    "state_id": "38"
  },
  {
    "id": "4575",
    "name": "Ayodhya",
    "state_id": "38"
  },
  {
    "id": "4576",
    "name": "Azamgarh",
    "state_id": "38"
  },
  {
    "id": "4577",
    "name": "Azizpur",
    "state_id": "38"
  },
  {
    "id": "4578",
    "name": "Azmatgarh",
    "state_id": "38"
  },
  {
    "id": "4579",
    "name": "Babarpur Ajitmal",
    "state_id": "38"
  },
  {
    "id": "4580",
    "name": "Baberu",
    "state_id": "38"
  },
  {
    "id": "4581",
    "name": "Babina",
    "state_id": "38"
  },
  {
    "id": "4582",
    "name": "Babrala",
    "state_id": "38"
  },
  {
    "id": "4583",
    "name": "Babugarh",
    "state_id": "38"
  },
  {
    "id": "4584",
    "name": "Bachhiowan",
    "state_id": "38"
  },
  {
    "id": "4585",
    "name": "Bachhraon",
    "state_id": "38"
  },
  {
    "id": "4586",
    "name": "Bad",
    "state_id": "38"
  },
  {
    "id": "4587",
    "name": "Badaun",
    "state_id": "38"
  },
  {
    "id": "4588",
    "name": "Baghpat",
    "state_id": "38"
  },
  {
    "id": "4589",
    "name": "Bah",
    "state_id": "38"
  },
  {
    "id": "4590",
    "name": "Bahadurganj",
    "state_id": "38"
  },
  {
    "id": "4591",
    "name": "Baheri",
    "state_id": "38"
  },
  {
    "id": "4592",
    "name": "Bahjoi",
    "state_id": "38"
  },
  {
    "id": "4593",
    "name": "Bahraich",
    "state_id": "38"
  },
  {
    "id": "4594",
    "name": "Bahsuma",
    "state_id": "38"
  },
  {
    "id": "4595",
    "name": "Bahua",
    "state_id": "38"
  },
  {
    "id": "4596",
    "name": "Bajna",
    "state_id": "38"
  },
  {
    "id": "4597",
    "name": "Bakewar",
    "state_id": "38"
  },
  {
    "id": "4598",
    "name": "Bakiabad",
    "state_id": "38"
  },
  {
    "id": "4599",
    "name": "Baldeo",
    "state_id": "38"
  },
  {
    "id": "4600",
    "name": "Ballia",
    "state_id": "38"
  },
  {
    "id": "4601",
    "name": "Balrampur",
    "state_id": "38"
  },
  {
    "id": "4602",
    "name": "Banat",
    "state_id": "38"
  },
  {
    "id": "4603",
    "name": "Banda",
    "state_id": "38"
  },
  {
    "id": "4604",
    "name": "Bangarmau",
    "state_id": "38"
  },
  {
    "id": "4605",
    "name": "Banki",
    "state_id": "38"
  },
  {
    "id": "4606",
    "name": "Bansdih",
    "state_id": "38"
  },
  {
    "id": "4607",
    "name": "Bansgaon",
    "state_id": "38"
  },
  {
    "id": "4608",
    "name": "Bansi",
    "state_id": "38"
  },
  {
    "id": "4609",
    "name": "Barabanki",
    "state_id": "38"
  },
  {
    "id": "4610",
    "name": "Baragaon",
    "state_id": "38"
  },
  {
    "id": "4611",
    "name": "Baraut",
    "state_id": "38"
  },
  {
    "id": "4612",
    "name": "Bareilly",
    "state_id": "38"
  },
  {
    "id": "4613",
    "name": "Bareilly Cantonment",
    "state_id": "38"
  },
  {
    "id": "4614",
    "name": "Barhalganj",
    "state_id": "38"
  },
  {
    "id": "4615",
    "name": "Barhani",
    "state_id": "38"
  },
  {
    "id": "4616",
    "name": "Barhapur",
    "state_id": "38"
  },
  {
    "id": "4617",
    "name": "Barkhera",
    "state_id": "38"
  },
  {
    "id": "4618",
    "name": "Barsana",
    "state_id": "38"
  },
  {
    "id": "4619",
    "name": "Barva Sagar",
    "state_id": "38"
  },
  {
    "id": "4620",
    "name": "Barwar",
    "state_id": "38"
  },
  {
    "id": "4621",
    "name": "Basti",
    "state_id": "38"
  },
  {
    "id": "4622",
    "name": "Begumabad Budhana",
    "state_id": "38"
  },
  {
    "id": "4623",
    "name": "Behat",
    "state_id": "38"
  },
  {
    "id": "4624",
    "name": "Behta Hajipur",
    "state_id": "38"
  },
  {
    "id": "4625",
    "name": "Bela",
    "state_id": "38"
  },
  {
    "id": "4626",
    "name": "Belthara",
    "state_id": "38"
  },
  {
    "id": "4627",
    "name": "Beniganj",
    "state_id": "38"
  },
  {
    "id": "4628",
    "name": "Beswan",
    "state_id": "38"
  },
  {
    "id": "4629",
    "name": "Bewar",
    "state_id": "38"
  },
  {
    "id": "4630",
    "name": "Bhadarsa",
    "state_id": "38"
  },
  {
    "id": "4631",
    "name": "Bhadohi",
    "state_id": "38"
  },
  {
    "id": "4632",
    "name": "Bhagwantnagar",
    "state_id": "38"
  },
  {
    "id": "4633",
    "name": "Bharatganj",
    "state_id": "38"
  },
  {
    "id": "4634",
    "name": "Bhargain",
    "state_id": "38"
  },
  {
    "id": "4635",
    "name": "Bharthana",
    "state_id": "38"
  },
  {
    "id": "4636",
    "name": "Bharuhana",
    "state_id": "38"
  },
  {
    "id": "4637",
    "name": "Bharwari",
    "state_id": "38"
  },
  {
    "id": "4638",
    "name": "Bhatni Bazar",
    "state_id": "38"
  },
  {
    "id": "4639",
    "name": "Bhatpar Rani",
    "state_id": "38"
  },
  {
    "id": "4640",
    "name": "Bhawan Bahadurnagar",
    "state_id": "38"
  },
  {
    "id": "4641",
    "name": "Bhinga",
    "state_id": "38"
  },
  {
    "id": "4642",
    "name": "Bhojpur Dharampur",
    "state_id": "38"
  },
  {
    "id": "4643",
    "name": "Bhokarhedi",
    "state_id": "38"
  },
  {
    "id": "4644",
    "name": "Bhongaon",
    "state_id": "38"
  },
  {
    "id": "4645",
    "name": "Bhulepur",
    "state_id": "38"
  },
  {
    "id": "4646",
    "name": "Bidhuna",
    "state_id": "38"
  },
  {
    "id": "4647",
    "name": "Bighapur",
    "state_id": "38"
  },
  {
    "id": "4648",
    "name": "Bijnor",
    "state_id": "38"
  },
  {
    "id": "4649",
    "name": "Bijpur",
    "state_id": "38"
  },
  {
    "id": "4650",
    "name": "Bikapur",
    "state_id": "38"
  },
  {
    "id": "4651",
    "name": "Bilari",
    "state_id": "38"
  },
  {
    "id": "4652",
    "name": "Bilaspur",
    "state_id": "38"
  },
  {
    "id": "4653",
    "name": "Bilgram",
    "state_id": "38"
  },
  {
    "id": "4654",
    "name": "Bilhaur",
    "state_id": "38"
  },
  {
    "id": "4655",
    "name": "Bilram",
    "state_id": "38"
  },
  {
    "id": "4656",
    "name": "Bilrayaganj",
    "state_id": "38"
  },
  {
    "id": "4657",
    "name": "Bilsanda",
    "state_id": "38"
  },
  {
    "id": "4658",
    "name": "Bilsi",
    "state_id": "38"
  },
  {
    "id": "4659",
    "name": "Bindki",
    "state_id": "38"
  },
  {
    "id": "4660",
    "name": "Bisalpur",
    "state_id": "38"
  },
  {
    "id": "4661",
    "name": "Bisanda Buzurg",
    "state_id": "38"
  },
  {
    "id": "4662",
    "name": "Bisauli",
    "state_id": "38"
  },
  {
    "id": "4663",
    "name": "Bisharatganj",
    "state_id": "38"
  },
  {
    "id": "4664",
    "name": "Bisokhar",
    "state_id": "38"
  },
  {
    "id": "4665",
    "name": "Biswan",
    "state_id": "38"
  },
  {
    "id": "4666",
    "name": "Bithur",
    "state_id": "38"
  },
  {
    "id": "4667",
    "name": "Budaun",
    "state_id": "38"
  },
  {
    "id": "4668",
    "name": "Bugrasi",
    "state_id": "38"
  },
  {
    "id": "4669",
    "name": "Bulandshahar",
    "state_id": "38"
  },
  {
    "id": "4670",
    "name": "Burhana",
    "state_id": "38"
  },
  {
    "id": "4671",
    "name": "Chail",
    "state_id": "38"
  },
  {
    "id": "4672",
    "name": "Chak Imam Ali",
    "state_id": "38"
  },
  {
    "id": "4673",
    "name": "Chakeri",
    "state_id": "38"
  },
  {
    "id": "4674",
    "name": "Chakia",
    "state_id": "38"
  },
  {
    "id": "4675",
    "name": "Chandauli",
    "state_id": "38"
  },
  {
    "id": "4676",
    "name": "Chandausi",
    "state_id": "38"
  },
  {
    "id": "4677",
    "name": "Chandpur",
    "state_id": "38"
  },
  {
    "id": "4678",
    "name": "Charkhari",
    "state_id": "38"
  },
  {
    "id": "4679",
    "name": "Charthawal",
    "state_id": "38"
  },
  {
    "id": "4680",
    "name": "Chaumuhan",
    "state_id": "38"
  },
  {
    "id": "4681",
    "name": "Chhaprauli",
    "state_id": "38"
  },
  {
    "id": "4682",
    "name": "Chhara Rafatpur",
    "state_id": "38"
  },
  {
    "id": "4683",
    "name": "Chharprauli",
    "state_id": "38"
  },
  {
    "id": "4684",
    "name": "Chhata",
    "state_id": "38"
  },
  {
    "id": "4685",
    "name": "Chhatari",
    "state_id": "38"
  },
  {
    "id": "4686",
    "name": "Chhibramau",
    "state_id": "38"
  },
  {
    "id": "4687",
    "name": "Chhutmalpur",
    "state_id": "38"
  },
  {
    "id": "4688",
    "name": "Chilkana Sultanpur",
    "state_id": "38"
  },
  {
    "id": "4689",
    "name": "Chirgaon",
    "state_id": "38"
  },
  {
    "id": "4690",
    "name": "Chit Baragaon",
    "state_id": "38"
  },
  {
    "id": "4691",
    "name": "Chitrakut Dham",
    "state_id": "38"
  },
  {
    "id": "4692",
    "name": "Chopan",
    "state_id": "38"
  },
  {
    "id": "4693",
    "name": "Choubepur Kalan",
    "state_id": "38"
  },
  {
    "id": "4694",
    "name": "Chunar",
    "state_id": "38"
  },
  {
    "id": "4695",
    "name": "Churk Ghurma",
    "state_id": "38"
  },
  {
    "id": "4696",
    "name": "Colonelganj",
    "state_id": "38"
  },
  {
    "id": "4697",
    "name": "Dadri",
    "state_id": "38"
  },
  {
    "id": "4698",
    "name": "Dalmau",
    "state_id": "38"
  },
  {
    "id": "4699",
    "name": "Dankaur",
    "state_id": "38"
  },
  {
    "id": "4700",
    "name": "Dariyabad",
    "state_id": "38"
  },
  {
    "id": "4701",
    "name": "Dasna",
    "state_id": "38"
  },
  {
    "id": "4702",
    "name": "Dataganj",
    "state_id": "38"
  },
  {
    "id": "4703",
    "name": "Daurala",
    "state_id": "38"
  },
  {
    "id": "4704",
    "name": "Dayal Bagh",
    "state_id": "38"
  },
  {
    "id": "4705",
    "name": "Deoband",
    "state_id": "38"
  },
  {
    "id": "4706",
    "name": "Deoranian",
    "state_id": "38"
  },
  {
    "id": "4707",
    "name": "Deoria",
    "state_id": "38"
  },
  {
    "id": "4708",
    "name": "Dewa",
    "state_id": "38"
  },
  {
    "id": "4709",
    "name": "Dhampur",
    "state_id": "38"
  },
  {
    "id": "4710",
    "name": "Dhanauha",
    "state_id": "38"
  },
  {
    "id": "4711",
    "name": "Dhanauli",
    "state_id": "38"
  },
  {
    "id": "4712",
    "name": "Dhanaura",
    "state_id": "38"
  },
  {
    "id": "4713",
    "name": "Dharoti Khurd",
    "state_id": "38"
  },
  {
    "id": "4714",
    "name": "Dhauratanda",
    "state_id": "38"
  },
  {
    "id": "4715",
    "name": "Dhaurhra",
    "state_id": "38"
  },
  {
    "id": "4716",
    "name": "Dibai",
    "state_id": "38"
  },
  {
    "id": "4717",
    "name": "Dibiyapur",
    "state_id": "38"
  },
  {
    "id": "4718",
    "name": "Dildarnagar Fatehpur",
    "state_id": "38"
  },
  {
    "id": "4719",
    "name": "Do Ghat",
    "state_id": "38"
  },
  {
    "id": "4720",
    "name": "Dohrighat",
    "state_id": "38"
  },
  {
    "id": "4721",
    "name": "Dostpur",
    "state_id": "38"
  },
  {
    "id": "4722",
    "name": "Dudhinagar",
    "state_id": "38"
  },
  {
    "id": "4723",
    "name": "Dulhipur",
    "state_id": "38"
  },
  {
    "id": "4724",
    "name": "Dundwaraganj",
    "state_id": "38"
  },
  {
    "id": "4725",
    "name": "Ekdil",
    "state_id": "38"
  },
  {
    "id": "4726",
    "name": "Erich",
    "state_id": "38"
  },
  {
    "id": "4727",
    "name": "Etah",
    "state_id": "38"
  },
  {
    "id": "4728",
    "name": "Etawah",
    "state_id": "38"
  },
  {
    "id": "4729",
    "name": "Faizabad",
    "state_id": "38"
  },
  {
    "id": "4730",
    "name": "Faizabad Cantonment",
    "state_id": "38"
  },
  {
    "id": "4731",
    "name": "Faizganj",
    "state_id": "38"
  },
  {
    "id": "4732",
    "name": "Farah",
    "state_id": "38"
  },
  {
    "id": "4733",
    "name": "Faridnagar",
    "state_id": "38"
  },
  {
    "id": "4734",
    "name": "Faridpur",
    "state_id": "38"
  },
  {
    "id": "4735",
    "name": "Faridpur Cantonment",
    "state_id": "38"
  },
  {
    "id": "4736",
    "name": "Fariha",
    "state_id": "38"
  },
  {
    "id": "4737",
    "name": "Farrukhabad",
    "state_id": "38"
  },
  {
    "id": "4738",
    "name": "Fatehabad",
    "state_id": "38"
  },
  {
    "id": "4739",
    "name": "Fatehganj Pashchimi",
    "state_id": "38"
  },
  {
    "id": "4740",
    "name": "Fatehganj Purvi",
    "state_id": "38"
  },
  {
    "id": "4741",
    "name": "Fatehgarh",
    "state_id": "38"
  },
  {
    "id": "4742",
    "name": "Fatehpur",
    "state_id": "38"
  },
  {
    "id": "4743",
    "name": "Fatehpur Chaurasi",
    "state_id": "38"
  },
  {
    "id": "4744",
    "name": "Fatehpur Sikri",
    "state_id": "38"
  },
  {
    "id": "4745",
    "name": "Firozabad",
    "state_id": "38"
  },
  {
    "id": "4746",
    "name": "Gajraula",
    "state_id": "38"
  },
  {
    "id": "4747",
    "name": "Ganga Ghat",
    "state_id": "38"
  },
  {
    "id": "4748",
    "name": "Gangapur",
    "state_id": "38"
  },
  {
    "id": "4749",
    "name": "Gangoh",
    "state_id": "38"
  },
  {
    "id": "4750",
    "name": "Ganj Muradabad",
    "state_id": "38"
  },
  {
    "id": "4751",
    "name": "Garautha",
    "state_id": "38"
  },
  {
    "id": "4752",
    "name": "Garhi Pukhta",
    "state_id": "38"
  },
  {
    "id": "4753",
    "name": "Garhmukteshwar",
    "state_id": "38"
  },
  {
    "id": "4754",
    "name": "Gaura Barahaj",
    "state_id": "38"
  },
  {
    "id": "4755",
    "name": "Gauri Bazar",
    "state_id": "38"
  },
  {
    "id": "4756",
    "name": "Gausganj",
    "state_id": "38"
  },
  {
    "id": "4757",
    "name": "Gawan",
    "state_id": "38"
  },
  {
    "id": "4758",
    "name": "Ghatampur",
    "state_id": "38"
  },
  {
    "id": "4759",
    "name": "Ghaziabad",
    "state_id": "38"
  },
  {
    "id": "4760",
    "name": "Ghazipur",
    "state_id": "38"
  },
  {
    "id": "4761",
    "name": "Ghiror",
    "state_id": "38"
  },
  {
    "id": "4762",
    "name": "Ghorawal",
    "state_id": "38"
  },
  {
    "id": "4763",
    "name": "Ghosi",
    "state_id": "38"
  },
  {
    "id": "4764",
    "name": "Ghosia Bazar",
    "state_id": "38"
  },
  {
    "id": "4765",
    "name": "Ghughuli",
    "state_id": "38"
  },
  {
    "id": "4766",
    "name": "Gohand",
    "state_id": "38"
  },
  {
    "id": "4767",
    "name": "Gokul",
    "state_id": "38"
  },
  {
    "id": "4768",
    "name": "Gola Bazar",
    "state_id": "38"
  },
  {
    "id": "4769",
    "name": "Gola Gokarannath",
    "state_id": "38"
  },
  {
    "id": "4770",
    "name": "Gonda",
    "state_id": "38"
  },
  {
    "id": "4771",
    "name": "Gopamau",
    "state_id": "38"
  },
  {
    "id": "4772",
    "name": "Gopiganj",
    "state_id": "38"
  },
  {
    "id": "4773",
    "name": "Gorakhpur",
    "state_id": "38"
  },
  {
    "id": "4774",
    "name": "Gosainganj",
    "state_id": "38"
  },
  {
    "id": "4775",
    "name": "Govardhan",
    "state_id": "38"
  },
  {
    "id": "4776",
    "name": "Greater Noida",
    "state_id": "38"
  },
  {
    "id": "4777",
    "name": "Gulaothi",
    "state_id": "38"
  },
  {
    "id": "4778",
    "name": "Gulariya",
    "state_id": "38"
  },
  {
    "id": "4779",
    "name": "Gulariya Bhindara",
    "state_id": "38"
  },
  {
    "id": "4780",
    "name": "Gunnaur",
    "state_id": "38"
  },
  {
    "id": "4781",
    "name": "Gursahaiganj",
    "state_id": "38"
  },
  {
    "id": "4782",
    "name": "Gursarai",
    "state_id": "38"
  },
  {
    "id": "4783",
    "name": "Gyanpur",
    "state_id": "38"
  },
  {
    "id": "4784",
    "name": "Hafizpur",
    "state_id": "38"
  },
  {
    "id": "4785",
    "name": "Haidergarh",
    "state_id": "38"
  },
  {
    "id": "4786",
    "name": "Haldaur",
    "state_id": "38"
  },
  {
    "id": "4787",
    "name": "Hamirpur",
    "state_id": "38"
  },
  {
    "id": "4788",
    "name": "Handia",
    "state_id": "38"
  },
  {
    "id": "4789",
    "name": "Hapur",
    "state_id": "38"
  },
  {
    "id": "4790",
    "name": "Hardoi",
    "state_id": "38"
  },
  {
    "id": "4791",
    "name": "Harduaganj",
    "state_id": "38"
  },
  {
    "id": "4792",
    "name": "Hargaon",
    "state_id": "38"
  },
  {
    "id": "4793",
    "name": "Hariharpur",
    "state_id": "38"
  },
  {
    "id": "4794",
    "name": "Harraiya",
    "state_id": "38"
  },
  {
    "id": "4795",
    "name": "Hasanpur",
    "state_id": "38"
  },
  {
    "id": "4796",
    "name": "Hasayan",
    "state_id": "38"
  },
  {
    "id": "4797",
    "name": "Hastinapur",
    "state_id": "38"
  },
  {
    "id": "4798",
    "name": "Hata",
    "state_id": "38"
  },
  {
    "id": "4799",
    "name": "Hathras",
    "state_id": "38"
  },
  {
    "id": "4800",
    "name": "Hyderabad",
    "state_id": "38"
  },
  {
    "id": "4801",
    "name": "Ibrahimpur",
    "state_id": "38"
  },
  {
    "id": "4802",
    "name": "Iglas",
    "state_id": "38"
  },
  {
    "id": "4803",
    "name": "Ikauna",
    "state_id": "38"
  },
  {
    "id": "4804",
    "name": "Iltifatganj Bazar",
    "state_id": "38"
  },
  {
    "id": "4805",
    "name": "Indian Telephone Industry Mank",
    "state_id": "38"
  },
  {
    "id": "4806",
    "name": "Islamnagar",
    "state_id": "38"
  },
  {
    "id": "4807",
    "name": "Itaunja",
    "state_id": "38"
  },
  {
    "id": "4808",
    "name": "Itimadpur",
    "state_id": "38"
  },
  {
    "id": "4809",
    "name": "Jagner",
    "state_id": "38"
  },
  {
    "id": "4810",
    "name": "Jahanabad",
    "state_id": "38"
  },
  {
    "id": "4811",
    "name": "Jahangirabad",
    "state_id": "38"
  },
  {
    "id": "4812",
    "name": "Jahangirpur",
    "state_id": "38"
  },
  {
    "id": "4813",
    "name": "Jais",
    "state_id": "38"
  },
  {
    "id": "4814",
    "name": "Jaithara",
    "state_id": "38"
  },
  {
    "id": "4815",
    "name": "Jalalabad",
    "state_id": "38"
  },
  {
    "id": "4816",
    "name": "Jalali",
    "state_id": "38"
  },
  {
    "id": "4817",
    "name": "Jalalpur",
    "state_id": "38"
  },
  {
    "id": "4818",
    "name": "Jalaun",
    "state_id": "38"
  },
  {
    "id": "4819",
    "name": "Jalesar",
    "state_id": "38"
  },
  {
    "id": "4820",
    "name": "Jamshila",
    "state_id": "38"
  },
  {
    "id": "4821",
    "name": "Jangipur",
    "state_id": "38"
  },
  {
    "id": "4822",
    "name": "Jansath",
    "state_id": "38"
  },
  {
    "id": "4823",
    "name": "Jarwal",
    "state_id": "38"
  },
  {
    "id": "4824",
    "name": "Jasrana",
    "state_id": "38"
  },
  {
    "id": "4825",
    "name": "Jaswantnagar",
    "state_id": "38"
  },
  {
    "id": "4826",
    "name": "Jatari",
    "state_id": "38"
  },
  {
    "id": "4827",
    "name": "Jaunpur",
    "state_id": "38"
  },
  {
    "id": "4828",
    "name": "Jewar",
    "state_id": "38"
  },
  {
    "id": "4829",
    "name": "Jhalu",
    "state_id": "38"
  },
  {
    "id": "4830",
    "name": "Jhansi",
    "state_id": "38"
  },
  {
    "id": "4831",
    "name": "Jhansi Cantonment",
    "state_id": "38"
  },
  {
    "id": "4832",
    "name": "Jhansi Railway Settlement",
    "state_id": "38"
  },
  {
    "id": "4833",
    "name": "Jhinjhak",
    "state_id": "38"
  },
  {
    "id": "4834",
    "name": "Jhinjhana",
    "state_id": "38"
  },
  {
    "id": "4835",
    "name": "Jhusi",
    "state_id": "38"
  },
  {
    "id": "4836",
    "name": "Jhusi Kohna",
    "state_id": "38"
  },
  {
    "id": "4837",
    "name": "Jiyanpur",
    "state_id": "38"
  },
  {
    "id": "4838",
    "name": "Joya",
    "state_id": "38"
  },
  {
    "id": "4839",
    "name": "Jyoti Khuria",
    "state_id": "38"
  },
  {
    "id": "4840",
    "name": "Jyotiba Phule Nagar",
    "state_id": "38"
  },
  {
    "id": "4841",
    "name": "Kabrai",
    "state_id": "38"
  },
  {
    "id": "4842",
    "name": "Kachhauna Patseni",
    "state_id": "38"
  },
  {
    "id": "4843",
    "name": "Kachhla",
    "state_id": "38"
  },
  {
    "id": "4844",
    "name": "Kachhwa",
    "state_id": "38"
  },
  {
    "id": "4845",
    "name": "Kadaura",
    "state_id": "38"
  },
  {
    "id": "4846",
    "name": "Kadipur",
    "state_id": "38"
  },
  {
    "id": "4847",
    "name": "Kailashpur",
    "state_id": "38"
  },
  {
    "id": "4848",
    "name": "Kaimganj",
    "state_id": "38"
  },
  {
    "id": "4849",
    "name": "Kairana",
    "state_id": "38"
  },
  {
    "id": "4850",
    "name": "Kakgaina",
    "state_id": "38"
  },
  {
    "id": "4851",
    "name": "Kakod",
    "state_id": "38"
  },
  {
    "id": "4852",
    "name": "Kakori",
    "state_id": "38"
  },
  {
    "id": "4853",
    "name": "Kakrala",
    "state_id": "38"
  },
  {
    "id": "4854",
    "name": "Kalinagar",
    "state_id": "38"
  },
  {
    "id": "4855",
    "name": "Kalpi",
    "state_id": "38"
  },
  {
    "id": "4856",
    "name": "Kamalganj",
    "state_id": "38"
  },
  {
    "id": "4857",
    "name": "Kampil",
    "state_id": "38"
  },
  {
    "id": "4858",
    "name": "Kandhla",
    "state_id": "38"
  },
  {
    "id": "4859",
    "name": "Kandwa",
    "state_id": "38"
  },
  {
    "id": "4860",
    "name": "Kannauj",
    "state_id": "38"
  },
  {
    "id": "4861",
    "name": "Kanpur",
    "state_id": "38"
  },
  {
    "id": "4862",
    "name": "Kant",
    "state_id": "38"
  },
  {
    "id": "4863",
    "name": "Kanth",
    "state_id": "38"
  },
  {
    "id": "4864",
    "name": "Kaptanganj",
    "state_id": "38"
  },
  {
    "id": "4865",
    "name": "Karaon",
    "state_id": "38"
  },
  {
    "id": "4866",
    "name": "Karari",
    "state_id": "38"
  },
  {
    "id": "4867",
    "name": "Karhal",
    "state_id": "38"
  },
  {
    "id": "4868",
    "name": "Karnawal",
    "state_id": "38"
  },
  {
    "id": "4869",
    "name": "Kasganj",
    "state_id": "38"
  },
  {
    "id": "4870",
    "name": "Katariya",
    "state_id": "38"
  },
  {
    "id": "4871",
    "name": "Katghar Lalganj",
    "state_id": "38"
  },
  {
    "id": "4872",
    "name": "Kathera",
    "state_id": "38"
  },
  {
    "id": "4873",
    "name": "Katra",
    "state_id": "38"
  },
  {
    "id": "4874",
    "name": "Katra Medniganj",
    "state_id": "38"
  },
  {
    "id": "4875",
    "name": "Kauriaganj",
    "state_id": "38"
  },
  {
    "id": "4876",
    "name": "Kemri",
    "state_id": "38"
  },
  {
    "id": "4877",
    "name": "Kerakat",
    "state_id": "38"
  },
  {
    "id": "4878",
    "name": "Khadda",
    "state_id": "38"
  },
  {
    "id": "4879",
    "name": "Khaga",
    "state_id": "38"
  },
  {
    "id": "4880",
    "name": "Khailar",
    "state_id": "38"
  },
  {
    "id": "4881",
    "name": "Khair",
    "state_id": "38"
  },
  {
    "id": "4882",
    "name": "Khairabad",
    "state_id": "38"
  },
  {
    "id": "4883",
    "name": "Khairagarh",
    "state_id": "38"
  },
  {
    "id": "4884",
    "name": "Khalilabad",
    "state_id": "38"
  },
  {
    "id": "4885",
    "name": "Khamaria",
    "state_id": "38"
  },
  {
    "id": "4886",
    "name": "Khanpur",
    "state_id": "38"
  },
  {
    "id": "4887",
    "name": "Kharela",
    "state_id": "38"
  },
  {
    "id": "4888",
    "name": "Khargupur",
    "state_id": "38"
  },
  {
    "id": "4889",
    "name": "Khariya",
    "state_id": "38"
  },
  {
    "id": "4890",
    "name": "Kharkhoda",
    "state_id": "38"
  },
  {
    "id": "4891",
    "name": "Khatauli",
    "state_id": "38"
  },
  {
    "id": "4892",
    "name": "Khatauli Rural",
    "state_id": "38"
  },
  {
    "id": "4893",
    "name": "Khekra",
    "state_id": "38"
  },
  {
    "id": "4894",
    "name": "Kheri",
    "state_id": "38"
  },
  {
    "id": "4895",
    "name": "Kheta Sarai",
    "state_id": "38"
  },
  {
    "id": "4896",
    "name": "Khudaganj",
    "state_id": "38"
  },
  {
    "id": "4897",
    "name": "Khurja",
    "state_id": "38"
  },
  {
    "id": "4898",
    "name": "Khutar",
    "state_id": "38"
  },
  {
    "id": "4899",
    "name": "Kiraoli",
    "state_id": "38"
  },
  {
    "id": "4900",
    "name": "Kiratpur",
    "state_id": "38"
  },
  {
    "id": "4901",
    "name": "Kishanpur",
    "state_id": "38"
  },
  {
    "id": "4902",
    "name": "Kishni",
    "state_id": "38"
  },
  {
    "id": "4903",
    "name": "Kithaur",
    "state_id": "38"
  },
  {
    "id": "4904",
    "name": "Koiripur",
    "state_id": "38"
  },
  {
    "id": "4905",
    "name": "Konch",
    "state_id": "38"
  },
  {
    "id": "4906",
    "name": "Kopaganj",
    "state_id": "38"
  },
  {
    "id": "4907",
    "name": "Kora Jahanabad",
    "state_id": "38"
  },
  {
    "id": "4908",
    "name": "Korwa",
    "state_id": "38"
  },
  {
    "id": "4909",
    "name": "Kosi Kalan",
    "state_id": "38"
  },
  {
    "id": "4910",
    "name": "Kota",
    "state_id": "38"
  },
  {
    "id": "4911",
    "name": "Kotra",
    "state_id": "38"
  },
  {
    "id": "4912",
    "name": "Kotwa",
    "state_id": "38"
  },
  {
    "id": "4913",
    "name": "Kulpahar",
    "state_id": "38"
  },
  {
    "id": "4914",
    "name": "Kunda",
    "state_id": "38"
  },
  {
    "id": "4915",
    "name": "Kundarki",
    "state_id": "38"
  },
  {
    "id": "4916",
    "name": "Kunwargaon",
    "state_id": "38"
  },
  {
    "id": "4917",
    "name": "Kurara",
    "state_id": "38"
  },
  {
    "id": "4918",
    "name": "Kurawali",
    "state_id": "38"
  },
  {
    "id": "4919",
    "name": "Kursath",
    "state_id": "38"
  },
  {
    "id": "4920",
    "name": "Kurthi Jafarpur",
    "state_id": "38"
  },
  {
    "id": "4921",
    "name": "Kushinagar",
    "state_id": "38"
  },
  {
    "id": "4922",
    "name": "Kusmara",
    "state_id": "38"
  },
  {
    "id": "4923",
    "name": "Laharpur",
    "state_id": "38"
  },
  {
    "id": "4924",
    "name": "Lakhimpur",
    "state_id": "38"
  },
  {
    "id": "4925",
    "name": "Lakhna",
    "state_id": "38"
  },
  {
    "id": "4926",
    "name": "Lalganj",
    "state_id": "38"
  },
  {
    "id": "4927",
    "name": "Lalitpur",
    "state_id": "38"
  },
  {
    "id": "4928",
    "name": "Lar",
    "state_id": "38"
  },
  {
    "id": "4929",
    "name": "Lawar",
    "state_id": "38"
  },
  {
    "id": "4930",
    "name": "Ledwa Mahuwa",
    "state_id": "38"
  },
  {
    "id": "4931",
    "name": "Lohta",
    "state_id": "38"
  },
  {
    "id": "4932",
    "name": "Loni",
    "state_id": "38"
  },
  {
    "id": "4933",
    "name": "Lucknow",
    "state_id": "38"
  },
  {
    "id": "4934",
    "name": "Machhlishahr",
    "state_id": "38"
  },
  {
    "id": "4935",
    "name": "Madhoganj",
    "state_id": "38"
  },
  {
    "id": "4936",
    "name": "Madhogarh",
    "state_id": "38"
  },
  {
    "id": "4937",
    "name": "Maghar",
    "state_id": "38"
  },
  {
    "id": "4938",
    "name": "Mahaban",
    "state_id": "38"
  },
  {
    "id": "4939",
    "name": "Maharajganj",
    "state_id": "38"
  },
  {
    "id": "4940",
    "name": "Mahmudabad",
    "state_id": "38"
  },
  {
    "id": "4941",
    "name": "Mahoba",
    "state_id": "38"
  },
  {
    "id": "4942",
    "name": "Maholi",
    "state_id": "38"
  },
  {
    "id": "4943",
    "name": "Mahona",
    "state_id": "38"
  },
  {
    "id": "4944",
    "name": "Mahroni",
    "state_id": "38"
  },
  {
    "id": "4945",
    "name": "Mailani",
    "state_id": "38"
  },
  {
    "id": "4946",
    "name": "Mainpuri",
    "state_id": "38"
  },
  {
    "id": "4947",
    "name": "Majhara Pipar Ehatmali",
    "state_id": "38"
  },
  {
    "id": "4948",
    "name": "Majhauli Raj",
    "state_id": "38"
  },
  {
    "id": "4949",
    "name": "Malihabad",
    "state_id": "38"
  },
  {
    "id": "4950",
    "name": "Mallanwam",
    "state_id": "38"
  },
  {
    "id": "4951",
    "name": "Mandawar",
    "state_id": "38"
  },
  {
    "id": "4952",
    "name": "Manikpur",
    "state_id": "38"
  },
  {
    "id": "4953",
    "name": "Maniyar",
    "state_id": "38"
  },
  {
    "id": "4954",
    "name": "Manjhanpur",
    "state_id": "38"
  },
  {
    "id": "4955",
    "name": "Mankapur",
    "state_id": "38"
  },
  {
    "id": "4956",
    "name": "Marehra",
    "state_id": "38"
  },
  {
    "id": "4957",
    "name": "Mariahu",
    "state_id": "38"
  },
  {
    "id": "4958",
    "name": "Maruadih",
    "state_id": "38"
  },
  {
    "id": "4959",
    "name": "Maswasi",
    "state_id": "38"
  },
  {
    "id": "4960",
    "name": "Mataundh",
    "state_id": "38"
  },
  {
    "id": "4961",
    "name": "Mathu",
    "state_id": "38"
  },
  {
    "id": "4962",
    "name": "Mathura",
    "state_id": "38"
  },
  {
    "id": "4963",
    "name": "Mathura Cantonment",
    "state_id": "38"
  },
  {
    "id": "4964",
    "name": "Mau",
    "state_id": "38"
  },
  {
    "id": "4965",
    "name": "Mau Aima",
    "state_id": "38"
  },
  {
    "id": "4966",
    "name": "Maudaha",
    "state_id": "38"
  },
  {
    "id": "4967",
    "name": "Mauranipur",
    "state_id": "38"
  },
  {
    "id": "4968",
    "name": "Maurawan",
    "state_id": "38"
  },
  {
    "id": "4969",
    "name": "Mawana",
    "state_id": "38"
  },
  {
    "id": "4970",
    "name": "Meerut",
    "state_id": "38"
  },
  {
    "id": "4971",
    "name": "Mehnagar",
    "state_id": "38"
  },
  {
    "id": "4972",
    "name": "Mehndawal",
    "state_id": "38"
  },
  {
    "id": "4973",
    "name": "Mendu",
    "state_id": "38"
  },
  {
    "id": "4974",
    "name": "Milak",
    "state_id": "38"
  },
  {
    "id": "4975",
    "name": "Miranpur",
    "state_id": "38"
  },
  {
    "id": "4976",
    "name": "Mirat",
    "state_id": "38"
  },
  {
    "id": "4977",
    "name": "Mirat Cantonment",
    "state_id": "38"
  },
  {
    "id": "4978",
    "name": "Mirganj",
    "state_id": "38"
  },
  {
    "id": "4979",
    "name": "Mirzapur",
    "state_id": "38"
  },
  {
    "id": "4980",
    "name": "Misrikh",
    "state_id": "38"
  },
  {
    "id": "4981",
    "name": "Modinagar",
    "state_id": "38"
  },
  {
    "id": "4982",
    "name": "Mogra Badshahpur",
    "state_id": "38"
  },
  {
    "id": "4983",
    "name": "Mohan",
    "state_id": "38"
  },
  {
    "id": "4984",
    "name": "Mohanpur",
    "state_id": "38"
  },
  {
    "id": "4985",
    "name": "Mohiuddinpur",
    "state_id": "38"
  },
  {
    "id": "4986",
    "name": "Moradabad",
    "state_id": "38"
  },
  {
    "id": "4987",
    "name": "Moth",
    "state_id": "38"
  },
  {
    "id": "4988",
    "name": "Mubarakpur",
    "state_id": "38"
  },
  {
    "id": "4989",
    "name": "Mughal Sarai",
    "state_id": "38"
  },
  {
    "id": "4990",
    "name": "Mughal Sarai Railway Settlemen",
    "state_id": "38"
  },
  {
    "id": "4991",
    "name": "Muhammadabad",
    "state_id": "38"
  },
  {
    "id": "4992",
    "name": "Muhammadi",
    "state_id": "38"
  },
  {
    "id": "4993",
    "name": "Mukrampur Khema",
    "state_id": "38"
  },
  {
    "id": "4994",
    "name": "Mundia",
    "state_id": "38"
  },
  {
    "id": "4995",
    "name": "Mundora",
    "state_id": "38"
  },
  {
    "id": "4996",
    "name": "Muradnagar",
    "state_id": "38"
  },
  {
    "id": "4997",
    "name": "Mursan",
    "state_id": "38"
  },
  {
    "id": "4998",
    "name": "Musafirkhana",
    "state_id": "38"
  },
  {
    "id": "4999",
    "name": "Muzaffarnagar",
    "state_id": "38"
  },
  {
    "id": "5000",
    "name": "Nadigaon",
    "state_id": "38"
  },
  {
    "id": "5001",
    "name": "Nagina",
    "state_id": "38"
  },
  {
    "id": "5002",
    "name": "Nagram",
    "state_id": "38"
  },
  {
    "id": "5003",
    "name": "Nai Bazar",
    "state_id": "38"
  },
  {
    "id": "5004",
    "name": "Nainana Jat",
    "state_id": "38"
  },
  {
    "id": "5005",
    "name": "Najibabad",
    "state_id": "38"
  },
  {
    "id": "5006",
    "name": "Nakur",
    "state_id": "38"
  },
  {
    "id": "5007",
    "name": "Nanaunta",
    "state_id": "38"
  },
  {
    "id": "5008",
    "name": "Nandgaon",
    "state_id": "38"
  },
  {
    "id": "5009",
    "name": "Nanpara",
    "state_id": "38"
  },
  {
    "id": "5010",
    "name": "Naraini",
    "state_id": "38"
  },
  {
    "id": "5011",
    "name": "Narauli",
    "state_id": "38"
  },
  {
    "id": "5012",
    "name": "Naraura",
    "state_id": "38"
  },
  {
    "id": "5013",
    "name": "Naugawan Sadat",
    "state_id": "38"
  },
  {
    "id": "5014",
    "name": "Nautanwa",
    "state_id": "38"
  },
  {
    "id": "5015",
    "name": "Nawabganj",
    "state_id": "38"
  },
  {
    "id": "5016",
    "name": "Nichlaul",
    "state_id": "38"
  },
  {
    "id": "5017",
    "name": "Nidhauli Kalan",
    "state_id": "38"
  },
  {
    "id": "5018",
    "name": "Nihtaur",
    "state_id": "38"
  },
  {
    "id": "5019",
    "name": "Nindaura",
    "state_id": "38"
  },
  {
    "id": "5020",
    "name": "Niwari",
    "state_id": "38"
  },
  {
    "id": "5021",
    "name": "Nizamabad",
    "state_id": "38"
  },
  {
    "id": "5022",
    "name": "Noida",
    "state_id": "38"
  },
  {
    "id": "5023",
    "name": "Northern Railway Colony",
    "state_id": "38"
  },
  {
    "id": "5024",
    "name": "Nurpur",
    "state_id": "38"
  },
  {
    "id": "5025",
    "name": "Nyoria Husenpur",
    "state_id": "38"
  },
  {
    "id": "5026",
    "name": "Nyotini",
    "state_id": "38"
  },
  {
    "id": "5027",
    "name": "Obra",
    "state_id": "38"
  },
  {
    "id": "5028",
    "name": "Oel Dhakwa",
    "state_id": "38"
  },
  {
    "id": "5029",
    "name": "Orai",
    "state_id": "38"
  },
  {
    "id": "5030",
    "name": "Oran",
    "state_id": "38"
  },
  {
    "id": "5031",
    "name": "Ordinance Factory Muradnagar",
    "state_id": "38"
  },
  {
    "id": "5032",
    "name": "Pachperwa",
    "state_id": "38"
  },
  {
    "id": "5033",
    "name": "Padrauna",
    "state_id": "38"
  },
  {
    "id": "5034",
    "name": "Pahasu",
    "state_id": "38"
  },
  {
    "id": "5035",
    "name": "Paintepur",
    "state_id": "38"
  },
  {
    "id": "5036",
    "name": "Pali",
    "state_id": "38"
  },
  {
    "id": "5037",
    "name": "Palia Kalan",
    "state_id": "38"
  },
  {
    "id": "5038",
    "name": "Parasi",
    "state_id": "38"
  },
  {
    "id": "5039",
    "name": "Parichha",
    "state_id": "38"
  },
  {
    "id": "5040",
    "name": "Parichhatgarh",
    "state_id": "38"
  },
  {
    "id": "5041",
    "name": "Parsadepur",
    "state_id": "38"
  },
  {
    "id": "5042",
    "name": "Patala",
    "state_id": "38"
  },
  {
    "id": "5043",
    "name": "Patiyali",
    "state_id": "38"
  },
  {
    "id": "5044",
    "name": "Patti",
    "state_id": "38"
  },
  {
    "id": "5045",
    "name": "Pawayan",
    "state_id": "38"
  },
  {
    "id": "5046",
    "name": "Phalauda",
    "state_id": "38"
  },
  {
    "id": "5047",
    "name": "Phaphund",
    "state_id": "38"
  },
  {
    "id": "5048",
    "name": "Phulpur",
    "state_id": "38"
  },
  {
    "id": "5049",
    "name": "Phulwaria",
    "state_id": "38"
  },
  {
    "id": "5050",
    "name": "Pihani",
    "state_id": "38"
  },
  {
    "id": "5051",
    "name": "Pilibhit",
    "state_id": "38"
  },
  {
    "id": "5052",
    "name": "Pilkana",
    "state_id": "38"
  },
  {
    "id": "5053",
    "name": "Pilkhuwa",
    "state_id": "38"
  },
  {
    "id": "5054",
    "name": "Pinahat",
    "state_id": "38"
  },
  {
    "id": "5055",
    "name": "Pipalsana Chaudhari",
    "state_id": "38"
  },
  {
    "id": "5056",
    "name": "Pipiganj",
    "state_id": "38"
  },
  {
    "id": "5057",
    "name": "Pipraich",
    "state_id": "38"
  },
  {
    "id": "5058",
    "name": "Pipri",
    "state_id": "38"
  },
  {
    "id": "5059",
    "name": "Pratapgarh",
    "state_id": "38"
  },
  {
    "id": "5060",
    "name": "Pukhrayan",
    "state_id": "38"
  },
  {
    "id": "5061",
    "name": "Puranpur",
    "state_id": "38"
  },
  {
    "id": "5062",
    "name": "Purdil Nagar",
    "state_id": "38"
  },
  {
    "id": "5063",
    "name": "Purqazi",
    "state_id": "38"
  },
  {
    "id": "5064",
    "name": "Purwa",
    "state_id": "38"
  },
  {
    "id": "5065",
    "name": "Qasimpur",
    "state_id": "38"
  },
  {
    "id": "5066",
    "name": "Rabupura",
    "state_id": "38"
  },
  {
    "id": "5067",
    "name": "Radha Kund",
    "state_id": "38"
  },
  {
    "id": "5068",
    "name": "Rae Bareilly",
    "state_id": "38"
  },
  {
    "id": "5069",
    "name": "Raja Ka Rampur",
    "state_id": "38"
  },
  {
    "id": "5070",
    "name": "Rajapur",
    "state_id": "38"
  },
  {
    "id": "5071",
    "name": "Ramkola",
    "state_id": "38"
  },
  {
    "id": "5072",
    "name": "Ramnagar",
    "state_id": "38"
  },
  {
    "id": "5073",
    "name": "Rampur",
    "state_id": "38"
  },
  {
    "id": "5074",
    "name": "Rampur Bhawanipur",
    "state_id": "38"
  },
  {
    "id": "5075",
    "name": "Rampur Karkhana",
    "state_id": "38"
  },
  {
    "id": "5076",
    "name": "Rampur Maniharan",
    "state_id": "38"
  },
  {
    "id": "5077",
    "name": "Rampura",
    "state_id": "38"
  },
  {
    "id": "5078",
    "name": "Ranipur",
    "state_id": "38"
  },
  {
    "id": "5079",
    "name": "Rashidpur Garhi",
    "state_id": "38"
  },
  {
    "id": "5080",
    "name": "Rasra",
    "state_id": "38"
  },
  {
    "id": "5081",
    "name": "Rasulabad",
    "state_id": "38"
  },
  {
    "id": "5082",
    "name": "Rath",
    "state_id": "38"
  },
  {
    "id": "5083",
    "name": "Raya",
    "state_id": "38"
  },
  {
    "id": "5084",
    "name": "Renukut",
    "state_id": "38"
  },
  {
    "id": "5085",
    "name": "Reoti",
    "state_id": "38"
  },
  {
    "id": "5086",
    "name": "Richha",
    "state_id": "38"
  },
  {
    "id": "5087",
    "name": "Risia Bazar",
    "state_id": "38"
  },
  {
    "id": "5088",
    "name": "Rithora",
    "state_id": "38"
  },
  {
    "id": "5089",
    "name": "Robertsganj",
    "state_id": "38"
  },
  {
    "id": "5090",
    "name": "Roza",
    "state_id": "38"
  },
  {
    "id": "5091",
    "name": "Rudarpur",
    "state_id": "38"
  },
  {
    "id": "5092",
    "name": "Rudauli",
    "state_id": "38"
  },
  {
    "id": "5093",
    "name": "Rudayan",
    "state_id": "38"
  },
  {
    "id": "5094",
    "name": "Rura",
    "state_id": "38"
  },
  {
    "id": "5095",
    "name": "Rustamnagar Sahaspur",
    "state_id": "38"
  },
  {
    "id": "5096",
    "name": "Sabatwar",
    "state_id": "38"
  },
  {
    "id": "5097",
    "name": "Sadabad",
    "state_id": "38"
  },
  {
    "id": "5098",
    "name": "Sadat",
    "state_id": "38"
  },
  {
    "id": "5099",
    "name": "Safipur",
    "state_id": "38"
  },
  {
    "id": "5100",
    "name": "Sahanpur",
    "state_id": "38"
  },
  {
    "id": "5101",
    "name": "Saharanpur",
    "state_id": "38"
  },
  {
    "id": "5102",
    "name": "Sahaspur",
    "state_id": "38"
  },
  {
    "id": "5103",
    "name": "Sahaswan",
    "state_id": "38"
  },
  {
    "id": "5104",
    "name": "Sahawar",
    "state_id": "38"
  },
  {
    "id": "5105",
    "name": "Sahibabad",
    "state_id": "38"
  },
  {
    "id": "5106",
    "name": "Sahjanwa",
    "state_id": "38"
  },
  {
    "id": "5107",
    "name": "Sahpau",
    "state_id": "38"
  },
  {
    "id": "5108",
    "name": "Saidpur",
    "state_id": "38"
  },
  {
    "id": "5109",
    "name": "Sainthal",
    "state_id": "38"
  },
  {
    "id": "5110",
    "name": "Saiyadraja",
    "state_id": "38"
  },
  {
    "id": "5111",
    "name": "Sakhanu",
    "state_id": "38"
  },
  {
    "id": "5112",
    "name": "Sakit",
    "state_id": "38"
  },
  {
    "id": "5113",
    "name": "Salarpur Khadar",
    "state_id": "38"
  },
  {
    "id": "5114",
    "name": "Salimpur",
    "state_id": "38"
  },
  {
    "id": "5115",
    "name": "Salon",
    "state_id": "38"
  },
  {
    "id": "5116",
    "name": "Sambhal",
    "state_id": "38"
  },
  {
    "id": "5117",
    "name": "Sambhawali",
    "state_id": "38"
  },
  {
    "id": "5118",
    "name": "Samdhan",
    "state_id": "38"
  },
  {
    "id": "5119",
    "name": "Samthar",
    "state_id": "38"
  },
  {
    "id": "5120",
    "name": "Sandi",
    "state_id": "38"
  },
  {
    "id": "5121",
    "name": "Sandila",
    "state_id": "38"
  },
  {
    "id": "5122",
    "name": "Sarai Mir",
    "state_id": "38"
  },
  {
    "id": "5123",
    "name": "Sarai akil",
    "state_id": "38"
  },
  {
    "id": "5124",
    "name": "Sarauli",
    "state_id": "38"
  },
  {
    "id": "5125",
    "name": "Sardhana",
    "state_id": "38"
  },
  {
    "id": "5126",
    "name": "Sarila",
    "state_id": "38"
  },
  {
    "id": "5127",
    "name": "Sarsawan",
    "state_id": "38"
  },
  {
    "id": "5128",
    "name": "Sasni",
    "state_id": "38"
  },
  {
    "id": "5129",
    "name": "Satrikh",
    "state_id": "38"
  },
  {
    "id": "5130",
    "name": "Saunkh",
    "state_id": "38"
  },
  {
    "id": "5131",
    "name": "Saurikh",
    "state_id": "38"
  },
  {
    "id": "5132",
    "name": "Seohara",
    "state_id": "38"
  },
  {
    "id": "5133",
    "name": "Sewal Khas",
    "state_id": "38"
  },
  {
    "id": "5134",
    "name": "Sewarhi",
    "state_id": "38"
  },
  {
    "id": "5135",
    "name": "Shahabad",
    "state_id": "38"
  },
  {
    "id": "5136",
    "name": "Shahganj",
    "state_id": "38"
  },
  {
    "id": "5137",
    "name": "Shahi",
    "state_id": "38"
  },
  {
    "id": "5138",
    "name": "Shahjahanpur",
    "state_id": "38"
  },
  {
    "id": "5139",
    "name": "Shahjahanpur Cantonment",
    "state_id": "38"
  },
  {
    "id": "5140",
    "name": "Shahpur",
    "state_id": "38"
  },
  {
    "id": "5141",
    "name": "Shamli",
    "state_id": "38"
  },
  {
    "id": "5142",
    "name": "Shamsabad",
    "state_id": "38"
  },
  {
    "id": "5143",
    "name": "Shankargarh",
    "state_id": "38"
  },
  {
    "id": "5144",
    "name": "Shergarh",
    "state_id": "38"
  },
  {
    "id": "5145",
    "name": "Sherkot",
    "state_id": "38"
  },
  {
    "id": "5146",
    "name": "Shikarpur",
    "state_id": "38"
  },
  {
    "id": "5147",
    "name": "Shikohabad",
    "state_id": "38"
  },
  {
    "id": "5148",
    "name": "Shisgarh",
    "state_id": "38"
  },
  {
    "id": "5149",
    "name": "Shivdaspur",
    "state_id": "38"
  },
  {
    "id": "5150",
    "name": "Shivli",
    "state_id": "38"
  },
  {
    "id": "5151",
    "name": "Shivrajpur",
    "state_id": "38"
  },
  {
    "id": "5152",
    "name": "Shohratgarh",
    "state_id": "38"
  },
  {
    "id": "5153",
    "name": "Siddhanur",
    "state_id": "38"
  },
  {
    "id": "5154",
    "name": "Siddharthnagar",
    "state_id": "38"
  },
  {
    "id": "5155",
    "name": "Sidhauli",
    "state_id": "38"
  },
  {
    "id": "5156",
    "name": "Sidhpura",
    "state_id": "38"
  },
  {
    "id": "5157",
    "name": "Sikandarabad",
    "state_id": "38"
  },
  {
    "id": "5158",
    "name": "Sikandarpur",
    "state_id": "38"
  },
  {
    "id": "5159",
    "name": "Sikandra",
    "state_id": "38"
  },
  {
    "id": "5160",
    "name": "Sikandra Rao",
    "state_id": "38"
  },
  {
    "id": "5161",
    "name": "Singahi Bhiraura",
    "state_id": "38"
  },
  {
    "id": "5162",
    "name": "Sirathu",
    "state_id": "38"
  },
  {
    "id": "5163",
    "name": "Sirsa",
    "state_id": "38"
  },
  {
    "id": "5164",
    "name": "Sirsaganj",
    "state_id": "38"
  },
  {
    "id": "5165",
    "name": "Sirsi",
    "state_id": "38"
  },
  {
    "id": "5166",
    "name": "Sisauli",
    "state_id": "38"
  },
  {
    "id": "5167",
    "name": "Siswa Bazar",
    "state_id": "38"
  },
  {
    "id": "5168",
    "name": "Sitapur",
    "state_id": "38"
  },
  {
    "id": "5169",
    "name": "Siyana",
    "state_id": "38"
  },
  {
    "id": "5170",
    "name": "Som",
    "state_id": "38"
  },
  {
    "id": "5171",
    "name": "Sonbhadra",
    "state_id": "38"
  },
  {
    "id": "5172",
    "name": "Soron",
    "state_id": "38"
  },
  {
    "id": "5173",
    "name": "Suar",
    "state_id": "38"
  },
  {
    "id": "5174",
    "name": "Sukhmalpur Nizamabad",
    "state_id": "38"
  },
  {
    "id": "5175",
    "name": "Sultanpur",
    "state_id": "38"
  },
  {
    "id": "5176",
    "name": "Sumerpur",
    "state_id": "38"
  },
  {
    "id": "5177",
    "name": "Suriyawan",
    "state_id": "38"
  },
  {
    "id": "5178",
    "name": "Swamibagh",
    "state_id": "38"
  },
  {
    "id": "5179",
    "name": "Tajpur",
    "state_id": "38"
  },
  {
    "id": "5180",
    "name": "Talbahat",
    "state_id": "38"
  },
  {
    "id": "5181",
    "name": "Talgram",
    "state_id": "38"
  },
  {
    "id": "5182",
    "name": "Tambaur",
    "state_id": "38"
  },
  {
    "id": "5183",
    "name": "Tanda",
    "state_id": "38"
  },
  {
    "id": "5184",
    "name": "Tatarpur Lallu",
    "state_id": "38"
  },
  {
    "id": "5185",
    "name": "Tetribazar",
    "state_id": "38"
  },
  {
    "id": "5186",
    "name": "Thakurdwara",
    "state_id": "38"
  },
  {
    "id": "5187",
    "name": "Thana Bhawan",
    "state_id": "38"
  },
  {
    "id": "5188",
    "name": "Thiriya Nizamat Khan",
    "state_id": "38"
  },
  {
    "id": "5189",
    "name": "Tikaitnagar",
    "state_id": "38"
  },
  {
    "id": "5190",
    "name": "Tikri",
    "state_id": "38"
  },
  {
    "id": "5191",
    "name": "Tilhar",
    "state_id": "38"
  },
  {
    "id": "5192",
    "name": "Tindwari",
    "state_id": "38"
  },
  {
    "id": "5193",
    "name": "Tirwaganj",
    "state_id": "38"
  },
  {
    "id": "5194",
    "name": "Titron",
    "state_id": "38"
  },
  {
    "id": "5195",
    "name": "Tori Fatehpur",
    "state_id": "38"
  },
  {
    "id": "5196",
    "name": "Tulsipur",
    "state_id": "38"
  },
  {
    "id": "5197",
    "name": "Tundla",
    "state_id": "38"
  },
  {
    "id": "5198",
    "name": "Tundla Kham",
    "state_id": "38"
  },
  {
    "id": "5199",
    "name": "Tundla Railway Colony",
    "state_id": "38"
  },
  {
    "id": "5200",
    "name": "Ugu",
    "state_id": "38"
  },
  {
    "id": "5201",
    "name": "Ujhani",
    "state_id": "38"
  },
  {
    "id": "5202",
    "name": "Ujhari",
    "state_id": "38"
  },
  {
    "id": "5203",
    "name": "Umri",
    "state_id": "38"
  },
  {
    "id": "5204",
    "name": "Umri Kalan",
    "state_id": "38"
  },
  {
    "id": "5205",
    "name": "Un",
    "state_id": "38"
  },
  {
    "id": "5206",
    "name": "Unchahar",
    "state_id": "38"
  },
  {
    "id": "5207",
    "name": "Unnao",
    "state_id": "38"
  },
  {
    "id": "5208",
    "name": "Usaihat",
    "state_id": "38"
  },
  {
    "id": "5209",
    "name": "Usawan",
    "state_id": "38"
  },
  {
    "id": "5210",
    "name": "Utraula",
    "state_id": "38"
  },
  {
    "id": "5211",
    "name": "Varanasi",
    "state_id": "38"
  },
  {
    "id": "5212",
    "name": "Varanasi Cantonment",
    "state_id": "38"
  },
  {
    "id": "5213",
    "name": "Vijaigarh",
    "state_id": "38"
  },
  {
    "id": "5214",
    "name": "Vrindavan",
    "state_id": "38"
  },
  {
    "id": "5215",
    "name": "Wazirganj",
    "state_id": "38"
  },
  {
    "id": "5216",
    "name": "Zafarabad",
    "state_id": "38"
  },
  {
    "id": "5217",
    "name": "Zaidpur",
    "state_id": "38"
  },
  {
    "id": "5218",
    "name": "Zamania",
    "state_id": "38"
  },
  {
    "id": "5219",
    "name": "Almora",
    "state_id": "39"
  },
  {
    "id": "5220",
    "name": "Almora Cantonment",
    "state_id": "39"
  },
  {
    "id": "5221",
    "name": "Badrinathpuri",
    "state_id": "39"
  },
  {
    "id": "5222",
    "name": "Bageshwar",
    "state_id": "39"
  },
  {
    "id": "5223",
    "name": "Bah Bazar",
    "state_id": "39"
  },
  {
    "id": "5224",
    "name": "Banbasa",
    "state_id": "39"
  },
  {
    "id": "5225",
    "name": "Bandia",
    "state_id": "39"
  },
  {
    "id": "5226",
    "name": "Barkot",
    "state_id": "39"
  },
  {
    "id": "5227",
    "name": "Bazpur",
    "state_id": "39"
  },
  {
    "id": "5228",
    "name": "Bhim Tal",
    "state_id": "39"
  },
  {
    "id": "5229",
    "name": "Bhowali",
    "state_id": "39"
  },
  {
    "id": "5230",
    "name": "Chakrata",
    "state_id": "39"
  },
  {
    "id": "5231",
    "name": "Chamba",
    "state_id": "39"
  },
  {
    "id": "5232",
    "name": "Chamoli and Gopeshwar",
    "state_id": "39"
  },
  {
    "id": "5233",
    "name": "Champawat",
    "state_id": "39"
  },
  {
    "id": "5234",
    "name": "Clement Town",
    "state_id": "39"
  },
  {
    "id": "5235",
    "name": "Dehra Dun Cantonment",
    "state_id": "39"
  },
  {
    "id": "5236",
    "name": "Dehradun",
    "state_id": "39"
  },
  {
    "id": "5237",
    "name": "Dehrakhas",
    "state_id": "39"
  },
  {
    "id": "5238",
    "name": "Devaprayag",
    "state_id": "39"
  },
  {
    "id": "5239",
    "name": "Dhaluwala",
    "state_id": "39"
  },
  {
    "id": "5240",
    "name": "Dhandera",
    "state_id": "39"
  },
  {
    "id": "5241",
    "name": "Dharchula",
    "state_id": "39"
  },
  {
    "id": "5242",
    "name": "Dharchula Dehat",
    "state_id": "39"
  },
  {
    "id": "5243",
    "name": "Didihat",
    "state_id": "39"
  },
  {
    "id": "5244",
    "name": "Dineshpur",
    "state_id": "39"
  },
  {
    "id": "5245",
    "name": "Doiwala",
    "state_id": "39"
  },
  {
    "id": "5246",
    "name": "Dugadda",
    "state_id": "39"
  },
  {
    "id": "5247",
    "name": "Dwarahat",
    "state_id": "39"
  },
  {
    "id": "5248",
    "name": "Gadarpur",
    "state_id": "39"
  },
  {
    "id": "5249",
    "name": "Gangotri",
    "state_id": "39"
  },
  {
    "id": "5250",
    "name": "Gauchar",
    "state_id": "39"
  },
  {
    "id": "5251",
    "name": "Haldwani",
    "state_id": "39"
  },
  {
    "id": "5252",
    "name": "Haridwar",
    "state_id": "39"
  },
  {
    "id": "5253",
    "name": "Herbertpur",
    "state_id": "39"
  },
  {
    "id": "5254",
    "name": "Jaspur",
    "state_id": "39"
  },
  {
    "id": "5255",
    "name": "Jhabrera",
    "state_id": "39"
  },
  {
    "id": "5256",
    "name": "Joshimath",
    "state_id": "39"
  },
  {
    "id": "5257",
    "name": "Kachnal Gosain",
    "state_id": "39"
  },
  {
    "id": "5258",
    "name": "Kaladungi",
    "state_id": "39"
  },
  {
    "id": "5259",
    "name": "Kalagarh",
    "state_id": "39"
  },
  {
    "id": "5260",
    "name": "Karnaprayang",
    "state_id": "39"
  },
  {
    "id": "5261",
    "name": "Kashipur",
    "state_id": "39"
  },
  {
    "id": "5262",
    "name": "Kashirampur",
    "state_id": "39"
  },
  {
    "id": "5263",
    "name": "Kausani",
    "state_id": "39"
  },
  {
    "id": "5264",
    "name": "Kedarnath",
    "state_id": "39"
  },
  {
    "id": "5265",
    "name": "Kelakhera",
    "state_id": "39"
  },
  {
    "id": "5266",
    "name": "Khatima",
    "state_id": "39"
  },
  {
    "id": "5267",
    "name": "Kichha",
    "state_id": "39"
  },
  {
    "id": "5268",
    "name": "Kirtinagar",
    "state_id": "39"
  },
  {
    "id": "5269",
    "name": "Kotdwara",
    "state_id": "39"
  },
  {
    "id": "5270",
    "name": "Laksar",
    "state_id": "39"
  },
  {
    "id": "5271",
    "name": "Lalkuan",
    "state_id": "39"
  },
  {
    "id": "5272",
    "name": "Landaura",
    "state_id": "39"
  },
  {
    "id": "5273",
    "name": "Landhaura Cantonment",
    "state_id": "39"
  },
  {
    "id": "5274",
    "name": "Lensdaun",
    "state_id": "39"
  },
  {
    "id": "5275",
    "name": "Logahat",
    "state_id": "39"
  },
  {
    "id": "5276",
    "name": "Mahua Dabra Haripura",
    "state_id": "39"
  },
  {
    "id": "5277",
    "name": "Mahua Kheraganj",
    "state_id": "39"
  },
  {
    "id": "5278",
    "name": "Manglaur",
    "state_id": "39"
  },
  {
    "id": "5279",
    "name": "Masuri",
    "state_id": "39"
  },
  {
    "id": "5280",
    "name": "Mohanpur Mohammadpur",
    "state_id": "39"
  },
  {
    "id": "5281",
    "name": "Muni Ki Reti",
    "state_id": "39"
  },
  {
    "id": "5282",
    "name": "Nagla",
    "state_id": "39"
  },
  {
    "id": "5283",
    "name": "Nainital",
    "state_id": "39"
  },
  {
    "id": "5284",
    "name": "Nainital Cantonment",
    "state_id": "39"
  },
  {
    "id": "5285",
    "name": "Nandaprayang",
    "state_id": "39"
  },
  {
    "id": "5286",
    "name": "Narendranagar",
    "state_id": "39"
  },
  {
    "id": "5287",
    "name": "Pauri",
    "state_id": "39"
  },
  {
    "id": "5288",
    "name": "Pithoragarh",
    "state_id": "39"
  },
  {
    "id": "5289",
    "name": "Pratitnagar",
    "state_id": "39"
  },
  {
    "id": "5290",
    "name": "Raipur",
    "state_id": "39"
  },
  {
    "id": "5291",
    "name": "Raiwala",
    "state_id": "39"
  },
  {
    "id": "5292",
    "name": "Ramnagar",
    "state_id": "39"
  },
  {
    "id": "5293",
    "name": "Ranikhet",
    "state_id": "39"
  },
  {
    "id": "5294",
    "name": "Ranipur",
    "state_id": "39"
  },
  {
    "id": "5295",
    "name": "Rishikesh",
    "state_id": "39"
  },
  {
    "id": "5296",
    "name": "Rishikesh Cantonment",
    "state_id": "39"
  },
  {
    "id": "5297",
    "name": "Roorkee",
    "state_id": "39"
  },
  {
    "id": "5298",
    "name": "Rudraprayag",
    "state_id": "39"
  },
  {
    "id": "5299",
    "name": "Rudrapur",
    "state_id": "39"
  },
  {
    "id": "5300",
    "name": "Rurki",
    "state_id": "39"
  },
  {
    "id": "5301",
    "name": "Rurki Cantonment",
    "state_id": "39"
  },
  {
    "id": "5302",
    "name": "Shaktigarh",
    "state_id": "39"
  },
  {
    "id": "5303",
    "name": "Sitarganj",
    "state_id": "39"
  },
  {
    "id": "5304",
    "name": "Srinagar",
    "state_id": "39"
  },
  {
    "id": "5305",
    "name": "Sultanpur",
    "state_id": "39"
  },
  {
    "id": "5306",
    "name": "Tanakpur",
    "state_id": "39"
  },
  {
    "id": "5307",
    "name": "Tehri",
    "state_id": "39"
  },
  {
    "id": "5308",
    "name": "Udham Singh Nagar",
    "state_id": "39"
  },
  {
    "id": "5309",
    "name": "Uttarkashi",
    "state_id": "39"
  },
  {
    "id": "5310",
    "name": "Vikasnagar",
    "state_id": "39"
  },
  {
    "id": "5311",
    "name": "Virbhadra",
    "state_id": "39"
  },
  {
    "id": "5312",
    "name": "24 Parganas (n)",
    "state_id": "41"
  },
  {
    "id": "5313",
    "name": "24 Parganas (s)",
    "state_id": "41"
  },
  {
    "id": "5314",
    "name": "Adra",
    "state_id": "41"
  },
  {
    "id": "5315",
    "name": "Ahmadpur",
    "state_id": "41"
  },
  {
    "id": "5316",
    "name": "Aiho",
    "state_id": "41"
  },
  {
    "id": "5317",
    "name": "Aistala",
    "state_id": "41"
  },
  {
    "id": "5318",
    "name": "Alipur Duar",
    "state_id": "41"
  },
  {
    "id": "5319",
    "name": "Alipur Duar Railway Junction",
    "state_id": "41"
  },
  {
    "id": "5320",
    "name": "Alpur",
    "state_id": "41"
  },
  {
    "id": "5321",
    "name": "Amalhara",
    "state_id": "41"
  },
  {
    "id": "5322",
    "name": "Amkula",
    "state_id": "41"
  },
  {
    "id": "5323",
    "name": "Amlagora",
    "state_id": "41"
  },
  {
    "id": "5324",
    "name": "Amodghata",
    "state_id": "41"
  },
  {
    "id": "5325",
    "name": "Amtala",
    "state_id": "41"
  },
  {
    "id": "5326",
    "name": "Andul",
    "state_id": "41"
  },
  {
    "id": "5327",
    "name": "Anksa",
    "state_id": "41"
  },
  {
    "id": "5328",
    "name": "Ankurhati",
    "state_id": "41"
  },
  {
    "id": "5329",
    "name": "Anup Nagar",
    "state_id": "41"
  },
  {
    "id": "5330",
    "name": "Arambagh",
    "state_id": "41"
  },
  {
    "id": "5331",
    "name": "Argari",
    "state_id": "41"
  },
  {
    "id": "5332",
    "name": "Arsha",
    "state_id": "41"
  },
  {
    "id": "5333",
    "name": "Asansol",
    "state_id": "41"
  },
  {
    "id": "5334",
    "name": "Ashoknagar Kalyangarh",
    "state_id": "41"
  },
  {
    "id": "5335",
    "name": "Aurangabad",
    "state_id": "41"
  },
  {
    "id": "5336",
    "name": "Bablari Dewanganj",
    "state_id": "41"
  },
  {
    "id": "5337",
    "name": "Badhagachhi",
    "state_id": "41"
  },
  {
    "id": "5338",
    "name": "Baduria",
    "state_id": "41"
  },
  {
    "id": "5339",
    "name": "Baghdogra",
    "state_id": "41"
  },
  {
    "id": "5340",
    "name": "Bagnan",
    "state_id": "41"
  },
  {
    "id": "5341",
    "name": "Bagra",
    "state_id": "41"
  },
  {
    "id": "5342",
    "name": "Bagula",
    "state_id": "41"
  },
  {
    "id": "5343",
    "name": "Baharampur",
    "state_id": "41"
  },
  {
    "id": "5344",
    "name": "Bahirgram",
    "state_id": "41"
  },
  {
    "id": "5345",
    "name": "Bahula",
    "state_id": "41"
  },
  {
    "id": "5346",
    "name": "Baidyabati",
    "state_id": "41"
  },
  {
    "id": "5347",
    "name": "Bairatisal",
    "state_id": "41"
  },
  {
    "id": "5348",
    "name": "Baj Baj",
    "state_id": "41"
  },
  {
    "id": "5349",
    "name": "Bakreswar",
    "state_id": "41"
  },
  {
    "id": "5350",
    "name": "Balaram Pota",
    "state_id": "41"
  },
  {
    "id": "5351",
    "name": "Balarampur",
    "state_id": "41"
  },
  {
    "id": "5352",
    "name": "Bali Chak",
    "state_id": "41"
  },
  {
    "id": "5353",
    "name": "Ballavpur",
    "state_id": "41"
  },
  {
    "id": "5354",
    "name": "Bally",
    "state_id": "41"
  },
  {
    "id": "5355",
    "name": "Balurghat",
    "state_id": "41"
  },
  {
    "id": "5356",
    "name": "Bamunari",
    "state_id": "41"
  },
  {
    "id": "5357",
    "name": "Banarhat Tea Garden",
    "state_id": "41"
  },
  {
    "id": "5358",
    "name": "Bandel",
    "state_id": "41"
  },
  {
    "id": "5359",
    "name": "Bangaon",
    "state_id": "41"
  },
  {
    "id": "5360",
    "name": "Bankra",
    "state_id": "41"
  },
  {
    "id": "5361",
    "name": "Bankura",
    "state_id": "41"
  },
  {
    "id": "5362",
    "name": "Bansbaria",
    "state_id": "41"
  },
  {
    "id": "5363",
    "name": "Banshra",
    "state_id": "41"
  },
  {
    "id": "5364",
    "name": "Banupur",
    "state_id": "41"
  },
  {
    "id": "5365",
    "name": "Bara Bamonia",
    "state_id": "41"
  },
  {
    "id": "5366",
    "name": "Barakpur",
    "state_id": "41"
  },
  {
    "id": "5367",
    "name": "Barakpur Cantonment",
    "state_id": "41"
  },
  {
    "id": "5368",
    "name": "Baranagar",
    "state_id": "41"
  },
  {
    "id": "5369",
    "name": "Barasat",
    "state_id": "41"
  },
  {
    "id": "5370",
    "name": "Barddhaman",
    "state_id": "41"
  },
  {
    "id": "5371",
    "name": "Barijhati",
    "state_id": "41"
  },
  {
    "id": "5372",
    "name": "Barjora",
    "state_id": "41"
  },
  {
    "id": "5373",
    "name": "Barrackpore",
    "state_id": "41"
  },
  {
    "id": "5374",
    "name": "Baruihuda",
    "state_id": "41"
  },
  {
    "id": "5375",
    "name": "Baruipur",
    "state_id": "41"
  },
  {
    "id": "5376",
    "name": "Barunda",
    "state_id": "41"
  },
  {
    "id": "5377",
    "name": "Basirhat",
    "state_id": "41"
  },
  {
    "id": "5378",
    "name": "Baska",
    "state_id": "41"
  },
  {
    "id": "5379",
    "name": "Begampur",
    "state_id": "41"
  },
  {
    "id": "5380",
    "name": "Beldanga",
    "state_id": "41"
  },
  {
    "id": "5381",
    "name": "Beldubi",
    "state_id": "41"
  },
  {
    "id": "5382",
    "name": "Belebathan",
    "state_id": "41"
  },
  {
    "id": "5383",
    "name": "Beliator",
    "state_id": "41"
  },
  {
    "id": "5384",
    "name": "Bhadreswar",
    "state_id": "41"
  },
  {
    "id": "5385",
    "name": "Bhandardaha",
    "state_id": "41"
  },
  {
    "id": "5386",
    "name": "Bhangar Raghunathpur",
    "state_id": "41"
  },
  {
    "id": "5387",
    "name": "Bhangri Pratham Khanda",
    "state_id": "41"
  },
  {
    "id": "5388",
    "name": "Bhanowara",
    "state_id": "41"
  },
  {
    "id": "5389",
    "name": "Bhatpara",
    "state_id": "41"
  },
  {
    "id": "5390",
    "name": "Bholar Dabri",
    "state_id": "41"
  },
  {
    "id": "5391",
    "name": "Bidhannagar",
    "state_id": "41"
  },
  {
    "id": "5392",
    "name": "Bidyadharpur",
    "state_id": "41"
  },
  {
    "id": "5393",
    "name": "Biki Hakola",
    "state_id": "41"
  },
  {
    "id": "5394",
    "name": "Bilandapur",
    "state_id": "41"
  },
  {
    "id": "5395",
    "name": "Bilpahari",
    "state_id": "41"
  },
  {
    "id": "5396",
    "name": "Bipra Noapara",
    "state_id": "41"
  },
  {
    "id": "5397",
    "name": "Birlapur",
    "state_id": "41"
  },
  {
    "id": "5398",
    "name": "Birnagar",
    "state_id": "41"
  },
  {
    "id": "5399",
    "name": "Bisarpara",
    "state_id": "41"
  },
  {
    "id": "5400",
    "name": "Bishnupur",
    "state_id": "41"
  },
  {
    "id": "5401",
    "name": "Bolpur",
    "state_id": "41"
  },
  {
    "id": "5402",
    "name": "Bongaon",
    "state_id": "41"
  },
  {
    "id": "5403",
    "name": "Bowali",
    "state_id": "41"
  },
  {
    "id": "5404",
    "name": "Burdwan",
    "state_id": "41"
  },
  {
    "id": "5405",
    "name": "Canning",
    "state_id": "41"
  },
  {
    "id": "5406",
    "name": "Cart Road",
    "state_id": "41"
  },
  {
    "id": "5407",
    "name": "Chachanda",
    "state_id": "41"
  },
  {
    "id": "5408",
    "name": "Chak Bankola",
    "state_id": "41"
  },
  {
    "id": "5409",
    "name": "Chak Enayetnagar",
    "state_id": "41"
  },
  {
    "id": "5410",
    "name": "Chak Kashipur",
    "state_id": "41"
  },
  {
    "id": "5411",
    "name": "Chakalampur",
    "state_id": "41"
  },
  {
    "id": "5412",
    "name": "Chakbansberia",
    "state_id": "41"
  },
  {
    "id": "5413",
    "name": "Chakdaha",
    "state_id": "41"
  },
  {
    "id": "5414",
    "name": "Chakpara",
    "state_id": "41"
  },
  {
    "id": "5415",
    "name": "Champahati",
    "state_id": "41"
  },
  {
    "id": "5416",
    "name": "Champdani",
    "state_id": "41"
  },
  {
    "id": "5417",
    "name": "Chamrail",
    "state_id": "41"
  },
  {
    "id": "5418",
    "name": "Chandannagar",
    "state_id": "41"
  },
  {
    "id": "5419",
    "name": "Chandpur",
    "state_id": "41"
  },
  {
    "id": "5420",
    "name": "Chandrakona",
    "state_id": "41"
  },
  {
    "id": "5421",
    "name": "Chapari",
    "state_id": "41"
  },
  {
    "id": "5422",
    "name": "Chapui",
    "state_id": "41"
  },
  {
    "id": "5423",
    "name": "Char Brahmanagar",
    "state_id": "41"
  },
  {
    "id": "5424",
    "name": "Char Maijdia",
    "state_id": "41"
  },
  {
    "id": "5425",
    "name": "Charka",
    "state_id": "41"
  },
  {
    "id": "5426",
    "name": "Chata Kalikapur",
    "state_id": "41"
  },
  {
    "id": "5427",
    "name": "Chauhati",
    "state_id": "41"
  },
  {
    "id": "5428",
    "name": "Checha Khata",
    "state_id": "41"
  },
  {
    "id": "5429",
    "name": "Chelad",
    "state_id": "41"
  },
  {
    "id": "5430",
    "name": "Chhora",
    "state_id": "41"
  },
  {
    "id": "5431",
    "name": "Chikrand",
    "state_id": "41"
  },
  {
    "id": "5432",
    "name": "Chittaranjan",
    "state_id": "41"
  },
  {
    "id": "5433",
    "name": "Contai",
    "state_id": "41"
  },
  {
    "id": "5434",
    "name": "Cooch Behar",
    "state_id": "41"
  },
  {
    "id": "5435",
    "name": "Dainhat",
    "state_id": "41"
  },
  {
    "id": "5436",
    "name": "Dakshin Baguan",
    "state_id": "41"
  },
  {
    "id": "5437",
    "name": "Dakshin Jhapardaha",
    "state_id": "41"
  },
  {
    "id": "5438",
    "name": "Dakshin Rajyadharpur",
    "state_id": "41"
  },
  {
    "id": "5439",
    "name": "Dakshin Raypur",
    "state_id": "41"
  },
  {
    "id": "5440",
    "name": "Dalkola",
    "state_id": "41"
  },
  {
    "id": "5441",
    "name": "Dalurband",
    "state_id": "41"
  },
  {
    "id": "5442",
    "name": "Darap Pur",
    "state_id": "41"
  },
  {
    "id": "5443",
    "name": "Darjiling",
    "state_id": "41"
  },
  {
    "id": "5444",
    "name": "Daulatpur",
    "state_id": "41"
  },
  {
    "id": "5445",
    "name": "Debipur",
    "state_id": "41"
  },
  {
    "id": "5446",
    "name": "Defahat",
    "state_id": "41"
  },
  {
    "id": "5447",
    "name": "Deora",
    "state_id": "41"
  },
  {
    "id": "5448",
    "name": "Deulia",
    "state_id": "41"
  },
  {
    "id": "5449",
    "name": "Dhakuria",
    "state_id": "41"
  },
  {
    "id": "5450",
    "name": "Dhandadihi",
    "state_id": "41"
  },
  {
    "id": "5451",
    "name": "Dhanyakuria",
    "state_id": "41"
  },
  {
    "id": "5452",
    "name": "Dharmapur",
    "state_id": "41"
  },
  {
    "id": "5453",
    "name": "Dhatri Gram",
    "state_id": "41"
  },
  {
    "id": "5454",
    "name": "Dhuilya",
    "state_id": "41"
  },
  {
    "id": "5455",
    "name": "Dhulagari",
    "state_id": "41"
  },
  {
    "id": "5456",
    "name": "Dhulian",
    "state_id": "41"
  },
  {
    "id": "5457",
    "name": "Dhupgari",
    "state_id": "41"
  },
  {
    "id": "5458",
    "name": "Dhusaripara",
    "state_id": "41"
  },
  {
    "id": "5459",
    "name": "Diamond Harbour",
    "state_id": "41"
  },
  {
    "id": "5460",
    "name": "Digha",
    "state_id": "41"
  },
  {
    "id": "5461",
    "name": "Dignala",
    "state_id": "41"
  },
  {
    "id": "5462",
    "name": "Dinhata",
    "state_id": "41"
  },
  {
    "id": "5463",
    "name": "Dubrajpur",
    "state_id": "41"
  },
  {
    "id": "5464",
    "name": "Dumjor",
    "state_id": "41"
  },
  {
    "id": "5465",
    "name": "Durgapur",
    "state_id": "41"
  },
  {
    "id": "5466",
    "name": "Durllabhganj",
    "state_id": "41"
  },
  {
    "id": "5467",
    "name": "Egra",
    "state_id": "41"
  },
  {
    "id": "5468",
    "name": "Eksara",
    "state_id": "41"
  },
  {
    "id": "5469",
    "name": "Falakata",
    "state_id": "41"
  },
  {
    "id": "5470",
    "name": "Farakka",
    "state_id": "41"
  },
  {
    "id": "5471",
    "name": "Fatellapur",
    "state_id": "41"
  },
  {
    "id": "5472",
    "name": "Fort Gloster",
    "state_id": "41"
  },
  {
    "id": "5473",
    "name": "Gabberia",
    "state_id": "41"
  },
  {
    "id": "5474",
    "name": "Gadigachha",
    "state_id": "41"
  },
  {
    "id": "5475",
    "name": "Gairkata",
    "state_id": "41"
  },
  {
    "id": "5476",
    "name": "Gangarampur",
    "state_id": "41"
  },
  {
    "id": "5477",
    "name": "Garalgachha",
    "state_id": "41"
  },
  {
    "id": "5478",
    "name": "Garbeta Amlagora",
    "state_id": "41"
  },
  {
    "id": "5479",
    "name": "Garhbeta",
    "state_id": "41"
  },
  {
    "id": "5480",
    "name": "Garshyamnagar",
    "state_id": "41"
  },
  {
    "id": "5481",
    "name": "Garui",
    "state_id": "41"
  },
  {
    "id": "5482",
    "name": "Garulia",
    "state_id": "41"
  },
  {
    "id": "5483",
    "name": "Gayespur",
    "state_id": "41"
  },
  {
    "id": "5484",
    "name": "Ghatal",
    "state_id": "41"
  },
  {
    "id": "5485",
    "name": "Ghorsala",
    "state_id": "41"
  },
  {
    "id": "5486",
    "name": "Goaljan",
    "state_id": "41"
  },
  {
    "id": "5487",
    "name": "Goasafat",
    "state_id": "41"
  },
  {
    "id": "5488",
    "name": "Gobardanga",
    "state_id": "41"
  },
  {
    "id": "5489",
    "name": "Gobindapur",
    "state_id": "41"
  },
  {
    "id": "5490",
    "name": "Gopalpur",
    "state_id": "41"
  },
  {
    "id": "5491",
    "name": "Gopinathpur",
    "state_id": "41"
  },
  {
    "id": "5492",
    "name": "Gora Bazar",
    "state_id": "41"
  },
  {
    "id": "5493",
    "name": "Guma",
    "state_id": "41"
  },
  {
    "id": "5494",
    "name": "Gurdaha",
    "state_id": "41"
  },
  {
    "id": "5495",
    "name": "Guriahati",
    "state_id": "41"
  },
  {
    "id": "5496",
    "name": "Guskhara",
    "state_id": "41"
  },
  {
    "id": "5497",
    "name": "Habra",
    "state_id": "41"
  },
  {
    "id": "5498",
    "name": "Haldia",
    "state_id": "41"
  },
  {
    "id": "5499",
    "name": "Haldibari",
    "state_id": "41"
  },
  {
    "id": "5500",
    "name": "Halisahar",
    "state_id": "41"
  },
  {
    "id": "5501",
    "name": "Haora",
    "state_id": "41"
  },
  {
    "id": "5502",
    "name": "Harharia Chak",
    "state_id": "41"
  },
  {
    "id": "5503",
    "name": "Harindanga",
    "state_id": "41"
  },
  {
    "id": "5504",
    "name": "Haringhata",
    "state_id": "41"
  },
  {
    "id": "5505",
    "name": "Haripur",
    "state_id": "41"
  },
  {
    "id": "5506",
    "name": "Harishpur",
    "state_id": "41"
  },
  {
    "id": "5507",
    "name": "Hatgachha",
    "state_id": "41"
  },
  {
    "id": "5508",
    "name": "Hatsimla",
    "state_id": "41"
  },
  {
    "id": "5509",
    "name": "Hijuli",
    "state_id": "41"
  },
  {
    "id": "5510",
    "name": "Hindustan Cables Town",
    "state_id": "41"
  },
  {
    "id": "5511",
    "name": "Hooghly",
    "state_id": "41"
  },
  {
    "id": "5512",
    "name": "Howrah",
    "state_id": "41"
  },
  {
    "id": "5513",
    "name": "Hugli-Chunchura",
    "state_id": "41"
  },
  {
    "id": "5514",
    "name": "Humaipur",
    "state_id": "41"
  },
  {
    "id": "5515",
    "name": "Ichha Pur Defence Estate",
    "state_id": "41"
  },
  {
    "id": "5516",
    "name": "Ingraj Bazar",
    "state_id": "41"
  },
  {
    "id": "5517",
    "name": "Islampur",
    "state_id": "41"
  },
  {
    "id": "5518",
    "name": "Jafarpur",
    "state_id": "41"
  },
  {
    "id": "5519",
    "name": "Jagadanandapur",
    "state_id": "41"
  },
  {
    "id": "5520",
    "name": "Jagdishpur",
    "state_id": "41"
  },
  {
    "id": "5521",
    "name": "Jagtaj",
    "state_id": "41"
  },
  {
    "id": "5522",
    "name": "Jala Kendua",
    "state_id": "41"
  },
  {
    "id": "5523",
    "name": "Jaldhaka",
    "state_id": "41"
  },
  {
    "id": "5524",
    "name": "Jalkhura",
    "state_id": "41"
  },
  {
    "id": "5525",
    "name": "Jalpaiguri",
    "state_id": "41"
  },
  {
    "id": "5526",
    "name": "Jamuria",
    "state_id": "41"
  },
  {
    "id": "5527",
    "name": "Jangipur",
    "state_id": "41"
  },
  {
    "id": "5528",
    "name": "Jaygaon",
    "state_id": "41"
  },
  {
    "id": "5529",
    "name": "Jaynagar-Majilpur",
    "state_id": "41"
  },
  {
    "id": "5530",
    "name": "Jemari",
    "state_id": "41"
  },
  {
    "id": "5531",
    "name": "Jemari Township",
    "state_id": "41"
  },
  {
    "id": "5532",
    "name": "Jetia",
    "state_id": "41"
  },
  {
    "id": "5533",
    "name": "Jhalida",
    "state_id": "41"
  },
  {
    "id": "5534",
    "name": "Jhargram",
    "state_id": "41"
  },
  {
    "id": "5535",
    "name": "Jhorhat",
    "state_id": "41"
  },
  {
    "id": "5536",
    "name": "Jiaganj-Azimganj",
    "state_id": "41"
  },
  {
    "id": "5537",
    "name": "Joka",
    "state_id": "41"
  },
  {
    "id": "5538",
    "name": "Jot Kamal",
    "state_id": "41"
  },
  {
    "id": "5539",
    "name": "Kachu Pukur",
    "state_id": "41"
  },
  {
    "id": "5540",
    "name": "Kajora",
    "state_id": "41"
  },
  {
    "id": "5541",
    "name": "Kakdihi",
    "state_id": "41"
  },
  {
    "id": "5542",
    "name": "Kakdwip",
    "state_id": "41"
  },
  {
    "id": "5543",
    "name": "Kalaikunda",
    "state_id": "41"
  },
  {
    "id": "5544",
    "name": "Kalara",
    "state_id": "41"
  },
  {
    "id": "5545",
    "name": "Kalimpong",
    "state_id": "41"
  },
  {
    "id": "5546",
    "name": "Kaliyaganj",
    "state_id": "41"
  },
  {
    "id": "5547",
    "name": "Kalna",
    "state_id": "41"
  },
  {
    "id": "5548",
    "name": "Kalyani",
    "state_id": "41"
  },
  {
    "id": "5549",
    "name": "Kamarhati",
    "state_id": "41"
  },
  {
    "id": "5550",
    "name": "Kanaipur",
    "state_id": "41"
  },
  {
    "id": "5551",
    "name": "Kanchrapara",
    "state_id": "41"
  },
  {
    "id": "5552",
    "name": "Kandi",
    "state_id": "41"
  },
  {
    "id": "5553",
    "name": "Kanki",
    "state_id": "41"
  },
  {
    "id": "5554",
    "name": "Kankuria",
    "state_id": "41"
  },
  {
    "id": "5555",
    "name": "Kantlia",
    "state_id": "41"
  },
  {
    "id": "5556",
    "name": "Kanyanagar",
    "state_id": "41"
  },
  {
    "id": "5557",
    "name": "Karimpur",
    "state_id": "41"
  },
  {
    "id": "5558",
    "name": "Karsiyang",
    "state_id": "41"
  },
  {
    "id": "5559",
    "name": "Kasba",
    "state_id": "41"
  },
  {
    "id": "5560",
    "name": "Kasimbazar",
    "state_id": "41"
  },
  {
    "id": "5561",
    "name": "Katwa",
    "state_id": "41"
  },
  {
    "id": "5562",
    "name": "Kaugachhi",
    "state_id": "41"
  },
  {
    "id": "5563",
    "name": "Kenda",
    "state_id": "41"
  },
  {
    "id": "5564",
    "name": "Kendra Khottamdi",
    "state_id": "41"
  },
  {
    "id": "5565",
    "name": "Kendua",
    "state_id": "41"
  },
  {
    "id": "5566",
    "name": "Kesabpur",
    "state_id": "41"
  },
  {
    "id": "5567",
    "name": "Khagrabari",
    "state_id": "41"
  },
  {
    "id": "5568",
    "name": "Khalia",
    "state_id": "41"
  },
  {
    "id": "5569",
    "name": "Khalor",
    "state_id": "41"
  },
  {
    "id": "5570",
    "name": "Khandra",
    "state_id": "41"
  },
  {
    "id": "5571",
    "name": "Khantora",
    "state_id": "41"
  },
  {
    "id": "5572",
    "name": "Kharagpur",
    "state_id": "41"
  },
  {
    "id": "5573",
    "name": "Kharagpur Railway Settlement",
    "state_id": "41"
  },
  {
    "id": "5574",
    "name": "Kharar",
    "state_id": "41"
  },
  {
    "id": "5575",
    "name": "Khardaha",
    "state_id": "41"
  },
  {
    "id": "5576",
    "name": "Khari Mala Khagrabari",
    "state_id": "41"
  },
  {
    "id": "5577",
    "name": "Kharsarai",
    "state_id": "41"
  },
  {
    "id": "5578",
    "name": "Khatra",
    "state_id": "41"
  },
  {
    "id": "5579",
    "name": "Khodarampur",
    "state_id": "41"
  },
  {
    "id": "5580",
    "name": "Kodalia",
    "state_id": "41"
  },
  {
    "id": "5581",
    "name": "Kolaghat",
    "state_id": "41"
  },
  {
    "id": "5582",
    "name": "Kolaghat Thermal Power Project",
    "state_id": "41"
  },
  {
    "id": "5583",
    "name": "Kolkata",
    "state_id": "41"
  },
  {
    "id": "5584",
    "name": "Konardihi",
    "state_id": "41"
  },
  {
    "id": "5585",
    "name": "Konnogar",
    "state_id": "41"
  },
  {
    "id": "5586",
    "name": "Krishnanagar",
    "state_id": "41"
  },
  {
    "id": "5587",
    "name": "Krishnapur",
    "state_id": "41"
  },
  {
    "id": "5588",
    "name": "Kshidirpur",
    "state_id": "41"
  },
  {
    "id": "5589",
    "name": "Kshirpai",
    "state_id": "41"
  },
  {
    "id": "5590",
    "name": "Kulihanda",
    "state_id": "41"
  },
  {
    "id": "5591",
    "name": "Kulti",
    "state_id": "41"
  },
  {
    "id": "5592",
    "name": "Kunustara",
    "state_id": "41"
  },
  {
    "id": "5593",
    "name": "Kuperskem",
    "state_id": "41"
  },
  {
    "id": "5594",
    "name": "Madanpur",
    "state_id": "41"
  },
  {
    "id": "5595",
    "name": "Madhusudanpur",
    "state_id": "41"
  },
  {
    "id": "5596",
    "name": "Madhyamgram",
    "state_id": "41"
  },
  {
    "id": "5597",
    "name": "Maheshtala",
    "state_id": "41"
  },
  {
    "id": "5598",
    "name": "Mahiari",
    "state_id": "41"
  },
  {
    "id": "5599",
    "name": "Mahikpur",
    "state_id": "41"
  },
  {
    "id": "5600",
    "name": "Mahira",
    "state_id": "41"
  },
  {
    "id": "5601",
    "name": "Mahishadal",
    "state_id": "41"
  },
  {
    "id": "5602",
    "name": "Mainaguri",
    "state_id": "41"
  },
  {
    "id": "5603",
    "name": "Makardaha",
    "state_id": "41"
  },
  {
    "id": "5604",
    "name": "Mal",
    "state_id": "41"
  },
  {
    "id": "5605",
    "name": "Malda",
    "state_id": "41"
  },
  {
    "id": "5606",
    "name": "Mandarbani",
    "state_id": "41"
  },
  {
    "id": "5607",
    "name": "Mansinhapur",
    "state_id": "41"
  },
  {
    "id": "5608",
    "name": "Masila",
    "state_id": "41"
  },
  {
    "id": "5609",
    "name": "Maslandapur",
    "state_id": "41"
  },
  {
    "id": "5610",
    "name": "Mathabhanga",
    "state_id": "41"
  },
  {
    "id": "5611",
    "name": "Mekliganj",
    "state_id": "41"
  },
  {
    "id": "5612",
    "name": "Memari",
    "state_id": "41"
  },
  {
    "id": "5613",
    "name": "Midnapur",
    "state_id": "41"
  },
  {
    "id": "5614",
    "name": "Mirik",
    "state_id": "41"
  },
  {
    "id": "5615",
    "name": "Monoharpur",
    "state_id": "41"
  },
  {
    "id": "5616",
    "name": "Mrigala",
    "state_id": "41"
  },
  {
    "id": "5617",
    "name": "Muragachha",
    "state_id": "41"
  },
  {
    "id": "5618",
    "name": "Murgathaul",
    "state_id": "41"
  },
  {
    "id": "5619",
    "name": "Murshidabad",
    "state_id": "41"
  },
  {
    "id": "5620",
    "name": "Nabadhai Dutta Pukur",
    "state_id": "41"
  },
  {
    "id": "5621",
    "name": "Nabagram",
    "state_id": "41"
  },
  {
    "id": "5622",
    "name": "Nabgram",
    "state_id": "41"
  },
  {
    "id": "5623",
    "name": "Nachhratpur Katabari",
    "state_id": "41"
  },
  {
    "id": "5624",
    "name": "Nadia",
    "state_id": "41"
  },
  {
    "id": "5625",
    "name": "Naihati",
    "state_id": "41"
  },
  {
    "id": "5626",
    "name": "Nalhati",
    "state_id": "41"
  },
  {
    "id": "5627",
    "name": "Nasra",
    "state_id": "41"
  },
  {
    "id": "5628",
    "name": "Natibpur",
    "state_id": "41"
  },
  {
    "id": "5629",
    "name": "Naupala",
    "state_id": "41"
  },
  {
    "id": "5630",
    "name": "Navadwip",
    "state_id": "41"
  },
  {
    "id": "5631",
    "name": "Nebadhai Duttapukur",
    "state_id": "41"
  },
  {
    "id": "5632",
    "name": "New Barrackpore",
    "state_id": "41"
  },
  {
    "id": "5633",
    "name": "Ni Barakpur",
    "state_id": "41"
  },
  {
    "id": "5634",
    "name": "Nibra",
    "state_id": "41"
  },
  {
    "id": "5635",
    "name": "Noapara",
    "state_id": "41"
  },
  {
    "id": "5636",
    "name": "Nokpul",
    "state_id": "41"
  },
  {
    "id": "5637",
    "name": "North Barakpur",
    "state_id": "41"
  },
  {
    "id": "5638",
    "name": "Odlabari",
    "state_id": "41"
  },
  {
    "id": "5639",
    "name": "Old Maldah",
    "state_id": "41"
  },
  {
    "id": "5640",
    "name": "Ondal",
    "state_id": "41"
  },
  {
    "id": "5641",
    "name": "Pairagachha",
    "state_id": "41"
  },
  {
    "id": "5642",
    "name": "Palashban",
    "state_id": "41"
  },
  {
    "id": "5643",
    "name": "Panchla",
    "state_id": "41"
  },
  {
    "id": "5644",
    "name": "Panchpara",
    "state_id": "41"
  },
  {
    "id": "5645",
    "name": "Pandua",
    "state_id": "41"
  },
  {
    "id": "5646",
    "name": "Pangachhiya",
    "state_id": "41"
  },
  {
    "id": "5647",
    "name": "Paniara",
    "state_id": "41"
  },
  {
    "id": "5648",
    "name": "Panihati",
    "state_id": "41"
  },
  {
    "id": "5649",
    "name": "Panuhat",
    "state_id": "41"
  },
  {
    "id": "5650",
    "name": "Par Beliya",
    "state_id": "41"
  },
  {
    "id": "5651",
    "name": "Parashkol",
    "state_id": "41"
  },
  {
    "id": "5652",
    "name": "Parasia",
    "state_id": "41"
  },
  {
    "id": "5653",
    "name": "Parbbatipur",
    "state_id": "41"
  },
  {
    "id": "5654",
    "name": "Parui",
    "state_id": "41"
  },
  {
    "id": "5655",
    "name": "Paschim Jitpur",
    "state_id": "41"
  },
  {
    "id": "5656",
    "name": "Paschim Punro Para",
    "state_id": "41"
  },
  {
    "id": "5657",
    "name": "Patrasaer",
    "state_id": "41"
  },
  {
    "id": "5658",
    "name": "Pattabong Tea Garden",
    "state_id": "41"
  },
  {
    "id": "5659",
    "name": "Patuli",
    "state_id": "41"
  },
  {
    "id": "5660",
    "name": "Patulia",
    "state_id": "41"
  },
  {
    "id": "5661",
    "name": "Phulia",
    "state_id": "41"
  },
  {
    "id": "5662",
    "name": "Podara",
    "state_id": "41"
  },
  {
    "id": "5663",
    "name": "Port Blair",
    "state_id": "41"
  },
  {
    "id": "5664",
    "name": "Prayagpur",
    "state_id": "41"
  },
  {
    "id": "5665",
    "name": "Pujali",
    "state_id": "41"
  },
  {
    "id": "5666",
    "name": "Purba Medinipur",
    "state_id": "41"
  },
  {
    "id": "5667",
    "name": "Purba Tajpur",
    "state_id": "41"
  },
  {
    "id": "5668",
    "name": "Purulia",
    "state_id": "41"
  },
  {
    "id": "5669",
    "name": "Raghudebbati",
    "state_id": "41"
  },
  {
    "id": "5670",
    "name": "Raghudebpur",
    "state_id": "41"
  },
  {
    "id": "5671",
    "name": "Raghunathchak",
    "state_id": "41"
  },
  {
    "id": "5672",
    "name": "Raghunathpur",
    "state_id": "41"
  },
  {
    "id": "5673",
    "name": "Raghunathpur-Dankuni",
    "state_id": "41"
  },
  {
    "id": "5674",
    "name": "Raghunathpur-Magra",
    "state_id": "41"
  },
  {
    "id": "5675",
    "name": "Raigachhi",
    "state_id": "41"
  },
  {
    "id": "5676",
    "name": "Raiganj",
    "state_id": "41"
  },
  {
    "id": "5677",
    "name": "Raipur",
    "state_id": "41"
  },
  {
    "id": "5678",
    "name": "Rajarhat Gopalpur",
    "state_id": "41"
  },
  {
    "id": "5679",
    "name": "Rajpur",
    "state_id": "41"
  },
  {
    "id": "5680",
    "name": "Ramchandrapur",
    "state_id": "41"
  },
  {
    "id": "5681",
    "name": "Ramjibanpur",
    "state_id": "41"
  },
  {
    "id": "5682",
    "name": "Ramnagar",
    "state_id": "41"
  },
  {
    "id": "5683",
    "name": "Rampur Hat",
    "state_id": "41"
  },
  {
    "id": "5684",
    "name": "Ranaghat",
    "state_id": "41"
  },
  {
    "id": "5685",
    "name": "Raniganj",
    "state_id": "41"
  },
  {
    "id": "5686",
    "name": "Ratibati",
    "state_id": "41"
  },
  {
    "id": "5687",
    "name": "Raypur",
    "state_id": "41"
  },
  {
    "id": "5688",
    "name": "Rishra",
    "state_id": "41"
  },
  {
    "id": "5689",
    "name": "Rishra Cantonment",
    "state_id": "41"
  },
  {
    "id": "5690",
    "name": "Ruiya",
    "state_id": "41"
  },
  {
    "id": "5691",
    "name": "Sahajadpur",
    "state_id": "41"
  },
  {
    "id": "5692",
    "name": "Sahapur",
    "state_id": "41"
  },
  {
    "id": "5693",
    "name": "Sainthia",
    "state_id": "41"
  },
  {
    "id": "5694",
    "name": "Salap",
    "state_id": "41"
  },
  {
    "id": "5695",
    "name": "Sankarpur",
    "state_id": "41"
  },
  {
    "id": "5696",
    "name": "Sankrail",
    "state_id": "41"
  },
  {
    "id": "5697",
    "name": "Santoshpur",
    "state_id": "41"
  },
  {
    "id": "5698",
    "name": "Saontaidih",
    "state_id": "41"
  },
  {
    "id": "5699",
    "name": "Sarenga",
    "state_id": "41"
  },
  {
    "id": "5700",
    "name": "Sarpi",
    "state_id": "41"
  },
  {
    "id": "5701",
    "name": "Satigachha",
    "state_id": "41"
  },
  {
    "id": "5702",
    "name": "Serpur",
    "state_id": "41"
  },
  {
    "id": "5703",
    "name": "Shankhanagar",
    "state_id": "41"
  },
  {
    "id": "5704",
    "name": "Shantipur",
    "state_id": "41"
  },
  {
    "id": "5705",
    "name": "Shrirampur",
    "state_id": "41"
  },
  {
    "id": "5706",
    "name": "Siduli",
    "state_id": "41"
  },
  {
    "id": "5707",
    "name": "Siliguri",
    "state_id": "41"
  },
  {
    "id": "5708",
    "name": "Simla",
    "state_id": "41"
  },
  {
    "id": "5709",
    "name": "Singur",
    "state_id": "41"
  },
  {
    "id": "5710",
    "name": "Sirsha",
    "state_id": "41"
  },
  {
    "id": "5711",
    "name": "Siuri",
    "state_id": "41"
  },
  {
    "id": "5712",
    "name": "Sobhaganj",
    "state_id": "41"
  },
  {
    "id": "5713",
    "name": "Sodpur",
    "state_id": "41"
  },
  {
    "id": "5714",
    "name": "Sonamukhi",
    "state_id": "41"
  },
  {
    "id": "5715",
    "name": "Sonatikiri",
    "state_id": "41"
  },
  {
    "id": "5716",
    "name": "Srikantabati",
    "state_id": "41"
  },
  {
    "id": "5717",
    "name": "Srirampur",
    "state_id": "41"
  },
  {
    "id": "5718",
    "name": "Sukdal",
    "state_id": "41"
  },
  {
    "id": "5719",
    "name": "Taherpur",
    "state_id": "41"
  },
  {
    "id": "5720",
    "name": "Taki",
    "state_id": "41"
  },
  {
    "id": "5721",
    "name": "Talbandha",
    "state_id": "41"
  },
  {
    "id": "5722",
    "name": "Tamluk",
    "state_id": "41"
  },
  {
    "id": "5723",
    "name": "Tarakeswar",
    "state_id": "41"
  },
  {
    "id": "5724",
    "name": "Tentulberia",
    "state_id": "41"
  },
  {
    "id": "5725",
    "name": "Tentulkuli",
    "state_id": "41"
  },
  {
    "id": "5726",
    "name": "Thermal Power Project",
    "state_id": "41"
  },
  {
    "id": "5727",
    "name": "Tinsukia",
    "state_id": "41"
  },
  {
    "id": "5728",
    "name": "Titagarh",
    "state_id": "41"
  },
  {
    "id": "5729",
    "name": "Tufanganj",
    "state_id": "41"
  },
  {
    "id": "5730",
    "name": "Ukhra",
    "state_id": "41"
  },
  {
    "id": "5731",
    "name": "Ula",
    "state_id": "41"
  },
  {
    "id": "5732",
    "name": "Ulubaria",
    "state_id": "41"
  },
  {
    "id": "5733",
    "name": "Uttar Durgapur",
    "state_id": "41"
  },
  {
    "id": "5734",
    "name": "Uttar Goara",
    "state_id": "41"
  },
  {
    "id": "5735",
    "name": "Uttar Kalas",
    "state_id": "41"
  },
  {
    "id": "5736",
    "name": "Uttar Kamakhyaguri",
    "state_id": "41"
  },
  {
    "id": "5737",
    "name": "Uttar Latabari",
    "state_id": "41"
  },
  {
    "id": "5738",
    "name": "Uttar Mahammadpur",
    "state_id": "41"
  },
  {
    "id": "5739",
    "name": "Uttar Pirpur",
    "state_id": "41"
  },
  {
    "id": "5740",
    "name": "Uttar Raypur",
    "state_id": "41"
  },
  {
    "id": "5741",
    "name": "Uttarpara-Kotrung",
    "state_id": "41"
  },
];
  